/* eslint-disable */
/**
 * Diccionario EN — viaja en el arranque (es el idioma por defecto).
 *
 * Generado al partir lib/i18n.tsx (auditoría 2026-09-15). Las claves se editan ACÁ; el checker
 * (scripts/checkI18n.mjs) lee los dos archivos.
 */
export const EN: Record<string, string> = {
    'common.loading': 'Loading…',
    'app.updated': 'The app was updated. Reload to continue.',
    'app.reload': 'Reload',
    'common.confirmDelete': 'Delete this? It cannot be undone.',
    'common.confirmRemove': 'Remove? This cannot be undone.',
    'common.refresh': 'Refresh',
    'load.failed': 'Could not load {what}.',
    'atrv.frameTitle': 'ATR video', 'atrv.openYoutube': 'Open on YouTube ↗', 'atrv.openVideo': '▶ Open video ↗',
    'patr.dead': 'This link is no longer available.', 'patr.deadHelp': 'If you need this video, please reply to the email it came with and we will send a new link.', 'patr.kicker': 'ATR video', 'patr.download': 'Download video', 'patr.sharedBy': 'This video was shared by', 'patr.forClaim': 'for the insurance claim referenced in the email it came with.',
    'load.what.idioma': 'the Spanish text',
    'load.what.datos': 'some data',
    'load.what.archive': 'the archive',
    'load.what.directory': 'the directory',
    'load.what.calls': 'the calls',
    'load.what.callAlerts': 'the call alerts',
    'load.what.intake': 'the intake submissions',
    'load.what.coverage': 'the search results',
    'load.what.appointments': 'the appointments',
    'load.what.policies': 'the policies',
    'load.what.negotiations': 'the negotiations',
    'load.what.silentFailures': 'the silent failures',
    'load.what.rotations': 'the rotations',
    'load.what.teams': 'the teams',
    'load.what.deptViews': 'the department views',
    'load.what.history': 'the history',
    'load.what.archivedFiles': 'the archived files',
    'load.what.chat': 'the chat',
    'load.what.emailBody': 'the email body',
    'common.saveState': 'Save state',
    'common.prevDay': 'Previous day', 'common.nextDay': 'Next day', 'common.prevMonth': 'Previous month', 'common.nextMonth': 'Next month',
    'sys.topQueries': 'Most expensive queries (pg_stat_statements, since the last database restart)', 'sys.topQueriesOff': 'pg_stat_statements is not enabled on this database.', 'sys.onlyPlatform': 'The query text covers every company on this server, so it is only shown through the platform login.', 'sys.query': 'Query', 'sys.totalS': 'Total s', 'sys.calls': 'Calls', 'sys.meanMs': 'Mean ms', 'sys.maxMs': 'Max ms',
    'common.save': 'Save', 'common.saved': 'Saved', 'common.saving': 'Saving…',
    'common.on': 'On',
    'common.off': 'Off',
    'common.download': 'Download',
    // JobFlow Access toggle (Contractors)
    'jfa.title': 'JobFlow Access',
    'jfa.saveFirst': 'Save the contractor first to enable JobFlow Access.',
    'vault.title': 'Payment vault (W9 & bank)',
    'vault.superOnly': 'Super-manager only',
    'vault.hint': 'Save the W9 and bank account the contractor sends you. Bank details are stored encrypted.',
    'vault.proofs': 'Bank account proof (as they sent it)',
    'vault.proofsHint': 'Attach the screenshots/emails the contractor sent with their account info — kept exactly as received, as backup. You can add several.',
    'vault.proofDrop': 'Drop or click to add a proof (image/PDF)',
    'vault.removeProofConfirm': 'Remove this proof file?',
    'vault.w9': 'W9',
    'vault.accounts': 'Accepted bank accounts (last 4)',
    'vault.accountsHint': 'The last 4 digits of every account this contractor gets paid into. Every proof of payment is checked against this list: if the receipt credits another account, the payment is blocked and Payments is alerted.',
    'vault.accountsAuto': 'They load themselves: when a W9 or an account proof is uploaded, the document is read and the account it shows is added.',
    'vault.acctRead': 'Read account',
    'vault.acctReadHint': 'Read this document and pull out the account number and routing. The full number is stored encrypted; only the last 4 are used to check payments.',
    'vault.acctReading': 'Reading the document\u2026',
    'vault.acctReadOk': 'Account \u2022\u2022\u2022\u2022{n} loaded from this document.',
    'vault.acctReadLow': 'The digits were not clear enough to load on their own \u2014 check the document and type the last 4 by hand.',
    'vault.acctReadNoAccount': 'This document does not show a bank account (a plain W9 often does not).',
    'vault.acctReadFailed': 'Could not read this document.',
    'vault.accountsNone': 'No account on file — proofs for this contractor cannot be checked against an account yet.',
    'vault.acctLast4': 'Last 4',
    'vault.acctLabel': 'Label (optional) — e.g. Chase operating',
    'vault.acctAdd': 'Add account',
    'vault.acctInvalid': 'Enter the last 4 digits of the account.',
    'vault.acctRetire': 'Retire',
    'vault.acctRetired': 'retired',
    'vault.acctRetireConfirm': 'Retire this account? Payments to it will be blocked from now on. It stays on the file as history.',
    'vault.acctSeen': 'Seen on past receipts:',
    'vault.acctSeenHint': 'Found on this contractor\u2019s payment receipts. Check it is really theirs before adding it.',
    'vault.acctFromProofs': 'from past receipts',
    'vault.acctUnblocked': '{n} blocked payment(s) released by this account.',
    'vault.acctBlocked': '{n} pending payment(s) are now blocked — their receipt credits an account that is no longer accepted.',
    'vault.w9Drop': 'Drop the W9 (PDF/image) or click to upload',
    'vault.uploading': 'Uploading…',
    'vault.removeW9Confirm': 'Remove the saved W9?',
    'vault.bank': 'Bank account',
    'vault.reveal': 'Reveal',
    'vault.addBank': 'Add bank account',
    'vault.revealedWarn': 'Sensitive data shown — this access is logged.',
    'vault.bankName': 'Bank name',
    'vault.accountHolder': 'Account holder',
    'vault.routing': 'Routing number',
    'vault.account': 'Account number',
    'vault.accountRequired': 'Account number is required.',
    'vault.removeBankConfirm': 'Delete the saved bank account?',
    'jfa.statusActive': 'Active · last provisioned {date}',
    'jfa.statusInactive': 'Inactive',
    'jfa.notConfigured': '⚠ JobFlow is not configured on the backend (JOBFLOW_API_URL / JOBFLOW_PROVISION_KEY missing).',
    'jfa.maxUsers': 'Allowed users in JobFlow (1–500)',
    'jfa.showRcv': 'Show approved amount (RCV)',
    'jfa.paidTools': 'Paid tools (CRM Pro)',
    'jfa.saved': 'Saved — contractor provisioned in JobFlow.',
    'jfa.savedInvited': 'Saved — JobFlow sent the contractor an email invite to set their password.',
    'jfa.disabled': 'Access disabled — history preserved in JobFlow.',
    'jfa.disableConfirm': 'The contractor will lose access to the bridge. Their history in JobFlow is preserved. Continue?',
    'jfa.error': 'Could not save JobFlow access.',
    'common.edit': 'Edit',
    'mi.title': 'Items to add — written by hand',
    'eg.secAdd': 'Items to ADD — written by supplements',
    'mi.add': 'Add item',
    'mi.empty': 'Nothing yet. Add what the comparison cannot see: what you found on site, in the photos, or what you know and no PDF says.',
    'mi.codePh': 'Code or your own words — how the estimator finds it',
    'mi.kindPh': 'Trade (optional)',
    'mi.amountPh': '$ estimated',
    'mi.descPh': 'What goes there',
    'mi.notePh': 'The note that goes in the estimate',
    'mi.urlPh': 'Photo link (CompanyCam, Drive…)',
    'mi.addPhoto': 'Add photo',
    'mi.openPhotos': 'Open these photos in another tab',
    'mi.improve': 'Improve with AI',
    'mi.improveHint': 'AI rewrites your note properly — it keeps your meaning, it does not replace your argument',
    'mi.confirmDelete': 'Delete this item?',
    'common.remove': 'Remove',
    'comms.fromSystem': 'From the department', 'comms.fromMe': 'From me',
    'comms.fromSystemHint': 'Goes out from the department account. Replies come back into the claim on their own.',
    'comms.fromMeNote': 'goes out as {email} — a normal email, and it still lands on the claim',
    'mine.assigned': 'Assigned to me', 'mine.myMailbox': 'My mailbox',
    'mine.mailboxEmpty': 'Nothing here yet. Mail is fetched automatically every few minutes.',
    'mine.syncNow': 'Fetch now', 'mine.notSetUp': 'Your mailbox is not set up yet — ask the master to add it in Settings → Email.',
    'mba.tab': 'Email',
    'mba.serverTitle': 'Mail server (same for everyone)',
    'mba.serverHint': 'Everyone is on the same hosting, so this is written once. Per person only the address, the password and the name the mail goes out with change.',
    'mba.serverMissing': 'not set yet',
    'mba.imapHost': 'IMAP server (incoming)', 'mba.smtpHost': 'SMTP server (outgoing)', 'mba.port': 'Port',
    'mba.peopleTitle': 'Mailbox per employee',
    'mba.peopleCount': '{con} of {total} set up',
    'mba.noMailbox': 'no mailbox',
    'mba.ok': 'connects', 'mba.failing': 'failing', 'mba.untested': 'not tested',
    'mba.ownHost': 'own server',
    'mba.setUp': 'Set up',
    'mba.address': 'Email address', 'mba.fromName': 'Name on outgoing mail',
    'mba.password': 'Password', 'mba.passwordSet': 'Password (leave empty to keep)', 'mba.revealHint': 'Show the saved password (it gets logged who looked)', 'mba.noPassword': 'no password saved',
    'mba.testOkSaved': 'connects fine — saved', 'mba.testTypedHint': 'Tests the password you just typed; if it connects, it is saved.', 'mba.test': 'Test connection', 'mba.testOk': 'connects fine', 'mba.testFail': 'could not connect',
    'mba.saved': 'Saved', 'mba.removed': 'Mailbox removed',
    'mba.removeConfirm': 'Remove the mailbox of {name}? Their mail stops syncing into the app.',
    'common.clear': 'Clear',
    'common.create': 'Create',
    'common.retry': 'Retry',
    'common.loadFailed': "This didn't load. Check your connection and try again.",
    'err.generico': 'Something went wrong. Please try again.',
    'err.pdfProtegido': 'This PDF is password protected, so it cannot be read. Save it again without a password and upload it.',
    'err.pdfMuchasPaginas': 'This PDF has too many pages to read at once. Split it and upload the part with the numbers.',
    'err.pdfMuyGrande': 'This file is too large to read. Upload a lighter version.',
    'err.pdfIlegible': 'This file could not be read — it may be damaged or not be a real PDF.',
    'err.documentoIlegible': 'This file could not be read. Check that it opens correctly and upload it again.',
    'common.cancel': 'Cancel',
    'common.add': 'Add',
    'common.delete': 'Delete',
    'common.send': 'Send',
    'common.back': 'Back',
    'common.actions': 'Actions',
    'common.status': 'Status',
    'common.amount': 'Amount',
    'common.total': 'Total',
    'cd.totalReceived': 'Total received',
    'common.hide': 'Hide',
    'common.close': 'Close', 'common.none': 'None.',
    'common.needManager': 'Could not load (requires manager+ role).',
    'common.needSuperManager': 'Could not load (requires super-manager+ role).',
    'addr.placeholder': 'Start typing an address…',
    'addr.unavailable': 'Address suggestions unavailable — you can still type it manually.',
    'addr.verified': 'verified',
    'intake.addrInvalid': 'That address does not look like a property address. Please pick it from the suggestions, or type it like: 123 Main St, City, State ZIP.',

    'nav.operations': 'Operations',
    'nav.management': 'Management',
    'nav.searchMenu': 'Search menu…', 'nav.inboxes': 'Inboxes', 'nav.departments': 'Departments',
    'nav.mail': 'Mail', 'nav.intakeMail': 'Intake Mail', 'nav.claimMail': 'Claim Mail', 'nav.supplementsMail': 'Supplements Mail', 'nav.paymentsMail': 'Payments Mail', 'nav.unassignedMail': 'Unassigned',
    'nav.dashboard': 'Dashboard',
    'nav.finder': 'Finder',
    'nav.lastViewed': 'Last viewed',
    'nav.diary': 'To Do',
    'diary.help': 'Your cases for today, by priority. Work each one and move on.',
    'diary.actionable': '{n} cases need attention',
    'diary.allClear': 'All clear — nothing needs attention right now.',
    'diary.noneAssigned': 'Nothing assigned to you in payment stages.',
    'diary.manager': 'Manager alert',
    'diary.coSection': 'Contractor follow-ups',
    'diary.coSectionHelp': 'Separate from claim follow-ups: expand a row to see the latest notes and leave the contractor follow-up right here (posting shares to JobFlow and resets the 3-day clock).',
    'diary.coChatTitle': 'Contractor chat',
    'diary.coGeneralTitle': 'General update',
    'diary.coRefresh': 'Done — refresh list',
    'diary.urgent': 'Urgent',
    'diary.followup': 'Needs follow-up (overdue)',
    'diary.today': 'Due today',
    'diary.ontrack': 'On track',
    'task.title': 'Tasks assigned to me', 'task.goToView': 'Open in {view}, with this client selected',
    'task.new': 'New task',
    'task.assignTo': 'Assign to',
    'task.teams': 'Teams',
    'task.people': 'People', 'chat.taskFromNote': 'Task', 'chat.taskFromNoteHint': 'Assign a task about this note to a person, a team or a department — it lands in their To Do with a link to this note.',
    'task.priority': 'Priority',
    'task.prioLow': 'Low',
    'task.prioNormal': 'Normal',
    'task.prioHigh': 'High',
    'task.titlePh': 'What needs to be done',
    'task.notePh': 'Note (optional)',
    'task.claimPh': 'Which client is this about? (optional — search by name or claim #)',
    'task.due': 'Due',
    'task.assign': 'Assign task',
    'task.from': 'from',
    'task.done': 'Done',
    'task.empty': 'No tasks assigned to you.',
    'task.remind': 'Reminder',
    'task.setReminder': 'Set alarm',
    'task.clearReminder': 'Clear',
    'task.updates': 'Updates',
    'task.noUpdates': 'No updates yet.',
    'task.updatePh': 'Leave an update…',
    'task.postUpdate': 'Post',
    'task.created': '✓ Task assigned.',
    'task.needAssigneeTitle': 'Pick a member and a title.',
    'lv.help': 'The claims you opened most recently — pick up where you left off.',
    'lv.empty': "You haven't opened any claims yet.",
    'lv.viewedAt': 'Opened',
    'finder.title': 'Finder',
    'finder.help': 'Search anything — client name, phone, address, claim #, email, policy # or an amount. Phone works in any format (or just the last 4 digits). Amounts match deposited checks, invoices and payments so you can reconcile.',
    'finder.placeholder': 'Name, phone, address, claim # or amount (e.g. 4,000.00)…',
    'finder.amountMode': 'Searching by amount',
    'finder.searching': 'Searching…',
    'finder.noResults': 'No matches found.',
    'finder.clients': 'Clients',
    'finder.clientsHelp': 'Grouped by claim status — the same groups as the board. Click a status to see only that one.',
    'finder.groupStatus': 'Group: Status',
    'finder.collapseAll': 'Collapse all',
    'finder.expandAll': 'Expand all',
    'finder.allStatuses': 'All',
    'finder.noStage': 'No stage',
    'finder.checks': 'Checks',
    'finder.checksHelp': 'Checks matching this amount — when and where they were deposited and which client they belong to.',
    'finder.invoices': 'Invoices',
    'finder.invoicesHelp': 'Invoices whose payout or fee matches this amount.',
    'finder.payments': 'Payments',
    'finder.paymentsHelp': 'Outgoing payments matching this amount.',
    'finder.open': 'Open',
    'finder.viewCheck': 'View check',
    'finder.viewInvoice': 'View invoice',
    'finder.deposited': 'Deposited',
    'finder.invoiceNo': 'Invoice #',
    'finder.payout': 'Payout',
    'finder.fee': 'Fee',
    'finder.payee': 'Payee',
    'finder.paidAt': 'Paid',
    'finder.unpaid': 'Not paid yet',
    'nav.invoiceTodo': 'Invoice To-Do',
    'nav.review': 'Review Invoice',
    'nav.checks': 'Checks Received',
    'nav.checksIssued': 'Checks Issued',
    // ── El cheque que SALE (2026-10-27). Hermano de "Checks Received": lo que entra del seguro
    // contra lo que la empresa gira. "Issued" y no "Printed" porque el registro guarda también los
    // borradores y los anulados, no solo lo que pasó por la impresora.
    'oc.title': 'Pay by check',
    'oc.titleOther': 'New check',
    'oc.pickInvoices': 'Invoices to pay',
    'oc.noInvoices': 'This claim has no issued invoice with an open payout.',
    'oc.ofPayout': 'of {x}',
    'oc.payableTo': 'Payable to',
    'oc.contractor': 'Contractor',
    'oc.homeowner': 'Homeowner',
    'oc.payeeName': 'Pay to the order of',
    'oc.payeeNamePh': 'Vendor, employee, anyone',
    'oc.category': 'Category',
    'oc.categoryPh': 'Vendor, payroll, rent…',
    'oc.amount': 'Amount',
    'oc.full': 'Full',
    'oc.partial': 'Partial',
    'oc.overLeft': 'More than the {x} these invoices still owe.',
    'oc.memo': 'Memo',
    'oc.withSignature': 'Print my signature',
    'oc.noSignatureYet': 'Draw your signature in your profile first',
    'oc.create': 'Continue',
    'oc.checkNumber': 'Check number',
    'oc.checkNumberPh': 'e.g. 1001',
    'oc.checkNumberHelp': 'The number already printed on the paper. We record it; we never print it.',
    'oc.scaleWarning': 'Load the check in the printer and print at 100% ("Actual size"). Turn off "Fit to page" — a scaled sheet ruins the check.',
    'oc.print': 'Print check',
    'oc.payByCheck': 'Pay by check',
    'oc.printCheck': 'Print check',
    'oc.err.check_amount_over_payout': 'That is more than these invoices still owe.',
    'oc.err.invoice_already_paid': 'Those invoices have nothing left to pay.',
    'oc.err.invoice_not_issued': 'Issue the invoice before paying it.',
    'oc.err.payout_not_payable': 'That invoice has no payout to pay.',
    'oc.err.check_number_taken': 'That check number is already used.',
    'oc.err.check_already_printed': 'This check was already printed. Void it if it came out wrong.',
    'oc.err.no_payment_permission': 'You do not have permission to issue checks.',
    'oc.err.payee_unknown': 'This claim has no name on file for that payee.',
    'oc.newCheck': 'New check',
    'oc.filterAllStatus': 'Any status',
    'oc.filterAllKinds': 'Claim and non-claim',
    'oc.kindClaim': 'Claim',
    'oc.kindOther': 'Not a claim',
    'oc.searchPh': 'Payee, check number, claim…',
    'oc.totals': '{n} checks · {printed} printed · {voided} voided',
    'oc.colNumber': 'Check #',
    'oc.colDate': 'Date',
    'oc.colPayee': 'Payable to',
    'oc.colFor': 'For',
    'oc.empty': 'No checks yet.',
    'oc.replaces': 'reprint of a voided check',
    'oc.status.draft': 'Draft',
    'oc.status.printed': 'Printed',
    'oc.status.voided': 'Voided',
    'oc.viewPdf': 'Open the PDF',
    'oc.reprint': 'Print again',
    'oc.void': 'Void',
    'oc.voidTitle': 'Void check {n}',
    'oc.voidReason': 'What happened to it',
    'oc.voidReasonPh': 'Jammed, printed crooked, wrong amount…',
    'oc.newCheckNumber': 'New check number',
    'oc.newCheckNumberHelp': 'Leave it empty to void without reprinting. The old number is never reused.',
    'oc.voidAndReprint': 'Void and reprint',
    'oc.editPayee': 'Change the name on the check',
    'oc.payeeWas': 'The card says: {n}',
    'oc.uploadCheck': 'Upload check',
    'oc.scanReplace': 'Replace the uploaded check',
    'oc.trackingFile': 'Shipment receipt',
    'oc.trackingDrop': 'Drop the shipment receipt (PDF or photo)',
    'oc.trackingReplace': 'Replace the shipment receipt',
    'oc.copyTracking': 'Copy the tracking number',
    'oc.printedAndUploaded': 'Printed, and the printed check is on file',
    'oc.willTake': 'takes #{n}',
    'oc.willTakeHelp': 'The number it takes if the checks are printed in this order. Not reserved: the number is used when the paper goes through the printer.',
    'oc.nextInBook': 'Next in the book: #{n} (last used #{last}).',
    'oc.useAnotherNumber': 'Use a different number',
    'oc.numberReasonPh': 'Why not the next one? (jammed sheet, new book…)',
    'oc.numberReasonAsk': 'Why is the check number changing?',
    'oc.err.check_number_out_of_sequence': 'That is not the next check in the book. Say why you are skipping it.',
    'oc.err.number_reason_required': 'Say why the check number is changing.',
    'oc.signature': 'Signature',
    'oc.noSignature': 'No signature (sign by hand)',
    'oc.signatureHelp': 'Only people on the bank signature card appear here. Whoever prints the check can use theirs.',
    'oc.checkNumberRequired': 'Type the number printed on the check.',
    'oc.err.not_a_check_signer': 'That person is not an authorized signer on the bank account.',
    'oc.err.signer_without_signature': 'That signer has not drawn their signature yet.',
    'oc.panelGenerated': 'Check generated',
    'oc.panelPrinted': 'Check printed',
    'oc.viewCheck': 'View check',
    'oc.viewOnlyPrinted': 'Print the check first.',
    'oc.fixNumber': 'Fix the check number',
    'oc.scanTitle': 'The printed check',
    'oc.scanHelp': 'Drop a photo or a scan of the check that came out of the printer. It is read and cross-checked against the amount, the payee and the check number on file.',
    'oc.scanDrop': 'Drop the printed check here',
    'oc.scanReading': 'Reading the check…',
    'oc.scan.match': 'The printed check matches the record.',
    'oc.scan.mismatch': 'The printed check does NOT match:',
    'oc.scan.unreadable': 'The check could not be read. Try a sharper photo.',
    'oc.scanField.amount': 'Amount',
    'oc.scanField.payee': 'Payable to',
    'oc.scanField.check_number': 'Check number',
    'oc.scanExpected': 'on file {a}, on paper {b}',
    'oc.tracking': 'Tracking number',
    'oc.trackingPh': 'If it was mailed',
    'oc.err.no_print_permission': 'Checks are printed by people who can make payments, or by a super-manager in Payments.',
    'oc.err.check_not_printed': 'Print the check before uploading the scan.',
    'oc.pendingContractor': 'authorized to the contractor — this check pays it',
    'oc.pendingHomeowner': 'authorized to the homeowner — this check pays it',
    'oc.err.pending_payment_other_payee': 'That invoice has a payment authorized to the other party. Pay that one, or void it first.',
    'oc.contractorNameFixed': "From the contractor's file",
    'oc.colMilestones': 'Bank · Mail',
    'oc.selectAll': 'Select every printed check',
    'oc.selectOne': 'Select check {n}',
    'oc.bulkSelected': '{n} checks selected',
    'oc.bulkClear': 'Clear',
    'oc.bank': 'In bank',
    'oc.mailed': 'Mailed',
    'oc.bankPending': 'Not in bank',
    'oc.mailedPending': 'Not mailed',
    'oc.markBank': 'Entered in the bank',
    'oc.markMailed': 'Mark as mailed',
    'oc.markBankHelp': 'Entered in the bank so it will be paid (positive pay). Click to mark.',
    'oc.markMailedHelp': 'Mailed to the payee. Click to mark — it is posted to the claim.',
    'oc.bankDoneBy': 'Entered in the bank by {who} on {at}',
    'oc.mailedDoneBy': 'Mailed by {who} on {at}',
    'oc.mailedWithoutBankWarn': '{n} of those checks went out without being entered in the bank: the bank will refuse them. Enter them now.',
    'oc.err.no_checks': 'Pick at least one check.',
    'oc.err.invalid_milestone': 'That is not a check milestone.',
    'oc.err.payee_changed': 'Someone changed who this check is payable to. Look at it again before printing.',
    'oc.err.not_found': 'That check no longer exists.',
    'oc.err.contractor_name_locked': "A contractor's name comes from their file. Fix it there, or pay the homeowner instead.",
    'oc.err.payee_type_fixed': 'This check is not for a claim: it is payable to whoever was typed.',
    'oc.err.check_voided': 'This check is voided.',
    'oc.err.check_not_found': 'That check no longer exists.',
    'oc.err.payee_type_required': 'Say whether this is paid to the contractor or the homeowner.',
    'prof.sig.title': 'My signature',
    'prof.sig.help': 'Draw it with your finger. It is printed on a check only when you turn on "Print my signature".',
    'prof.sig.none': 'No signature saved yet.',
    'prof.sig.draw': 'Draw my signature',
    'prof.sig.redo': 'Draw it again',
    'prof.sig.clear': 'Clear',
    'prof.sig.fit': 'Sign inside the box: anything drawn past the edge is cut off and cannot be recovered.',
    'prof.sig.empty': 'Draw something first.',
    'prof.sig.confirmRemove': 'Remove your saved signature?',
    'nav.acv': 'ACV Check',
    'nav.depreciation': 'Depreciation Check',
    'nav.approvedRepair': 'Approved for Repair', 'nav.supplementCheck': 'Waiting Supplement Check',
    'nav.payTo': 'To Pay',
    'nav.readyToPay': 'Ready to Pay',
    'nav.homeownerCheck': 'Homeowner with check',
    'nav.contractorCheck': 'Contractor with check',
    'nav.bounced': 'Bounced Checks',
    'nav.payQueue': 'Pay Queue',
    'nav.requestAuth': 'Request Payment Authorization',
    'nav.owedToUs': 'Owed to us',
    'owed.title': 'Owed to us',
    'owed.help': 'Claims with a negative payout, or where the homeowner/contractor holds the check — we pay no one; they owe us the fee.',
    'owed.empty': 'Nothing owed to us right now.',
    'owed.amount': 'Owed',
    'owed.actions': 'Decide',
    'owed.looksLast': 'Looks like the last check — charge the homeowner',
    'owed.waitDep': 'Wait depreciation',
    'owed.chargeHo': 'Charge homeowner',
    'rpa.title': 'Request Payment Authorization',
    'rpa.help': 'Clients with a contractor that still need the homeowner authorization to pay the contractor. Get it early — even before the invoice.',
    'rpa.empty': 'Nothing pending — no authorization requests open.',
    'rpa.request': 'Request',
    'rpa.open': 'Open',
    'rpa.upload': 'Upload authorization',
    'rpa.uploaded': '✓ File uploaded. Now mark Authorized or Denied.',
    'rpa.uploadFailed': 'Could not upload “{name}” ({mb} MB).',
    'rpa.savedAuth': '✓ Authorization saved.',
    'rpa.savedDenied': '✓ Denial recorded.',
    'rpa.cantOpenCheck': 'Could not open the check.',
    'rpa.proofUnavailable': 'Uploaded, but the preview could not be opened.',
    'rpa.viewFile': 'Open file',
    'rpa.uploadFirst': 'Upload the file first.',
    'rpa.uploadCol': 'Upload here',
    'rpa.viewCheck': 'View check',
    'rpa.viewInvoice': 'View invoice',
    'rpa.deny': 'Homeowner denied — upload proof',
    'rpa.authorized': '✓ Authorized',
    'rpa.denied': '✕ Denied',
    'rpa.cancelRequest': 'Cancel request',
    'rpa.cancelConfirm': 'Cancel this authorization request? It leaves this queue.',
    'rpa.cancelled': '✓ Request cancelled.',
    'rpa.daysWaitingHelp': 'Days this authorization has been requested and pending.', 'rpa.onHold': 'Payment on hold',
    'rpa.updates': 'Board updates (Monday)',
    'rpa.noUpdates': 'No updates yet.',
    'rpa.coPhone': 'Contractor phone', 'rpa.owner': 'Claim owner',
    'rpa.updatePh': 'Write an update about this authorization…',
    'rpa.postUpdate': 'Post',
    'queue.empty': 'No claims in this queue right now.',
    'q.insurance': 'Insurance',
    'ins.noInfo': 'No saved info for this insurer yet.',
    'ins.openPortal': 'Open website',
    'ins.depDays': 'Max days depreciation recovered',
    'ins.days': 'days',
    'ins.importMonday': 'Import from Monday',
    'ins.importConfirm': 'This replaces the entire insurance list with the data from the Monday board. Continue?',
    'ins.imported': 'Imported {n} insurance companies from Monday.',
    'ins.allFields': 'All fields (from Monday)',
    'adj.title': 'Adjuster info',
    'adj.ph': 'Insurance adjuster name, phone, notes…',
    'adj.empty': 'No adjusters yet.',
    'adj.add': 'Add adjuster',
    'adj.fa': 'Field Adjuster (FA)',
    'adj.da': 'Desk Adjuster (DA)',
    'adj.manager': 'Manager',
    'adj.other': 'Other',
    'adj.otherPh': 'Title (e.g. Estimator)',
    'adj.namePh': 'Name',
    'adj.emailPh': 'Email',
    'adj.phonePh': 'Phone',
    'adj.del': 'Remove',
    'adj.delConfirm': 'Remove this adjuster?',
    'adj.newest': 'newest', 'adj.previous': 'Previous', 'adj.old': 'old',
    'adj.import': 'Import adjuster info from Monday',
    'adj.imported': 'Updated adjuster info on {n} claims.',
    'adj.changedOn': 'changed {d}',
    'adj.history': 'previous versions ({n})',
    'log.button': 'Activity Log',
    'log.title': 'Activity Log — activity on this claim',
    'log.empty': 'No activity recorded yet.',
    'log.system': 'System',
    'con.importMonday': 'Import from Monday',
    'con.noInfo': 'No saved info for this contractor yet.',
    'con.importConfirm': 'This imports/updates all contractors from the Monday board (by name). Continue?',
    'con.imported': 'Imported/updated {n} contractors from Monday.',
    'q.days': 'Days',
    'scope.assigned': 'Assigned',
    'scope.viewMember': 'View member',
    'scope.claimTeam': 'Claim team',
    'req.title': 'Request a visit',
    'req.sendHint': 'Send a copy to Scheduling → Waiting to Schedule',
    'req.sent': 'sent to Waiting to Schedule',
    'req.inspection': 'Inspection',
    'req.atrAdjuster': 'ATR with adjuster', 'req.atr': 'ATR', 'req.atrOnSite': 'ATR on site',
    'req.photos': 'Photos only',
    'req.reinspection': 'Reinspection',
    'req.checkPickup': 'Check pickup',
    'req.materialSample': 'Material sample',
    'req.reschedule': 'Reschedule',
    'req.atrHint': 'Add notes and photos/files so Scheduling has what they need. Your notes become the inspector notes shown in the inspector app.',
    'req.visitHint': 'Add notes and photos/files for the {type} so Scheduling has what they need. Your notes become the inspector notes shown in the inspector app.',
    'req.sendVisit': 'Send {type} request',
    'req.atrNotesPh': 'Notes for the inspector (what to do, what to grab, where to leave the shingle…)',
    'req.atrFiles': 'Drag & drop photos / files',
    'req.atrSend': 'Send ATR request',
    'wtc.title': 'Waiting to clear',
    'wtc.bank': 'Bank',
    'wtc.days': 'Days',
    'wtc.available': 'Available in bank',
    'wtc.empty': 'No deposited checks waiting to clear.',
    'rtp.title': 'Ready to pay',
    'rtp.waitingHelp': 'Authorized payments waiting for the check to clear. When the check is marked available in bank, they move to the Pay Queue automatically.',
    'rtp.waitingClear': 'Waiting check to clear',
    'held.homeownerTitle': 'Homeowner with check',
    'held.contractorTitle': 'Contractor with check',
    'held.help': 'Checks held by the homeowner/contractor (manual control). You can still invoice from the claim — we just record where the check is.',
    'held.empty': 'No checks here.',
    'held.markDeposited': 'Mark deposited',
    'hold.title': 'Where is the check? (manual)',
    'hold.daysHeld': 'Days the check has been in this hand',
    'hold.none': '— where is it?',
    'hold.homeownerHas': 'Homeowner has the check',
    'hold.depositedOurs': 'Deposited in our bank',
    'hold.contractorHas': 'Contractor has the check',
    'hold.contractorDep': 'Contractor deposited it',
    'hold.homeownerDep': 'Homeowner deposited it',
    'rtp.invoices': 'Invoices',
    'rtp.payTo': 'Pay to',
    'rtp.payHO': 'Pay HO',
    'rtp.payCO': 'Pay contractor',
    'rtp.needInvoice': 'Create an invoice first',
    'rtp.authorized': '✓ Payment authorized (now in Pay Queue)',
    'rtp.reviewInvoice': 'Review invoice first',
    'rtp.empty': 'No checks ready to pay.',
    'rtp.confCheck': 'Check available',
    'rtp.confAuth': 'HO authorization',
    'rtp.goPay': 'Pay now →',
    'rtp.tabWaiting': 'Waiting',
    'rtp.tabDenied': 'Denied auth',
    'hold.tab': 'Hold payments',
    'hold.action': 'Hold',
    'hold.release': 'Release hold',
    'hold.badge': 'Payment held',
    'hold.note': 'Reason',
    'hold.help': 'Payments held — waiting for something special before paying. They stay in Ready to Pay, highlighted.',
    'hold.empty': 'No payments on hold.',
    'hold.askNote': 'Why is this payment on hold? (reason)',
    'hold.set': '✓ Payment placed on hold.',
    'hold.cleared': '✓ Hold released.',
    'hold.holdedTag': 'PAYMENT HOLDED',
    'hold.onClaim': 'Hold payment',
    'hold.heldBy': 'Held by',
    'hold.proofHelp': 'This payment is on hold — upload the proof required to release it.',
    'hold.tabHolded': 'Holded',
    'rtp.deniedHelp': 'The homeowner denied paying the contractor. Pay the homeowner instead.',
    'rtp.deniedEmpty': 'No denied authorizations.',
    'rtp.payHo': 'Pay',
    'bnc.title': 'Bounced checks',
    'bnc.empty': 'No bounced checks.',
    'bnc.reissue': 'Request reissue',
    'bnc.reissued': '✓ Reissue requested — day counter restarted',
    'chk.amountEditHelp': 'Click to correct the amount the AI read',
    'chk.amountHasPayments': 'this check already has a payment behind it — reverse the payment first',
    'chk.title': 'Checks received',
    'chk.searchPh': 'Search a claim (claim # or homeowner)…',
    'chk.open': 'Open claim',
    'chk.changeClaim': 'Change claim',
    'chk.drop': 'Drag the scanned check here or click to upload',
    'chk.dropAny': 'Drag a scanned check here — AI will find the client',
    'chk.dropMany': 'Drag one or many scanned checks — AI reads each and finds the client',
    'chk.processing': 'Reading check',
    'chk.bulkDone': 'Done',
    'chk.bulkUnmatched': 'could not be matched (scan them one by one)',
    'chk.bulkToComplete': 'to complete by hand (filling them in now)',
    'chk.queueRemaining': 'left in queue',
    'chk.skipNext': 'Skip this one',
    'chk.cancelAll': 'Cancel all',
    'chk.selectClient': 'Select the client this check belongs to:',
    'chk.noMatch': 'No automatic match — search the client below.',
    'chk.attached': '✓ Check saved on',
    'chk.reading': 'Reading the check with AI…',
    'chk.scanned': '✓ Check read & saved',
    'chk.scannedNoAi': "AI couldn't read it — enter the data by hand and pick the client.",
    'chk.manualNeeded': "The AI couldn't read this check. Fill in the data by hand.",
    'chk.uploadError': 'Could not upload the file. Try again.',
    'chk.checkNo': 'Check #', 'chk.type': 'Type', 'chk.typeNone': '— type', 'chk.typeAcv': 'ACV', 'chk.typeRepairs': 'Repairs', 'chk.typeSupplements': 'Supplements', 'chk.typeDepreciation': 'Depreciation', 'chk.typeBc': 'BC upgrades',
    'chk.scanDrop': 'Drag a check here — AI reads it', 'chk.scanHint': 'Reads amount, check #, payable to and type. Then set deposited / available in bank / status on the row.',
    'chk.dupHistorical': 'Same amount as a historical check on this claim — if it is the same one, delete this row and attach the photo to the historical one, or the money counts twice.',
    'chk.attachPhoto': 'Attach photo',
    'chk.payableTo': 'Payable to',
    'chk.onClaim': 'Checks on this claim',
    'chk.noChecks': 'No checks yet on this claim.',
    'chk.viewPhoto': 'View photo',
    'chk.hidePhoto': 'Hide photo',
    'chk.editAmount': 'Click to correct the amount (OCR misreads happen)',
    'chk.toDeposit': 'Checks arrived',
    'chk.toDepositHelp': 'Checks that arrived on the selected day. Pick the bank, send to mortgage, or delete a wrong upload.',
    'chk.doNotDeposit': 'DO NOT DEPOSIT — flagged on the claim',
    'chk.doNotDepositConfirm': 'This claim is flagged "do not deposit". Are you sure you want to deposit this check anyway?',
    'chk.needsMortgage': 'Needs mortgage endorsement',
    'chk.inMortgage': 'In mortgage flow',
    'chk.arrivedOn': 'Arrived on',
    'chk.today': 'Today',
    'chk.noArrivals': 'No checks arrived on this day.',
    'chk.noSearchMatch': 'No checks match your search.',
    'chk.dup': 'Duplicate check # on this claim',
    'chk.dupExact': 'Duplicate check # AND amount — likely cancelled, do not deposit',
    'chk.viewOther': 'View other',
    'chk.payeeMismatch': 'Payable-to differs from homeowner',
    'chk.delete': 'Delete',
    'chk.confirmDelete': 'Delete this check? (only for a wrong upload)',
    'chk.uploadedBy': 'Uploaded by',
    'chk.reassign': 'Wrong client?',
    'chk.reassignTo': 'Search the real client to reassign this check:',
    'nav.waitingClear': 'Waiting to Clear',
    'nav.mortgage': 'Mortgage',
    'nav.claims': 'Claims',
    'nav.archive': 'Archive',
    'archive.help': 'Finished claims (Cancelled, Denied, Finalized, Completed) or archived by hand. They leave the active lists.',
    'archive.empty': 'No archived claims.',
    'archive.archivedOn': 'Archived on',
    'archive.archivedTag': 'Archived',
    'archive.archive': 'Archive',
    'archive.unarchive': 'Unarchive',
    'archive.confirm': 'Archive this claim? It leaves the active lists.',
    'archive.request': 'Request archive',
    'archive.requestConfirm': 'Send an archive request to a super-manager?',
    'archive.reasonPrompt': 'Why should this claim be archived? (the super-manager sees this note)',
    'archive.requested': 'Archive requested',
    'nav.reports': 'Reports',
    'nav.emailHealth': 'Email Health',
    'nav.systemHealth': 'System Health', 'sys.title': 'System Health', 'sys.live': 'live (5s)', 'sys.window': 'window', 'sys.p50': 'Latency p50', 'sys.p95': 'Latency p95', 'sys.p99': 'Latency p99', 'sys.reqMin': 'Req / min', 'sys.inWindow': 'in window', 'sys.errorRate': 'Error rate', 'sys.pool': 'DB pool', 'sys.waiting': 'waiting', 'sys.poolWarn': 'Requests are WAITING for a DB connection — the pool is saturated (raise DB_POOL_MAX or reduce slow queries).', 'sys.slowestRoutes': 'Slowest endpoints (by p95)', 'sys.route': 'Endpoint', 'sys.count': 'Count', 'sys.noData': 'No traffic yet in this window.', 'sys.recentSlow': 'Recent slow requests (>500ms)', 'sys.noSlow': 'No slow requests — nice.', 'sys.slowQueries': 'Slow DB queries (>200ms)', 'sys.noSlowQ': 'No slow queries — nice.',
    'eh.title': 'Email Health',
    'eh.subtitle': 'Deliverability of outgoing mail: delivered, bounced and spam-complaint rates. Keep bounces under 4% and complaints under 0.1% to stay out of spam.',
    'eh.deliveredRate': 'Delivered',
    'eh.deliveredHint': 'of mail that got a verdict',
    'eh.bounceRate': 'Bounce rate',
    'eh.bounceHint': 'keep under 4%',
    'eh.complaintRate': 'Complaint rate',
    'eh.complaintHint': 'keep under 0.1%',
    'eh.suppressed': 'Suppressed',
    'eh.suppressedHint': 'addresses we will not email',
    'eh.breakdown': 'Outbound breakdown',
    'eh.sent': 'sent',
    'eh.received': 'received',
    'eh.noData': 'No email sent in this window yet.',
    'eh.byDept': 'By department',
    'eh.department': 'Department',
    'eh.general': 'General',
    'eh.suppressionList': 'Suppression list',
    'eh.suppressionExplain': 'These addresses hard-bounced or marked us as spam. We never email them again (protects your domain reputation). Reactivate only if you are sure the address is valid.',
    'eh.noSuppressions': 'No suppressed addresses.',
    'eh.reactivate': 'Reactivate',
    'eh.confirmUnsuppress': 'Reactivate this address? We will be able to email it again.',
    'eh.reasonComplaint': 'SPAM',
    'eh.reasonBounce': 'BOUNCED',
    'eh.st.sent': 'Sent',
    'eh.st.delivered': 'Delivered',
    'eh.st.opened': 'Opened',
    'eh.st.clicked': 'Clicked',
    'eh.st.delayed': 'Delayed',
    'eh.st.bounced': 'Bounced',
    'eh.st.complained': 'Spam complaint',
    'eh.st.failed': 'Failed',
    'eh.st.suppressed': 'Suppressed',
    'nav.settings': 'Settings',
    'kpi.tab': 'KPI',
    'kpi.title': 'KPI',
    'kpi.today': 'Today',
    'kpi.goalsMet': 'Goals met',
    'kpi.callsOut': 'Outbound calls',
    'kpi.callsIn': 'Inbound calls',
    'kpi.emails': 'Emails sent',
    'kpi.notes': 'Notes in the CRM',
    'kpi.short.callsOut': 'Calls out',
    'kpi.short.callsIn': 'Calls in',
    'kpi.short.emails': 'Emails',
    'kpi.short.notes': 'Notes',
    'kpi.tipWithGoal': '{label} today: {n} of {goal}',
    'kpi.tip': '{label} today: {n}',
    'kpi.tipExternalOnly': 'only calls with people outside the company; calls between coworkers do not count',
    'kpi.period': 'Period',
    'kpi.p.today': 'Today',
    'kpi.p.yesterday': 'Yesterday',
    'kpi.p.week': 'This week',
    'kpi.p.last_week': 'Last week',
    'kpi.p.month': 'This month',
    'kpi.p.last_month': 'Last month',
    'kpi.p.custom': 'Custom',
    'kpi.from': 'From',
    'kpi.to': 'To',
    'kpi.department': 'Department',
    'kpi.allDepartments': 'All departments',
    'kpi.targets': 'Targets',
    'kpi.targetsTitle': 'Daily targets',
    'kpi.targetsHint': 'Per person, per working day. Leave it empty for no target.',
    'kpi.noTarget': 'No target',
    'kpi.perDay': 'per day',
    'kpi.badTarget': 'Targets are whole numbers from 0 to 1000.',
    'kpi.saveFailed': 'Could not save the targets.',
    'kpi.badRange': 'That date range is not valid (up to 92 days).',
    'kpi.peopleAtGoal': '{a} of {b} people at the goal of {goal}',
    'kpi.daysAtGoal': '{pct}% of worked days reached {goal}',
    'kpi.avgPerDay': '{n} per person per working day',
    'kpi.noAnswer': '{n} not answered',
    'kpi.talkTotal': '{t} on the phone',
    'kpi.person': 'Employee',
    'kpi.talk': 'Talk',
    'kpi.daily': 'Day by day · {label}',
    'kpi.empty': 'Nobody in this filter.',
    'kpi.noActivity': 'no activity',
    'kpi.daysWorked': '{n} days worked',
    'kpi.daysAtGoalTip': 'Reached {goal} on {a} of {b} worked days',
    'kpi.toGo': '{n} to go',
    'kpi.footnote': 'Calls count only with people outside the company: a call between two coworkers (extension to extension) does not count. Outbound calls count every call that rang on the other side, answered or not (the unanswered ones are shown apart); a call where your own phone did not connect (desk phone offline) does not count. Inbound calls count when answered, also the ones that come through the main menu and the queues. Calls show up a few minutes after they end. Emails are the ones sent from the CRM (claim thread or personal mailbox). Notes are the messages written in the claim chats. Each day is the person’s own workday in their time zone. A worked day is a day with a clock-in or with any of these.',
    'nav.logout': 'Sign out',
    'topbar.waitingClear': 'Waiting Check to Clear',

    'reset.title': 'Set a new password', 'reset.newPw': 'New password', 'reset.confirmPw': 'Confirm password', 'reset.setPw': 'Set password',
    'reset.min8': 'At least 8 characters.', 'reset.mismatch': 'Passwords do not match.', 'reset.error': 'Could not reset. Try again.',
    'reset.expired': 'This link expired or was already used.', 'reset.invalidTitle': 'Link not valid', 'reset.invalidSub': 'This reset link is invalid, expired or already used. Ask an admin to send a new one.',
    'reset.doneTitle': 'Password updated', 'reset.doneSub': 'You can now sign in with your new password.', 'reset.backLogin': '← Back to sign in',
    'auth.signin': 'Sign in',
    'auth.signinSub': "Sign in to your company's workspace.",
    'mnav.inbox': 'Inbox',
    'mnav.panel': 'Dashboard',
    'mnav.alerts': 'Alerts',
    'mnav.menu': 'Menu',
    // Hub de Inbox móvil (/inbox): tabs + títulos de sección.
    'mhub.title': 'Inbox',
    'mhub.all': 'All',
    'mhub.email': 'Email',
    'mhub.sms': 'SMS',
    'mhub.chat': 'Chat',
    'mhub.messages': 'Messages',
    'mhub.myMailboxes': 'My mailboxes',
    'mhub.more': 'More',
    'auth.brandTitle': 'The claim, from intake to check.',
    'auth.brandSub': "Proactive's internal CRM — intake, e-sign, scheduling, claims, supplements, payments and COC, all in one place.",
    'auth.company': 'Company', 'auth.pickCompany': 'Your email exists in more than one company — pick the one you are signing in to.',
    'auth.email': 'Email',
    'auth.password': 'Password',
    'auth.enter': 'Enter',
    'auth.platformQ': 'Are you the platform-owner?',
    'auth.platformTitle': 'Platform-owner',
    'auth.platformSub': 'Platform tenant management.',
    'auth.platformConsole': 'Platform Console',
    'auth.invalidCreds': 'Invalid credentials',
    'auth.error': 'Sign-in error',
    'auth.throttled': 'Too many attempts. Please wait a few minutes and try again.',
    'auth.locked': 'Account locked after too many failed attempts. Try again in about {mins} min or contact your office.',
    'auth.mfaTitle': 'Two-factor verification',
    'auth.mfaSub': 'Enter the 6-digit code from your authenticator app (or a backup code).',
    'auth.mfaCode': 'Verification code',
    'auth.mfaVerify': 'Verify',
    'auth.mfaBack': '← Back to sign in',
    'auth.mfaInvalid': 'Invalid code. Try again.',
    'auth.mfaExpired': 'Session expired. Please sign in again.',
    'theme.toDark': 'Switch to dark mode',
    'theme.toLight': 'Switch to light mode',
    'pres.myStatus': 'My status',
    'pres.dotActive': 'Available', 'pres.dotOnCall': 'On a call', 'pres.dotBusy': 'Busy',
    'pres.dotDnd': 'Do not disturb', 'pres.dotOffline': 'Offline',
    'pres.available': 'Available',
    'pres.busy': 'Busy',
    'pres.dnd': 'Do not disturb',
    'pres.syncsToPhone': 'Also changes on your RingCentral phone',

    'dash.feeOwed': 'Fee Owed',
    'em.st_suppressed': 'NOT SENT — address suppressed', 'em.st_bounced': 'BOUNCED', 'em.st_failed': 'SEND FAILED', 'em.st_complained': 'MARKED AS SPAM by the recipient', 'pq.why_waiting_ho_auth': 'waiting homeowner authorization', 'pq.why_check_not_cleared': 'the check has not cleared the bank yet', 'pq.why_check_bounced': 'the check BOUNCED', 'pq.whyNoAction': 'nothing to unblock here — the bypass does not apply', 'sup.overdue': 'Overdue', 'ec.title': 'Approved — check not received yet', 'ec.only30': 'Only 30+ days', 'ec.all': 'Show all', 'ec.fromSupplement': 'from an approved supplement', 'dash.feeSince': 'since {d}', 'dash.feeOwedSub': 'Billed — invoices issued',
    'dash.feeCollected': 'Fee Collected',
    'dash.feeCollectedSub': 'Collected — checks cleared',
    'dash.gap': 'Gap',
    'dash.gapSub': 'Owed − Collected',
    'dash.waiting': 'Checks waiting',
    'dash.legendAck': 'sent ack ≤{a}d',
    'dash.legendTransit': 'in transit ≤{b}d',
    'dash.legendOverdue': 'overdue',
    'dash.noWaiting': 'No checks waiting.',
    'dash.sent': 'sent',
    'dash.noAck': 'no ack',
    'dash.homeowners': 'Homeowners holding a check',
    'dash.waitingClear': 'Checks waiting to clear',
    'dash.ctWaiting': 'Waiting (no sent date)',
    'dash.ctSent': 'Sent — days since',
    'dash.ctWithCheck': 'Homeowner / contractor with check (days)',
    'dash.ctOwed': 'Owed to us (max 7 days)',
    'dash.ctEmployees': 'Check dates by employee',
    'dash.ctEmployeesHelp': 'Who got the most check dates that month.',
    'dash.checkAlerts': 'Check alerts',
    'dash.alertNoDate': '{d}d without a send date — call the insurance',
    'dash.alertNotArrived': 'sent {d}d ago and not arrived — call the insurance',
    'dash.cocNotSent': 'COC not sent — clock not running',
    'dash.depClockNote': 'The clock starts when the COC is sent.',
    'dash.supClockNote': 'The clock starts at Supplement Resolved.',
    'dash.gotDate': 'date in {n}d',
    'dash.peekGone': 'This claim is no longer in this queue.',
    // Bank info del homeowner (Payments)
    'hob.title': 'Homeowner bank information',
    'hob.help': 'Where to deposit the homeowner’s money. Drop the check photo (voided check) and fill in the bank details.',
    'hob.bank': 'Bank name', 'hob.routing': 'Routing number', 'hob.account': 'Account number',
    'hob.drop': 'Drop the check photo here (or click)',
    'hob.view': 'View photo', 'hob.deleteConfirm': 'Delete this check photo?',
    'ft.ho_bank_check': 'HO bank check',
    'dash.filterOwner': 'Filter by assigned owner',
    'dash.allOwners': 'All owners',
    'dash.total': 'Total',
    'dash.markAvailable': 'Available',
    'dash.arrivedToday': 'Checks arrived today',

    'claims.new': 'New claim',
    'claims.createTitle': 'Create claim',
    'claims.num': 'Claim #',
    'claims.homeowner': 'Homeowner', 'claims.expandRow': 'Expand department view',
    'claims.inWelcomeCall': 'Welcome Call', 'claims.wcStuckHint': 'This claim is stuck in the Welcome Call queue — click × to bypass it without a recording.', 'claims.wcBypassConfirm': 'Bypass the Welcome Call for {name} without a recording?',
    'claims.rcv': 'RCV ($)',
    'claims.title': 'Claims',
    'claims.archivedTitle': 'Archived (Finalized)',
    'claims.searchPh': 'Search by claim # or homeowner…',
    'claims.showArchived': 'Show archived',
    // Selección múltiple + asignar equipo en bulk (2026-08-03).
    'claims.selectGroup': 'Select every claim in this group',
    'claims.nSelected': 'Selected: {n}',
    'claims.clearSel': 'Clear',
    'claims.assignTeamTo': 'Assign claim team',
    'claims.pickTeam': 'Pick a team',
    'claims.assignBulk': 'Assign to all selected',
    'claims.bulkClaimTeam': 'the claim team — the team that owns the claim; Payments and Supplements follow it (Scheduling does not)',
    'claims.bulkConfirm': 'Assign {n} claim(s) to {team}?',
    'claims.bulkDone': '{n} claim(s) reassigned. {same} already had that team.',
    'claims.hideClosed': 'Hide closed',
    // Board de Claims: barra de herramientas y panel de filtros (vivían en español/inglés fijo).
    'claims.newClient': 'New client',
    'claims.filter': 'Filter',
    'claims.sort': 'Sort',
    'claims.sortDir': 'Direction',
    'claims.groupStatus': 'Group: Status',
    'claims.claimsWord': 'claims',
    'claims.ofTotal': 'of {n}',
    'claims.groupedByStatus': 'grouped by status',
    'claims.allContractors': 'Contractor (all)',
    'claims.allInsurance': 'Insurance (all)',
    'claims.allStatus': 'Claim status (all)',
    'claims.supNotSubmitted': 'Not submitted yet',
    'claims.supNotSubmittedHint': 'the carrier estimate is in; our supplement has not been sent since',
    'claims.supSubmitted': 'Supplement submitted',
    'claims.supSecond': 'Second attempt',
    'claims.supThird': 'Third attempt',
    'claims.supNth': 'Attempt #{n}',
    'claims.supCarrierReplied': 'Carrier replied · review pending',
    'claims.supCounterReady': 'Counter offer ready · not sent',
    'claims.supLastSent': 'Last sent to the carrier on {d}',
    'claims.lorSubmitted': 'LOR submitted',
    'claims.lorNotSubmitted': 'LOR not submitted',
    'claims.lorNotSubmittedHint': 'the letter of representation has not been sent to the carrier',
    'claims.lorSentOn': 'LOR sent on {d}',
    'claims.mitToEstimate': 'To estimate',
    'claims.mitToEstimateHint': 'a service is flagged as needing a mitigation estimate',
    'claims.mitNotSent': 'Estimate done · not sent',
    'claims.mitNotSentHint': 'the mitigation estimate is in Files but no email went to the carrier',
    'claims.mitEstimateSent': 'Estimate sent',
    'claims.mitAttempt': 'Attempt #{n} · estimate {n} sent',
    'claims.mitFollowUps': '{n} follow-up(s) in this attempt',
    'claims.collapseAll': 'Collapse all',
    'claims.expandAll': 'Expand all',
    // Settings → General: Google Maps.
    'set.mapsNoKey': 'There is no GOOGLE_MAPS_API_KEY on the Railway backend.',
    'set.mapsStreetView': 'Street View (photos)',
    'set.mapsStatic': 'Static Maps (satellite)',
    'set.mapsSolar': 'Solar (roof)',
    'set.mapsHint': 'If "Street View" or "Static Maps" fail with REQUEST_DENIED, those APIs have to be enabled for this key\u2019s project in the Google Console.',
    // Settings → General: herramientas de super-manager (duplicados / welcome call / teams).
    'tool.dup.title': 'Duplicate claims',
    'tool.dup.desc': 'Duplicates across the two boards (Claims + Payments). Merging keeps the Claims claim as the face (preselected) and absorbs the Payments one: it keeps its payment status (e.g. Waiting 1st Check) linked to the Claims homeowner, and its Payments board updates move to the Payment department updates. Reversible (archived, not deleted).',
    'tool.dup.scan': 'Find duplicates',
    'tool.dup.none': 'No duplicates',
    'tool.dup.groups': '{n} duplicate group(s)',
    'tool.dup.mergeAll': 'Merge ALL ({n}) — Claims as the face',
    'tool.dup.mergeOne': 'Merge into the selected one',
    'tool.dup.pickHint': 'Pick above which one stays.',
    'tool.dup.pickFirst': 'Choose which claim stays.',
    'tool.dup.confirmOne': 'Merge {n} claim(s) into the selected one. The rest get archived (reversible). Continue?',
    'tool.dup.confirmAll': 'Merge the {n} groups keeping the CLAIMS claim as the face (the Payments one is absorbed, keeping its payment status + updates in the Payment dept). Reversible. Continue?',
    'tool.dup.merged': 'Merged {ok} of {total} groups.',
    'tool.dup.created': 'created',
    'tool.wc.title': 'Seed Welcome Call (list of 28)',
    'tool.wc.desc': 'Matches by client name and puts them in Scheduling → “Welcome Call”. Run Diagnose first to see who matches; then Move.',
    'tool.wc.diagnose': 'Diagnose',
    'tool.wc.move': 'Move to Welcome Call',
    'tool.wc.sMoved': 'Moved/ok',
    'tool.wc.sAlready': 'Already there',
    'tool.wc.sAmbiguous': 'Ambiguous',
    'tool.wc.sMissing': 'Not found',
    'tool.wc.bMoved': 'moved',
    'tool.wc.bAlready': 'already there',
    'tool.wc.bAmbiguous': 'ambiguous',
    'tool.wc.bMissing': 'not found',
    'tool.wc.maybe': 'maybe?',
    'tool.wc.noSimilar': 'no similar names',
    'tool.tb.title': 'Assign teams (Claims/Payments)',
    'tool.tb.desc': 'Assigns teams to claims by matching the person name with an existing team (the ones that do not match are skipped — nothing is created). Run Preview first (touches no data), then Apply.',
    'tool.tb.step1': '— from the current assigned_person, without Monday (fast)',
    'tool.tb.step2': '— from the assigned_person (account manager), without Monday (fast)',
    'tool.tb.step3': 'Advanced: read the account manager from Monday (people1) — may take a while',
    'tool.tb.apply': 'Apply',
    'tool.tb.previewMonday': 'Preview (Monday)',
    'tool.tb.applyMonday': 'Apply (Monday)',
    'tool.tb.applied': 'Applied',
    'tool.tb.previewNoWrite': 'Preview (nothing was written)',
    'tool.tb.stTotal': 'Active claims',
    'tool.tb.stBoard': 'With a Monday item',
    'tool.tb.stAm': 'Account manager found',
    'tool.tb.stClaimTeam': 'Claim team matched',
    'tool.tb.stPayTeam': 'Payments team matched',
    'tool.tb.stWouldChange': 'assigned_person would change',
    'tool.tb.amUnmatched': 'AM with no existing Claim team (skipped — nothing is created)',
    'tool.tb.payUnmatched': 'Person with no existing Payments team (skipped — nothing is created)',
    'tool.tb.colAm': 'AM (Monday)',
    'tool.tb.colAssigned': 'Current assigned',
    'tool.tb.isNew': '(new)',
    'tool.tb.confirmPayments': 'Apply? It assigns the Payments team (from assigned_person) to the claims that match an EXISTING team. It creates no teams and does not touch the account manager.',
    'tool.tb.confirmClaims': 'Apply? It assigns the Claims team (from assigned_person) to the claims that match an EXISTING Claims team. It creates no teams.',
    'tool.tb.confirmFull': 'Apply? It reads Monday: sets the account manager + Claim team and the Payments team on the claims that match.',
    'tool.tb.errMonday': 'Error (is the Monday connection configured?)',
    'claims.showClosed': 'Show closed',
    'claims.showActive': 'Show active',
    'claims.empty': 'No claims yet.',
    // Claims board móvil (mockup B-mobile: buscador + chips + cards)
    'mclaims.search': 'Search claim, client, address…',
    'mclaims.stage': 'Stage', 'mclaims.stageAll': 'Stage: All', 'mclaims.allStages': 'All stages',
    'mclaims.mine': 'My claims', 'mclaims.person': 'Person',
    'mclaims.contractor': 'Contractor', 'mclaims.pickContractor': 'Pick a contractor…', 'mclaims.allContractors': 'All contractors',
    'mdash.morning': 'Good morning', 'mdash.afternoon': 'Good afternoon', 'mdash.evening': 'Good evening',
    'mdash.wtc': 'Waiting to clear',
    'mdash.chartTitle': 'Fees collected', 'mdash.chartSub': 'Last {n} months',
    'mdash.today': 'Today', 'mdash.checkArrived': 'Check arrived', 'mdash.inspection': 'Inspection',
    'mdash.checksToday': '{n} checks arrived today', 'mdash.check1Today': '1 check arrived today', 'mdash.checks0Today': 'no checks yet today',
        'mclaims.pickStage': 'Filter by stage…',
    'mclaims.pickPerson': "View someone's claims…",
    'claims.colStatus': 'Status',
    'claims.colClaimStatus': 'Claim status',
    'claims.colPayStatus': 'Payment status',
    'claims.colTeam': 'Assigned team',
    'claims.colClaimTeam': 'Claim team',
    'claims.colSuppTeam': 'Supplements team',
    'claims.colPayTeam': 'Payments team',
    'claims.colFeeMode': 'Fee mode',
    'claims.colRcv': 'RCV',
    'claims.statusNew': 'new',
    'cdw.team': 'Team',
    'cdw.files': 'Files',
    'cdw.messages': 'Messages',
    'cdw.client': 'Client',
    'cdw.contractor': 'Contractor',
    'cdw.pa': 'PA',
    'cdw.policyNumber': 'Policy #',
    'ct.ndaFrom': 'From (confidential agreement)', 'ct.ndaFromHint': 'Sender for the contractor agreement only. Leave empty to use the contracts address above.', 'ct.kindNda': 'Confidential agreement', 'ct.ndaHint': 'One global template — the contractor signs it from their own page. No state, no contractor.', 'cfp.title': 'Files from contractor', 'cfp.photoAlbum': 'Photo album', 'nda.title': 'Confidential agreement', 'nda.signed': 'Signed', 'nda.waiting': 'Waiting for signature', 'nda.draft': 'Ready to send', 'nda.never': 'Not sent yet', 'nda.sentAt': 'Sent', 'nda.openedAt': 'Opened', 'nda.signedAt': 'Signed', 'nda.send': 'Send agreement', 'nda.resend': 'Resend', 'nda.viewSigned': 'View signed', 'nda.viewPdf': 'View PDF', 'nda.copyLink': 'Copy signing link', 'nda.allSends': 'All {n} sends', 'nda.hint': 'Goes to the contact email on file for {name}. Upload the template in Contracts (kind: NDA).', 'cdw.policyType': 'Policy type', 'cdw.engagementType': 'Claim kind', 'cdw.claimType': 'Damage type', 'cty.roof': 'Roof', 'cty.water': 'Water', 'cty.fire': 'Fire', 'cty.vandalism': 'Vandalism', 'cty.mitigation': 'Mitigation', 'cty.fromMitigation': 'this claim has a mitigation estimate', 'engc.auto': 'nobody set it — New claim is the default', 'cty.fromName': 'guessed from the client name', 'cty.fromLoss': 'guessed from the type of loss', 'cty.fromDefault': 'default — nobody set it', 'cty.setManually': 'set by hand', 'cty.setBy': 'set by {who} on {when}', 'cty.clickToChange': 'Click to change it.', 'cdw.mortgageCompany': 'Mortgage company',
    'lang.unknown': 'Language?', 'lang.hint': 'Weekly updates, texts and the welcome call go out in this language.', 'lang.clickToChange': 'Click to change it.',
    'cdw.typeOfLoss': 'Type of loss',
    'cdw.dateOfLoss': 'Date of loss', 'cdw.inspectionDate': 'Inspection date',
    'cdw.photos': 'Photos',
    'cdw.pitch': 'Roof pitch',
    'cdw.squares': 'Squares',
    'cdw.lastFollowup': 'Last follow-up',
    'cdw.followupsByTeam': 'Follow-ups by team',
    'cdw.damage': 'Damage type',
    'cdw.deductible': 'Deductible',
    'cdw.fee': 'Fee %',
    'cdw.lastUpdate': 'Last update', 'cdw.nextUpdate': 'Next update', 'cdw.houseRoof': 'House & roof', 'cdw.viewPhotos': 'View photos',
    'docs.title': 'Documents Proactive needs', 'docs.pending': '{n} pending', 'docs.none': 'No documents pending right now.', 'docs.openUpload': 'Open the claim to upload',
    'cdw.rcvInitial': 'RCV (initial)',
    'cdw.rcvFinal': 'RCV (final)', 'cdw.suppIncrease': 'Supplements +',
    'cdw.tabChat': 'General chat', 'cdw.tabItem': 'Item card', 'cdw.tabFiles': 'Files', 'cdw.tabIntake': 'Intake', 'cdw.tabScheduling': 'Scheduling', 'cdw.tabPayments': 'Payments', 'hoc.tab': 'HO Communication', 'hoc.all': 'All', 'hoc.emails': 'Emails', 'hoc.sms': 'SMS', 'hoc.calls': 'Calls', 'hoc.received': 'Received', 'hoc.sent': 'Sent', 'hoc.homeowner': 'Homeowner', 'hoc.aiSummary': 'AI summary of the call', 'hoc.noRecording': 'No recording for this call.', 'hoc.empty': 'Nothing has been sent to this homeowner yet.', 'hoc.reachOut': 'Reach out to the homeowner', 'hoc.byEmail': 'Email', 'hoc.bySms': 'SMS', 'hoc.callNow': 'Call now', 'hoc.noPhone': 'No phone on file', 'hoc.smsPh': 'Write the text message…', 'hoc.smsSent': 'Text sent.', 'hoc.calling': 'Calling — pick up your phone.', 'cdw.tabEmails': 'Emails',
    // EL CUARTO CANAL: el Client Portal. El aviso que le llega al claim team cuando el asegurado
    // escribe apunta a esta pestaña, así que acá se ve su mensaje y acá se le contesta.
    'hoc.portal': 'Client Portal',
    'hoc.byPortal': 'Portal reply',
    'hoc.portalAyuda': 'The homeowner sees this the next time they open their portal. The email with the full reply goes out only if the portal is live for this claim.',
    'hoc.portalPh': 'Write the reply the homeowner will read in their portal…',
    'hoc.portalSend': 'Reply in the portal',
    'hoc.pr.sent': 'Reply saved and emailed to the homeowner.',
    // `skipped_dry_run` es UN código para CUATRO puertas cerradas (portal apagado en Settings, modo
    // prueba, modo piloto sin este claim en la lista, o el portal apagado para este claim). El nombre
    // del código viene del contrato y no se toca; el texto sí tiene que cubrir las cuatro, porque
    // decir "modo prueba" cuando en realidad le apagamos el portal A ESA PERSONA manda a la oficina a
    // buscar el problema al lugar equivocado.
    'hoc.pr.skipped_dry_run': 'Reply saved. The portal is not live for this claim (test mode, or switched off for them), so no email went out — tell them by phone or text if it is urgent.',
    'hoc.pr.suppressed': 'Reply saved. No email: that address bounced before and is blocked.',
    'hoc.pr.sin_email': 'Reply saved. No email: this claim has no homeowner email on file.',
    'hoc.pr.failed': 'Reply saved, but the email did not go out. Try reaching them another way.',
    'cdw.checksReceived': 'Checks received', 'cdw.deposited': 'Deposited', 'cdw.checkSentDates': 'Check sent dates', 'cdw.checkSentAt': 'Check sent', 'cdw.checkExpectedSince': 'Expecting a check since',
    'cdw.tabTasks': 'Tasks', 'cdw.openClaim': 'Open claim', 'cdw.newClaim': 'NEW CLAIM', 'cdw.existingClaim': 'EXISTING CLAIM',
    'cdw.tasksOpen': 'Open tasks', 'cdw.tasksDone': 'Done (history)', 'cdw.taskBy': 'by', 'cdw.goToView': 'Open this view', 'cdw.assignTaskTo': 'Assign a task to {team}',
    'cdw.teamAdd': 'Assign a team to this department', 'cdw.teamPick': 'Pick a team…',
    'cdw.teamRemove': 'Remove {team} from this department', 'cdw.teamRemoveConfirm': 'Remove {team} from this department on this claim?',
    'cdw.payStatusChip': 'Payment status (Payments queue by status)',
    'archive.archived': 'Archived', 'archive.unarchiveConfirm': 'Unarchive this claim?',
    'cdw.rcvLatest': 'RCV (latest)',
    'cdw.open': 'Open full claim',
    'cdw.close': 'Close',
    'cdw.none': 'None',
    'cdw.loading': 'Loading…',

    'cd.estimate': 'Insurance estimate (Claude parsing)',
    'fin.finalizeTitle': 'Finalize claim', 'fin.finalizeHelp': 'Last payment done? Close the claim.', 'fin.finalizeBtn': 'Finalize it', 'fin.finalizeConfirm': 'Finalize this claim? It moves to Finalized.',
    'fin.summaryTitle': 'Payment summary',
    'cd.reading': 'Reading with AI…',
    'cd.estRead': 'Read',
    'cd.estFailed': 'Failed to read',
    'cd.estimateDrop': 'Drag the estimate PDF here or click to upload',
    'cd.repairEstimate': 'Repair estimate',
    'cd.repairEstimateHelp': 'This estimate is for repairs: just save the estimate + the received check and move the claim to "Approved for repair" to wait for final approval. You will bill later with the next check.',
    'cd.repairEstimateDone': '✓ Moved to "Approved for repair"',
    'cd.byUser': 'by',
    'cd.bySystem': 'system',
    'claims.allStatuses': 'All',
    'claims.noClaimNum': 'No claim # yet',
    'claims.otherStatuses': 'Other',
    'cbsync.title': 'Claims board sync (Monday)',
    'cbsync.loadBoards': 'Load boards',
    'cbsync.pickBoard': 'Pick the Claims board',
    'cbsync.preview': 'Preview',
    'cbsync.import': 'Import lifecycle status',
    'cbsync.createMissing': 'Create claims not yet in the app',
    'cbsync.createMissingHelp': 'Claims on the board being worked (not yet in Payments). Creates them with what the board has (claim#, name, insurance, address, status).',
    'cbsync.wouldCreate': 'would be created',
    'cbsync.created': 'created',
    'cbsync.importFiles': 'Import subitem files',
    'cbsync.filesConfirm': 'Download all files from Monday subitems into Files? Runs on the server; may take a while.',
    'cbsync.filesDownloaded': '{n} files downloaded',
    'cbsync.filesHint': 'Pulls every file attached to the subitems of each active claim into Files. Resumable — safe to run again.',
    'cbsync.subscribe': 'Subscribe webhook (2-way)',
    'cbsync.subscribeHelp': 'Registers a Monday webhook on this board so status changes flow back into the app.',
    'cbsync.subscribed': 'Webhook subscribed — Monday → app is now live.',
    'cbsync.twoWayHint': 'Two-way sync: Import stores each claim\'s item id; Subscribe turns on Monday → app. App → Monday works after import.',
    'cbsync.matched': 'Matched by claim #',
    'cbsync.unmatched': 'Unmatched',
    'cbsync.totalItems': 'Items on board',
    'cbsync.chosenCol': 'Status column detected',
    'cbsync.updated': 'Claims updated',
    'cbsync.dryRun': 'Preview only — nothing written',
    'cbsync.applied': 'Imported',
    'cbsync.sampleUnmatched': 'Sample unmatched items',
    'cd.tabInfo': 'Summary',
    'cd.tabOverview': 'Overview',
    'cd.pickTab': 'Go to section',
    'cd.tabFinance': 'Finance',
    'cd.tabPayments': 'Payments',
    'cd.tabContractor': 'Contractor', 'cd.contractorHint': 'Updates for the contractor: everything you post with "Send to CO" plus the claim movement log. This board will connect with JobFlow.',
    'chat.sendToCo': 'Send + CO', 'chat.toDoNone': 'To Do board…', 'chat.toDoHint': 'Also add this note to a To Do board', 'chat.toDoTeams': 'Teams', 'chat.toDoDepts': 'Departments', 'chat.toDoFallbackTitle': 'Note on the claim', 'chat.sendToCoHint': 'Also copy this update to the Contractor board',
    'chat.sendHint': 'Internal note — does NOT count as follow-up',
    'chat.followUpBtn': 'Follow up', 'chat.followUpHint': 'Post the update AND count it as a follow-up (resets the clock)',
    'chat.followUpChip': 'Follow-up', 'chat.followUpChipHint': 'This update counted as a follow-up',
    'chat.coForward': 'Send to CO', 'chat.coForwarded': 'Sent to CO',
    'chat.deleteHint': 'Delete this message (if it was shared with the contractor, it is deleted in JobFlow too)',
    'chat.deleteConfirm': 'Delete this message? If it was shared with the contractor, it will be deleted in JobFlow too.',
    'chat.coForwardHint': 'Copy this update to the Contractor board keeping its original date/time',
    'chat.coForwardConfirm': 'Send this update to the Contractor board? The contractor (and JobFlow) will see it with its original date/time.',
    'cd.boardUpdates': 'Board Monday updates', 'cd.tabInfoPending': 'Info Pending',
    'cdw.tabSupplements': 'Supplements',
    'cdw.tabClaims': 'Claims', 'cd.claimsUpdates': 'Claims Department Updates',
    'cd.timelineAll': 'Claim timeline — inspections, supplements and payments',
    'cd.supplementsUpdates': 'Supplement Department Updates',
    'supTl.title': 'Estimate timeline',
    'supTl.subtitle': 'What happened with the estimate — who and when',
    'supTl.error': "Couldn't load the timeline.",
    'supTl.empty': 'Nothing here yet — steps show up as the estimate moves along.',
    'supCmp.first': 'First insurance estimate',
    'supCmp.last': 'Latest insurance estimate',
    'supCmp.gained': 'Gained via supplement', 'supCmp.resolvedIn': 'Resolved in', 'supCmp.resolvedInDays': '{n} days',
    'supCmp.lost': 'Went down',
    'insTl.title': 'Inspection timeline',
    'insTl.subtitle': 'The full story of the visits — who asked, who went, and when',
    'insTl.empty': 'No visits yet — requests and appointments show up here.',
    'insTl.arrived': 'Claim arrived',
    'insTl.filed': 'Claim filed with the insurance',
    'insTl.request.inspection': 'Inspection requested',
    'insTl.request.atr': 'ATR requested',
    'insTl.request.reinspection': 'Reinspection requested',
    'insTl.request.check_pickup': 'Check pickup requested',
    'insTl.request.material_sample': 'Material sample requested',
    'insTl.request.reschedule': 'Reschedule requested',
    'insTl.request.made': 'Visit requested',
    'insTl.appt.booked.inspection': 'Inspection scheduled',
    'insTl.appt.booked.atr': 'ATR scheduled',
    'insTl.appt.booked.adjuster_meeting': 'Reinspection scheduled',
    'insTl.appt.booked.check_pickup': 'Check pickup scheduled',
    'insTl.appt.booked.material_sample': 'Material sample scheduled',
    'insTl.appt.booked.repair_video': 'Repair video scheduled',
    'insTl.appt.booked.custom': 'Visit scheduled',
    'insTl.visit.completed': 'Visit completed',
    'insTl.visit.inProgress': 'Visit in progress',
    'insTl.visit.noShow': 'No-show reported',
    'insTl.resched.done': 'Rescheduled',
    'insTl.resched.fieldRequest': 'Reschedule requested from the field',
    'insTl.resched.reassigned': 'Inspector reassigned',
    'tl.dtlScheduledFor': 'Scheduled for',
    'tl.dtlInspector': 'Inspector',
    'tl.dtlAddress': 'Address',
    'tl.dtlCanceledBy': 'Canceled by',
    'tl.dtlReason': 'Reason',
    'tl.dtlMethod': 'Method',
    'tl.dtlConfirmation': 'Confirmation #',
    'tl.dtlOnMyWay': 'On my way',
    'tl.dtlCheckIn': 'Check-in',
    'tl.dtlCheckOut': 'Check-out',
    'tl.dtlMiles': 'Distance',
    'tl.dtlRoof': 'Roof condition',
    'tl.dtlOpinion': 'Inspector opinion',
    'tl.dtlRebookedIn': 'Rebooked in',
    'supTl.stage.firstEstimate': 'Moved to First Estimate',
    'supTl.stage.reviewEstimate': 'Sent to Review Estimate',
    'supTl.approval.full': '✅ Approved — full approval by the insurance',
    'supTl.approval.repair': 'Approved for repair (not a full approval)',
    'tl.theApproved': 'The approved one',
    'supTl.stage.supplementing': 'Supplementing started',
    'supTl.stage.resolved': 'Supplement resolved',
    'supTl.estimate.version': 'Insurance estimate #{n}',
    'supTl.estimate.repair': 'Repair estimate #{n}',
    'supTl.invoice.created': 'Invoice created {num}',
    'supTl.invoice.submitted': 'Invoice sent to review',
    'supTl.invoice.approved': 'Invoice approved',
    'supTl.invoice.issued': 'Invoice issued {num}',
    'supTl.analysis.done': 'AI analyzed the estimate',
    'supTl.email.sent': 'Email sent',
    'supTl.update.posted': 'Supplement update',
    'supTl.viaMonday': 'via Monday sync',
    'supTl.system': 'System',
    'supTl.worked': 'worked',
    'supTl.gap': 'gap',
    'supTl.viewEstimate': 'View estimate',
    'supTl.viewInvoice': 'View invoice',
    'supTl.viewEmail': 'See email',
    'supTl.to': 'To',
    'supTl.noSubject': '(no subject)',
    'supTl.sketch.done': 'Sketch done',
    'supTl.estimate.done': 'Proactive estimate #{n}',
    'supTl.estimate.received': 'Insurance estimate #{n} received',
    'supTl.estimate.rebuild': 'Rebuild estimate uploaded',
    'supTl.estimate.sent': 'Estimate emailed to insurance',
    'supTl.estimate.sentExternal': 'Estimate marked sent (outside the app)',
    'tl.viaMonday': 'via Monday sync',
    'tl.system': 'System',
    'tl.worked': 'worked',
    'tl.statusDays': '{days}d in this status',
    'tl.statusCurrent': 'current · {days}d',
    'pb.expected': 'expected',
    'pb.fullyPaid': 'Fully collected',
    'pb.collected': 'collected',
    'pb.allCollected': 'All expected money collected',
    'pb.remaining': 'Still to come',
    'pb.stillComing': 'not yet received',
    'pb.depreciation': 'Depreciation',
    'pb.deductible': 'Deductible',
    'pb.deductibleNote': 'homeowner pays',
    'tl.gap': 'gap',
    'tl.error': "Couldn't load the timeline.",
    'tl.to': 'To',
    'tl.noSubject': '(no subject)',
    'tl.viewDoc': 'View',
    'tl.viewInvoice': 'View invoice',
    'tl.viewEmail': 'See email',
    'tl.viewCheck': 'View check',
    'tl.viewAuthProof': 'View authorization',
    'tl.viewPayProof': 'View proof',
    'tl.openTab': 'Open in new tab',
    'tl.payEmails': 'Payment emails sent',
    'tl.noPayEmails': 'No emails sent for this payment yet.',
    'tl.sendCO': 'Send to CO',
    'tl.sendHO': 'Send to HO',
    'tl.sendCOTip': 'Email this to the contractor',
    'tl.sendHOTip': 'Email this to the homeowner',
    'tl.sendTitle': 'Send by email',
    'tl.sendFrom': 'From the {dept} mailbox',
    'tl.dept.payments': 'Payments',
    'tl.dept.supplements': 'Supplements',
    'tl.co': 'Contractor',
    'tl.ho': 'Homeowner',
    'tl.subject': 'Subject',
    'tl.message': 'Message',
    'tl.willAttach': 'The document will be attached.',
    'tl.sendBodyDefault': 'Hi, please find the attached document. Let us know if you have any questions.',
    'tl.send': 'Send',
    'tl.sent': 'Sent',
    'tl.sendErrGeneric': "Couldn't send — try again.",
    'tl.sendErr.no_contractor_email': 'This claim has no contractor email on file.',
    'tl.sendErr.no_homeowner_email': 'This claim has no homeowner email on file.',
    'tl.sendErr.no_insurance_email': 'This claim has no insurance email on file.',
    'tl.insurance': 'Insurance',
    'tl.viewEstimate': 'View estimate',
    'tl.viewAnalysis': 'View full analysis',
    'tl.dtlProactive': 'Proactive',
    'tl.dtlInsurance': 'Insurance',
    'tl.dtlDifference': 'Difference',
    'tl.dtlPriceLists': 'Price lists',
    'tl.dtlAmount': 'Amount',
    'tl.dtlPriceList': 'Price list',
    'tl.dtlPriceListOurs': 'Our price list',
    'tl.dtlPriceListTheirs': 'Their price list',
    'tl.opBadge': 'Insurance pays O&P',
    'tl.missingTitle': "Not paid by insurance (we have it, they don't):",
    'payTl.title': 'Payments timeline',
    'payTl.subtitle': 'Checks, invoice and payments — who and when',
    'payTl.empty': 'Nothing here yet — checks and payments will show up.',
    'payTl.check.received': 'Check received',
    'payTl.check.deposited': 'Check deposited',
    'payTl.check.available': 'Check cleared (available)',
    'payTl.check.bounced': 'Check bounced',
    'payTl.invoice.created': 'Invoice created {num}',
    'payTl.invoice.submitted': 'Invoice sent to review',
    'payTl.invoice.approved': 'Invoice approved',
    'payTl.invoice.issued': 'Invoice issued {num}',
    'payTl.payment.authorizedContractor': 'Payment authorized to contractor',
    'payTl.payment.authorizedHomeowner': 'Payment authorized to homeowner',
    'payTl.payment.paidContractor': 'Paid to contractor',
    'payTl.payment.paidHomeowner': 'Paid to homeowner',
    'payTl.payment.voided': 'Payment voided',
    'payTl.st.inReview': 'Invoice in review',
    'payTl.st.toRedo': 'Invoice sent back to redo',
    'payTl.st.waitingClear': 'Waiting for the check to clear',
    'payTl.st.readyToPay': 'Ready to pay — in the pay queue',
    'payTl.st.generic': '{status}',
    'cd.tabCallLog': 'Call log',
    'cd.aiRead': 'Read it with AI',
    'cd.aiReadAgain': 'Read it with AI again',
    'cd.aiReading': 'reading…',
    'cd.aiNoFile': 'This version has no file in Files to read',
    'cd.generatedDocs': 'Generated documents',
    'cd.invPaidTo': 'Paid to',
    'cd.invAuthTo': 'Authorized to',
    'cd.invPaid': 'Paid',
    'cd.invAuthorized': 'Authorized',
    'svc.title': 'Services Performed',
    'svc.type': 'Service',
    'svc.vendor': 'Vendor',
    'svc.date': 'Date',
    'svc.amount': 'Amount',
    'svc.invoice': 'Invoice',
    'svc.viewInvoice': 'View',
    'svc.pendingInvoice': 'Pending invoice upload',
    'svc.billed': 'Billed',
    'svc.insPaid': 'Insurance paid',
    'svc.diff': 'Difference',
    'svc.add': 'Add service',
    'svc.needsEstimate': 'Needs our estimate',
    'svc.needsEstimateAsk': 'Needs our estimate?',
    'svc.fromFiles': 'From claim files',
    'svc.fromFilesHelp': 'Pick an invoice that is already uploaded to this claim (no re-upload).',
    'svc.pickFile': 'Pick a file…',
    'svc.needsEstimateOffHelp': 'Marked as needing our estimate (shows in Mitigation) — click to turn OFF',
    'svc.needsEstimateHelp': 'We must make the estimate (e.g. mitigation the contractor won\'t send). Adds the claim to the Mitigation column in Supplements.',
    'sup.meShort': 'Mitigation Estimate',
    'sup.meNone': 'No mitigation estimate yet.',
    'sup.meUpload': '⬆ Upload mitigation estimate (PDF)',
    'sup.contractorDocs': 'Contractor documents (tarp invoices / invoices)', 'sup.viewDoc': 'View',
    'sup.rebuildEstimate': 'Rebuild Estimate', 'sup.rebuildUpload': '⬆ Upload rebuild estimate', 'sup.rebuildReplace': '⬆ Replace rebuild estimate',
    'sup.rebuildHint': 'Attached to the email together with the mitigation estimate.', 'sup.rebuildSaved': 'Rebuild estimate uploaded',
    'sup.mitMovedFollowup': 'Email sent → moved to Mitigation Follow Up',
    'sup.firstMovedOut': 'Email sent → removed from First Estimate',
    'sup.meSaved': 'Saved as Mitigation Estimate',
    'svc.empty': 'No services recorded.',
    'svc.deleteConfirm': 'Delete this service?',
    'svc.payee': 'Paid to',
    'svc.contractor': 'Assigned contractor',
    'svc.other': 'Other vendor',
    'svc.otherName': 'Vendor name',
    'svc.toProactive': 'to Proactive',
    'svc.toOther': 'pay to other',
    'svcpay.title': 'Services paid outside the normal invoice',
    'svcpay.discount': 'Discount {amt} from the invoice (paid to another vendor):',
    'svcpay.proactive': '{n} service(s) collected by Proactive (pay-to-Proactive on the invoice).',
    'nav.requests': 'Requests',
    'nav.callMonitoring': 'Employee Monitoring', 'cm.accessTitle': 'Who can see Employee Monitoring', 'cm.accessHint': 'Tick a person to let them in; untick to take it away. The master always can.', 'cm.accessYes': 'Can see it ({n})', 'cm.accessNo': 'Cannot see it ({n})',
    'cm.pending': 'Pending', 'cm.reviewed': 'Reviewed',
    'cm.explain': "AI-detected issues from recorded calls — angry customers, employee conduct, threats, legal risk, and anything else an enterprise call-quality audit would flag. Review and mark as handled.",
    'cm.emptyPending': 'No pending alerts — nothing needs your review right now.',
    'cm.emptyReviewed': 'No reviewed alerts yet.',
    'cm.sev.high': 'High', 'cm.sev.medium': 'Medium', 'cm.sev.low': 'Low',
    'cm.inbound': 'Inbound', 'cm.outbound': 'Outbound',
    'cm.markReviewed': 'Mark reviewed', 'cm.reopen': 'Reopen',
    'note.attach': 'Attach a photo or file',
    'cm.seeCalls': 'See their calls', 'cm.hideCalls': 'Hide calls',
    'cm.per.day': 'Day', 'cm.per.week': 'Week', 'cm.per.month': 'Month',
    'cm.prev': 'Previous', 'cm.next': 'Next', 'cm.today': 'Today',
    'cm.tabPerformance': 'Performance',
    'cm.coverage': 'This period: {total} calls · {answered} answered · {attributed} with an identified employee · {classified} with an identified counterpart.',
    'cm.perfCalls': 'Answered calls', 'cm.perfMinutes': 'Minutes on the phone',
    'cm.perfEmpty': 'No calls in this period.',
    'cm.showEveryone': 'Show everyone, including people with no calls',
    'cm.person': 'Person', 'cm.outIn': 'Out / In', 'cm.medianCall': 'Typical call',
    'cm.activeDays': 'Days with calls', 'cm.mix': 'Who they called',
    'cm.medianOf': 'team median: {n} min',
    'cm.topCaller': 'Most minutes on the phone in this team',
    'cm.belowTeam': 'below their team',
    'cm.belowHelp': 'Less than half their team’s median, with at least 2 days of activity. It is a number, not a verdict — open their calls before drawing conclusions.',
    'cm.noActivity': 'no calls',
    'cm.outNoAnswer': 'Outbound calls nobody picked up (not counted)',
    'cm.lowCoverage': 'only {n} of {total} identified',
    'cm.lowCoverageHelp': 'Too few calls matched to a claim to show a reliable split.',
    'cm.ofN': '{n} of {total}',
    // Call Monitoring v3 (2026-08-03): calificar la alerta, reincidencia, DM al empleado, historial.
    'cm.tabHistory': 'Alert history',
    'cm.repeatNth': 'Repeat offense #{n}',
    'cm.repeatHelp': 'This is not the first serious alert for this employee. Alerts marked as noise are not counted.',
    'cm.fbUsefulHelp': 'This alert was worth flagging — keep flagging cases like this',
    'cm.fbNoiseHelp': 'This was not worth an alert — stop flagging cases like this, and do not count it against the employee',
    'cm.fbUsefulDone': 'Marked as a good call',
    'cm.fbNoiseDone': 'Marked as noise — it no longer counts against anyone',
    'cm.dmWrite': 'Message {name}',
    'cm.dmSentN': 'Messages sent ({n})',
    'cm.dmReplies': 'replies: {n}',
    'cm.dmSignedBy': 'Signed by',
    'cm.dmSuggest': 'Suggest text',
    'cm.dmPlaceholder': 'What you want {name} to do differently next time…',
    'cm.dmDraftHint': 'The employee sees this as a direct message from whoever signs it. Read it before sending.',
    'cm.dmSend': 'Send message',
    'cm.hoSms': 'Text {name}', 'cm.hoEmail': 'Email {name}', 'cm.hoNoPhone': 'This claim has no homeowner phone on file.',
    'cm.hoNoEmail': 'This claim has no homeowner email on file.', 'cm.hoApology': 'AI: draft apology & correction',
    'cm.hoSend': 'Send to homeowner', 'cm.hoSent': 'Sent.', 'cm.hoPlaceholder': 'Message for {name}…',
    'cm.dismissed': 'Dismissed', 'cm.emptyDismissed': 'No dismissed alerts.',
    'cm.dismissedHint': 'Dismissed by 👎 — vote 👍 to send it back to Pending.',
    'cm.exonerate': 'Not the employee’s fault', 'cm.exonerated': '{name} exonerated',
    'cm.exonerateHelp': 'The alert stays (it was correctly flagged), but it stops counting against the employee: no repeat-offense, no Employee of the Month penalty, no performance hit.',
    'cm.exonerateUndo': 'Undo — count it against the employee again',
    'cm.contractor': 'Contractor',
    'cm.dmSentBy': 'sent by {name}',
    'cm.dmNoReply': 'No reply yet.',
    'cm.histEmployee': 'Employee',
    'cm.histEveryone': 'Everyone',
    'cm.histNSerious': 'serious: {n}',
    'cm.histOnlySerious': 'Serious only',
    'cm.histNth': 'Serious alert #{n}',
    'cm.histNoise': 'Marked as noise',
    'cm.histNoDm': 'No message was sent to the employee for this one.',
    'cm.histEmpty': 'No alerts on record for this filter.',
    'cm.whyNoInsuranceRanking': 'Only {pct}% of calls are matched to a homeowner or an adjuster, so there is no "who calls the insurance most" ranking: calls to carrier 800-numbers are not in any claim, so they would count as zero. What you see is the mix of the calls we could identify.',
    'cm.noAccess': 'You do not have access to Call Monitoring. Ask the owner to add you.',
    'cm.access': 'Access', 'cm.whoHasAccess': 'Choose who can use Call Monitoring',
    'team.canViewCM': 'Call Monitoring access',
    'team.canViewCMHelp': 'Call Monitoring — only the people you turn on here can open it',
    'team.cantRevokeSelf': "You can't remove your own access",
    'team.canShareScreen': 'Share screen and Record',
    'team.canShareScreenHelp': 'Share screen and Record — everyone starts on; turn off whoever should not have it',
    'team.shareScreenMaster': 'The owner always has it',
    'team.canShareScreenInspector': 'Can receive a screen share (field team)',
    'cm.employee': 'Employee', 'cm.unknownEmployee': 'not identified',
    'cm.roleHomeowner': 'Homeowner', 'cm.roleAdjuster': 'Insurance adjuster',
    'cm.roleContractor': 'Contractor', 'cm.roleOther': 'Other party',
    'cm.showTranscript': 'See the full conversation', 'cm.hideTranscript': 'Hide the conversation',
    'cm.addComment': 'Comment', 'cm.comments1': '1 comment', 'cm.commentsN': '{n} comments', 'cm.noComments': 'No comments yet.',
    'cm.commentPlaceholder': 'Discuss this call… use @ to mention someone',
    'cm.postComment': 'Post',
    'cm.reviewedBy': 'Reviewed by {name}',
    'cm.catAngryCustomer': 'Angry customer', 'cm.catPoaching': 'Poaching attempt',
    'cm.catKnowledgeGap': "Employee didn't know how to answer", 'cm.catRudeTone': 'Rude / raised tone',
    'cm.catEmployeeError': 'Employee error', 'cm.catThreat': 'Threat',
    'cm.catLegalIssue': 'Legal issue', 'cm.catOther': 'Other (compliance)',
    'cm.tabAllCalls': 'All Calls', 'cm.tabUrgentAlerts': 'Urgent Alerts',
    'cm.filterUser': 'User', 'cm.allUsers': 'All users',
    'cm.colWhen': 'When', 'cm.colUser': 'User', 'cm.colDirection': 'In/Out', 'cm.colWith': 'With',
    'cm.colClaim': 'Claim', 'cm.colDuration': 'Duration', 'cm.colResult': 'Result', 'cm.colRecording': 'Recording',
    'cm.emptyCalls': 'No calls logged yet for this filter.',
    'cm.unassigned': 'Unmatched',
    'cm.summaryTitle': 'Calls per day by user',
    'cm.summaryEmpty': 'No calls in this range yet.',
    'nav.complaints': 'Complaints',
    'nav.evaluation': 'Employee Evaluation',
    'nav.timesheet': 'Hours & Pay',
    'nav.payroll': 'Payroll',
    'nav.broadcast': 'Broadcast',
    // Complaints
    'cmp.tab': 'Complaints', 'cmp.myComplaints': 'My Complaints', 'cmp.noneMine': 'No complaints involving you.',
    'cmp.dayN': 'day {n}', 'cmp.evidence': 'Evidence', 'cmp.publicThread': 'Case updates',
    'cmp.privateThread': 'Investigation (super-managers only)', 'cmp.privateNote': 'Private note (super-managers only)…',
    'cmp.yourResponse': 'Your response…', 'cmp.postUpdate': 'Post an update the employee sees…',
    'cmp.openRespondHint': 'This complaint is being reviewed. You can share your side now — the reviewers will read it while they investigate.',
    'cmp.markComplete': 'My response is complete', 'cmp.responseDone': 'Response marked complete — awaiting final review.',
    'cmp.windowOpen': 'Response window open — {n} day(s) left to defend.', 'cmp.windowClosed': 'Response window closed.',
    'cmp.valid': 'Valid', 'cmp.dismissed': 'Dismiss', 'cmp.upheld': 'Uphold', 'cmp.overturned': 'Overturn',
    'cmp.attach': 'Attach', 'cmp.send': 'Send', 'cmp.newComplaint': 'New complaint', 'cmp.create': 'Create',
    'cmp.title': 'Title', 'cmp.description': 'Description', 'cmp.targets': 'Employee(s)', 'cmp.groupHint': 'select one or more',
    'cmp.attachEvidence': 'Attach evidence (images, PDF, audio)', 'cmp.fileComplaint': 'File complaint',
    'cmp.history': 'History', 'cmp.allStatuses': 'All statuses', 'cmp.allEmployees': 'All employees', 'cmp.noneHistory': 'No complaints yet.',
    'cmp.status.under_investigation': 'Under investigation', 'cmp.status.valid': 'Valid — response window', 'cmp.status.dismissed': 'Dismissed', 'cmp.status.upheld': 'Upheld', 'cmp.status.overturned': 'Overturned',
    'cmp.status.open': 'Open — reviewing', 'cmp.status.processed': 'Processed — awaiting employee', 'cmp.status.denied': 'Denied', 'cmp.status.disputed': 'Disputed — final vote',
    'cmp.searchEmployee': 'Search employee…', 'cmp.searchClaim': 'Search claim by homeowner or number…', 'cmp.aboutClaim': 'About claim', 'cmp.affectedParty': 'Affected party',
    'cmp.party.homeowner': 'Homeowner', 'cmp.party.contractor': 'Contractor', 'cmp.internalNote': 'Internal note', 'cmp.internalNoteHint': 'Only reviewers see this; the employee never does.',
    'cmp.createdBy': 'Filed by', 'cmp.denyReason': 'Deny reason', 'cmp.denyReasonAsk': 'Reason for denying this complaint?', 'cmp.disputeReason': 'Dispute reason', 'cmp.disputeReasonAsk': 'Why do you dispute this complaint?',
    'cmp.accept': 'Accept', 'cmp.acceptConfirm': 'Accept this complaint? It will be upheld on your record.', 'cmp.dispute': 'Dispute',
    'cmp.voteProcess': 'Process', 'cmp.voteDeny': 'Deny', 'cmp.processN': 'to process', 'cmp.denyN': 'to deny', 'cmp.decisionVote': 'Decision vote', 'cmp.finalVote': 'Final vote (dispute)', 'cmp.yourVote': 'your vote', 'cmp.cannotVote': 'You cannot vote on this complaint (you filed it or are involved).',
    'cmp.dropHint': 'or drag & drop files here', 'cmp.selectedN': 'selected',
    'cmp.settings': 'Settings', 'cmp.votesRequired': 'Votes required', 'cmp.votesRequiredHint': 'How many reviewer votes to process or deny a complaint (auto-capped to the number of reviewers).', 'cmp.reviewers': 'Complaint reviewers', 'cmp.reviewersHint': 'These people vote on complaints and get a DM when one is filed.',
    'eom.tab': 'Employee of the Month', 'eom.voteBox': 'Vote Box', 'eom.voteBoxSoon': 'Monthly voting — coming online.', 'eom.adminSoon': 'EOM admin — coming online.',
    'kud.give': 'Recognize this', 'kud.given': 'You recognized this', 'kud.reviewQueue': 'Kudos review', 'nav.kudos': 'Kudos', 'kud.pageHint': 'Kudos waiting to be reviewed. An approved kudo gives points toward Employee of the Month; one left sitting here gives nobody anything.',
    'kud.dailyLimit': 'You already gave your kudo for today — you get 1 per day, make it count',
    'kud.history': 'Kudos history', 'kud.historyEmpty': 'No reviewed kudos yet.',
    'kud.approved': 'Approved', 'kud.skipped': 'Skipped',
    'kud.aiMerit': 'AI: merits it',
    'kud.approve': 'Approve', 'kud.skip': 'Skip', 'kud.selectAll': 'Select all', 'kud.deselectAll': 'Deselect all',
    'kud.queueEmpty': 'No kudos to review.', 'kud.by': 'by', 'kud.open': 'Open', 'kud.myKudos': 'Kudos I received',
    'eom.voteTitle': 'Vote for Employee of the Month', 'eom.voteHelp': 'One vote per month. Pick a colleague and say why. You can change it until the month closes.',
    'eom.pickColleague': 'Pick a colleague', 'eom.reasonPh': 'Why do they deserve it? (required)', 'eom.saveVote': 'Save my vote', 'eom.voteSaved': 'Vote saved', 'eom.noKudosYet': 'No recognized kudos yet.',
    'eom.leaderboard': 'Leaderboard', 'eom.employee': 'Employee', 'eom.kudos': 'Kudos', 'eom.votes': 'Votes', 'eom.penalty': 'Penalty', 'eom.total': 'Total', 'eom.givers': 'Givers', 'eom.dq': 'DQ',
    'eom.attendance': 'Attendance', 'eom.attDays': 'days worked', 'eom.attLate': 'days late', 'eom.attAbsent': 'absences',
    'eom.attendanceHelp': 'Days worked and hours are context only. Late days and absences DO subtract points.',
    'eom.closeMonth': 'Close the month', 'eom.pickWinner': 'Winner', 'eom.overrideNote': 'Override reason (required)', 'eom.close': 'Close month', 'eom.needNote': 'An override reason is required.',
    'eom.highlightPh': 'Highlight reason (shown in the announcement)', 'eom.announce': 'Announce', 'eom.st.open': 'Open', 'eom.st.closed': 'Closed', 'eom.st.announced': 'Announced',
    // Drawer de desglose de puntos (2026-08-03): de dónde salió cada punto de esa persona.
    'eom.seeBreakdown': 'See where these points came from',
    'eom.bdKudosNote': '{counted} counted · +{pts} pts (max {cap} per person who gave them)',
    'eom.bdOverCap': 'over the cap — no points',
    'eom.bdNoKudos': 'No approved kudos this month.',
    'eom.bdComplaints': 'Upheld complaints',
    'eom.bdComplaintNote': '−{pts} pts',
    'eom.bdNoComplaints': 'No upheld complaints this month.',
    'eom.bdCallAlerts': 'Serious call alerts',
    'eom.bdAlertNote': '{n} × penalty = −{pts} pts',
    'eom.bdNoAlerts': 'No serious call alerts this month.',
    // EOM: navegación por mes, barra azul de anuncio y de dónde sale el descuento (2026-08-03).
    'eom.prevMonth': 'Previous month', 'eom.nextMonth': 'Next month', 'eom.thisMonth': 'This month',
    'eom.noWinnerYet': 'no winner picked',
    'eom.callAlertsN': 'call alerts: {n}', 'eom.callAlertsHelp': 'Serious call alerts this month. Alerts you marked as noise do not count.',
    'eom.announceHint': 'Everyone gets a blue bar at the top of the app. They click it and the celebration plays.',
    'eom.bannerCta': 'We have an Employee of the Month for {month} — {name}. Tap to celebrate',
    'eom.bannerOpen': 'Celebrate',
    'eom.thanksBody': 'Thank you, {name}. From all of us at Proactive: the work you put in this month did not go unnoticed. Every claim you moved forward is a family getting their home back. Congratulations — and thank you for the way you show up.',
    'eom.congratsTitle': 'Congratulations', 'eom.employeeOfTheMonth': 'Employee of the Month', 'eom.celebrate': 'Awesome!',
    'eom.bdOpenChat': 'Open the conversation',
    'eom.lateDaysN': 'late: {n}',
    'eom.absencesN': 'absences: {n}',
    'eom.bdAttCapped': 'Attendance would have taken −{bruto} off; capped at −{pts} (monthly cap: {cap}).',
    'eom.attCap': 'Monthly cap on the attendance penalty',
    'eom.attCapHint': 'The most attendance can take off in a month, late days and absences together. Without it attendance decides the winner on its own: the worst August case was −68, against a best-ever 12 points of kudos. 0 = no cap.',
    'eom.bdAbsNote': 'Absences: {n} × penalty = −{pts} pts',
    'eom.bdAbsNone': 'No absences this month (each one costs {pts} pts).',
    'eom.bdAbsWhat': 'An absence is a scheduled day with no clock-in, or one marked as absent. Excused days and holidays do not count.',
    'eom.bdAttPenalty': 'attendance took −{pts} pts off',
    'eom.absencePenalty': 'Points off per absence',
    'eom.absencePenaltyHint': 'A day the person was scheduled and never clocked in, or one a manager marked as absent. Excused days and holidays never count, and neither does today — the day is still being worked. 0 = do not penalize.',
    'eom.bdCalls': 'Calls', 'eom.bdCallsNote': '{n} calls · {min} min this month',
    'eom.bdOtherAlerts': 'Alerts that do NOT cost points ({n})',
    'eom.bdAlertNo.low_severity': 'not serious — no points off',
    'eom.bdAlertNo.noise': 'dismissed with a thumbs-down',
    'eom.bdAlertNo.exonerated': 'employee cleared',
    'eom.bdLateNote': 'Late days: {n} × penalty = −{pts} pts',
    'eom.bdLateNone': 'No late days this month (each one costs {pts} pts).',
    'eom.bdAttFrozen': 'This month is closed: the frozen score does not carry the attendance. The day by day below is the real one.',
    'eom.latePenalty': 'Points off per late day',
    'eom.latePenaltyHint': 'A late day is one where the person clocked in past their start time PLUS their site\u2019s grace period — the same one the Attendance tab counts. 0 = do not penalize.',
    'eom.callAlertPenalty': 'Points off per serious call alert',
    'eom.complaintPenalty': 'Points off for an upheld complaint',
    'eom.penalties': 'Employee of the Month — penalties',
    'eom.penaltiesHint': 'What each thing costs in the monthly score. Kudos are worth {n} points each, for scale.',
    'eom.bdKudoRemove': 'Remove the points', 'eom.bdKudoRestore': 'Give the points back',
    'eom.bdKudoRemoved': 'removed — no points', 'eom.bdRevokedBy': 'removed by {name}',
    'eom.bdGiversNote': '{n} people this month', 'eom.bdNoGivers': 'Nobody gave them kudos this month.',
    'eom.bdGiverFilter': 'showing only what {name} gave', 'eom.bdClearFilter': 'show all',
    'eom.bdGiverCounted': '{counted} of {total} count',
    'eom.bdTableSays': 'the table says {n}',
    'eom.bdEmailMath': '{clients} clients × {per} = {pts} pts · {sent} emails sent',
    'eom.bdEmailCapped': 'capped at {cap}', 'eom.bdEmailN': '{n} emails', 'eom.bdEmail1': '1 email',
    'eom.bdEmailNone': 'No emails to a client this month.',
    'eom.bdEmailCut': 'showing {n} of {total}',
    'eom.bdAttDays': 'Days worked: {n}', 'eom.bdAttLate': 'Days late: {n}', 'eom.bdAttAbsent': 'Absences: {n}',
    'eom.bdAttNone': 'No clock or task records this month.',
    'eom.bdNoClock': 'This person does not have the time clock enabled — that dash is not a zero.',
    'eom.bdNoAudio': 'This call has no recording.',
    'eom.bdAlertKeep': 'The alert was right — it stays',
    'eom.bdAlertDrop': 'Not a real alert — remove it everywhere',
    'eom.bdAlertDropped': 'Removed everywhere: it no longer counts against this person.',
    'eom.bdUndo': 'Undo',
    'eom.bdCmOnly': 'Listening to calls and judging alerts needs Call Monitoring access (Settings → Teams).',
    'eom.bdFrozen': 'This month is closed: the table shows the frozen score. What you change here is real, but it does not move that score.',
    'eom.emailClick': 'click to see which clients', 'eom.giversClick': 'Click to see who gave them',
    'eom.attClick': 'click to see it day by day',
    'eom.ctxTitle': 'Where the kudo is', 'eom.ctxThisOne': 'this is the kudo',
    'eom.ctxNone': 'The original message is no longer there. This is what was saved the day of the kudo.',
    'eom.ctxOpenClaim': 'Open the claim',
    'eom.ctxGaveIt': '{giver} gave it to {to} on {date}',
    'prof.hireDate': 'Hire date', 'prof.eomWins': 'Employee of the Month wins', 'prof.kudosReceived': 'Kudos received', 'prof.complaintsHistory': 'Complaints history', 'prof.myComplaints': 'My complaints', 'prof.myProfile': 'My profile',
    'prof.metricKudos': 'Kudos', 'prof.metricVotes': 'Votes received', 'prof.metricWins': 'EOM wins', 'prof.metricClaims': 'Claims approved', 'prof.metricUpheld': 'Upheld complaints', 'prof.uploadPhoto': 'Upload photo',
    'req.empty': 'No pending requests.', 'req.selectAll': 'Select all', 'req.fromSystem': 'automatic (claim reached a closing stage)', 'req.bulkApproveConfirm': 'Approve {n} selected request(s)?', 'req.bulkRejectConfirm': 'Reject {n} selected request(s)?',
    'req.approvedHistory': 'Approved requests (history)',
    'req.approved': 'Approved',
    'req.approvedBy': 'Approved by',
    'rl.title': 'Release Letter',
    'rl.request': 'Request Release Letter',
    'rl.empty': 'No release letter requests.',
    'rl.reasonPrompt': 'Reason for the release letter (required):',
    'rl.reasonRequired': 'The reason is required for a release letter.',
    'rl.hint': 'Ask the Super Manager for a release letter. On approval it is generated, saved in Files and emailed to the homeowner and the insurance company.',
    'rl.rejectPrompt': 'Reason for rejecting (optional):',
    'rl.view': 'View letter',
    'rl.approve': 'Approve',
    'rl.reject': 'Reject',
    'rl.pending': 'Pending',
    'rl.approved': 'Approved',
    'rl.rejected': 'Rejected',
    'wx.title': 'Weather (3-yr storm history)',
    'wx.others': 'Others', 'wx.othersHint': 'Upload a weather/storm report (PDF). The AI reads it; storm reports show here.', 'wx.uploadReport': 'Upload weather report', 'wx.noOthers': 'No uploaded weather reports yet.', 'wx.uploadFail': 'Could not upload the report.',
    'wx.load': 'Load storm history',
    'wx.refresh': 'Refresh',
    'wx.loading': 'Loading…',
    'wx.slow': 'Querying NOAA — first load can take up to a minute.',
    'wx.hint': 'Storm history near the property (NOAA, free). On-demand.',
    'wx.none': 'No hail/wind storms in the last 3 years within 5 miles.',
    'wx.all': 'All', 'wx.noneFilter': 'No storms of this type.',
    // Lectura única de la póliza (mig 0504): el Policy Reader y el chip de Files.
    'pr.reread': 'Re-read policy', 'pr.rereadConfirm': 'Read this policy again from scratch? The current reading and analysis will be replaced.', 'pr.formsTitle': 'Forms and endorsements index', 'pr.formsSub': '{found} in the PDF · {missing} listed on the declarations but missing from the PDF', 'pr.notInPdf': 'listed · NOT in PDF', 'pr.pages': 'pp. {from}-{to}', 'pr.readingLine': 'Read {date} · {model} · {s}', 'pr.copiedReading': 'Copied from an identical policy already read', 'pr.modified': '{n} provision(s) modified by an endorsement — the endorsement text controls', 'pr.semaforoGreen': 'Reading complete', 'pr.semaforoYellow': 'Reading needs a look', 'pr.semaforoRed': 'Reading not usable — check the PDF', 'pr.rescue': 'Scanned PDF · read with {model}', 'pr.readingNow': 'The policy is being read (3 passes over the whole PDF). Analyze will be available when it finishes.', 'pr.whatChanged': 'Modifies {forms}',
    'pz.read': 'Read policy', 'pz.readHint': 'Read the whole policy with AI: declarations, every form and endorsement, and each provision with its exact quote and page. The Coverage Detector and Ray work from this reading.', 'pz.reading': 'Reading policy…', 'pz.queued': 'In queue…', 'pz.failed': 'Policy read failed', 'pz.retry': 'Retry', 'pz.done': 'Policy · {n} forms', 'pz.open': 'Open in Coverage Detector', 'pz.timeout': 'The policy reading is taking more than 8 minutes. It keeps running on the server; reload the page later to see it.', 'pz.chipHintFailed': 'Failed: {err}',
    'aim.f.policy_reading': "Policy reader (single reading)", 'aim.f.policy_reading.d': "Reads the whole policy ONCE, when it is uploaded: declarations, the index of every form and endorsement, and each provision with its exact quote, page, form number and whether an endorsement changes it. The Coverage Detector, Ray and the report work from this reading; the PDF is not sent again.", 'aim.f.policy_analysis': "Coverage detector (policy vs. claim)", 'aim.f.policy_analysis.d': "The policy already read, against the claim: highlights, red flags, claim strategies and plain-language explanations for the homeowner. Text only, no PDF.",
    'pr.title': 'Policy Reader', 'pr.subtitle': 'Upload the insurance policy PDF; AI reads it with verbatim citations, red flags and claim attack routes.', 'pr.uploadPolicy': 'Upload policy PDF', 'pr.claimType': 'Claim type', 'pr.dropHint': 'drag & drop or click', 'pr.uploading': 'Uploading…', 'pr.noPolicies': 'No policy uploaded yet.', 'pr.untitledPolicy': 'Policy', 'pr.insurer': 'Insurer', 'pr.policyNumber': 'Policy number', 'pr.jumpTo': 'Jump to this item', 'pr.analyze': 'Analyze with AI', 'pr.reanalyze': 'Re-analyze', 'pr.analyzing': 'Analyzing…', 'pr.analyzingHint': 'Working on the policy with AI — a full reading takes 2 to 4 minutes (three passes over the whole PDF); analyzing an already-read policy takes about 30 seconds. You can keep working; it will update on its own.', 'pr.extractFailed': 'Extraction failed. Try Analyze again.', 'pr.exportPdf': 'Export report', 'pr.exportSummary': 'Export summary', 'pr.notAnalyzed': 'Not analyzed yet. Click Analyze with AI.', 'pr.redFlags': 'Red Flags', 'pr.attackRoutes': 'Claim Attack Routes', 'pr.page': 'page', 'pr.goToPage': 'Open this page in the PDF', 'pr.pdfPageLabel': 'PDF · page', 'pr.whereToSee': 'Where to find it', 'pr.inSummary': 'In summary', 'pr.selectItem': 'Add to summary', 'pr.aiBusy': 'The AI service is busy. Try Analyze again in a moment.', 'pr.viewPdf': 'View PDF', 'pr.rayTitle': 'Ray — ask about this policy', 'pr.raySubtitle': 'Every answer cites a verbatim quote + page.', 'pr.rayPlaceholder': 'Ask Ray about this policy…', 'pr.send': 'Send', 'pr.thinking': 'Ray is reading the policy…', 'pr.addToReport': 'Add to report', 'pr.addedToReport': 'Added to report', 'pr.rayError': 'Ray failed. Try again.',
    'psum.title': 'Policy summary for the card', 'psum.useSuggestion': 'Use policy suggestion', 'psum.noPolicy': 'Analyze a policy above to auto-fill these from it.', 'psum.policyType': 'Policy type', 'psum.deductible': 'Deductible', 'psum.limits': 'Limits', 'psum.buildingCode': 'Building code / Ordinance', 'psum.clauses': 'Important clauses', 'psum.clausesHint': 'One clause per line', 'psum.confirm': 'Confirm & send to card', 'psum.saved': 'Saved to the card', 'psum.onCard': 'On the claim card',
    'bc.title': 'Building code', 'bc.yes': 'Yes', 'bc.no': 'No', 'bc.has': 'Has coverage', 'bc.hasNot': 'No coverage', 'bc.unknown': 'Unknown', 'bc.by': 'by', 'bc.notesPh': 'Notes (limits, endorsement, %, etc.)', 'bc.fromPolicy': 'From the policy (AI)',
    'wx.noGeo': 'Property has no coordinates yet (run property intel first).',
    'wx.fail': 'Could not fetch storm history.',
    'wx.potential': 'Potential Storm',
    'wx.main': 'Main storm',
    'wx.setMain': 'Set as main',
    'wx.hail': 'Hail',
    'wx.wind': 'Wind',
    // Vista de archivos en filas (2026-08-03): tipo editable + monto/fecha/origen en la línea.
    // Bonos por equipo (2026-08-03).
    // Nómina (super-manager).
    'payd.pdf': 'Summary PDF',
    'pay.title': 'Payroll', 'pay.tabPeriod': 'Pay period', 'pay.tabRates': 'Pay rates', 'payd.openHint': 'Open the day-by-day breakdown', 'payd.day': 'Day', 'payd.in': 'In', 'payd.out': 'Out', 'payd.paid': 'Paid', 'payd.productivity': 'Productivity', 'payd.delivered': 'Delivered', 'payd.review': 'under review', 'payd.stillOpen': 'still open', 'payd.late': 'late', 'payd.total': 'Total', 'payd.daysWorked': 'days worked', 'payd.workedNoPunch': 'worked without punching', 'payd.workedNoPunchHint': 'Delivered work or app activity on a day with no shift — the hours are not being paid.', 'payd.fixHours': 'Fix the hours of this day', 'payd.fixHoursHint': 'The old punch is voided, not overwritten: the correction is kept with its reason and who made it.', 'payd.reason': 'Reason', 'payd.reasonPh': 'Forgot to clock out…', 'payd.save': 'Save', 'payd.deltaHint': 'the paid hours are recalculated when you save', 'payd.noOutYet': 'This shift has no clock-out yet — close it first and then adjust it.', 'payd.lockedHint': 'Closed period: the payslip is frozen and the hours can no longer be corrected here.', 'payd.openBar': 'See the activity of this day', 'payd.actTitle': 'What they did', 'payd.actAll': 'All', 'payd.actFiles': 'Files', 'payd.actEmails': 'Emails sent', 'payd.actCalls': 'Calls', 'payd.actEmpty': 'No activity recorded that day.', 'payd.actNotes': 'Notes', 'payd.actSms': 'SMS', 'payd.actUpdates': 'Updates', 'payd.actTasks': 'Tasks done', 'payd.actPhotos': 'Photos', 'payd.actStages': 'Status changes', 'payd.actListen': 'Click to listen to the call', 'payd.actNoRecording': 'No recording for this call', 'bars.openActivity': 'See everything this person did that day: calls, emails, notes, SMS, updates, tasks, files, photos, status changes', 'payd.callIn': 'Received', 'payd.callOut': 'Called', 'payd.variosTurnos': 'This day has {n} shifts: the activity and the files below are the whole day\u2019s, and the light blue marks only this shift.', 'payd.break': 'Break', 'payd.breakAdd': 'Add a break', 'payd.breakRemove': 'Remove this break', 'payd.breakFromGaps': 'use the {n} the app saw', 'payd.blk.overlaps_shift': 'overlaps another shift — those hours would be paid twice', 'payd.blk.over_max_shift': 'longer than the location\u2019s maximum — check it before paying', 'payd.blk.no_in_punch': 'no clock-in: the hours cannot be derived', 'payd.blk.out_voided': 'the clock-out was voided — waiting for the correction', 'payd.noSignal': 'No signal at all this day — no app activity, no calls, no declared task.', 'payd.seenFrom': 'The app saw activity from {a} to {b}', 'payd.ofSignal': 'with signal', 'payd.moreThanPunched': '{n} more than what is punched', 'payd.useSeen': 'Use what the app saw', 'payd.gapTotal': 'of gap in the middle', 'payd.discountGaps': 'Discount {n} of gaps as a break', 'payd.willBePaid': 'will be paid for this day', 'payd.seenGapWarn': 'That stretch has {n} with no signal at all: check it before using it as is.', 'payd.addDay': 'Load the hours of this day', 'payd.addDaySave': 'Load the day', 'payd.addDayReasonPh': 'Worked without clocking in…', 'payd.addDayHint': 'It is created with its two punches and left under review — it creates payable hours, so somebody has to approve it before closing.', 'payd.overnightHint': 'The out is earlier than the in: it will be saved as a night shift ending the next day.',
    'pay.gross': 'Gross for the period', 'pay.people': 'People', 'pay.hours': 'Paid hours', 'pay.status': 'Status',
    'pay.st.open': 'Open', 'pay.st.locked': 'Closed', 'pay.st.paid': 'Paid',
    'pay.person': 'Person', 'pay.days': 'Days', 'pay.rate': 'Rate', 'pay.regular': 'Regular', 'pay.total': 'Total',
    'pay.noPeople': 'Nobody has the time clock enabled at this location yet.',
    'pay.blockedHint': "{n} person(s) can't be paid yet — an open shift, a shift under review, or no pay rate. Fix that before closing.",
    'pay.blk.no_rate': 'No pay rate loaded', 'pay.blk.open_shift': 'Has a shift still open',
    'pay.blk.needs_review': 'Has a shift under review',
    'pay.close': 'Close the period', 'pay.forceClose': 'Close anyway, skipping them',
    'pay.forceHint': 'Closes without the blocked people. Who was skipped is written to the audit trail.',
    'pay.closeConfirm': 'Close {p} and freeze pay stubs for {n} people? After this, correcting an old shift no longer changes what was already issued.',
    'pay.closedOn': 'Closed on {d}', 'pay.reopen': 'Reopen', 'pay.reopenConfirm': 'Reopen this period? The pay stubs already issued stay on record as superseded.',
    'pay.ratesHint': 'A rate is never overwritten: a new one is added from the date you choose, so reprinting an old pay stub still shows the old salary.',
    'pay.from': 'From', 'pay.note': 'Note', 'pay.noRate': 'No rate',
    'pay.setRate': 'Set rate', 'pay.changeRate': 'New rate', 'pay.history': '{n} rates on record',
    // Sueldo mensual y reglas de pago por país (2026-08-26).
    'pay.month': 'month', 'pay.since': 'since', 'pay.rateSaved': '✓ Pay saved.',
    'pay.noLocation': 'No location', 'pay.noLocationHint': 'Without a location they cannot clock in and have no pay rules — assign one in Attendance.',
    'pay.divisor': 'monthly salary ÷ {n} h',
    'pay.fixedSalary': 'Fixed salary (not hourly)',
    'pay.howPaid': 'How they are paid',
    'pay.modeMonthlyHourly': 'Hourly — I type the MONTHLY salary',
    'pay.modeHourly': 'Hourly — I type the rate per hour',
    'pay.modeFixed': 'Fixed salary (not hourly)',
    'pay.amountHour': 'Per hour ($)', 'pay.amountMonth': 'Per month ($)',
    'pay.perHalf': 'per half-month',
    'pay.modeHourlyHint': 'Paid for what the clock says, at this hourly rate.',
    'pay.modeFixedHint': 'Same amount every period, whatever the clock says. They still clock in for attendance, and they earn no overtime.',
    'pay.rateHistoryHint': 'The previous pay is kept: {n}\u2019s old payslips stay printed with the pay of their day.',
    // Reglas de pago por sede.
    'lr.title': 'Pay rules by location',
    'lr.hint': 'Each country has its own rules: they decide what a shift pays.',
    'lr.paidLunch': 'Lunch is paid', 'lr.minutesPaid': 'minutes paid',
    'lr.overtime': 'Overtime', 'lr.otOver': 'over {h} h a week', 'lr.otRate': 'the hourly rate',
    'lr.divisorHint': 'hours a month — the divisor that turns a monthly salary into an hourly rate (160 = 20 days × 8)',
    'lr.recomputeWhy': 'Shifts freeze their paid minutes when they close: this rule does not reach the shifts already closed.',
    'lr.recompute': 'Recompute shifts',
    'lr.recomputeConfirm': 'Recompute every closed shift at {n} since {d} with today\u2019s rules? Shifts inside a closed pay period are left untouched.',
    'lr.recomputeDone': '✓ {n} shifts recomputed, {s} left untouched (already paid).',
    'pay.ratePrompt': 'Hourly rate for {n}, in dollars (e.g. 18.50):',
    'pay.rateFromPrompt': 'Effective from (YYYY-MM-DD):',
    'pay.badRate': 'That rate is not a valid amount.',
    // Hoja de horas del equipo (manager+).
    'ts.title': 'Hours & Pay', 'ts.onlyReview': 'Only what needs checking',
    'ts.totalPay': 'Total to pay', 'ts.payFixed': 'salary', 'ts.payNoRateShort': 'no rate', 'ts.payMonthly': 'Fixed salary — the amount does not depend on the range you picked; it is set in Payroll.', 'ts.payNoRate': 'No pay rate loaded (Payroll → Pay rates).', 'ts.payMissing': '{n} without an amount',
    'ts.totalPaid': 'Paid hours', 'ts.needsReview': 'To check', 'ts.toCheck': 'to check',
    'ts.resolve': 'Mark checked', 'ts.empty': 'Nothing to show for this range.',
    'ts.reasonPrompt': 'Why are you correcting this shift? (it goes in the audit trail)',
    // Mis Horas (el empleado se ve a sí mismo; solo lectura).
    'myh.title': 'My hours',
    'myh.slips': 'My pay stubs',
    'slip.tag': 'Pay stub ready', 'slip.open': 'Open the PDF',
    'slip.msg': 'Your pay stub for {from} — {to} is ready', 'myh.prev': 'Previous two weeks', 'myh.next': 'Next two weeks',
    'myh.paid': 'Paid hours', 'myh.worked': 'Worked', 'myh.breaks': 'Breaks', 'myh.ot': 'Overtime', 'myh.late': 'Late',
    'myh.day': 'Day', 'myh.in': 'In', 'myh.out': 'Out', 'myh.detail': 'Detail', 'myh.review': 'under review',
    'myh.empty': 'No shifts in this range.',
    'myh.pendingHint': '{n} shift(s) still being reviewed — those hours are not final yet.',
    'myh.punch.in': 'In', 'myh.punch.out': 'Out', 'myh.punch.break_start': 'Break', 'myh.punch.break_end': 'Back',
    'myh.abs.absent': 'Absent', 'myh.abs.pto': 'Time off', 'myh.abs.holiday': 'Holiday', 'myh.abs.sick': 'Sick',
    // Broadcast (email masivo + el avión con el cartel).
    'bcast.title': 'Broadcast', 'bcast.gotIt': 'Got it',
    'bcast.inAppOnly': 'Only inside the app', 'bcast.publish': 'Publish',
    'bcast.inAppOnlyHint': 'Internal message — nobody gets an email. Inspectors do not see it.',
    'bcast.publishConfirm': 'Publish this message inside the app for everyone (except inspectors)?',
    'bcast.new': 'New campaign', 'bcast.audience': 'Audience', 'bcast.kind': 'Type',
    'bcast.aud.employees': 'Employees', 'bcast.aud.contractors': 'Contractors',
    'bcast.aud.homeowners': 'Homeowners (open claims)', 'bcast.aud.homeowners_all': 'Homeowners (all, closed included)',
    'bcast.teamCopy': '+ {n} employees get a copy (marked in the subject) so the team knows what went out.',
    'bcast.edit': 'Edit',
    'bcast.tab.all': 'All', 'bcast.tab.employees': 'Employees', 'bcast.tab.contractors': 'Contractors', 'bcast.tab.homeowners': 'Homeowners',
    'bcast.stats': 'Stats', 'bcast.opened': 'Opened',
    // Estadística de la campaña
    'bcs.sent': 'Sent', 'bcs.delivered': 'Delivered', 'bcs.opened': 'Opened', 'bcs.clicked': 'Clicked', 'bcs.replied': 'Replied',
    'bcs.bounced': 'Bounced / failed', 'bcs.unsubscribed': 'Unsubscribed', 'bcs.teamCopies': 'Team copies',
    'bcs.ratesNote': 'Percentages are over the emails sent to the audience (team copies excluded).',
    'bcs.opensTotal': '{n} opens in total', 'bcs.forwardNote': 'Email cannot report forwards; several opens from one person (×N) is the closest signal.',
    'bcs.links': 'Clicks by link', 'bcs.uniques': '({n} people)', 'bcs.search': 'Search name or email…',
    'bcs.f.all': 'All', 'bcs.f.opened': 'Opened', 'bcs.f.not_opened': 'Not opened', 'bcs.f.clicked': 'Clicked', 'bcs.f.replied': 'Replied',
    'bcs.f.bounced': 'Bounced', 'bcs.f.unsubscribed': 'Unsubscribed', 'bcs.f.copy': 'Team copies',
    'bcs.col.who': 'Recipient', 'bcs.col.status': 'Delivery', 'bcs.col.opened': 'Opened', 'bcs.col.clicked': 'Clicked', 'bcs.col.replied': 'Replied', 'bcs.col.other': '',
    'bcs.copy': 'copy', 'bcs.st.bounced': 'Bounced', 'bcs.st.delivered': 'Delivered', 'bcs.st.sent': 'Sent', 'bcs.st.unsubscribed': 'Unsubscribed', 'bcs.st.complained': 'Spam complaint',
    'bcs.none': 'Nobody matches this filter.',
    'bcast.kind.announcement': 'Announcement', 'bcast.kind.marketing': 'Marketing',
    'bcast.subject': 'Subject', 'bcast.body': 'Message',
    'bcast.inApp': 'Also show inside the app (the flying banner)',
    'bcast.inAppPh': 'Short line for the banner — leave empty to skip it',
    'bcast.willReach': 'Will reach {n} people', 'bcast.eg': 'e.g. {names}',
    'bcast.save': 'Save draft', 'bcast.send': 'Send now', 'bcast.test': 'Send me a test',
    'bcast.schedule': 'Schedule', 'bcast.sendConfirm': 'Send "{s}" to {n} people? This cannot be undone.',
    'bcast.st.draft': 'Draft', 'bcast.st.scheduled': 'Scheduled', 'bcast.st.sending': 'Sending',
    'bcast.st.sent': 'Sent', 'bcast.st.canceled': 'Canceled',
    'bcast.sent': 'Sent', 'bcast.failed': 'Failed', 'bcast.replies': 'Replies', 'bcast.comments': 'Team notes',
    'bcast.noReplies': 'No replies yet.', 'bcast.noComments': 'No notes yet.',
    'bcast.commentPh': 'Note for the team about this campaign…',
    'bcast.empty': 'No campaigns yet.', 'bcast.access': 'Who can use Broadcast',
    'bcast.accessHint': 'Anyone ticked here can write to every employee and every contractor. The master always can.',
    'bcast.marketingNote': 'Marketing emails carry an unsubscribe link and skip anyone who opted out. Announcements do not — they are operational.',
    'bcast.placeholders': 'You can use {{name}} and {{first_name}} in the message.',
    // Barra de COC vencido (3+ días sin enviarse).
    'cocAlert.tag': 'COC pending', 'cocAlert.send': 'Send it now',
    'cocChip.sent': 'Sent', 'cocChip.toSend': 'Still to send', 'cocChip.open': 'Open COC',
    // Mi casilla de correo (perfil personal).
    'mbx.title': 'My mailbox', 'mbx.email': 'Email address', 'mbx.displayName': 'Name shown to recipients',
    'mbx.password': 'Password', 'mbx.saved': 'saved', 'mbx.leaveBlank': 'leave blank to keep it',
    'mbx.imap': 'Incoming server (IMAP)', 'mbx.smtp': 'Outgoing server (SMTP)',
    'mbx.test': 'Test connection', 'mbx.sync': 'Fetch now', 'mbx.remove': 'Disconnect',
    'mbx.connected': 'Connected', 'mbx.failing': 'Not connecting', 'mbx.untested': 'Not tested yet',
    'mbx.testOk': 'Connected — incoming and outgoing both work.',
    'mbx.testFail': 'Could not connect.', 'mbx.synced': '{n} new message(s).',
    'mbx.lastSync': 'last fetch {d}',
    'mbx.removeConfirm': 'Disconnect this mailbox? Your saved password is deleted.',
    'mbx.hint': 'Your own mailbox, so you can read and reply from here and emails land on the right claim by themselves. The servers are guessed from your domain — test the connection and fix them if needed. Your password is stored encrypted and is never shown again.',
    // Datos del mortgage (pestaña Payments del claim).
    'mtg.title': 'Mortgage', 'mtg.company': 'Mortgage company', 'mtg.name': 'Name for the endorsement',
    'mtg.loan': 'Loan number', 'mtg.poBox': 'P.O. Box / mailing address',
    'mtg.checkSent': 'Check sent to mortgage', 'mtg.sentOn': 'Sent {d}', 'mtg.notSent': 'Check not sent yet',
    'cocAlert.msg': "{name} — the COC has been waiting {days} days to go out.",
    'cocAlert.more': '+{n} more', 'cocAlert.dismiss': 'Snooze 5 min — leave a follow-up date to silence it until then',
    'cocAlert.whyTitle': 'This COC keeps waiting. Why is it not being sent? Your answer is saved as a follow-up on the claim.',
    'cocAlert.whyPh': 'e.g. waiting for the completion photos from the contractor…', 'cocAlert.answer': 'Save answer',
    // Reloj de fichaje (barra de arriba + Mis Horas).
    'clock.title': 'Time clock', 'clock.in': 'Clock in', 'clock.out': 'Clock out',
    'clock.breakStart': 'Start break', 'clock.breakEnd': 'End break',
    'clock.onBreak': 'On break', 'clock.blocked': 'Blocked',
    'clock.todayTotal': 'Today', 'clock.since': 'Since', 'clock.breaks': 'Breaks',
    'clock.myHours': 'My hours',
    'clock.blk.no_location': 'You have no work location assigned yet — ask a manager to set one.',
    'clock.blk.not_enabled': 'The time clock is not enabled for your account.',
    'clock.err.timeclock_off_network': "You're not on the office network. Clock in from the office, or ask a manager.",
    'clock.err.timeclock_period_locked': 'That pay period is already closed.',
    'clock.err.timeclock_not_enabled': 'The time clock is not enabled for your account.',
    'clock.err.timeclock_no_location': 'You have no work location assigned yet.',
    'bon.title': 'Bonuses', 'bon.settings': 'Settings',
    'bon.teamTotal': 'team total', 'bon.noTeams': 'No teams with a bonus for this month.',
    'bon.noMembers': 'This team has no active members — nobody to pay.',
    'bon.dept.claims': 'Claims', 'bon.dept.supplements': 'Supplements',
    'bon.role.account_manager': 'Account manager', 'bon.role.assistant': 'Assistant', 'bon.role.member': 'Member',
    'bon.eomHint': 'Employee of the Month — extra on top of any team bonus',
    'bon.explainClaims': '{n} approved claims · tier of {tier} pays {rate} per claim → {total}',
    'bon.explainSups': '{gained} obtained above the first estimate · tier of {tier} → {total}',
    // Cierre del período — la foto auditable del trimestre (mig 0377 + bonuses/snapshots).
    'bsnap.title': 'Quarter close',
    'bsnap.tab': 'Quarter close',
    'bsnap.intro': 'The audit photo of the quarter. Preview as many times as you need, save it as a draft, and seal it only when the claim list holds up: once sealed, nobody can change it — not even an admin. That is what makes a bonus reviewable months later, after a backfill has moved the data underneath.',
    'bsnap.recalc': 'Recalculate',
    'bsnap.ended': 'Period ended',
    'bsnap.inProgress': 'Period still running',
    'bsnap.sealed': 'Sealed',
    'bsnap.metric': 'Metric',
    'bsnap.result': 'Now',
    'bsnap.saved': 'Saved',
    'bsnap.sample': 'met/measured',
    'bsnap.threshold': 'Threshold',
    'bsnap.excludedCol': 'Excluded',
    'bsnap.status': 'Status',
    'bsnap.notSaved': 'not saved',
    'bsnap.draft': 'Draft',
    'bsnap.notAuditable': 'not auditable',
    'bsnap.driftHint': 'The saved number and the one just calculated do not match: something moved underneath (a backfill, a corrected date, a merged claim).',
    'bsnap.days': '{n} days',
    'bsnap.businessDays': '{n} business days',
    'bsnap.queryVersion': 'query version',
    'bsnap.trend': 'By quarter',
    'sr.title': 'Supplement review',
    'sr.st.pending': 'pending', 'sr.st.in_progress': 'in progress', 'sr.st.submitted': 'sent to carrier',
    'sr.st.approved': 'approved', 'sr.st.not_applicable': 'not applicable',
    'sr.helpPending': 'Nobody has said yet whether this claim needed a supplement. The claim cannot be closed until someone does.',
    'sr.helpDone': 'Answered by {quien} on {cuando}{motivo}.',
    'sr.blocking': 'This claim is already in a closing stage and the review is still pending — that is what is blocking the stage change.',
    'sr.markInProgress': 'Reviewing', 'sr.markSubmitted': 'Sent to carrier', 'sr.markNa': "Doesn't apply",
    'sr.undo': 'Back to pending', 'sr.reasonLabel': 'Reason it does not apply',
    'sr.re.carrier_estimate_complete': 'Carrier estimate was complete',
    'sr.re.damage_not_covered': 'Damage not covered', 'sr.re.client_declined': 'Client declined',
    'sr.re.already_repaired': 'Already repaired', 'sr.re.other': 'Other',
    'hero.needsSupplementReview': 'This claim cannot be closed until someone says whether it needed a supplement. Open the Supplements tab and answer the review at the top.',
    'po.tab': 'Operational performance',
    'po.title': 'Operational performance by department',
    'po.window': 'Period {desde} to {hasta} · trend against {ant}',
    'po.updated': 'updated {hora}',
    'po.threshold': 'threshold {u}',
    'po.definition': 'What this measures',
    'po.trust': 'Data reliability: {estado}. {medidos} of {total} cases could be measured ({cob} field coverage). The light rates the DATA, not the team.',
    'po.trust.verde': 'good', 'po.trust.amarillo': 'partial', 'po.trust.rojo': 'poor', 'po.trust.gris': 'not enough data',
    'po.empty': 'Nothing to list.',
    'po.col.claim_number': 'Claim', 'po.col.homeowner_name': 'Homeowner', 'po.col.lifecycle_status': 'Stage',
    'po.col.insurance_company': 'Carrier', 'po.col.assigned_person': 'Assigned', 'po.col.desde': 'Since',
    'po.col.quien': 'Who', 'po.col.fecha': 'Date', 'po.col.entro': 'Clocked in', 'po.col.tarde': 'Minutes late',
    'nav.companyBoard': 'Measurement board',
    'nav.effectiveness': 'Effectiveness',
    'nav.depreciationOwed': 'Depreciation owed',
    'dep.pendingTitle': 'COCs with no depreciation check',
    'dep.pendingHelp': 'We told the carrier the job was finished — the COC, the completion photos, or both — and the depreciation check never came back. Sorted oldest first. Only claims where that notice went out at least 90 days ago; before that the check may still be on its way.',
    'dep.amountUnknown': '{n} of these have no depreciation amount on file, so the money cannot be totalled. What is known adds up to {total}.',
    'dep.days': 'days', 'dep.client': 'Client', 'dep.carrier': 'Carrier', 'dep.am': 'Account manager',
    'dep.stage': 'Stage', 'dep.amount': 'Depreciation', 'dep.none': 'Nothing pending. ',
    'dep.amTitle': 'By account manager',
    'dep.amHelp': 'COC to depreciation check, over the mature cohort ({cohorte}) so recent cases that have not finished do not make everyone look fast. Threshold {u} days. THIS DOES NOT PAY A BONUS — it is here to be watched for a quarter first. Rows under {min} measurements are dimmed: at that size one case moves the number several points.',
    'dep.noCheck': 'no check', 'dep.meets': 'meets', 'dep.mix': 'Carrier mix',
    'dep.noAm': '(no account manager)', 'dep.smallSample': 'small sample',
    // Desde cuándo cuenta el reloj y de qué constancia salió esa fecha (anclaDelReloj.ts).
    'dep.since': 'Clock from',
    'dep.srcBoard': 'board date', 'dep.srcCocSent': 'COC tab',
    'dep.srcCocLog': 'send log', 'dep.srcEmail': 'email to the carrier',
    'eff.title': 'What we recovered',
    'eff.since': 'Since {d}',
    'eff.recovered': 'recovered above the first offer',
    'eff.claimsRaised': 'claims where we raised it',
    'eff.medianIncrease': 'median increase',
    'eff.toFirstCheck': 'median to first check',
    'eff.days': '{n} days',
    'eff.byQuarter': 'By quarter',
    'eff.method': 'How these numbers are built. "Recovered" is the difference between the insurance company\'s first estimate on a claim and the highest one it later issued, counted only when a new estimate exceeds the highest already reached — a downward correction never counts as a gain. The increase and the per-claim figure ({mediana} median per claim) are MEDIANS, not averages: the average is pulled up by a few large claims. Speed is measured on {n} claims, from the day the claim came in to the first check. The window starts on {desde}, when estimate capture became consistent; earlier quarters would measure our recordkeeping rather than our work.',
    'eff.shareTitle': 'Share with a client',
    'eff.shareHint': 'A link that opens without a login and shows exactly what you see above — no names, no individual claims, only totals. It always expires, and you can cut it off at any time.',
    'eff.labelPlaceholder': 'What is this link for? (e.g. Pérez family)',
    'eff.expiresIn': 'expires in (days)',
    'eff.createLink': 'Create link',
    'eff.noShares': 'No links yet.',
    'eff.copy': 'Copy link', 'eff.copied': 'Copied',
    'eff.revoke': 'Revoke', 'eff.revoked': 'revoked', 'eff.expired': 'expired',
    'eff.revokeConfirm': 'Revoke the link "{l}"? Anyone still holding it will stop seeing the numbers — but whoever already opened it has already seen them.',
    'eff.opened': 'opened {n}×', 'eff.until': 'until {d}',
    'eff.pdf': 'Download PDF',
    'eff.goneTitle': 'This link is not available',
    'eff.goneBody': 'It may have expired or been turned off. Ask whoever sent it to you for a new one.',
    'bsnap.trendHint': 'Filled dots are sealed quarters. Hollow dots and a dashed line mean the number can still move — either it is not sealed yet or the sample is under 30 measurements. The axis always runs 0-100: it is never cropped.',
    'bsnap.countedClaims': '{n} claims counted',
    'bsnap.excludedTitle': 'Left out ({n}) — each one with its reason',
    'bsnap.saveDraft': 'Save draft',
    'bsnap.seal': 'Seal the period',
    'bsnap.sealWarning': 'Sealing is irreversible: the numbers become read-only for everyone.',
    'bsnap.cantSealInProgress': 'The quarter has not ended yet — sealing it would freeze a half-finished number.',
    'bsnap.saveBeforeSealing': 'Save the draft first: there is nothing to seal.',
    'bsnap.alreadySealed': 'This period is sealed. The numbers can no longer change.',
    'bsnap.confirmTitle': 'Seal {p}?',
    'bsnap.confirmBody': 'The numbers, the claims that formed them and the exclusions are frozen exactly as they are now. Nobody can edit or delete them afterwards — not an admin, not the master. A later backfill will no longer change this quarter.',
    'bsnap.confirmNotAuditable': '{n} metric(s) are marked not auditable and will be sealed anyway: {m}. I have read them and I am sealing on purpose.',
    'bsnap.sealNow': 'Seal',
    'bon.seeClaims': 'See claim by claim',
    'bon.noSupClaims': 'No supplements closed this month for this team.',
    'bon.paid': 'counts', 'bon.outOfWindow': 'out of window', 'bon.singleEstimate': 'only one estimate',
    'bon.col.claim': 'Client', 'bon.col.first': 'First', 'bon.col.last': 'Last',
    'bon.col.gain': 'Obtained', 'bon.col.days': 'Days', 'bon.col.status': 'Status',
    'bon.claimsTiers': 'Claims — rate PER CLAIM',
    'bon.claimsTiersHint': 'From this many approved claims, each one pays this much. 30 claims at 15.00 = 450.00',
    'bon.claimsArrow': 'claims →',
    'bon.supTiers': 'Supplements — TOTAL team bonus',
    'bon.supTiersHint': 'From this much obtained, the team gets this bonus IN TOTAL (not per claim).',
    'bon.splits': 'How the team bonus is split',
    'bon.splitsHint': 'By number of members. The first share goes to the account manager. Each row must add up to 100%.',
    'bon.nMembers': '{n} members', 'bon.other': 'Other',
    'bon.eomBonus': 'Employee of the Month', 'bon.supDays': 'Days to pay a supplement',
    'bon.floor': 'Baseline floor', 'bon.floorHint': 'below this, it is a repair estimate',
    'bon.whoCanEdit': 'Who can change all this',
    'bon.whoCanEditHint': 'Only managers and up. You always can, and cannot be removed.',
    'bon.pool.a': 'Claims', 'bon.pool.s': 'Supplements', 'bon.pool.p': 'Payments',
    'bon.explainA': '{n} approved · tier of {tier} pays {rate} per claim → pool {pool}, paid in full this month.',
    'bon.explainA0': 'Below the first tier: no claims pool this month.',
    'bon.explainS': '{counted} gained on supplements within the window × {pct}% → {cents}.',
    'bon.explainS0': 'No supplements person on this team: the pool is not paid.',
    'bon.explainP': 'Check date within {dd} business days: {dok} of {dt} · arrived within {ad} business days: {aok} of {at} → {pct}% of {max} → {cents}.',
    'bon.explainPnone': 'No checks measured for this team this month.',
    'bon.explainP0': 'No payments person on this team: the pool is not paid.',
    'bon.capHit': 'Team cap of {cap} reached: every pool and every person cut to {pct}%.',
    'bon.role.supplements': 'Supplements', 'bon.role.payments': 'Payments',
    'bon.from': 'A {a} · S {s} · P {p}',
    'bon.seeDetail': 'Detail', 'bon.hideDetail': 'Hide',
    'bon.chk.stage': 'Check', 'bon.chk.start': 'Clock starts', 'bon.chk.dateSet': 'Date recorded', 'bon.chk.arrived': 'Arrived',
    'bon.chk.onTime': 'on time', 'bon.chk.late': 'late', 'bon.chk.notThisMonth': 'not this month',
    'bon.chk.from.status': 'entered the queue', 'bon.chk.from.approved': 'claim approved', 'bon.chk.from.resolved': 'Resolved', 'bon.chk.from.pre_approved': 'Pre-approved',
    'bon.chk.from.coc': 'COC sent', 'bon.chk.from.issued': 'check issued (no stage start in the app)',
    'bon.chk.none': 'No checks measured for this team this month.',
    'bon.chk.acv': 'ACV', 'bon.chk.supplement': 'Supplement', 'bon.chk.depreciation': 'Depreciation',
    'bon.chk.hint': 'Clock 1 runs from the start of the stage to the day the send date is recorded; clock 2 to the day the check arrives. Both in business days. The start is the entry to the queue (Waiting 1st Check), the Resolved or the COC sent; when the app has none of those, the claim approval, the Pre-approved, the board COC date or, as a last resort, the date printed on the check. Each row says which one it used. A second check of the same stage starts at its own issue date. Each check counts in the month its clock closed.',
    'bon.s.sup': 'Supplements pool', 'bon.s.supPct': '% of dollars gained in window', 'bon.s.supCap': 'Max gain counted per claim',
    'bon.s.pay': 'Payments pool', 'bon.s.payMax': 'Max per team per month', 'bon.s.payDateDays': 'Business days to get the check date', 'bon.s.payArrivalDays': 'Business days for the check to arrive',
    'bon.s.cap': 'Cap per team per month', 'bon.s.capHint': '0 = no cap. Applies to the sum of what is paid in the month.',
    'bon.s.rules': 'Split, fixed by rule: 40% of the claims pool to the account manager and 60% shared by the assistants; the closing part 40 / 30 / 15 / 15 across account manager, assistants, supplements and payments; supplements and payments pools go to their own person. If more people join a role, the same pool is split among more.',
    'bon.pool.pen': 'Closing', 'bon.explainPen': '{n} claims past the {months}-month closing deadline without reaching {stage}: {cents} deducted this month.',
    'bon.explainPen0': 'No penalties this month.',
    'bon.closingHint': 'A claim must reach {stage} within {months} months of its approval. If it does not, and no super-manager approved an extension, what was paid for that claim is deducted from the next bonus.',
    'bon.locked': 'Month closed on {at} by {by}', 'bon.lock': 'Close month', 'bon.lockConfirm': 'Close {month}? The numbers get frozen, every payment is recorded claim by claim, and the penalties due are deducted. This cannot be undone.',
    'bon.lockNotEnded': 'The month has to end before it can be closed.', 'bon.lockDone': 'Month closed: {paid} paid, {deducted} deducted.',
    'bon.gross': 'Gross', 'bon.deduction': 'Deduction', 'bon.net': 'Net',
    'bon.pen.claim': 'Claim', 'bon.pen.deadline': 'Deadline', 'bon.pen.paid': 'Paid for it', 'bon.pen.before': 'Already deducted', 'bon.pen.now': 'Deducted this month',
    'bon.pen.new': 'new', 'bon.pen.carried': 'carried over',
    'bon.tl.title': 'Closing timeline', 'bon.tl.hint': 'Each bar is the time from approval to the closing deadline ({months} months). Orange: less than 15 days left. Red: past the deadline. The team can ask for more time; a super-manager decides.',
    'bon.tl.approved': 'Approved', 'bon.tl.deadline': 'Deadline', 'bon.tl.left': '{n} days left', 'bon.tl.overdueBy': '{n} days over', 'bon.tl.none': 'No approved claims to follow for this team.',
    'bon.tl.st.on_track': 'on track', 'bon.tl.st.near': 'closing soon', 'bon.tl.st.overdue': 'past deadline', 'bon.tl.st.pending_extension': 'extension requested',
    'bon.tl.st.extended': 'extended', 'bon.tl.st.finalized': 'closed on time', 'bon.tl.st.late': 'closed late', 'bon.tl.st.waived': 'waived', 'bon.tl.st.penalized': 'penalized',
    'bon.tl.ask': 'Ask for more time', 'bon.tl.askReason': 'Why does this claim need more time? (this goes to the super-managers)', 'bon.tl.askUntil': 'Until which date? (YYYY-MM-DD)',
    'bon.tl.requested': 'Requested by {by} until {until}', 'bon.tl.approve': 'Approve', 'bon.tl.reject': 'Reject', 'bon.tl.waive': 'Waive',
    'bon.tl.approveUntil': 'New deadline (YYYY-MM-DD)', 'bon.tl.note': 'Note (optional)', 'bon.tl.decided': '{status} by {by}',
    'bon.tl.penalty': 'Penalty {paid} · deducted {applied}',
    'bon.s.closingMonths': 'Months from approval to closing', 'bon.s.closingStage': 'Stage that closes the claim',
    'ird.copyAddress': 'Copy address', 'common.backToTop': 'Back to top', 'files.view': 'View', 'files.estimateFrom': 'Estimate', 'files.estimateFromHint': 'Open this estimate in the Estimating Tool to add or remove items', 'files.estimateNeedsReading': 'Read the estimate first (the "Not read" chip) — then you can estimate from it.', 'files.expand': 'Show details', 'files.collapse': 'Hide details',
    'files.expandAll': 'Open all', 'files.collapseAll': 'Close all',
    'files.delete': 'Delete file', 'files.changeType': 'Change the document type', 'files.newType': 'Add a type…', 'files.newTypePrompt': 'Name of the new file type (e.g. Tarp invoice):',
    'files.savingType': 'Changing type…', 'files.fromImport': 'imported',
    'ft.estimate': 'Insurance carrier estimate',
    'ft.proactive_estimate': 'Proactive estimate',
    'ft.mitigation_estimate': 'Mitigation estimate',
    'ft.rebuild_estimate': 'Rebuild estimate',
    'ft.estimate_esx': 'ESX file',
    'ft.coc': 'COC',
    'ft.contract': 'Contract / LOR',
    'ft.policy': 'Policy',
    'ft.weather_report': 'Weather report',
    'ft.roof_diagram': 'Roof diagram',
    'ft.atr_video': 'ATR video',
    'ft.job_photo': 'Photo',
    'ft.invoice': 'Invoice / Check',
    'ft.email_attachment': 'Email attachment',
    'ft.info_pending': 'Requested document',
    'ft.other': 'Other document',
    'files.drop': 'Drag & drop files (multiple) or click — AI will classify them',
    'files.confirmTitle': 'Confirm what each file is — AI suggested a type, you have the last word',
    'files.confirmAiSays': 'AI says it is:',
    'files.confirmOk': 'Confirm',
    'files.confirmFix': 'Save correction',
    'files.uploading': 'Uploading',
    'files.parsingEstimate': 'Reading estimate',
    'files.empty': 'No files uploaded yet.',
    'files.validated': 'Validated',
    'files.addLink': 'Add file by link', 'files.linkPrompt': 'Paste the file link (Drive, Dropbox, CompanyCam…) — e.g. the ATR the contractor sent', 'files.linkNamePrompt': 'Name for this file (e.g. "ATR — Lazaro Rodriguez")', 'files.linkSaved': 'Link saved as a file', 'files.rename': 'Rename', 'files.catEstimates': 'Estimates', 'files.catCoc': 'COC', 'files.catContracts': 'Contracts / LOR', 'files.catChecks': 'Checks & Invoices', 'files.catPhotos': 'Photos', 'files.catAtr': 'ATR', 'files.catOther': 'Other documents', 'files.replace': 'Replace file (upload corrected version)', 'files.replacing': 'Replacing…', 'files.replaced': 'File replaced with the new version', 'files.renaming': 'Renaming…', 'files.renamed': 'File renamed', 'files.labelPh': 'Label (e.g. LOR)', 'files.namePh': 'File name',
    'files.addAtr': 'Add ATR video', 'files.atrPrompt': 'Paste the ATR video link (YouTube)…', 'files.atrSaved': 'ATR video saved', 'files.approved': 'Approved', 'files.rejected': 'Rejected', 'files.by': 'by', 'files.estimatesTitle': 'Estimates (ours & insurance)',
    'files.mismatch': 'Check data',
    'files.vsClaim': 'vs claim',
    'files.deleteConfirm': 'Delete this file?',
    'files.openNew': 'Open in new tab',
    'files.download': 'Download',
    'files.estimateNote': 'Detected as estimate — parsed & numbered in Finance.',
    'files.uploadedBy': 'by',
    // ── Pestañas de Files (2026-08-21) ──
    'files.tabEstimates': 'Estimates',
    'files.tabInvoices': 'Invoices',
    'files.tabContract': 'Contract & policy',
    'files.tabCoc': 'COC',
    'files.tabReports': 'Reports',
    'files.tabPhotos': 'Photos',
    'files.tabEmail': 'From email',
    'files.tabCasa': 'Company docs',
    'files.tabAll': 'All',
    // ── Cómo llegó cada archivo ──
    'files.howArrived': 'How it arrived:',
    'files.origEmail': 'Came by email from {de}',
    'files.origJobflow': 'From the contractor (JobFlow)',
    'files.origMonday': 'Imported from Monday',
    'files.origLink': 'Added as a link',
    'files.origSystem': 'Generated by the app',
    'files.origUpload': 'Uploaded by {quien}',
    'files.origUploadDesde': 'Uploaded by {quien} from {pantalla}',
    'files.origDesconocido': 'Origin not recorded',
    'files.openEmail': 'Open the email →',
    'files.casaDoc': 'Company document',
    // ── Duplicados ──
    'files.dupSkipped': 'Already in this claim ({n}): {nombres}. Not saved again.',
    // ── Archivado (sacar de la lista sin borrar) ──
    'files.archiveHint': 'Archive — takes it out of the list without deleting it',
    'files.archived': 'Archived. You can bring it back from the drawer below.',
    'files.unarchive': 'Restore',
    'files.unarchiveHint': 'Bring it back to the list',
    'files.unarchived': 'Back in the list.',
    'files.archivedDrawer': 'Archived',
    'files.archivedEmpty': 'Nothing archived in this claim.',
    'files.archivedByCleanup': 'by the cleanup',
    'files.motivoFirma': 'email signature',
    'files.motivoDuplicado': 'duplicate',
    'files.motivoGenerico': 'company document',
    // ── Usar el archivo en Payments sin volver a subirlo ──
    'files.usePayments': 'Use in Payments',
    'files.usePaymentsHint': 'Reads the numbers off this file for the invoice — no need to download it and upload it again',
    'files.readingNumbers': 'Reading the numbers of',
    'files.numbersRead': 'Numbers read: {monto}. They are already in Payments.',
    'files.numbersReading': "Reading the estimate… the numbers will appear by themselves in about 2 minutes.",
    'files.numbersFailed': 'Could not read the numbers: {err}. Load them by hand in Payments.',
    'files.pickFromFiles': 'Or pick an estimate already in Files',
    'files.pickFromFilesHint': 'Reads it straight from the claim — no downloading and re-uploading',
    'files.noEstimatesInFiles': 'No estimates in Files yet.',
    'files.analyze': 'Analyze',
    'files.sharedCo': 'Shared with contractor',
    'files.hiddenCo': 'Hidden from contractor',
    'files.shareCoHint': 'Click to SHARE this file with the contractor in JobFlow',
    'files.hideCoHint': 'The contractor sees this file in JobFlow. Click to HIDE it (it stays here, nothing is deleted).',
    'files.savingVisibility': 'Updating sharing…',
    'files.portalVisible': 'The client sees this file in their portal — click to hide it',
    'files.portalManual': 'Set by a person',
    'files.portalWhy.no_marcado': 'The client does not see this file — click to show it',
    'files.portalWhy.tipo_no_permitido': 'This document type is not ticked in Settings → Client Portal, so the client never sees it',
    'files.portalWhy.tipo_prohibido': 'Never shown to the client: checks and recordings',
    'files.portalWhy.documento_generico': 'A company document (W-9, PA license), not part of this claim',
    'files.portalWhy.del_contratista': 'Came from the contractor and its type is not ticked in Settings',
    'files.portalWhy.archivado': 'Archived',
    'files.portalWhy.adjunto_hijo': 'An attachment of another file',
    'files.analyzeHint': 'Re-read this imported file with AI, as if uploading it now (classify + read amounts).',
    'files.amountEditHint': 'Click to correct the amount by hand (AI misreads happen)',
    'files.amountSaved': 'Amount saved', 'files.savingAmount': 'Saving amount…',
    'files.repairEstimate': 'Repair estimate', 'files.repairBy': 'Marked repair by', 'files.repairEstimateHint': 'Approved for repair — not a full-replacement approval; excluded as supplement baseline.',
    'files.repairBySystem': 'the system (backfill)',
    'files.repairRemoveHint': 'Remove this label — the estimate goes back to counting as a full approval',
    'files.repairRemoveConfirm': 'Remove the "Repair estimate" label? The estimate will count again as a full approval (it does not change the claim status).',
    'files.repairRemoved': 'Repair label removed',
    'files.repairSet': 'Marked as repair estimate',
    'files.tagSetBy': 'Label set by',
    'files.tagAutoShort': 'auto',
    'files.tagAutoWhy': 'Nobody set this label — the rule did, by amount and order. "Approved estimate" only means it is the FIRST insurance estimate, the baseline for counting supplement rounds. It does NOT mean the carrier approved the claim. If this one is a repair or a partial, change the label here.',
    'files.tagAuto': 'Automatic',
    'files.tagNotARound': 'Not a round',
    'files.tagHint': 'Fix this label by hand: repair, which round it is, leave it out of the sequence, or mark it as a tarp / mitigation / inspection (ATR) estimate that ADDS to the approved RCV. It applies to every copy of the same estimate.',
    'files.tagSaved': 'Label updated',
    // Estimados del seguro que SUMAN al RCV (dueño 2026-10-23): tarp, mitigación, inspección / ATR.
    'etag.tarp': 'Tarp estimate', 'etag.insMitigation': 'Mitigation estimate', 'etag.atr': 'Inspection / ATR estimate',
    'etag.addsToRcv': 'Adds to the approved RCV (not a round)',
    'files.repairTagHint': 'Change the label: Repair estimate, or Automatic to let the rule decide (Approved / Round N by amount and order).',
    'files.initialOurs': 'Proactive initial estimate', 'files.initialOursBy': 'Made by', 'files.initialOursHint': 'Our first estimate — this claim can no longer return to the First Estimate queue.',
    'etag.proactive': 'Proactive estimate', 'etag.approved': 'Approved estimate', 'etag.round': 'Round {n}',
    'etag.mitigation': 'Mitigation estimate', 'etag.insurance': 'Insurance estimate',
    'etag.analyzedBy': 'Analyzed by', 'etag.vs': 'vs', 'etag.counter': 'Proactive counter offer {n}',
    'etag.ours': 'Ours', 'etag.theirs': 'Insurance', 'etag.asking': 'Asking over', 'etag.prevRounds': 'Previous rounds', 'etag.increase': 'Increase',
    'files.analyzeContract': 'Analyze contract',
    'files.analyzeContractHint': 'Read this contract/LOR PDF with AI and validate it against the claim (name, address, insurance, policy #, signing date). Shows up in Claim Review.',
    'files.contractOk': 'Contract analyzed — everything matches the claim. See Claim Review.',
    'files.contractSignedMoved': 'Signed contract confirmed — moved to Contract Signed.',
    'files.contractIssues': 'Contract analyzed — {n} thing(s) to review. See Claim Review.',
    'files.analyzing': 'Analyzing',
    'files.analyzed': 'File analyzed',
    'files.analyzingAll': 'Analyzing all imported files…',
    'files.analyzedN': 'files analyzed',
    'files.analyzeAll': 'Analyze all imported',
    'files.analyzeAllHint': 'Re-reads every imported file with AI (classifies + reads amounts + dates).',
    'files.esxDownload': 'Download ESX',
    'files.esxNone': 'No ESX yet',
    'files.esxUpload': '⬆ Upload ESX',
    'files.esxReplace': '⬆ Replace ESX',
    'files.esxSaved': 'ESX saved',
    'files.docTotal': 'Document total',
    'files.deductible': 'Deductible',
    'files.depreciation': 'Depreciation',
    'files.netClaim': 'Net claim',
    'files.buildingCode': 'State building code (estimate)', 'files.newestFirst': 'Newest to oldest', 'smsModal.sms': 'Send SMS (opens the conversation)', 'smsModal.call': 'Call', 'smsModal.empty': 'No SMS with this number yet. Write the first one below.', 'files.emailContractor': 'Email to contractor', 'files.emailHomeowner': 'Email to homeowner', 'files.emailSent': 'Sent to {to} from claims@ with the file attached.', 'files.noContractorEmail': 'This claim has no contractor email on file.', 'files.noHomeownerEmail': 'This claim has no homeowner email on file.', 'files.oldestFirst': 'Oldest to newest', 'files.sortHint': 'Toggle the order by date',
    'files.priceList': 'Price list',
    'files.plCurrent': 'up to date',
    'files.plOutdated': '{n} mo old — outdated',
    'files.applying': 'Applying…',
    'files.approvedFull': 'Approved — claim status set to Approved, copied to Review Estimate',
    'files.sentToReview': 'Sent to Review Estimate (insurance vs our estimate)',
    'files.approvedRepair': 'Approved for repair — moved to the repair queue (waiting for check)',
    'cd.noFiles': 'No files yet.',
    'cd.estimate0': 'Estimate',
    'cd.tabTracking': 'Tracking',
    'cd.trackingEmpty': 'No activity yet.',
    'cd.daysInRepair': 'days in Approved for repair',
    'cd.homeownerAddress': 'Homeowner address',
    'cd.homeownerEmail': 'Homeowner email',
    'cd.assignedPerson': 'Assigned to (Monday)',
    'cd.feeAlert': "You've collected {pct}% of the fee — make sure to collect the rest",
    'cd.feeAlertSub': 'Remaining fee to collect:',
    'cd.hoAuthDrop': 'Drag the homeowner authorization here or click',
    'cd.contractorAuthTitle': 'Contractor Payment Authorization',
    'cd.contractorAuthHelp': 'Homeowner authorization to pay the contractor. You can request and upload it now — even before the invoice — so it is ready when you pay.',
    'cd.contractorAuthDrop': 'Drag the signed authorization here or click to upload',
    'cd.contractorAuthReplace': 'Replace',
    'cd.contractorAuthPending': 'Not yet authorized.',
    'cd.authUploadLabel': 'Upload the proof to authorize payment to',
    'cd.authRequest': 'Request authorization from homeowner',
    'cd.authRequested': 'Authorization requested',
    'cd.authCancel': 'Cancel request',
    'cd.authCancelConfirm': 'Cancel the payment authorization request?',
    'cd.authCancelled': '✓ Request cancelled.',
    'cd.authRequestHelp': 'Adds it to “Request Payment Authorization” so you can chase it.',
    'cd.listenAuth': 'Listen',
    'cd.authDeleteConfirm': 'Delete the saved contractor authorization?',
    'cd.hoAuthMissing': 'Not authorized yet — upload it in “Contractor Payment Authorization” above.',
    'cd.proofDrop': 'Drag the proof of payment here or click',
    'cd.uploading': 'Uploading…',
    'cd.fileReady': 'File uploaded',
    'cd.waivedManagerOnly': 'Only managers can waive a line',
    'cd.toCompanyManagerOnly': 'Only managers can send a line to the company (it takes the full amount out of the payout)',
    'cd.toCompany': 'to company',
    'cd.toCompanyHelp': "Proactive's work billed to insurance: the full amount goes to Proactive (expense, no fee, out of the contractor payout).",
    'cd.performance': 'Performance',
    'cd.performanceHelp': 'How many days the claim spent in each status.',
    'perf.help': 'Every time the claim status changes we save the date and count the days it spent there.',
    'perf.totalDays': 'Total days tracked', 'perf.currentStatus': 'Current status', 'perf.stages': 'Stages',
    'perf.claimStatusTimeline': 'Claim status timeline', 'perf.paymentTimeline': 'Payments status timeline',
    'perf.empty': 'No status changes recorded yet.',
    'cd.since': 'Since',
    'cd.current': 'current',
    'cd.received': 'Received',
    'cd.expected': 'expected',
    'cd.pending': 'Pending',
    'cd.deductibleNote': 'never comes to us',
    'cd.recon': 'Reconciliation',
    'paysum.title': 'Payment summary by email (AI)',
    'paysum.subtitle': 'For when the homeowner or contractor calls asking about the payments',
    'paysum.sendTo': 'Send to',
    'paysum.language': 'Language',
    'paysum.generate': 'Generate payment summary',
    'paysum.generating': 'Writing the summary…',
    'paysum.help': 'Claude writes it in plain, simple language and we add the money bar, the checks, the invoices and the exact figures. Review it before sending.',
    'paysum.willSendTo': 'Will be sent to',
    'paysum.fromPayments': 'from the Payments mailbox',
    'paysum.subject': 'Subject',
    'paysum.regenerate': 'Regenerate',
    'paysum.send': 'Send summary',
    'paysum.confirmSend': 'Send this payment summary by email?',
    'paysum.sent': 'Summary sent — saved in Payments Department Updates and in the tracker.',
    'paysum.errNoHoEmail': 'This claim has no homeowner email.',
    'paysum.errNoCoEmail': 'This claim has no contractor email.',
    'paysum.errNoAi': 'AI is not configured (missing Claude API key).',
    'payTl.coc.sent': 'COC sent to the adjuster',
    'payTl.summary.sentHomeowner': 'Payment summary sent to homeowner',
    'payTl.summary.sentContractor': 'Payment summary sent to contractor',
    'rec.recoveryTitle': 'Insurance recovery — what the carrier still owes',
    'rec.edit': 'Fix these numbers', 'rec.resetCalc': 'Back to the calculated ones',
    'rec.editedBy': 'edited by {who} · {when}',
    'rec.editHint': 'Only the numbers the AI reads off the estimate. Checks, fee and payouts come from real records — fix those where they were entered.',
    'rec.calcWas': 'calculated: {v}', 'rec.whyPh': 'Why are you changing it? (stays on record)',
    'rec.distributionTitle': 'What we did with the money received',
    'rec.rcv': 'RCV approved',
    'rec.deductible': 'Deductible',
    'rec.nonRecovDepr': 'Non-recoverable depreciation',
    'rec.checksReceived': 'Checks received',
    'rec.stillOwed': 'Still owed by insurance (expected check)',
    'rec.stillOwedNote': 'Same math as the invoice PDF. Recoverable depreciation is NOT subtracted — it comes as another check.',
    'rec.fullyCollected': 'Fully collected — nothing pending',
    'rec.fullyCollectedNote': '✓ Every dollar the carrier owed for this claim has arrived.',
    'rec.overpaidNote': '⚠ The carrier sent MORE than the approved RCV — check the estimate or a missing approved line.',
    'rec.rcvDelSeguro': "Taken from the insurance estimate: the claim's RCV matched our own estimate, which is what we are asking for, not what was approved.",
    'rec.rcvViejo': 'The approved RCV looks out of date',
    'rec.rcvViejoNota': 'The carrier already sent more than this RCV allows — it is short by at least {falta}, so the approved amount should be at least {minimo}. Almost always a supplement that was paid but never entered the number. The fee is being calculated on the old figure. Check it and fix the RCV before invoicing.',
    'rec.recoverableHint': 'Recoverable depreciation of {amount} is still pending: it arrives as a second check once the work is done.',
    'rec.fee': 'PA fee charged',
    'rec.paidCo': 'Paid to contractor',
    'rec.jumpHelp': 'Go to this payment in the tracker below (to see the proof / which one it was)',
    'cdw.financeUpdates': 'Finance Department Updates',
    'rec.noEstimate': 'No approved estimate yet',
    'rec.noEstimateNote': 'This claim has no approved RCV loaded yet. Once the estimate is analyzed you will see here how much the carrier still owes.',
    'pb.noEstimate': 'no estimate yet',
    'pb.noEstimateNote': 'No approved estimate loaded yet — analyze the estimate to see how much is expected.',
    'rec.paidHo': 'Paid to homeowner',
    'rec.cuentaNoCuadra': 'These numbers do not add up',
    'rec.cuentaNoCuadraNota': 'What has been distributed exceeds what came in by {monto}. Almost always this means one delivery is recorded twice — a check someone took AND a payment for that same money. Check this claim\u2019s Checks and Payments before invoicing.',
    'rec.deudaPendiente': 'Owed back to us: {monto}',
    'rec.deudaPendienteNota': 'This was already paid out and has to come back. It will be deducted from the payout of the next invoice on this claim, automatically.',
    'rec.committed': 'Committed (invoiced, not paid yet)',
    'rec.comprometeDeMas': 'This claim is about to pay out more than came in',
    'rec.comprometeDeMasNota': 'Counting what is already invoiced and waiting to be paid, {monto} more than the insurance sent would go out. Check it before the payment leaves — afterwards it has to be recovered.',
    'rec.allDistributed': 'All distributed',
    'rec.allDistributedNote': '✓ Everything received was billed and paid out.',
    'rec.toDistribute': 'Still to distribute',
    'rec.toDistributeNote': 'Money already in the bank that has not been billed or paid out yet.',
    'rec.overDistributed': 'Paid out over what was received',
    'rec.overDistributedNote': '⚠ Fee + payouts exceed the checks received. Review the payments.',
    'cd.reconRcv': 'RCV total',
    'cd.reconDeductible': 'Deductible',
    'cd.reconRps': 'RPS factor (depreciation)',
    'cd.reconFee': 'PA fee charged',
    'cd.reconPaidCo': 'Paid to contractor',
    'cd.reconPaidHo': 'Paid to homeowner',
    'cd.reconDiff': 'Difference',
    'cd.reconOk': 'Everything received and paid — balances to $0.',
    'cd.reconOff': 'Pending to receive or pay until it balances to $0.',
    'cd.extracted': 'Extracted values —',
    'cd.humanValidation': 'require human validation before billing',
    'cd.useRcv': 'Use RCV in the invoice',
    'cd.genInvoice': 'Generate invoice',
    'cd.line': '+ line',
    'cd.deductTitle': 'Deduct from the payout',
    'cd.deductHelp': 'Money the contractor or homeowner already received and has to be recovered. It comes off the payout, not off the fee.',
    'cd.deductBounced': 'This claim has {n} BOUNCED check(s) for {amount}. If someone was already paid with that money, deduct it here — otherwise it gets paid twice.',
    'cd.deductAmount': 'Amount ($)',
    'cd.deductReason': 'Reason (e.g. paid from the bounced check)',
    'cd.histDrop': 'Drop a historical invoice PDF here — AI reads it (for invoices issued before this CRM)',
    'cd.histReading': 'Reading the invoice',
    'cd.histConfirm': 'Confirm the historical invoice',
    'cd.histHelp': 'Check every amount before saving. The fee you enter here is the fee the NEXT invoice will not charge the client again.',
    'cd.histNumber': 'Invoice #',
    'cd.histDate': 'Date',
    'cd.histRcv': 'RCV approved ($)',
    'cd.histFee': 'Fee charged ($)',
    'cd.histPayout': 'Paid out ($)',
    'cd.histPaidTo': 'Paid to',
    'cd.histPaidToNone': '— not recorded —',
    'cd.histSave': 'Save historical invoice',
    'cd.histSaved': 'Historical invoice loaded.',
    'cd.histInvalid': 'Enter the fee and the amount paid out.',
    'cd.histOffsetWarn': 'CAREFUL: this claim already carries an opening balance of {amount} from the Excel import — check you are not counting the same fee twice.',
    'cd.cobroOpenHelp': 'They paid us? Record it here with the proof.',
    'cd.cobroAmount': 'Amount they paid ($)',
    'cd.cobroPaidBy': 'Who paid us',
    'cd.cobroDate': 'Date paid',
    'cd.cobroProof': 'Proof of payment',
    'cd.cobroSave': 'Record payment',
    'cd.cobroSaved': 'Payment recorded — this fee no longer shows as owed.',
    'cd.cobroInvalid': 'Enter the amount they paid.',
    'cd.cobroPaidUs': 'They paid us',
    'cd.cobroViewProof': 'View proof',
    'cd.cobroNoProof': 'no proof attached',
    'cd.cobroUndo': 'Undo',
    'cd.cobroDeleteConfirm': 'Undo this payment? The fee goes back to showing as owed.',
    'cd.condition': 'Payment condition (%)',
    'cd.checkForInvoice': 'Checks for this invoice — pick one or more (the total is summed)',
    'cd.checkAmountManualHelp': 'or type an amount to invoice only part of the check',
    'cd.checkAmountOver': '{typed} is more than the {available} available in checks — check the amount before issuing.',
    'cd.checkAmountOverBilled': '{typed} is more than the {available} left to invoice: {total} in checks − {billed} already invoiced.',
    'cd.checkLeftToInvoice': 'Left to invoice: {left} ({total} in checks − {billed} already invoiced)',
    'cd.checkUsed': 'already invoiced',
    'cd.checkUsedPaid': 'already invoiced and paid',
    'cd.checkUsedHint': 'This check was already invoiced in {where}, so it cannot be used again.',
    'cd.checkUsedPaidHint': 'This check was already invoiced in {where} and that invoice was paid. Using it again would pay the same money twice.',
    'cd.checkLeftOnIt': '{left} left',
    'cd.checkForInvoiceManual': 'Check amount ($) — for payout / mode B',
    'cd.checkForInvoiceNote': 'You can invoice with deposited checks; paying still requires the check to be available.',
    'cd.checksSelected': 'Selected',
    'cd.fullFee': 'Charge full fee on this check (final check)',
    'cd.fullFeeHelp': 'Mode B: no more checks expected → take all the remaining fee now (capped by the check).',
    'cd.auto': 'auto',
    'cd.feeRate': 'Fee rate (%)',
    'cd.feeZeroWarn': 'Fee is 0% — the invoice will not charge any fee. Set it here.',
    'cd.contractSignedAt': 'Contract signed at {p}%',
    'cd.contractAt': 'Contract at {p}%',
    'cd.expectedTitle': 'Expected checks',
    'cd.expectedHelp': 'Checks we expect from the estimate (ACV, recoverable depreciation, supplements). Add from a suggestion or manually.',
    'cd.expectedSuggested': 'Suggested from the estimate',
    'cd.expectedLabel': 'Description',
    'cd.expectedReceived': 'Received',
    'cd.expectedPending': 'Pending',
    'cd.expectedAdd': 'Add',
    'cd.expectedNeedLabel': 'Enter a description for the expected check.',
    'cd.expectedNeedAmount': 'Enter a valid amount (e.g. 4188.49).',
    'cd.estVersions': 'Estimates',
    'cd.estVersionsHelp': 'Each estimate that arrives is saved as a version, with the increase vs the previous one.',
    'cd.estDate': 'Arrived',
    'cd.estViewFile': 'View PDF',
    'cd.estSummary': 'Total increase (estimate 1 → last)',
    'cd.estNoChange': 'no changes',
    'cd.estDeleteConfirm': 'Delete this estimate version?',
    'cd.loadFailed': "This claim couldn't be opened.",
    'cd.partialLoad': 'Some parts of this claim did not load. What you see may be incomplete.',
    'cd.moneyDataIncomplete': 'Invoice data did not load, so amounts cannot be checked against what was already billed.',
    'cd.backToClaims': 'Back to Claims',
    'cd.netClaim': 'Net Claim',
    'cd.netClaimHelp': '(expected check = ACV − deductible)',
    'cd.netClaimRecov': 'Net Claim if depreciation recoverable',
    'cd.netClaimRecovShort': 'Net Claim (recov.)',
    'cd.netClaimRecovHelp': 'Total collectible if the depreciation is recoverable (net claim + depreciation = RCV − deductible).',
    'cd.depreciation': 'Depreciation',
    'cd.recoverable': 'Recoverable',
    'cd.nonRecoverable': 'Non-recoverable',
    'cd.acvReceived': 'ACV received',
    'cd.deprReceived': 'Depreciation received',
    'cd.preview': 'Preview (both modes)',
    'cd.generateDraft': 'Generate draft invoice',
    'cd.feeMethod': 'Fee method',
    'cd.feeMethodPercent': 'Fee %',
    'cd.feeMethodFlat': 'Flat fee',
    'cd.feeMethodFlatHelp': 'Charge a fixed amount instead of the %. Use it to continue a claim that was billed flat (e.g. the same $500 on the next check). Pick the check(s) below.',
    'cd.flatFeeTitle': 'Flat fee invoice (super-manager)',
    'cd.flatFeeHelp': 'Charge a fixed fee with no insurance check (e.g. claim below deductible). No payout.',
    'cd.flatFeeAmount': 'Flat fee $',
    'cd.flatFeeGenerate': 'Generate flat fee',
    'cd.flatFeeInvalid': 'Enter a valid flat fee amount.',
    'cd.flatFeeCheck': 'Check amount (optional)',
    'cd.flatFeeBreakdown': 'Check − fee = payout',
    'cd.flatFeeOverCheck': 'The flat fee cannot exceed the check amount.',
    'cd.modeA': 'Mode A (incremental)',
    'cd.modeB': 'Mode B (per-check cap)',
    'cd.deferred': 'Deferred',
    'cd.feeToCharge': 'Fee to charge (current mode)',
    'cd.payout': 'Payout',
    'cd.wait': 'Check wait',
    'cd.noWait': 'No check awaited.',
    'cd.expectCheck': 'Expect a check',
    'cd.awaitingAck': 'Awaiting send ack',
    'cd.inTransit': 'In transit · sent {d}d ago',
    'cd.markSent': 'Mark check as sent',
    'cd.restartWait': 'Restart wait',
    'cd.doNotDeposit': 'Do not deposit',
    'cd.doNotDepositHelp': 'Is a check coming that should NOT be deposited? Flag it and you will be alerted when it arrives.',
    'cd.doNotDepositOn': 'When this check arrives in Checks Received, you will see a "do not deposit" alert.',
    'cd.allowDeposit': 'Allow deposit',
    'cd.updates': 'Board updates (Monday)',
    'cd.noUpdates': 'No updates yet.',
    'cd.writeUpdate': 'Write an update…',
    // JOBFLOW P2-7 — contractor updates feed
    'cu.viewOn': 'Contractor view',
    'cu.viewOff': 'Contractor view',
    'cu.viewHint': 'Preview exactly what the contractor sees (shared entries only).',
    'cu.previewNote': 'This is what the contractor sees — only entries you shared.',
    'cu.nothingShared': 'Nothing shared with the contractor yet.',
    'cu.share': 'Share with contractor',
    'cu.unshare': 'Unshare',
    'cu.sharedBadge': 'Shared',
    'cu.generate': 'Generate update',
    'cu.generateHint': 'Draft a professional contractor-facing update with AI (excludes internal notes).',
    'upd.attach': 'Attach file or screenshot',
    'upd.title': 'Updates',
    'upd.empty': 'No updates yet.',
    'upd.placeholder': 'Write an update…',
    'upd.post': 'Post',
    'upd.search': 'Search in updates…',
    'upd.showAll': 'Show all {n} updates', 'upd.showLatest': 'Show only the latest',
    'upd.noMatch': 'No updates match your search.',
    'fu.compose': 'Write a follow-up…',
    'fu.title': 'Follow-up',
    // Chips de follow-up del To Do (número + unidad; el texto va aparte para que traduzca bien).
    // Bloque del manager: lo que todavía no tiene dueño.
    // Selección múltiple (estilo Monday): barra flotante con el conteo y las acciones del lote.
    // Company dashboard
    'common.error': 'Could not load.',
    'nav.company': 'Company',
    'cdash.title': 'Company dashboard', 'cdash.day': 'Day', 'cdash.week': 'Week', 'cdash.month': 'Month',
    'cdash.allAms': 'All account managers', 'cdash.allTeams': 'All claim teams',
    'scope.noneMineShowingAll': 'nothing assigned to you here — showing everything',
    'cdash.contractor': 'Contractor', 'cdash.date': 'Date',
    'cdash.allContractors': 'All contractors', 'cdash.searchPh': 'Contractor or account manager…',
    // Claves que se usaban en el codigo pero nunca llegaron al diccionario: en pantalla salia el
    // identificador crudo ("cdw.phone"). Las detecta ahora scripts/checkI18n.mjs.
    'cdw.claimNumber': 'Claim #', 'cdw.name': 'Name', 'cdw.phone': 'Phone',
    'dept.claimStatus': 'Claim status',
    'common.change': 'Change', 'common.done': 'Done', 'common.optional': 'optional',
    'nem.attach': 'Attach files',
    'upd.dropHere': 'Drop image/file here',
    'cdash.approvedIn': 'Approved in {p}', 'cdash.newIn': 'New claims in {p}',
    'cdash.rcv': 'RCV', 'cdash.days': 'Days',
    'cdash.daysHint': 'Days from the inspection to the approval',
    'cdash.noInspection': 'No inspection on record for this claim',
    'cdash.prev': 'Previous period', 'cdash.next': 'Next period', 'cdash.today': 'Current',
    'cdash.weekOf': 'week of', 'cdash.thisWeekHint': 'rolling, regardless of the period above',
    'cdash.approvedMonth': 'Approved this month', 'cdash.approvedWeek': 'Approved · last 7 days',
    'cdash.newPeriod': 'New claims', 'cdash.totalActive': 'Active claims',
    'cdash.newByContractor': 'New claims by contractor', 'cdash.approvedByContractor': 'Approved by contractor',
    'cdash.byContractor': 'Claims by contractor', 'cdash.toFile': 'Claims to file', 'cdash.sinAgendar': 'Waiting to be scheduled', 'cdash.sinAgendarEmpty': 'Everything is scheduled.', 'cdash.tagAdjuster': 'Adjuster meeting', 'cdash.tagClaimIn': 'Claim in', 'cdash.tagReinspection': 'Re-inspection requested', 'cdash.tagAtr': 'ATR', 'cdash.tagWelcome': 'Welcome call',
    'cdash.cocToSend': 'COC to send', 'cdash.waitingApproval': 'Waiting approval',
    'cdash.waitingCompletion': 'Waiting project completion', 'cdash.empty': 'Nothing here right now.',
    'cdash.dayRange': 'last 14 days', 'cdash.weekRange': 'last 8 weeks', 'cdash.monthRange': 'last 6 months',
    'cdash.approvedCoverage': 'Approval date known for {n} of {total} claims — it is only recorded when the stage changes inside the app, so the history before that is incomplete.',
    'bulk.assign': 'Assign to', 'bulk.moveTo': 'Move to', 'bulk.followUp': 'Follow up', 'bulk.archive': 'Archive',
    'bulk.fuNote': 'Bulk follow-up', 'bulk.archiveConfirm': 'Archive {n} claims? They leave every view.',
    'bulk.selected': '{n} selected', 'bulk.clear': 'Clear selection', 'bulk.all': 'Select all',
    'bulk.working': 'Applying… {done} of {total}', 'bulk.doneOk': '{n} updated',
    'bulk.donePartial': '{ok} updated · {failed} failed',
    'diary.unassigned': 'Unassigned', 'diary.assignTo': 'Assign to…',
    'diary.unassignedHelp': 'Nobody sees these in their own list — assign them so someone works them.',
    'diary.noTeamChip': 'no claim team',
    'fu.dUnit': 'd', 'fu.ago': 'ago', 'fu.in': 'in', 'fu.late': 'late',
    'fu.agoToday': 'today', 'fu.dueToday': 'due today', 'fu.fuNever': 'no follow-up yet',
    'fu.tipDays': 'Days in this view', 'fu.tipLast': 'Last follow-up: {d}', 'fu.tipNext': 'Next follow-up: {d}',
    'todo.asInView': 'As seen in “{view}”',
    'fu.lastFu': 'Last follow-up',
    'fu3.claims': 'Claims', 'fu3.supplements': 'Suppl.', 'fu3.payments': 'Payments',
    'fu3.ok': 'on time', 'fu3.none': 'no follow-up in this department',
    'fu3.never': 'never', 'fu3.idle': 'no follow-up for this status (see the view settings)',
    'fu3.late': '{d}d late',
    'fu3.today': 'today', 'fu3.in': 'in {d}d',
    'fu3.calc': 'calculated from the cadence, no date was scheduled',
    'fup.inStatus': 'days in status', 'fup.noFollowUp': 'without follow-up', 'fup.lastFollowUp': 'last follow-up',
    'fup.next': 'next follow-up', 'fup.never': 'never followed up', 'fup.btn': 'Follow up',
    'fup.btnHint': 'Opens the Department Update to write the follow-up and log it.',
    'fup.modalTitle': 'Department Update',
    'fu.daysNoFu': 'Days without follow-up',
    'fu.daysInStage': 'Days in this stage (not days without follow-up)',
    'fu.nextFu': 'Next follow-up', 'fu.checkSent': 'Check sent', 'fu.checkSentHint': 'Check info already obtained — nothing to chase; follow-up alert is off until it arrives.',
    'fu.daysWaiting': 'days waiting',
    'fu.never': 'never',
    'fu.due': 'due',
    'fu.logTitle': 'Log a follow-up',
    'fu.channel': 'Channel',
    'fu.note': 'Note (what happened)',
    'fu.log': 'Log follow-up',
    'fu.insAdjTitle': 'Insurance & adjuster',
    'fu.insurance': 'Insurance company',
    'fu.adjuster': 'Desk adjuster (name / phone / email)',
    'fu.fieldAdjuster': 'Field adjuster (name / phone / email)',
    'fu.adjusterPh': 'Name · phone · email',
    'fu.saveAdj': 'Save & post update',
    'fup.bd': 'business days',
    'fup.agoShort': '{d}d ago',
    'fup.noClock': 'no follow-up in this status',
    'fup.inStatusHint': 'Business days (Mon–Fri) since it entered this status on {d}',
    'fup.lastHint': 'Days since the last follow-up logged in Supplements, and who did it. Red from the 4th day without one.',
    'fup.nextHint': 'Next follow-up: scheduled by hand, or calculated from the cadence of this status. Green = on time · yellow = due today or tomorrow · red = overdue.',
    'fu.savedGeneral': 'Saved — posted to Payments & General',
    'fu.history': 'Follow-up history',
    'fu.noHistory': 'No follow-ups logged yet.',
    'fu.chCall': 'Call',
    'fu.chEmail': 'Email',
    'fu.chSms': 'SMS',
    'fu.chNote': 'Internal note',
    'fu.chOther': 'Other',
    'fu.prNormal': 'Normal',
    'fu.prFollowup': 'Needs follow-up',
    'fu.prUrgent': 'Urgent',
    'fu.prManager': 'Manager alert',
    'q.invoiceBy': 'Invoice by',
    'rot.triggerViews': 'Or when it lands in a working view (board menus)',
    'claims.updatesBubble': '{n} update(s) in this claim',
    'em.uploadingN': 'Uploading {i}/{n}…',
    'em.uploadFailedSome': 'Some files did not upload: {names}',
    'photos.deleteHint': 'Wrong link? Scratch it out (with a reason)',
    'photos.deleteReason': 'Why is this photo link being removed?',
    'photos.deleteReasonRequired': 'A reason is required to remove the link.',
    'photos.deletedBy': 'deleted by {user} — {reason}',
    'photos.restore': 'Restore',
    'dash.invActivity': 'Invoices by day — who makes them, who reviews them',
    'dash.invMade': '✍️ Invoices made',
    'dash.invReviewed': 'Invoices reviewed',
    'dash.invIssued': '{n} issued that day',
    'fu.tabAll': 'All',
    'fu.tabNotSent': 'No date yet',
    'fu.tabSent': 'Sent',
    'fu.tabWaitingPay': 'Waiting payment',
    'fu.tabNoPay': 'No payment',
    'fu.estRcv': 'RCV',
    'fu.estAcv': 'ACV',
    'fu.insEstimates': 'Insurance estimates',
    'fu.insEstimateFile': 'Estimate',
    'fu.outcome.title': 'What happened to the check?',
    'fu.outcome.needSent': 'Enter the check sent date first — there is no check to track yet.',
    'fu.outcome.reissue': 'Check lost — chasing re-issue',
    'fu.outcome.ho_with_check.btn': 'Homeowner with check',
    'fu.outcome.ho_with_check.help': 'The check arrived but the homeowner has it. Moves the claim to Homeowner with check and starts counting the days they hold it.',
    'fu.outcome.ho_with_check.confirm': 'Homeowner with check: the homeowner has the check. Move the claim there and start counting the days?',
    'fu.outcome.ho_with_check.note': '🧍 Homeowner with check — the check arrived and the homeowner is holding it.',
    'fu.outcome.co_with_check.btn': 'Contractor with check',
    'fu.outcome.co_with_check.help': 'The check arrived but the contractor has it. Moves the claim to Contractor with check and starts counting the days they hold it.',
    'fu.outcome.co_with_check.confirm': 'Contractor with check: the contractor has the check. Move the claim there and start counting the days?',
    'fu.outcome.co_with_check.note': '👷 Contractor with check — the check arrived and the contractor is holding it.',
    'fu.outcome.cashed.btn': 'Check cashed',
    'fu.outcome.cashed.help': 'The homeowner cashed the check without authorization, so they owe us the fee. Moves the claim to Owed to Us.',
    'fu.outcome.cashed.confirm': 'Check cashed: the homeowner cashed it without authorization. Move the claim to Owed to Us?',
    'fu.outcome.cashed.note': '💸 Check cashed without authorization — moved to Owed to Us.',
    'fu.outcome.lost.btn': 'Check lost',
    'fu.outcome.lost.help': 'The check was lost. The claim stays in this queue so we can call for a re-issue, and the clock restarts today.',
    'fu.outcome.lost.confirm': 'Check lost: mark it lost and start chasing the re-issue?',
    'fu.outcome.lost.note': '↻ Check lost — calling for a re-issue.',
    'fu.received.btn': 'Payment received',
    'fu.received.help': 'The check already arrived: pick which one and save its date as the arrival for this stage.',
    'fu.received.title': 'Which check arrived?',
    'fu.received.none': 'No checks loaded on this claim yet — you can still enter the date by hand.',
    'fu.received.orDate': 'Or enter the date:',
    'fu.received.save': 'Save',
    'fu.received.aiGuess': 'AI guess',
    'fu.received.noDate': 'no date',
    'fu.docs.btn': 'Waiting on a document',
    'fu.docs.clearBtn': 'Document received',
    'fu.docs.help': 'The wait is blocked because a document is missing (the final invoice from the contractor, etc.). The claim stays in this queue — its bar just shows why it is stuck.',
    'fu.docs.clearHelp': 'The document arrived: clear the flag and let the bar go back to normal.',
    'fu.docs.ask': 'Which document is missing? (e.g. final invoice from the contractor)',
    'fu.docs.clearConfirm': 'The document arrived — clear the flag?',
    'fu.docs.chip': 'Waiting on a document',
    'fu.docs.noteSet': '📄 Waiting on a document — this payment cannot move forward until it arrives.',
    'fu.docs.noteCleared': '📄 Document received — the wait is no longer blocked.',
    'dash.waitingDocs': 'Waiting on a document',
    'fu.noPay': 'No payment',
    'fu.noPayHelp': 'No check is coming for this claim. Moves it to Repair (No Payment to HO or CO) and posts the note in Payments Updates.',
    'fu.noPayConfirm': 'No payment: no check is coming for this claim. Move it to Repair (No Payment to HO or CO) and post the note in Payments Updates?',
    'fu.enteredOn': 'In this status since',
    'fu.daysIn': '{n}d in status',
    'fu.checkAmountPh': 'Amount ($) — if known',
    'fu.suggested': 'From the estimate',
    'fu.noPayBadge': 'No payment — nothing to track',
    'fu.colClient': 'Client',
    'fu.colPayment': 'Payment status',
    'fu.colClaimStatus': 'Claim status',
    'fu.colSuppStatus': 'Supplement status',
    'fu.colDeptStatus': 'Status',
    'fu.colSince': 'Since',
    'fu.colDays': 'Days',
    'fu.colManager': 'Account manager',
    'fu.colPaymentsManager': 'Payments manager',
    'fu.colLastFu': 'Last follow-up',
    'fu.colNextFu': 'Next follow-up',
    'fu.colDaysDue': 'Days due',
    'cd.stageRepair': 'Repair check',
    'afr.ask': 'This claim has no insurance-estimate numbers. Is a repair check coming?\n\nOK = Yes, track the check (Waiting payment)\nCancel = No payment to track',
    'fu.checkDate': 'Incoming check date',
    'fu.checkDateSave': 'Save date',
    'fu.checkDateSaved': 'Check date saved.',
    'fu.checkDateEdit': 'Change',
    'fu.checkDateHelp': 'Set when the check was sent — it syncs to Monday.', 'fu.underDed': 'Under deductible', 'fu.underDedConfirm': 'Under deductible: no check is coming. Move this claim to Repair (No Payment to HO or CO) and post the note in Payments Updates?',
    'cd.checks': 'Checks',
    'cd.amountPh': 'Amount $',
    'cd.payableProactive': 'Payable to Proactive',
    'cd.payableHo': 'Proactive + Homeowner',
    'cd.payableMortgage': 'Proactive + Mortgage',
    'cd.registerCheck': 'Register check', 'cd.holdPayment': 'Hold payment', 'cd.claimInvoices': 'Claim invoices', 'cd.deleteCheckConfirm': 'Delete this check?',
    'cd.noChecks': 'No checks.',
    'cd.colPayableTo': 'Payable to',
    'cd.depositedOn': 'Deposited',
    'cd.availableOn': 'Available in bank',
    'cd.checkDeleteConfirm': 'Delete this check? (it removes it permanently)',
    'cd.checkDeleteHelp': 'Delete this check (super-manager) — for errors that must be removed.',
    'cd.sendMortgage': 'Send to mortgage',
    'cd.markEndorsed': 'Mark endorsed',
    'cd.depositBofa': 'Deposit BOFA',
    'cd.markAvailable': 'Mark available',
    'cd.bounce': 'Bounce',
    'cd.bounceAvailableHelp': 'Bounce this check even though it is available (the bank reversed it).',
    'cd.bounceConfirm': 'Mark this check as bounced? It will be removed from available funds.',
    'cd.editDepreciation': 'Edit depreciation manually',
    'cd.editParsed': 'Edit values',
    'cd.editParsedHelp': 'Correct the amounts if Claude read the estimate wrong (RCV, deductible, depreciation). Saved to the estimate and the claim.',
    'cd.recoverableHelp': 'Check if the depreciation is recoverable (comes back later); leave unchecked for non-recoverable.',
    'cd.checkDatesTitle': 'Check sent dates',
    'clk.title': 'Check clocks', 'clk.help': 'Two different waits: getting the carrier to tell us the check date (that one is on us), and the check actually arriving. Same scale across the three so they can be compared.',
    'clk.toDate': 'to date', 'clk.toCheck': 'to check', 'clk.waitingSoFar': 'waiting',
    'clk.arrived': 'Arrived', 'clk.waiting': 'Waiting', 'clk.noCheck': 'no check yet', 'clk.noData': 'no data',
    'clk.fromQueue': 'from entering the queue', 'clk.fromApproved': 'from approval', 'clk.fromSuppApproved': 'from supplement approval', 'clk.fromCoc': 'from COC',
    'clk.fromIssued': "from the check's issue date (no stage start in the app)",
    'clk.noAnchor': 'No start date on file (not even the check date) — days cannot be counted.',
    'clk.approxHint': 'Approximate: on older records the check date was logged together with the rest, so this stretch is not measured exactly.',
    'cd.checkDatesHelp': 'Date each check was sent (written to Monday). Tracks the days waiting for the check to arrive.',
    'cd.checkStage': 'Check',
    'cd.checkSentOn': 'Sent on',
    'cd.checkDaysWaiting': 'Days waiting',
    'cd.checkSetDate': 'Set sent date',
    'cd.checkSent': '✓ Check sent', 'cd.checkArrived': 'Arrived', 'cd.paidOn': 'paid', 'cd.payoutPending': 'payment pending', 'cd.addExtraCheck': 'Add another check (supplement/repairs…)', 'cd.extraCheckLabelPh': 'Check name (e.g. Supplement #2)', 'cd.extraCheckDeleteConfirm': 'Delete this extra check entry?', 'cd.checkArrivedSaved': 'Check marked as arrived', 'cd.checkArrivedUndo': 'Undo: the check has NOT arrived, keep waiting', 'cd.checkArrivedUndoShort': 'Undo', 'cd.checkArrivedUndoConfirm': 'Mark this check as NOT received? It goes back to waiting and the day counter starts running again.', 'cd.checkOnTheWay': 'on the way',
    'cd.checkInfo': 'Check info',
    'cd.checkDetails': 'Details',
    'cd.checkAmount': 'Amount',
    'cd.checkPayees': 'Payees (made out to)',
    'cd.checkPayeeNote': 'Note (exact names, etc.)',
    'cd.payee_homeowner': 'Homeowner',
    'cd.payee_mortgage': 'Mortgage',
    'cd.payee_contractor': 'Contractor',
    'cd.payee_proactive': 'Proactive',
    'cd.checkDestination': 'Sent to',
    'cd.dest_homeowner': "Homeowner's house",
    'cd.dest_office': 'Our office',
    'cd.checkSentSaved': 'Check sent date saved',
    'cd.stageAcv': 'ACV (1st check)',
    'cd.stageDepreciation': 'Depreciation',
    'cd.stageSupplement': 'Supplement',
    'cd.stageBounced': 'Bounced (re-issue)',
    'cd.stageMortgage': 'Mortgage',
    'cd.resendHo': 'Resend to HO',
    'cd.resendNoPayment': 'This invoice has no payment behind it yet — the receipt goes out when the payment is sent.',
    'cd.resendNoCoEmail': 'This contractor has no email on file. Add it in Settings → Contractors (or in the claim) and try again.',
    'cd.resendNoHoEmail': 'This homeowner has no email on file. Add it on the claim card and try again.',
    'cd.resendCo': 'Resend to contractor',
    'cd.resendHoHelp': 'Re-send the receipt + invoice email to the homeowner.',
    'cd.resendCoHelp': 'Re-send the receipt + invoice email to the contractor.',
    'cd.receiptResent': 'Receipt re-sent to',
    'cd.emailsTitle': 'Emails sent',
    'cd.emailsHelp': 'Copy of every payment email sent (and re-sends): to whom, when and status.',
    'cd.emailWhen': 'Sent',
    'cd.emailTo': 'To',
    'cd.emailSubject': 'Subject',
    'cd.emailResend': 'resend',
    'cd.emailSent': 'sent',
    'cd.emailFailed': 'failed',
    'cd.waitingManager': 'waiting for manager',
    'cd.payWithThis': 'Pay with this',
    'cd.authTitle': 'Authorize payment (compliance gate)',
    'cd.checkAvailable': 'Check (must be available)',
    'cd.checkForPay': 'Check (pays once it is available in bank)',
    'cd.authUploadedBy': 'uploaded by {who}',
    'cd.contractorAuthorized': 'Contractor authorized',
    'cd.viewAuth': 'View authorization',
    'cd.authReuse': 'one authorization per claim — reused for the next payments',
    'cd.payTo': 'Pay to',
    'cd.homeownerOpt': 'Homeowner',
    'cd.contractorOpt': 'Contractor',
    'cd.payInvoice': 'Invoice (the payment must equal it)',
    'cd.payInvoiceNone': '— No linked invoice —',
    'cd.payAmtLocked': 'Locked to the invoice amount',
    'cd.amountUsd': 'Amount ($)',
    'cd.hoAuth': 'Homeowner authorization (URL) — required to pay the contractor',
    'cd.bypassHoAuth': 'Bypass homeowner authorization',
    'cd.bypassPrompt': 'Reason to pay the contractor WITHOUT the homeowner authorization:',
    'cd.bypassHelp': 'Super-manager only · the reason is recorded for audit',
    'cd.authorizePay': 'Authorize payment',
    'cd.proofPh': 'Proof of payment URL',
    'cd.markPaid': 'Mark paid',
    'cd.invoices': 'Claim invoices',
    'cd.noInvoices': 'No invoices yet.',
    'cd.colInvoice': 'Invoice',
    'cd.colFee': 'Fee',
    'cd.colPayout': 'Payout',
    'cd.colGenerated': 'Generated',
    'cd.colPaid': 'Paid',
    'cd.orderedTo': 'ordered to',
    'cd.paidToWho': 'Paid to…',
    'cd.markPaidTo': 'Mark as paid…',
    'cd.markPaidHelp': 'Invoice paid outside the system (historical): records a real payment dated today, no proof, skipping authorize + pay. Reversible with Reverse payment.',
    'cd.markPaidConfirm': 'Mark this invoice as paid outside the system? Records a real payment (no proof), skipping authorize + pay.',
    'cd.histPaidHelp': 'Imported invoice: record who the payout was paid to. It reflects in the next invoice.',
    'cd.editHist': 'Edit',
    'cd.editHistHelp': 'Correct imported (historical) data. The fee counts toward the next invoice and stays in sync with the payout.',
    'cd.delImportedHelp': 'Delete this imported (Excel) invoice to redo it. Removes its historical payment too.',
    'cd.pay': 'Pay',
    'cd.owedToUs': 'Owed to us',
    'cd.owedToUsHelp': 'Negative payout or the check is held by the homeowner/contractor — we do not pay anyone; they owe us the fee.',
    'cd.paidOnDate': 'paid {date}',
    'cd.paidWithCheck': 'with check',
    'cd.paidWithCheckHelp': 'See the photo of the check this invoice was paid with',
    'cd.paidToOn': 'Paid to {who} {amount} on {date}',
    'cd.payoutPendingTo': 'To pay {who} {amount} — pending',
    'cd.viewInvoiceHelp': 'Open the invoice this payment came from',
    'cd.chkPaid': 'Invoice paid',
    'cd.chkInvoicedNotPaid': 'Invoiced — not paid yet',
    'cd.chkInvoice': 'Invoice',
    'cd.chkPaidOpenErr': 'Could not open the file',
    'cd.viewProof': 'View proof',
    'cd.approvedBy': 'approved by',
    'cd.preparedBy': 'prepared by',
    'cd.submittedBy': 'sent to review by',
    'cd.authorizedBy': 'authorized by',
    'cd.cancelAuth': 'Cancel authorization',
    'cd.cancelAuthHelp': 'Undo this payment authorization (wrong payee) to re-authorize. Super-manager only.',
    'cd.cancelAuthConfirm': 'Cancel this payment authorization? The invoice stays; you can re-authorize to the correct payee.',
    'cd.voidPay': 'Reverse payment',
    'cd.voidInv': 'Void invoice',
    'cd.regenPdf': 'Regenerate PDF',
    'cd.regenPdfHelp': "Re-render this issued invoice's PDF with the current data and overwrite the frozen snapshot. Number, amounts and date stay the same.",
    'cd.regenPdfConfirm': "Regenerate this issued invoice's PDF? The current frozen snapshot will be replaced.",
    'cd.voidInvHelp': 'Cancel this issued (unpaid) invoice. Keeps the record and its number; then create a new corrected invoice.',
    'cd.voidInvPrompt': 'Why are you voiding this invoice? (kept for the audit trail)',
    'cd.voidInvNeedReason': 'A reason is required to void an issued invoice.',
    'cd.voidInvConfirm': 'Void this issued invoice? It stays in the ledger as VOID (number preserved) and you can then generate a new corrected invoice. This cannot be undone.',
    'cd.voidInvDone': 'Invoice voided. You can now generate a new corrected invoice.',
    'cd.voidInvPaid': 'This invoice is already paid — reverse the payment first, then void.',
    'cd.voidInvAuthorized': 'This invoice has a payment authorized — cancel the authorization first, then void.',
    'cd.voidPayHelp': 'Payment was already sent but reversed at the bank. Voids it and leaves the invoice ready to re-authorize.',
    'cd.voidPayPrompt': 'Reverse this sent payment? Enter a reason (e.g. cancelled at the bank, homeowner changed their mind):',
    'cd.voidPayDone': '✓ Payment reversed. The invoice is ready to re-authorize.',
    'cd.submit': 'Submit to review',
    'cd.approve': 'Approve',
    'cd.notApprove': 'Not approved',
    'cd.notApproved': 'Not approved',
    'cd.notApprovedPrompt': 'Why is this invoice not approved? (it goes back to “Invoice to do”)',
    'cd.saveLines': 'Save lines',
    'cd.linesLocked': 'An invoice was already generated with these lines — you can add lines and edit amounts, but not remove the lines that were already invoiced.',
    'cd.issue': 'Issue (PDF)',
    'cd.issued': 'issued',
    'cd.viewPdf': 'View PDF',
    'cd.invDeleteConfirm': 'Delete this invoice to regenerate it?',
    'cd.imported': 'historical · paid',
    'cd.importedHelp': 'Imported from the old Excel — already invoiced and paid. Reference only.',

    'rep.moneyReceived': 'Money received',
    'rep.moneyReceivedSub': 'Checks received',
    'rep.feeBilled': 'Fee billed',
    'rep.feeBilledSub': 'Issued invoices',
    'rep.paymentsAuth': 'Payments authorized',
    'rep.bounced': 'Bounced checks',
    'rep.contractorByMonth': 'Contractor payments by month',
    'rep.noContractor': 'No contractor payments.',
    'rep.month': 'Month',
    'rep.total': 'Total',
    'rep.from': 'From',
    'rep.to': 'To',
    'rep.apply': 'Apply',
    'rep.feeCollectedByMonth': 'Fee collected by month',
    'rep.feeCollectedSub': 'Fee realized when checks clear, per month.',
    'rep.noFeeCollected': 'No fee collected in this period.',
    'rep.contractor1099': 'Contractor payments (1099)',
    'rep.contractor1099Sub': 'Total paid to each contractor — use the year to file the 1099.',
    'rep.no1099': 'No contractor payments in this period.',
    'rep.contractor': 'Contractor',
    'rep.monthsBreakdown': 'By month',
    'rep.totalPeriod': 'Total (period)',
    'rep.grandTotal': 'Grand total',

    'set.tabGeneral': 'General',
    'set.tabTeams': 'Teams',
    'set.tabPartners': 'Partners',
    'set.tabSecurity': 'Security',
    'mfa.title': 'Two-factor authentication (2FA)',
    'mfa.desc': 'Add a second step at sign-in using an authenticator app (Google Authenticator, Authy, 1Password…).',
    'mfa.on': 'Enabled',
    'mfa.off': 'Not enabled',
    'mfa.enable': 'Enable 2FA',
    'mfa.disable': 'Disable 2FA',
    'mfa.scan': 'Scan this QR code with your authenticator app:',
    'mfa.manual': "Can't scan? Enter this key manually:",
    'mfa.enterCode': 'Enter the 6-digit code to confirm',
    'mfa.enterCodeDisable': 'Enter a current code to disable',
    'mfa.confirm': 'Confirm & enable',
    'mfa.badCode': 'Invalid code. Try again.',
    'mfa.backupTitle': 'Save your backup codes',
    'mfa.backupDesc': 'Each code works once if you lose your device. Store them somewhere safe — they will not be shown again.',
    'mfa.copy': 'Copy codes',
    'dset.followUp': 'Follow-up every (days)',
    'dset.followUpHelp': 'Cadence to follow up claims in this department (e.g. Payments 2, Supplements 3).',
    'dset.manualFu': 'Allow changing the next follow-up date by hand',
    'dset.manualFuHelp': 'Off by default: the system sets the date from the cadence above and nobody moves it. Turn it on only if this department really needs to pick dates by hand — the pencil next to "Next follow-up" appears in its updates.',
    'dset.emailFrom': 'Sending email account',
    'dset.emailFromHelp': 'Emails from this department are sent from this address.',
    'dset.teamRoles': 'Team roles',
    'dset.teamRolesHelp': 'Roles that make up a claim team in this department (Claims 3, Supplements 2).',
    'dset.addRole': 'Add role',
    'dteam.title': 'Teams',
    'dteam.add': 'New team',
    'dteam.newTeamName': 'Team name (e.g. John\'s Team)',
    'dteam.roleHint': 'Each team has {n} role slots. Change the size in this department\'s Settings tab.',
    'dteam.userHint': 'Not role-based — just add the users of this department.',
    'dteam.freeHint': 'Create a team and add as many people as you need (no size limit).',
    'dteam.people': 'people',
    'dteam.empty': 'No teams yet.',
    'dteam.noUsers': 'No users assigned.',
    'dteam.addUser': 'Add user',
    'dteam.deleteConfirm': 'Delete this team?',
    'dteam.newMember': 'New member',
    'dteam.individual': 'Individual',
    'dteam.individuals': 'Individuals (no team)',
    'dteam.assignWhen': 'Assign to claim when',
    'dteam.mManual': 'Manual (assign by hand)',
    'dteam.mRR': 'Round-robin (auto, one by one)',
    'dteam.pickStages': 'Pick the claim stages that trigger assignment:',
    'dteam.byContractor': 'Claims teams are assigned by the claim\'s contractor when it arrives — no stage rule here.',
    'rot.scope': 'Which claims this round-robin takes',
    'rot.scopeAll': 'All claims',
    'rot.scopeNoContractor': 'Only claims without a contractor',
    'rot.scopeContractor': 'Only the claims of one contractor',
    'rot.pickContractor': 'Pick the contractor',
    'rot.title': 'Round-robins',
    'rot.namePh': 'Round-robin name (e.g. Estimators)',
    'rot.add': 'New round-robin',
    'rot.hint': 'Add participants in order (whole teams or single people) and pick the claim stage that triggers it. Each time a claim hits the stage, the next in line is assigned — then it rotates.',
    'rot.empty': 'No round-robins yet.',
    'rot.deleteConfirm': 'Delete this round-robin?',
    'rot.queue': 'Rotation queue (order matters)',
    'rot.noParts': 'No participants yet — add teams or people below.',
    'rot.addPart': 'Add team or person',
    'rot.team': 'Team',
    'rot.next': 'Next',
    'rot.triggerWhen': 'Trigger when the claim reaches',
    'set.branding': 'Letterhead (appears on the invoice PDF)',
    'set.address': 'Address',
    'set.phone': 'Phone',
    'call.title': 'Call',
    'call.ringing': 'Calling… your phone will ring first, then connect the contact.',
    'call.dialing_app': 'Opening your phone app…',
    'call.set_number_prompt': 'Enter your phone number (cell or extension) for click-to-call. RingCentral will ring this number first, then connect the call.',
    'call.saved': 'Call-from number saved.',
    'call.setting_label': 'My call-from number (click-to-call)',
    'call.setting_help': 'Number RingCentral rings first when you click a phone in a claim. Leave empty to open your phone app instead.',
    'call.save': 'Save',
    'call.colleagueRinging': 'Calling {name}… your phone will ring first, then connect them.',
    'call.noExtensionYet': "We don't have {name}'s RingCentral extension yet — it's learned automatically the first time they make or receive a call.",
    'call.failed': "Couldn't place the call. Try again in a moment.",
    'set.website': 'Website',
    'set.accent': 'Accent color (hex)',
    'set.defaultFee': 'Default fee (%)',
    'set.saveBranding': 'Save letterhead',
    'set.banks': 'Bank accounts', 'w9.title': 'Company W9', 'w9.hint': 'Uploaded once; attached to every Send LOR (with the PA license for the claim state).', 'w9.none': 'No W9 uploaded yet.', 'w9.upload': 'Upload W9', 'w9.replace': 'Replace', 'w9.view': 'View', 
    'set.bankPh': 'Name (e.g. BOFA)',
    'set.thresholds': 'Day thresholds (check wait alerts)',
    'set.sentAck': 'Send acknowledgment (orange → red)',
    'set.arrival': 'Arrival after send (green → red)',
    'set.thresholdHelp': 'Ack: max days to confirm the check was sent to the office. Arrival: max days to arrive once sent.',
    'set.welcomeDelay': 'Welcome call delay (minutes)',
    'set.welcomeDelayHelp': 'Minutes to wait after a new client comes in before the AI welcome call fires automatically (default 4). Set 0 to call immediately.',
    'set.saveThresholds': 'Save thresholds',
    'set.email': 'Email template (on payment)',
    'set.subject': 'Subject',
    'set.body': 'Body (HTML)',
    'set.saveTemplate': 'Save template',
    'set.tagsHelp': 'Click a tag to insert it into the last field you focused (subject or body). It gets filled in automatically when the email is sent.',
    'tag.claimNumber': 'Claim #',
    'tag.homeowner': 'Client',
    'tag.contractor': 'Contractor',
    'tag.address': 'Address',
    'tag.insurance': 'Insurance',
    'tag.company': 'My company',
    'tag.amount': 'Amount',
    'set.emailOn': 'Email provider connected',
    'set.emailOff': 'Email not configured — set RESEND_API_KEY and EMAIL_FROM on the server.',
    'set.emailTest': 'Send test',
    'set.emailTestPh': 'your@email.com',
    'set.emailTestOk': '✓ Test email sent',
    'set.emailTestErr': 'Could not send — check the API key / from domain',

    'team.title': 'Team',
    'team.help': 'Turn "Can make payments" ON for the person who logs into the bank and sends payments. Others (manager+) can only view the pay queue.',
    'team.name': 'User',
    'team.mondayName': 'Monday name',
    'team.mondayNameHelp': "The user's name in Monday's 'assigned person' column. Blank = use the app name.",
    'team.assigneeSaved': '✓ Monday name saved.',
    'team.nameSaved': '✓ Name saved.',
    'team.editNameHelp': 'Edit the employee name (fix typos). Saves when you click away.',
    'team.email': 'Email',
    'team.role': 'Role',
    'team.password': 'Initial password',
    'team.passwordPh': 'min 8 characters',
    'team.passwordSet': '✓ Password updated',
    'team.newPasswordFor': 'New password for',
    'team.tcOn': 'Turn on the time clock for this person', 'team.tcArea': 'Work area (decides time zone, pay rules and auto clock-in)', 'team.tcAreaPick': 'Pick an area…', 'team.tcNeedsArea': 'Pick the work area first: without it there is no time zone to read the schedule in, and the clock cannot do anything.', 'team.tcFrom': 'Starts', 'team.tcTo': 'Ends', 'team.tcWorkday': 'Which day do they work', 'team.tcTzHint': 'Hours are the wall clock of:', 'team.canPay': 'Can make payments', 'team.canSign': 'Signs checks', 'team.searchPh': 'Search name, email, role or department…',
    'team.emailSaved': '✓ Email saved.', 'team.editEmailHelp': 'Edit the email — press Enter or click away to save.',
    'team.online': 'Online now', 'team.offline': 'Offline', 'team.lastLogin': 'Last login', 'team.neverLogged': 'Never',
    'team.resetPassword': 'Reset password', 'team.resendInvite': 'Resend invite', 'team.setManual': 'Set password manually',
    'team.resetHelp': 'Emails a link to create a new password.', 'team.inviteHelp': 'Emails a temporary password; they must change it on first login.',
    'team.resetConfirm': 'Send a password-reset link to {email}?', 'team.resetSent': 'Reset link emailed to',
    'team.inviteConfirm': 'Email a new temporary password to {email}? Their current password will be replaced.', 'team.inviteSent': 'Invitation emailed to',
    'team.department': 'Department (To Do)', 'team.departments': 'Departments', 'team.noDept': 'No department', 'team.deptsFor': 'Departments for', 'team.deptDefault': 'Default:', 'team.deptsSaved': 'Departments saved', 'team.deptsHint': 'The default department (★) decides which To Do this user sees when they log in. Management = no department: they land on the Management dashboard and get @management mentions.', 'team.mgmt': 'Management',
    // Teléfonos del empleado (extensión de RingCentral + caller ID) y traspaso de la línea.
    'team.phonesHelp': 'Phone numbers (RingCentral extension + caller ID)',
    'team.phonesFor': 'Phone numbers for',
    'team.phonesSaved': '✓ Phone numbers saved.',
    'team.extension': 'RingCentral extension (the phone)',
    'team.extNumber': 'Ext #',
    'team.extShort': 'Ext',
    'team.extIdPh': 'RingCentral extension id',
    'team.extNoNumber': 'Extension linked',
    'team.noPhone': 'No phone',
    'team.callFrom': 'Caller ID (calls out from)',
    'team.phonesHint': 'The extension is the physical phone: it decides who each call in the log belongs to, the presence dot and click-to-call. One extension = one owner — assigning it here takes it away from whoever had it.',
    'team.extBelongsTo': 'That extension currently belongs to {name}. Saving takes it away from them.',
    'team.extTakenFrom': 'Taken from {name}.',
    'team.callsOnExt': 'Calls logged under this extension',
    'team.unattributed': 'Nobody (unattributed)',
    'team.callsWord': 'calls',
    'team.last30': 'in the last 30 days',
    'team.moveCallsFrom': 'The phone changed hands on:',
    'team.moveCallsBtn': 'Move those calls to {name}',
    'team.moveCallsHint': 'Earlier calls stay with whoever had the phone back then.',
    'team.moveCallsConfirm': 'Move every call logged under this extension since {date} to {name}?',
    'team.moveCallsDone': 'calls moved.',
    'team.on': 'Can pay',
    'team.off': 'Off',
    'team.active': 'Active',
    'team.activeOn': 'Active',
    'team.activeOff': 'Inactive',
    'team.addUser': 'Add user',
    'team.setAllPw': 'Set same password for all',
    'team.setAllPrompt': 'Password for everyone (min 8). They will be required to change it on first login:',
    'team.setAllConfirm': 'Set this password for ALL users (except you)? Each must change it on next login.',
    'team.setAllDone': 'users updated (must change on next login)',
    'fpw.title': 'Set a new password',
    'fpw.subtitle': 'For security, you must set your own password before continuing.',
    'fpw.new': 'New password',
    'fpw.confirm': 'Confirm password',
    'fpw.save': 'Save and continue',
    'fpw.min': 'Minimum 8 characters.',
    'fpw.mismatch': 'Passwords do not match.',
    'team.create': 'Create user',
    'team.created': '✓ User created',
    'team.formError': 'Name, email and a password (8+ chars) are required.',
    'team.emailTaken': 'That email is already in use.',

    'pq.toPayTitle': 'Claims marked To Pay (Monday)',
    'pq.toPayHelp': 'Claims whose Monday status is "To Pay" or "PAY TO HO". Open a claim to create the invoice and authorize the payment.',
    'pq.title': 'Payments to make',
    'pq.empty': 'Nothing to pay right now.',
    'pq.tabTodo': 'To do',
    'pq.tabDone': 'Done',
    'pq.doneTitle': 'Payments done',
    'pq.doneEmpty': 'No payments sent in this range.',
    'pq.from': 'From',
    'pq.to': 'To',
    'pq.clearFilter': 'Clear',
    'pq.dayPayments': 'payments',
    'pq.viewProofPdf': 'Proof',
    'pq.sendAll': 'Send all verified',
    'pq.toHO': 'to Homeowner',
    'pq.toCO': 'to Contractor',
    'pq.viewInvoice': 'Invoice',
    'pq.viewProof': 'View authorization proof',
    'pq.daysWaitingHelp': 'Days the client has been waiting for the payment to be made.',
    'pq.copyHomeowner': 'Copy homeowner name',
    'pq.copyContractor': 'Copy contractor name',
    'pq.copyAmount': 'Copy amount',
    'pq.bypassedBy': 'Authorization bypassed by',
    'pq.noEmail': 'No email sent yet',
    'pq.totalToPay': 'Total to pay',
    'pq.totalPaid': 'Total paid',
    'pq.prevDay': 'Previous day',
    'pq.nextDay': 'Next day',
    'pq.noInvoice': 'No invoice',
    'pq.backToInvoice': 'Send back',
    'pq.backHelp': 'Remove from the queue and send the claim back to “Invoice to do” to redo the invoice (for items imported from Excel).',
    'pq.backConfirm': 'Remove this payment from the queue and send the claim back to “Invoice to do”?',
    'pq.viewOnly': 'View only — you do not have payment permission.',
    'pq.dropHint': 'Drag the proof PDF here or click to upload',
    'pq.uploading': 'Uploading & verifying with AI…',
    'pq.verified': 'Verified',
    'pq.failed': 'Verification failed',
    'pq.acctMismatch': 'BAD PAYMENT — the receipt credits an account that is not on file for this contractor',
    'pq.acctMismatchFix': "This cannot be overridden. If the contractor changed banks, a super-manager loads the new account in their file (Contractors \u2192 Payment vault) and this payment unblocks by itself \u2014 nothing has to be re-uploaded. If they did not change banks, this money is going somewhere else.",
    'pq.acctNotOnFile': "No account on file for whoever is being paid here, so the receipt was not checked against one. A super-manager can load the last 4 digits in the contractor's file \u2014 or just upload their W9 or a voided check, which is read automatically \u2014 to turn this check on.",
    'pq.acctSeen': 'The receipt shows',
    'pq.acctMatch': 'Paid into account \u2022\u2022\u2022\u2022{n}, which is on file for this contractor.',
    'pq.acctUnreadable': 'The receipt does not show the destination account, so it could not be checked against the one on file \u2014 the amount and payee were.',
    'pq.notUploaded': 'No proof yet',
    'pq.bypass': '⚠ Send anyway (bypass)',
    'pq.bypassHelp': 'Super-manager only: send this payment even though the AI could not verify the proof. You must say why.',
    'pq.bypassNeedsProof': 'Upload the proof first — the bypass skips the AI check, not the document.',
    'pq.bypassAsk': 'Why are you sending this without AI verification? (e.g. the bank prints the payee as "GMG (…1732)"; the amount matches)',
    'pq.bypassNeedsReason': 'A reason is required.',
    'pq.bypassed': 'Sent without AI verification',
    'pq.bypassUndo': 'Undo',
    'pq.bypassUndoConfirm': 'Remove the bypass? The payment goes back to needing AI verification.',
    'pq.send': 'Send',
    'pq.sendBlocked': 'Upload a valid, verified proof first',
    'pq.amount': 'Amount',
    'pq.sentMsg': 'Sent {sent}, blocked {blocked}.',

    'sync.title': 'Monday sync',
    // CORTE DE MONDAY (2026-08-24) — ver MONDAY_SYNC_ENABLED en backend/src/config/env.ts.
    'sync.cutTitle': 'Monday is disconnected.',
    'sync.cutBody': 'Turned off on 2026-08-24. Monday was still overwriting the Payments status of this app — 824 times over 248 claims in 30 days — and it won every conflict: 113 of those un-finalized a claim that was already done. Nothing was deleted: the boards, the history and the files are still where they were, and the app kept the local copy (32,000 board updates and 12,000 subitem files). Turning it back on is one environment variable.',
    'sync.cutCleanup': 'All that is left to take down: Monday keeps calling our webhook until its subscriptions are deleted from its side. Delete them here.',
    'sync.step1': '1. Connect the board (the token is stored encrypted).',
    'sync.statusConnected': 'Connected to Monday',
    'sync.boardId': 'Board ID',
    'sync.token': 'API token',
    'sync.connect': 'Connect',
    'sync.reconnect': 'Update connection',
    'sync.connected': '✓ Connected',
    'sync.needBoth': 'Board ID and token are required.',
    'sync.step2': '2. Map each canonical field to a real board column.',
    'sync.loadColumns': 'Load board columns',
    'sync.noColumns': 'No columns returned — check the token and board ID.',
    'sync.canonical': 'Canonical field',
    'sync.boardColumn': 'Board column',
    'sync.saveMapping': 'Save mapping',
    'sync.mapSaved': '✓ Mapping saved',
    'sync.needMapping': 'Map at least one field.',
    'sync.pull': 'Sync from Monday now',
    'sync.pullHelp': '2b. Import the board items as claims now (the webhook only brings future changes). Re-runnable: updates existing, creates new.',
    'sync.pullResult': '✓ Imported: {created} new, {updated} updated ({total} items).',
    'sync.lastSync': 'Last sync',
    'sync.neverSynced': 'Never synced yet.',
    'sync.step3': '3. Webhook (incoming changes Monday → app). One click registers it in Monday:',
    'sync.connectWebhook': 'Connect webhook in Monday',
    'sync.webhookManual': 'This is the URL it registers (for reference / manual setup):',
    'sync.whShow': 'See registered webhooks', 'sync.whHide': 'Hide webhooks', 'sync.whNone': 'This board has no webhooks.', 'sync.whNotOurs': 'board automation — not ours', 'sync.whDeleteConfirm': 'Delete this webhook? Monday will stop sending this event to it.', 'sync.whDeleted': 'Webhook deleted.', 'sync.whDupes': 'There are duplicates: subscribing creates a new one and never removes the old, so each re-subscribe leaves another alive. Two per board is enough — delete the rest.', 'sync.webhookOk': '✓ Webhook connected ({n} event(s)).',
    'sync.webhookAlready': '✓ Webhook was already connected.',

    'sec.mortgage': 'Checks in mortgage flow',
    'sec.noMortgage': 'Nothing waiting for the mortgage.',
    'sec.mortgageStatus': 'Mortgage status',
    'sec.review': 'Invoices to approve',
    'sec.noReview': 'No invoices in review.',
    'sec.feeToCharge': 'Fee to charge',
    'sec.preparedBy': 'Prepared by',
    'sec.checks': 'Checks',
    'sec.check': 'Check',
    'sec.invoiceTodoTitle': 'Invoice To-Do',
    'sec.invoiceTodoDesc': 'Claims ready to bill. Open a claim to read the estimate with Claude and generate the invoice.',
    'sec.waitingClearTitle': 'Waiting Check to Clear',
    'sec.waitingClearDesc': 'Deposited checks awaiting availability confirmation (only manager+ marks as available).',

    'plat.console': 'Platform Console',
    'plat.createTenant': 'Create tenant (PA firm)',
    'plat.name': 'Name',
    'plat.slug': 'Slug',
    'plat.fee': 'Default fee (%)',
    'plat.firstUser': 'First user (master role)',
    'plat.createBtn': 'Create tenant',
    'plat.tenants': 'Tenants & app usage',
    'plat.noTenants': 'No tenants yet.',
    'plat.colTenant': 'Tenant',
    'plat.colUsers': 'Users',
    'plat.colClaims': 'Claims',
    'plat.colInvoices': 'Invoices',
    'plat.colFeeBilled': 'Fee billed',
    'plat.colMoneyReceived': 'Money received',
    'plat.colLastActivity': 'Last activity',
    'plat.notAuthorized': 'Not authorized',
    'plat.goLogin': 'Go to login',
    // --- Plataforma multi-departamento (Fase A-E) ---
    'nav.insurance': 'Insurance',
    'nav.contractors': 'Contractors',
    'nav.contracts': 'Contracts',
    'nav.intakeForm': 'Intake Form',
    'ifb.title': 'Intake Form builder',
    'ifb.subtitle': 'Edit the public intake form: create, edit, delete and reorder questions. "Maps to" fields fill the client card; the rest are extra answers.',
    'ifb.publicLink': 'Public form link (for your website)',
    'ifb.publicLinkHelp': 'Put this link on your website. Each submission creates a Lead, notifies the Intake team, sends the contract, and schedules the AI welcome call automatically.',
    'common.copy': 'Copy', 'common.copied': 'Copied', 'common.open': 'Open',
    'ifb.addQuestion': 'Add question',
    'ifb.label': 'Question',
    'ifb.help': 'Help text',
    'ifb.type': 'Type',
    'ifb.mapsTo': 'Maps to (client card)',
    'ifb.extra': 'Extra (not a claim field)',
    'ifb.required': 'Required',
    'ifb.options': 'Options (comma-separated)',
    'ifb.saved': 'Saved',
    'ct.title': 'Contracts',
    'ct.subtitle': 'Contract templates per state. Upload the PDF (with blanks) and place the fields to fill.',
    'ct.newTemplate': 'New template',
    'ct.state': 'State',
    'ct.namePh': 'Template name (e.g. GA Public Adjuster Contract)',
    'ct.uploadPdf': 'Upload PDF',
    'ct.uploadHint': 'Upload the state contract PDF (with the blanks). Then add the fields to fill on top.',
    'ct.needStateName': 'Enter a state and a name first',
    // Contrato ESPECIAL por contratista (mig 0402).
    'ct.forWho': 'For',
    'ct.forEveryone': 'Everyone in the state',
    'ct.specialContract': 'special contract',
    'ct.specialUploadHint': 'This template goes out ONLY for this contractor\u2019s claims. Everyone else in the state keeps the generic one.',
    'ct.onlyThisContractorHint': 'Only this contractor\u2019s claims get this contract. Everyone else keeps the generic template for the state.',
    'ct.moveToContractorConfirm': 'Make this the special contract for {name}? It will stop going out for everyone else in the state.',
    'ct.moveToGenericConfirm': 'Make this the generic template for the state? It will go out for EVERY claim in that state.',
    'ct.specialFor': 'Special contract \u2014 {name}',
    'csc.title': 'Special contract',
    'csc.on': 'Special contract ON',
    'csc.off': 'Special contract OFF',
    'csc.onHint': 'This contractor\u2019s claims go out with their own contract, not the state\u2019s generic one.',
    'csc.offHint': 'Turn on only if this contractor requires a clause the others do not have. Their claims currently use the generic template for the state.',
    'csc.offConfirm': 'Turn off the special contract for {name}? Their next claims go out with the generic template. Nothing is deleted \u2014 the PDF and its fields stay saved.',
    'csc.namePh': '{name} contract (e.g. special clause)',
    'csc.uploadHint': 'Upload their PDF (with the blanks) and place the fields on top, same as any template. Already generated contracts are not affected.',
    'csc.noFieldsWarn': 'No fields placed yet: this contract would go out blank. Open Fields and place them.',
    'ct.kindPa': 'Public Adjuster', 'ct.kindAppraiser': 'Appraiser contract',
    'ct.globalOne': 'One for everyone (global)',
    'ct.appraiserHint': 'Upload the appraiser agreement PDF. It is global (one for all claims) and signed by the homeowner only.',
    'ct.uploading': 'Uploading…',
    'ct.saving': 'Saving…',
    'ct.empty': 'No templates yet. Upload one per state.',
    'ct.inactive': 'inactive',
    'ct.fields': 'fields',
    'ct.preview': 'Preview',
    'ct.editFields': 'Fields',
    'ct.activate': 'Activate',
    'ct.deactivate': 'Deactivate',
    'ct.deleteConfirm': 'Delete this template?',
    'ct.fieldsHint': 'Add the fields to stamp on the PDF. Position is in PDF points (origin bottom-left). A visual placer is coming next.',
    'ct.field': 'Field',
    'ct.page': 'Page',
    'ct.size': 'Size',
    'ct.addField': 'Add field',
    'ct.saveFields': 'Save fields',
    'ct.placeHint': 'Pick a field, then click on the PDF to place it. Click a pin to remove it.',
    'ct.previewFilled': 'Preview filled',
    'ct.fineTune': 'Fine-tune positions',
    'ct.legendHomeowner': '● Homeowner',
    'ct.legendPa': '● PA (Proactive)',
    'cx.title': 'Contract', 'cx.paTitle': 'Public Adjuster Contract', 'cx.fee': 'Fee',
    'cx.appraiserTitle': 'Appraiser contract',
    'cx.appraiserNone': 'No appraiser contract prepared yet for this claim.',
    'cx.appraiserNoTpl': 'No appraiser template uploaded yet (Settings → Contracts).',
    'cx.none': 'No contract prepared yet for this claim.',
    'cx.prepare': 'Prepare contract',
    'cx.prepareHint': 'Just build the contract PDF (review it before sending).',
    'cx.sendEsign': 'Send for e-signature',
    'cx.esignSection': 'E-signature',
    'cx.uploadSection': 'Already signed on paper',
    'cx.prepared': 'Prepared',
    'cx.sent': 'Sent to homeowner',
    'cx.resentTimes': 'Resent {n}×',
    'cx.sentFirst': 'First sent',
    'cx.sentResend': 'Resend',
    'cx.opened': 'Opened by homeowner',
    'cx.hoSigned': 'Signed by homeowner',
    'cx.paSigned': 'Signed by PA',
    'cx.complete': 'Fully executed',
    'cx.sentTo': 'Sent to',
    'cx.view': 'View contract',
    'cx.viewSigned': 'View signed contract',
    'cx.send': 'Send to homeowner',
    'cx.resend': 'Resend',
    'cx.paSign': 'Sign as PA',
    'cx.paSignHere': 'Sign here (Public Adjuster)',
    'cx.confirmSign': 'Confirm signature',
    'cx.paSignedOk': 'PA signature stamped on the contract ✓',
    'cx.copyLink': 'Copy signing link',
    'cx.linkCopied': 'Signing link copied',
    'cx.sendSms': 'Send by SMS', 'cx.smsConfirm': 'Text the secure signing link to the homeowner\'s phone on the card?', 'cx.smsSentOk': 'Signing link sent by SMS', 'cx.viaSms': 'via SMS', 'cx.errNoPhone': 'The homeowner has no phone on the card — add it and try again.', 'cx.errSmsFailed': 'The SMS could not be sent. Check the number and try again.',
    'cx.sentOk': 'Contract emailed to the homeowner',
    'cx.drawFirst': 'Draw your signature first',
    'cx.paperHint': 'Signed on paper? Upload the signed PDF — the claim moves to Contract Signed.',
    'cx.uploadSigned': 'Upload signed contract (PDF)',
    'cx.paperUploaded': 'Signed contract uploaded (paper)',
    // Editar los datos del contrato + historial de versiones (ContractEditModal).
    'cx.editData': 'Edit contract data',
    'cxe.title': 'Contract data',
    'cxe.tabData': 'Data',
    'cxe.tabHistory': 'History',
    'cxe.hintDraft': 'These are the values printed on this contract. Save and the PDF is rebuilt — the link the homeowner has in their email will show the corrected contract.',
    'cxe.hintSigned': 'This contract is already signed. The correction is applied on the signed document itself: the signatures stay exactly as they are and the PDF carries no mark of the change. The homeowner sees the corrected contract through their signing link; the history below is ours only.',
    'cxe.hintPaper': 'This contract was uploaded as a scan (no template), so the body of the PDF cannot be corrected. Saving updates the record and the signature certificate only.',
    'cxe.notPrinted': 'not on this document',
    'cxe.note': 'Reason (internal)',
    'cxe.notePh': 'e.g. the homeowner gave us the wrong date of loss',
    'cxe.resendCopy': 'Email the corrected copy to the homeowner (the PDF attached to the original email cannot change)',
    'cxe.saved': 'Contract updated ✓',
    'cxe.savedAndSent': 'Contract updated ✓ — corrected copy emailed to the homeowner',
    'cxe.noVersions': 'No corrections yet — this is the original document.',
    'cxe.vCurrent': 'Current document',
    'cxe.vPdf': 'PDF before this change',
    'cxe.errVoided': 'This contract is voided — it cannot be edited.',
    'cxe.errNotFound': 'Contract not found.',
    'cxe.errNoTemplate': 'The template of this contract no longer exists — the PDF cannot be rebuilt.',
    // Etiquetas de los campos del contrato (mismas claves que el catálogo del backend).
    'cxf.homeowner_name': 'Homeowner name(s)',
    'cxf.homeowner_phone': 'Phone',
    'cxf.homeowner_email': 'Email',
    'cxf.loss_address': 'Loss address',
    'cxf.primary_address': 'Primary address',
    'cxf.date_of_loss': 'Date of loss',
    'cxf.loss_description': 'Description of loss',
    'cxf.insurance_carrier': 'Insurance carrier',
    'cxf.policy_number': 'Policy number',
    'cxf.claim_number': 'Claim number',
    'cxf.contract_date': 'Contract date',
    'cxf.fee_percent': 'Fee %',
    'cxf.rcv_percent': 'RCV %',
    'cxf.acv_percent': 'ACV %',
    'cxf.pa_name': 'PA name',
    'cxf.pa_license': 'PA license #',
    'cxf.pa_phone': 'PA phone',
    'cxf.pa_email': 'PA email',
    'wc.title': 'Welcome call',
    'wc.done': 'Done',
    'wc.aiPending': 'AI requested',
    'wc.calling': 'Calling…',
    'wc.recording': 'Recording',
    'wc.callAi': 'Call with AI',
    'wc.aiHint': 'Triggers the AI welcome call (Bland.ai).',
    'wc.aiRequested': 'AI call started',
    'wc.uploadRecording': 'Upload recording (audio)',
    'wc.result': 'Call result', 'wc.res.accepted': 'Accepted', 'wc.res.not_accepted': 'Not accepted', 'wc.res.done': 'Done', 'wc.res.no_answer': 'No answer', 'wc.res.needs_human': 'Needs human follow-up', 'wc.flagProblem': '⚠ Giving problems', 'wc.problemOn': 'Giving problems', 'wc.problemReason': 'What is the problem? (no answer, wrong phone, missing docs…)', 'wc.markDone': 'Mark Welcome Call as Done', 'wc.toReadyFile': 'Move to Ready to File', 'wc.doneConfirm': 'Mark the Welcome Call as done and move the claim to Ready to File?', 'wc.movedReadyFile': '✓ Done — moved to Ready to File', 'wc.needRecording': 'Add a call recording (or run the AI call) before marking done.', 'wc.answers': "Homeowner's answers",
    'wc.bypass': 'Bypass', 'wc.bypassHint': "Skip the Welcome Call without a recording — for claims that don't need one.", 'wc.bypassPrompt': 'Reason for bypassing the Welcome Call (optional):', 'wc.bypassed': '✓ Bypassed — moved to Ready to File',
    'wc.tabNeeded': 'Needed', 'wc.tabNeededHint': 'Claims in Claim Accepted / Claim in — the ones waiting for their welcome call.',
    'flow.wc': 'Welcome Call', 'flow.intake': 'Intake', 'flow.photos': 'Photos', 'flow.contract': 'Contract', 'flow.problem': 'Problem',
    'ckc.title': 'Who confirmed this check?', 'ckc.adjuster': 'Adjuster', 'ckc.adjusterPh': 'Name of who confirmed it',
    'ckc.source': 'How', 'ckc.source.phone': 'Phone', 'ckc.source.email': 'Email', 'ckc.source.portal': 'Portal', 'ckc.source.carrier_letter': 'Letter',
    'ckc.notes': 'How the call went', 'ckc.notesPh': 'e.g. called the 800 line, Karen confirmed it was mailed on the 12th',
    'ckc.phoneHint': 'A phone confirmation with no linked call needs a note — otherwise the date has nothing behind it.',
    'ckc.reason': 'Reason for the change', 'ckc.reasonPh': 'Required from the second edit on', 'ckc.save': 'Save', 'ckc.cancel': 'Cancel',
    'ss.title': 'Supplements sent to the carrier',
    'ss.help': 'Marking the send starts the clock we can actually move: the internal leg runs ~20 days against ~11 on the carrier side.',
    'ss.markSent': 'Mark as sent', 'ss.cancel': 'Cancel', 'ss.save': 'Save send', 'ss.saveEdit': 'Save change',
    'ss.sentOn': 'Sent on', 'ss.amount': 'Amount asked ($)', 'ss.method': 'Method', 'ss.adjuster': 'Adjuster', 'ss.reference': 'Carrier reference',
    'ss.reason': 'Reason for the change', 'ss.reasonPh': 'Required from the second edit on', 'ss.edit': 'Edit',
    'ss.none': 'No supplement recorded as sent yet.', 'ss.waiting': 'waiting {d}d', 'ss.edited': 'edited {n}×',
    'ss.resolve': 'Resolve…', 'ss.resolvedAmountPrompt': 'Amount approved by the carrier ($). Leave empty if unknown.',
    'ss.method.email': 'Email', 'ss.method.portal': 'Portal', 'ss.method.mail': 'Mail', 'ss.method.fax': 'Fax', 'ss.method.phone': 'Phone', 'ss.method.other': 'Other',
    'ss.outcome.approved': 'Approved', 'ss.outcome.partial': 'Partial', 'ss.outcome.denied': 'Denied', 'ss.outcome.withdrawn': 'Withdrawn',
    'cb.title': 'Company Board', 'cb.loading': 'Loading…', 'cb.refresh': 'Refresh', 'cb.updated': 'Updated',
    'cb.alerts': 'Needs attention today',
    'cb.funnel': 'Funnel', 'cb.step': 'Step', 'cb.conv': 'conversion', 'cb.daysFromPrev': 'days from previous',
    'cb.cycle': 'Full cycle, arrival to first ACV check',
    'cb.cycleHelp': 'Median. The total is NOT the sum of the stretches: each one is measured over the population that completed it, which is a different set.',
    'cb.flow': 'Stock and flow, last 12 weeks',
    'cb.flowHelp': 'Right now {wip} claims are in progress, median age {edad} days. How many are stuck and how many move are different questions — that is why they sit together.',
    'cb.money': 'Money', 'cb.owed': 'billed', 'cb.collected': 'collected', 'cb.gap': 'billed, not collected',
    'cb.moneySince': 'Fee events start on {d}. The portfolio imported from Monday is not in here — read as history it would show a jump that is the migration, not the business.',
    'cb.suppRate': 'Supplement rate',
    'cb.suppRateHelp': 'The recurring-revenue metric: each point of improvement is permanent income, unlike speeding up the cycle, which pays once. Groups under 10 claims are not shown.',
    'cb.byAm': 'By account manager', 'cb.byCarrier': 'By carrier',
    'cb.carriers': 'Carrier scorecard', 'cb.suppShort': 'supp.',
    'cb.capacity': 'Capacity', 'cb.inspectors': 'Inspectors',
    'cb.alertsNone': 'Nothing over the line right now.',
    'cb.andMore': 'and {n} more',
    'cb.dataProblems': 'Fields that lie',
    'cb.dataProblemsHelp': 'Coverage above answers which fields are missing. This answers a different question: which ones are filled in with something that is not true.',
    'cb.aging': 'Aging by stage', 'cb.agingHelp': '{n} claims have been sitting for more than 90 days. Rows are sorted by that bucket, not by volume: what matters first is where work is stalling. Click any number to see the claims behind it.',
    'cb.stage': 'Stage', 'cb.max': 'max', 'cb.coverage': 'coverage', 'cb.smallSample': 'small sample',
    'cb.claims': 'claims', 'cb.close': 'Close', 'cb.days': 'days', 'cb.claim': 'Claim', 'cb.homeowner': 'Homeowner', 'cb.carrier': 'Carrier', 'cb.fee': 'Est. fee',
    'cb.dataQuality': 'Data quality', 'cb.fieldCoverage': 'Field coverage', 'cb.limbo': 'Records in limbo',
    'cb.vLive': 'Live claims', 'cb.vLiveNote': '{n}-day median age since arrival',
    'cb.vStuck': 'Stuck 90+ days', 'cb.vStuckNote': '{pct}% of everything live',
    'cb.vFlow': 'In vs. out · 4 weeks', 'cb.vFlowNote': '{e} arrived · {s} closed',
    'cb.vWorst': 'Longest wait', 'cb.vWorstNote': 'a claim in {etapa}',
    'cb.flowIn': 'Arrived', 'cb.flowOut': 'Closed', 'cb.flowNet': 'Net',
    'cb.weekOf': 'Week of {d}', 'cb.weekOpen': 'still open',
    'cb.flowPartial': 'The last bar is dimmed: that week is still running and does not compare with the closed ones.',
    'cb.agingWaiting': 'Days waiting',
    'cb.agingBarsHelp': 'Each bar is a stage, split by how long the claims sitting there have been waiting. Widths share one scale, so bars compare across rows. Click any block to open the claims behind it.',
    'cb.agingTable': 'See it as a table',
    'cb.reference': 'Reference',
    'cb.referencePreview': 'funnel · supplement rate · carriers · capacity · data quality',
    'cwa.realAge': 'real: {d}d',
    'cwa.realAgeHelp': 'Real time waiting for approval, from the Monday board. The other counter starts at the July backfill, so it caps at 49 days and hides the oldest claims.',
    'cwa.sumInQueue': 'in queue', 'cwa.sumMedian': 'median age', 'cwa.sumMax': 'oldest',
    'cwa.sumOver90': 'over 90 days', 'cwa.sumDays': '{d}d',
    'cwa.sumCoverage': 'Ages come from the board date, which covers {n} of {total} claims ({pct}%). The rest show no age rather than a made-up one.',
    'cwa.claimsTeam': 'Claims team', 'cwa.photos': 'Photos', 'cwa.noPhotos': 'No photos', 'cwa.followUp': 'Follow-up',
    'cwa.noAppt': 'No date set', 'cwa.noInspector': 'No inspector', 'cwa.inspectorNotes': 'Notes for the inspector', 'cwa.inspectorNotesPh': 'Notes for the inspector for this inspection…', 'cwa.inspectorFilesDrop': 'Drop a photo or PDF for the inspector (they see it in the field app)', 'cwa.inspectorFileRemove': 'Stop sending it to the inspector', 'cwa.saveNotes': 'Save notes', 'cwa.notesSaved': 'Saved', 'insp.filterByInspector': 'Inspector', 'insp.allInspectors': 'All inspectors',
    'val.title': 'Validations', 'val.photos': 'Photos', 'val.photosWrongTitle': "What's wrong with the photos?", 'val.photosWrongPh': 'e.g. photos from wrong property', 'val.photosWrongHint': 'This adds an item to Info Pending: "Photos needed - <your note>".', 'val.photosWrongAdd': 'Add to Info Pending', 'val.policy': 'Policy validation', 'val.lor': 'LOR review', 'val.weather': 'Weather report', 'val.existingNew': 'Existing / New claim', 'val.intake': 'Intake questions', 'val.pending': 'Pending', 'val.auto': 'Auto ✓', 'val.markDone': 'Mark validated', 'val.markPending': 'Mark pending', 'val.goToSection': 'Open its section',
    'cwa.inspectionReport': 'Inspection report & ATR', 'cwa.emailOverview': 'Email & case overview', 'cwa.uploadEstimate': 'Files & insurance estimate (AI)', 'cwa.updates': 'Claims Department Updates',
    // Previews de una línea de los módulos colapsados (rediseño Tech Premium, working views).
    'mod.updatesPreview': 'Department updates & follow-up', 'mod.emailPreview': 'Email history for this claim', 'mod.inspectionPreview': 'Visits, inspection reports & ATR videos', 'mod.stormsPreview': 'NOAA storm search near the property',
    // Módulos del board de Supplements (rediseño Tech Premium, working views).
    'mod.emailTitle': 'Claim email',
    'mod.analyzeNone': 'Run the AI line-by-line comparison of both estimates.',
    'mod.analyzeDone': 'AI analysis ready — open for the detail, dispute email & tools.',
    'mod.askDiffPreview': '{n} line items where we ask differently — open for the detail.',
    'mod.negDetailPreview': 'Line-by-line decisions: dispute or let go.',
    'mod.followupPreview': 'Add a note & schedule the next follow-up.',
    'mod.quickComparePreview': 'Insurance vs our estimate — upload the supplement here.',
    'mod.contractorDocsPreview': '{n} contractor documents (invoices / tarp).',
    'mod.servicesPreview': 'Services performed on this claim.',
    'mod.tasksPreview': 'Assign a task to a team.',
    'mod.accessoriesPreview': 'Hand-counted roof accessories (pipe boots, vents…).',
    'mod.photos': 'Property photos', 'mod.photosPreview': 'House (street view) & roof (satellite).',
    'mod.verifiedMeas': 'Verified measurements (1ESX)', 'mod.verifiedMeasPreview': 'Order the verified roof measurement.',
    'mod.roofDiagramPreview': 'Upload the roof report — AI reads squares & pitch.',
    'mod.insEstPreview': 'Upload the insurance estimate — AI parses RCV, deductible & net.',
    'mod.itemsPreview': '{n} pre-approved items with their photo links.',
    'cwa.decision': 'Decision', 'cwa.needReschedule': 'Need reschedule', 'cwa.needsAtr': 'Needs ATR', 'cwa.reinspection': 'Get reinspection', 'cwa.getReinspTitle': 'Get reinspection — call the insurance until the adjuster approves it', 'cwa.reinspApproved': 'Reinspection approved → Scheduling', 'cwa.reinspApprovedConfirm': 'The adjuster APPROVED the reinspection? It will move to Scheduling to be booked.', 'cwa.atrRequest': 'ATR request', 'cwa.approved': 'Approved', 'cwa.approvedRepair': 'Approved for repair',
    'cwa.empty': 'No claims waiting approval.', 'cwa.decided': 'Decision saved.', 'cwa.confirm': 'Set this claim to',
    'atr.emailToInsurance': 'Email the ATR to the insurance', 'atr.sendToInsurance': 'Send to insurance → Follow up', 'atr.sendConfirm': 'Send the ATR to the insurance and move to ATR Follow up?',
    'atr.followUpInsurance': 'Follow-up with the insurance (ATR)', 'atr.rejected': 'ATR Rejected', 'atr.followUpHint': 'Approve or reject once the insurance responds to the ATR.',
    'atr.accepted': 'Accepted', 'atr.requestNew': 'Request new', 'atr.managerReview': 'Manager review',
    // El video del ATR como archivo + link público para el adjuster + modo inspector (2026-09-17).
    'nav.inspectorMode': 'Inspector mode',
    'insp.backToOffice': 'Back to the office app',
    'insp.rep.button': 'My report',
    'insp.rep.title': 'Your report',
    'insp.rep.none': 'No notes were saved for this visit.',
    'insp.rep.checkedOut': 'checked out {time}',
    'insp.rep.roof': 'Roof condition',
    'insp.rep.opinion': 'Your ATR opinion',
    // Visitas de días anteriores + reporte tardío (pedido del dueño 2026-10-05).
    'insp.sched.upcoming': 'Upcoming',
    'insp.sched.past': 'Past visits',
    'insp.sched.none': 'Nothing scheduled in the next 2 weeks.',
    'insp.past.banner': '{n} past visits are missing their report',
    'insp.past.bannerOne': '1 past visit is missing its report',
    'insp.past.bannerHint': 'Tap to see them and write the report.',
    'insp.past.intro': 'Your visits from the last {n} days, with what each one has and what is missing.',
    'insp.past.filterMissing': 'Missing something',
    'insp.past.filterAll': 'All',
    'insp.past.allGood': 'All caught up — nothing is missing.',
    'insp.past.none': 'No visits in the last {n} days.',
    'insp.past.reportMissing': 'Report missing',
    'insp.past.reportOk': 'Report',
    'insp.past.videoMissing': 'ATR video missing',
    'insp.past.videos': '{n} videos',
    'insp.past.videoOne': '1 video',
    'insp.past.noShow': 'No-show',
    'insp.past.addReport': 'Write the report',
    'insp.past.didntHappen': 'This visit didn’t happen',
    'insp.past.didntHappenTitle': 'The visit didn’t happen',
    'insp.past.didntHappenHint': 'Tell the office why. The visit leaves your list and the claim goes back to Scheduling to be rescheduled.',
    'insp.past.didntHappenPh': 'What happened? (nobody home, rain, the adjuster canceled…)',
    'insp.past.didntHappenSend': 'Tell the office',
    'insp.past.didntHappenNeedReason': 'Please write what happened.',
    'insp.past.formTitle': 'Report',
    'insp.past.formHint': 'Visit of {date}. Write what happened. It is saved as a late report — no GPS needed.',
    'insp.past.save': 'Save report',
    'insp.past.saved': 'Report saved.',
    'insp.past.sentToOffice': 'Sent — the office will reschedule it.',
    'insp.past.lateMark': 'Written late, on {date}',
    'insp.past.loadFailed': 'Could not load. Check your connection.',
    'insp.past.retry': 'Try again',
    // La oficina mirando la app de un inspector (solo lectura).
    'insp.viewOnly.blocked': 'View only — nothing can be done from here.',
    'insp.viewOnly.messages': '{name}’s messages are private. They are not shown in this view.',
    'insp.viewOnly.pushOn': 'On · {n} devices',
    'insp.viewOnly.pushOnOne': 'On · 1 device',
    'insp.viewOnly.pushOff': 'OFF — not turned on in their phone',
    'cvb.atr': 'ATR videos',
    'cvb.info': 'Informative videos',
    'cvb.noneHint': 'No videos yet — click to upload one',
    'cvb.drop': 'Drag & drop a video here, or click to choose',
    'cvb.dropHint': 'MOV, MP4, WEBM… up to 10 GB. The claim team gets notified.',
    'cvb.captionPh': 'Name (e.g. Attic, Gutter damage)',
    'cvb.empty': 'No videos yet.',
    'cvb.notVideo': 'That file is not a video.',
    'cvb.oneAtATime': 'One video at a time — the first one is uploading.',
    'cvb.busy': 'Wait for the current upload to finish.',
    'cvb.retry': 'Retry',
    'cvb.by': 'by {name}',
    'cvb.fromOffice': 'Uploaded from the claim card',
    'cvb.comments': 'Comments',
    'cvb.commentPh': 'Write a comment…',
    'cvb.post': 'Post',
    'cvb.deleteComment': 'Delete comment',
    'cvb.deleteConfirm': 'Delete this comment?',
    'cvb.loadFailed': "Couldn't load the videos.",
    'cvid.atrSection': 'ATR videos',
    'cvid.infoSection': 'Informative videos',
    'cvid.report': 'Report',
    'cvid.reportTitle': 'Inspection report',
    'cvid.noReport': 'No report was written for this visit yet.',
    'cvid.checkedOut': 'checked out {time}',
    'cvid.chipAtr': 'ATR video available',
    'cvid.chipInfo': 'Informative video available',
    'cvid.chipGo': 'See the videos',
    'cvid.title': 'Videos',
    'cvid.info': 'Info',
    'cvid.visit': 'Visit',
    'cvid.summary': '{atr} ATR · {info} informative',
    'cvid.publicLink': 'Public link',
    'insp.vid.button': 'Upload videos',
    'insp.vid.title': 'Videos of this visit',
    'insp.vid.hint': 'Upload the ATR video or any informative video about {name}. They stay attached to this visit and its report.',
    'insp.vid.uploadAtr': 'Upload ATR video',
    'insp.vid.uploadInfo': 'Upload informative video',
    'insp.vid.captionPh': 'What is this video? (e.g. Attic, gutter damage)',
    'insp.vid.uploaded': 'Uploaded for this visit',
    'insp.vid.none': 'No videos yet.',
    'insp.vid.infoBadge': 'Info',
    'insp.vid.open': 'Open',
    'insp.vid.close': 'Close',
    'bc.button': 'Business card',
    'bc.yourPa': 'Your Public Adjuster',
    'bc.office': 'Office',
    'bc.ext': 'ext.',
    'bc.claimsTeam': 'Claims team',
    'bc.inspector': 'Field Inspector',
    'bc.claim': 'Claim',
    'cd.videoAtr': 'ATR video',
    'cd.videoInfo': 'Video',
    'insp.leg.drive': '{min} min · {mi} mi',
    'insp.leg.fromHome': 'from home',
    'insp.leg.fromOffice': 'from the office',
    'insp.leg.fromPrev': 'from {name}',
    'insp.leg.onTime': 'On time',
    'insp.leg.late': 'Late {n} min',
    'insp.leg.eta': 'ETA {time}',
    'insp.leg.leaveBy': 'Leave by {time}',
    'insp.up.pickFile': 'Upload video file',
    'insp.up.orLink': 'or paste a link (YouTube, Drive)',
    'insp.up.preparing': 'Preparing…',
    'insp.up.finishing': 'Finishing…',
    'insp.up.done': 'Uploaded — the office has it.',
    'insp.up.failed': 'The upload stopped',
    'insp.up.retry': 'Retry',
    'insp.up.cancel': 'Cancel upload',
    'insp.up.offline': 'no connection, waiting…',
    'insp.up.keepOpen': 'Keep this screen open until it finishes. Wi-Fi recommended: the file is uploaded in full quality.',
    'insp.up.remaining': '≈ {time} left',
    'insp.up.hevc': 'This video is HEVC (High Efficiency). It uploads fine, but adjusters on Windows may not be able to play it. For future videos: iPhone Settings → Camera → Formats → Most Compatible.',
    'insp.up.notVideo': 'Please choose a video file (.MOV or .MP4).',
    'insp.up.cancelConfirm': 'Cancel this upload? What was uploaded so far will be discarded.',
    'atr.link': 'Link for the adjuster',
    'atr.generateLink': 'Generate link',
    'atr.generateAndAccept': 'Generate link & accept',
    'atr.linkTitle': 'Name on the link',
    'atr.linkTitleHint': 'This is what the adjuster sees as the title of the page (and as the link text in the email).',
    'atr.copy': 'Copy',
    'atr.copied': 'Copied',
    'atr.openLink': 'Open the public page',
    'atr.rename': 'Rename',
    'atr.revoke': 'Revoke',
    'atr.revokeConfirm': 'Revoke this link? Anyone who has it will no longer be able to open the video. You can generate a new one.',
    'atr.views': 'Opened {n}×',
    'atr.lastView': 'last {date}',
    'atr.notOpened': 'Not opened yet',
    'atr.noLinkYet': 'No public link yet — the internal file does not open for the adjuster.',
    'atr.linked': 'Link ready',
    'atr.fileBadge': 'File',
    'atr.hevcWarn': 'HEVC video (iPhone High Efficiency): it may not play in Chrome/Edge on Windows. Ask the inspector to use “Most Compatible” for the next one.',
    'atr.playFailed': 'This browser could not play the video. Open the file to download it.',
    'atr.openFile': 'Open file',
    'atr.accept': 'Accept', 'atr.acceptedBy': 'Accepted by', 'atr.acceptHint': 'Accept the video you will send, then email it to the adjuster below.',
    'atr.videoIncluded': 'ATR video included', 'atr.emailToAdjuster': 'Email the ATR to the adjuster',
    'atr.acceptConfirm': 'Accept this ATR and send it to the insurance (ATR Follow up)?', 'atr.requestNewConfirm': 'Send this back to be re-done (ATR request)?',
    'wcsec.todo': 'To-Do', 'wcsec.problems': 'Giving Problems', 'wcsec.empty': 'No claims here.',
    'pb.title': 'Photo batches', 'pb.missing': 'Missing', 'pb.open': 'Open', 'pb.addLink': 'Add link',
    'rtf.lorSent': 'LOR sent', 'rtf.lorEmail': 'Send our LOR to (insurance email)', 'rtf.sendLor': 'Send LOR', 'rtf.allInsurers': 'All',
    'rtf.daysWaitingHint': 'Days waiting in this queue',
    'lor.title': 'Letter of Representation (LOR)', 'lor.sendHint': 'Sends the "LOR To Insurance" template with the claim # and the attachments, and keeps it in this email history.',
    'lor.sendAgain': 'Send LOR again', 'lor.resendConfirm': 'The LOR was already sent. Send it again?', 'lor.notSent': 'LOR not sent yet', 'lor.sentAgainLabel': 'LOR sent again', 'lor.by': 'by',
    'lor.openContract': 'Open the contract', 'lor.errClaimNumber': 'Enter the insurance claim # first — the LOR goes out with it.', 'lor.errEmail': 'Enter the insurance email.',
    'lor.errLorRequired': 'Send the LOR to the insurance first — a claim cannot be marked Claim in without it.', 'lor.filedNeedsLor': 'Send the LOR first; then Claim filed moves it to Claim in.',
    'rtf.email': 'Email', 'lor.notOpened': 'Not opened yet', 'lor.claimTypeNeeded': 'required to file', 'lor.markSent': 'Mark as sent by another way', 'lor.markSentPrompt': 'How was the LOR sent? (portal, fax, personal email…) This note stays on record with your name.', 'lor.markedManually': 'marked by hand', 'lor.recognized': 'sent from the claim email box', 'lor.recognizedHint': 'An email to the insurance with the contract attached counts as the LOR.', 'lor.bounced': 'Bounced — the insurance did not receive it',
    'rtf.schedulingUpdates': 'Scheduling Department Updates', 'rtf.schedulingUpdatesHint': 'Click to open the updates thread',
    'rtf.lorAttached': 'Attached to the email', 'rtf.lorNoFiles': 'No LOR / PA license found to attach — check the signed contract and the PA license for this state.', 'prv.house': 'House', 'prv.roof': 'Roof', 'prv.measuring': 'Measuring…', 'prv.noMeasure': 'no measurement', 'prv.googleMeasure': 'Google roof measurement', 'prv.roofArea': 'Roof area', 'prv.pitch': 'Pitch',
    'wcs.title': 'AI Welcome Call', 'wcs.subtitle': 'When (after the contract is sent) the AI welcome call auto-fires, and the script the AI uses.', 'wcs.delay': 'Auto-fire', 'wcs.minutes': 'minutes after the contract is sent', 'wcs.script': 'AI call script', 'wcs.custom': 'Custom', 'wcs.usingDefault': 'Using default', 'wcs.reset': 'Reset to default', 'wcs.tokens': 'Placeholders', 'wcs.voicemail': 'Voicemail message',
    'rtf.filingTitle': 'File with insurance', 'rtf.claimNumber': 'Insurance claim #', 'rtf.confirmation': 'Confirmation #', 'rtf.method': 'Filing method', 'rtf.rep': 'Insurance rep', 'rtf.notes': 'Filing notes', 'rtf.claimFiled': 'Claim Filed', 'rtf.filedHint': 'Files the claim → Claim In → Waiting to Schedule (Claim Route).', 'rtf.fileConfirm': 'Mark this claim as filed with insurance and move it to Waiting to Schedule?', 'rtf.errInsurance': 'Select the insurance company first.', 'rtf.errType': 'Select the claim type first.', 'rtf.errNumber': 'Enter the insurance claim # or a confirmation #.', 'rtf.empty': 'No claims ready to file.',
    'wc.uploaded': 'Recording uploaded',
    'wc.uploadConfirm': 'Save "{f}" as the WELCOME CALL for {n}? Double-check it is this client’s call.',
    'wc.callResult': 'Call result',
    'wc.aPolicyholder': 'Policyholder / authorized',
    'wc.aContractSigned': 'Contract signed',
    'wc.aAuthorized': 'Authorized the inspection',
    'wc.aLinkSent': 'Signing link texted to the client',
    'wc.aEmailFixed': 'Corrected email',
    'wc.aCallback': 'Callback requested',
    'wc.errNoPhone': 'This claim has no valid phone number.',
    'wc.errNotConfigured': 'Bland.ai is not configured (check BLAND_API_KEY / BLAND_PHONE_NUMBER in Railway).',
    'wc.errUnreachable': 'Could not reach Bland.ai. Try again.',
    'ct.emailTpl': 'Contract email template',
    'ct.from': 'From (sending email)',
    'ct.fromHint': 'The contract is sent from this address. Use one on your Resend-verified domain (e.g. contracts@claimsproactive.com).',
    'ct.replyTo': 'Reply-to',
    'ct.subject': 'Subject',
    'ct.body': 'Email body',
    'ct.mergeHint': 'Merge tags',
    'ct.saveTpl': 'Save template',
    'ct.saved': 'Saved',
    'ct.globalDefault': 'Global (any state without its own)',
    'ct.stateDefaults': 'No-contractor defaults (per state)',
    'ct.stateDefaultsHint': 'When a homeowner submits without a contractor, use these fee/PA + account manager per state so a contract always goes out.',
    'ct.restampTitle': 'Re-generate unsigned contracts',
    'ct.restampHint': 'Re-stamps the PDF of every not-yet-signed contract using the current template. Use it after adding/moving a field (e.g. the fee %) so already-sent contracts show it. The signing link stays the same.',
    'ct.restampBtn': 'Re-generate PDFs',
    'ct.restampConfirm': 'Re-generate the PDF of all unsigned contracts with the current template? Signing links stay valid.',
    'ct.restampDone': 'Done — re-generated {n} of {total} unsigned contracts.',
    'ct.paRepairTitle': 'PA license audit',
    'ct.paRepairHint': 'Checks every contract against the PA licenses per state (Settings → Teams → Public Adjuster). Unsigned contracts with a PA not licensed in their state get corrected and re-stamped (same signing link). Signed ones are only listed — decide manually if a new contract must be sent.',
    'ct.paRepairCheck': 'Check',
    'ct.paRepairFix': 'Repair unsigned',
    'ct.paRepairConfirm': 'Correct the PA (name, license, phone, email) on every unsigned contract whose PA is not licensed in its state, and re-stamp the PDFs? Signing links stay valid.',
    'ct.paRepairSummary': '{checked} contracts checked — {bad} with a PA/license issue.',
    'ct.paRepairFixed': '{n} repaired.',
    'ct.paRepairSigned': 'Already signed with the wrong PA (not modified — legal document):',
    'ct.paRepairShouldBe': 'should be',
    'ct.paRepairMissing': 'No PA licensed in the state (cannot fix automatically):',
    'ct.stateMismatchWarn': '⚠ The form says {form} but the property address is in {address} — the contract would go out with the {form} template. Fix the state on the claim before sending.',
    'ct.paMissingWarn': '⚠ No PA licensed in {state} — the contract cannot be sent. Add the license in Settings → Teams → Public Adjuster.',
    'cx.onlyPaSigns': 'Only {pa} can sign this contract — it is printed in their name and license.', 'cx.errSignerNotPa': 'You are not the Public Adjuster printed on this contract — only they can sign it. A contract signed by two different people cannot be fixed afterwards.', 'cx.errNoPaOnContract': 'This contract has no Public Adjuster printed — regenerate it before signing.', 'cx.errAutoSignTyped': 'The automatic signature only types the printed PA name — it cannot stamp a drawn signature.', 'cx.errTeamPaNotLicensed': 'The PA of the team assigned to this claim is not licensed in {state} — the contract cannot go out with them. Assign a team whose PA holds a {state} license (Settings → Teams).', 'ct.paFromTeam': 'from the assigned team ({team}) — this is who signs', 'ct.paFromBackup': 'backup (contractor card) — this claim has no team yet; the final PA is confirmed when the contract is sent', 'ct.paBlockedWarn': '⚠ {pa}, the PA of the assigned team ({team}), is not licensed in {state} — the contract cannot be sent. Assign a team whose PA holds a {state} license, or add the license in Settings → Teams → Public Adjuster.', 'dir.paBackupHint': 'These PA fields are a BACKUP only. The contract prints — and can only be signed by — the PA of the team assigned to the claim (Settings → Teams). They are used only while the claim has no team.', 'ct.paLabel': 'PA',
    'req.noNote': 'No note left by the requester.', 'req.openFull': 'Open the full claim in a new tab', 'req.daysWaiting': '{n} days waiting', 'req.oneDay': '1 day waiting', 'req.today': 'today', 'req.daysWaitingHint': 'Days since this request was made',
    'sup.typeOfLoss': 'Type of loss',
    'al.insOther': 'Insurance not listed — type it…',
    'al.insOtherPh': 'Insurance company name',
    'al.insBackToList': 'Choose from the list',
    "pq.heldTitle": "Held — authorized payments that can't go out yet",
    "pq.heldHint": "Authorized payments that are still outside the pay queue, whatever the payee. Each row says WHY: the check has not cleared the bank, the check bounced, or the homeowner authorization is missing. The manager bypass only unlocks that last case — on a check it does nothing.",
    'pq.heldAuthBy': 'authorized by',
    'pq.heldRequestAuth': 'Request HO authorization',
    'pq.heldBypassBtn': 'Bypass with reason',
    'pq.heldBypassPrompt': 'Reason for paying WITHOUT the homeowner authorization (audited):',
    'pq.heldBypassed': '✓ Released — the payment is now in the queue.',
    'tosign.title': 'To Sign — waiting for PA signature',
    'tosign.hint': 'Contracts the homeowner already signed — they only need the PA signature to be fully executed.',
    'tosign.empty': 'Nothing pending — every signed contract has its PA signature.',
    'tosign.signedOn': 'homeowner signed {when}',
    'tosign.waiting': '{n}d waiting',
    'tosign.goSign': 'Sign as PA',
    'fu.editNext': 'Edit next follow-up',
    'fu.clearNext': 'Remove next follow-up',
    'fu.save': 'Save',
    'hero.reqKindCancel': 'Cancel claim requested',
    'fnc.button': 'File a new claim',
    'fnc.buttonRequest': 'Request new claim',
    'fnc.hintSuper': 'Opens a NEW claim for this client and property (new damage): starts as Lead, empty, with a new claim number. This claim is archived and linked as the previous claim.',
    'fnc.hintRequest': 'Asks the Super Manager to open a NEW claim for this client and property (new damage).',
    'fnc.confirm': 'File a NEW claim for this client?\n\nThe new claim starts as Lead (to send the contract), with no files and a new claim number. Client, property, policy and contractor carry over.\n\nThis claim will be ARCHIVED and linked as "Previous claim" — all of its history stays available from the new one.',
    'fnc.reasonPrompt': 'Why file a new claim? (new damage, date of loss…) — the Super Manager will see this note:',
    'fnc.requested': 'New claim requested',
    'fnc.pending': 'There is already a pending request to file a new claim for this claim.',
    'fnc.exists': 'A new claim was already filed from this claim.',
    'fnc.reqKind': 'New claim requested',
    'fnc.prevAvailable': 'Previous claim available',
    'fnc.prevHint': 'This claim was filed again. See all the history, updates and files of previous claim {n}.',
    'fnc.nextFiled': 'New claim filed',
    'fnc.nextHint': 'A new claim was filed for this client. This one is kept as the previous claim.',
    'fnc.tab': 'Previous Claim Info',
    'fnc.prevTitle': 'Previous claim',
    'fnc.prevSub': '{name} · in system since {date}. Everything below is the history of the previous claim (read from it live).',
    'fnc.openPrev': 'Open previous claim',
    'fnc.prevFiles': 'Previous claim files',
    'fnc.openNew': 'New claim',
    'hero.reqKindHold': 'Hold requested',
    'hero.reqKindArchive': 'Archive requested',
    'hero.reqKindRelease': 'Release letter requested',
    'hero.reqBy': 'by {name} · {date}',
    'hero.reqPending': 'Pending decision',
    'hero.reqApproved': 'Approved',
    'hero.reqRejected': 'Rejected',
    'hero.reqDecidedBy': 'decided by {name}',
    'hero.reqNoNote': 'No note left by the requester.',
    'ct.accountManager': 'Account manager',
    'ct.roundRobin': 'Round-robin (Claims)',
    'ct.fixedTeam': 'Fixed team',
    'ct.addState': 'Add state',
    'cci.title': 'Client card',
    'cci.claimType': 'Claim type',
    'al.addLead': 'Add Lead',
    'al.title': 'Add Lead',
    'al.contractor': 'Contractor',
    'al.photosLink': 'Photos link',
    'al.create': 'Create Lead',
    'al.created': 'Lead created',
    'al.nextStep': 'Send the contract for e-signature, or upload an already-signed PDF.',
    'al.sendContract': 'Send contract',
    'al.openClaim': 'Open claim',
    'al.needNameAddr': 'Name and address are required.',
    'ird.openClaim': 'Open claim',
    'ird.contractStatus': 'Contract',
    'ird.contract': 'Contract',
    'ird.signed': 'Signed',
    'ird.awaitingSign': 'Awaiting signature',
    'ird.sent': 'Sent',
    'ird.opened': 'opened',
    'ird.resend': 'Resend',
    'ird.resent': 'Contract resent.',
    'ird.viewSigning': 'View signing page',
    'ird.paper': 'paper',
    'ird.esign': 'e-signature',
    'ird.photosLabel': 'Photos link (CompanyCam)',
    'ird.photosHint': 'Once the contract is signed and photos are added, the claim moves to Claim Review automatically.',
    'ird.movedReview': '✓ Moved to Claim Review',
    'photos.title': 'Photos', 'photos.open': 'Open photos', 'photos.upload': 'Upload photos', 'photos.addLink': 'Add link', 'photos.history': 'History', 'photos.current': 'current',
    'ird.toClaimReview': 'Move to Claim Review', 'ird.forceReviewConfirm': 'Move to Claim Review even if documents are missing?', 'ird.forceReviewHint': 'Use this if some documents are still missing but you want to review the claim now.',
    'ird.acceptNew': 'Accept — new claim', 'ird.acceptExisting': 'Accept — existing claim', 'ird.deny': 'Deny', 'ird.denyConfirm': 'Mark this claim as Not Accepted?', 'ird.decideHint': 'New claim = needs filing with insurance. Existing = an open claim we will start working.', 'ird.reopenReview': 'Reopen to Claim Review', 'ird.existing': 'Existing', 'ird.existingHint': 'Existing open claim we are working (no new filing needed).', 'ird.waitForDocs': 'Wait for docs', 'ird.waitForDocsHint': 'Move to Waiting Documents: we wait for the Info Pending documents to arrive, then it returns to Claim Review automatically.', 'ird.waitForDocsConfirm': 'Move to Waiting Documents until the pending documents arrive?', 'ird.claimStatus': 'Claim status', 'ird.paymentStatus': 'Payment status', 'ird.denyReasonLabel': 'Reason why (moves the claim to Not Accepted and notifies)', 'ird.denyReasonPh': 'Why is this claim not accepted?', 'ird.denySave': 'Save — mark Not Accepted',
    'so.ask': 'Seeking 2nd opinion', 'so.pending': '2nd opinion requested', 'so.resolve': 'Resolve', 'so.reasonLabel': 'Why do you need a second opinion?', 'so.reasonPh': 'What should they look at? e.g. the roof age vs the policy…', 'so.send': 'Request', 'so.sent': 'Requested.', 'so.sentTo': 'Sent to {name}.', 'so.notSet': 'No one is set to receive second opinions yet — set it with the second-opinion button above.', 'so.self': 'You are the one who receives second opinions.', 'so.settingTitle': 'Second opinions go to', 'so.goesTo': 'Second opinions go to {name}', 'so.notSetShort': '2nd opinion: not set', 'so.nobody': 'Nobody', 'so.settingHint': 'They get it as a task in their To Do, with the reason.', 'iq.photosUp': 'Photos', 'iq.wasEdited': 'edited', 'iq.clientSaid': 'the client had answered', 'iq.changedBy': 'changed by {quien} on {cuando}', 'iq.photosWait': 'No photos', 'iq.photosInFiles': '{n} file(s) from contractor — photos may be inside', 'iq.qComplete': 'Intake ✓', 'iq.qIncomplete': 'Intake incomplete', 'iq.qMissing': 'Intake missing', 'iq.intakeQuestions': 'Intake questions', 'iq.wcDone': 'Welcome ✓', 'iq.wcPending': 'Welcome pending', 'iq.paper': 'Paper', 'iq.online': 'Online', 'iq.eSigned': 'E-signed', 'iq.paperContract': 'Paper contract', 'iq.contractSent': 'Contract sent', 'iq.noContract': 'No contract', 'iq.contract': 'Contract', 'iq.photos': 'Photos', 'iq.policy': 'Policy', 'dept.viewCalendar': 'Calendar',
    'rec.title': 'Call recording', 'rec.typePh': 'Recording type (e.g. Approval call)', 'rec.withPh': '— With whom —', 'rec.party.adjuster': 'Adjuster', 'rec.party.homeowner': 'Homeowner', 'rec.party.contractor': 'Contractor', 'rec.party.other': 'Other', 'rec.partyNamePh': 'Name (optional)', 'rec.upload': 'Upload recording', 'rec.uploading': 'Uploading…', 'rec.saved': 'Recording saved', 'rec.by': 'by', 'rec.play': 'Play', 'rec.open': 'Open', 'rec.deleteConfirm': 'Delete this recording?', 'rec.auto': 'Auto (RingCentral)', 'rec.autoHint': 'Automatically downloaded from RingCentral and matched to this claim by phone number.', 'rec.aiSummary': 'AI summary of this call', 'rec.aiTranscript': 'See full transcript', 'rec.aiFailed': 'Summary not available for this recording', 'rec.aiGenerate': 'Generate AI summary', 'rec.aiWorking': 'Transcribing and summarizing…',
    'ird.storms': 'Storm search', 'ird.documents': 'Documents', 'co.title': 'Case Overview', 'co.subtitle': 'Strategies & instructions for this claim — anyone can post.', 'co.empty': 'No notes yet. Post the first strategy or instruction.', 'co.placeholder': 'Write a strategy or instruction…', 'co.saved': 'Saved', 'co.discussion': 'Internal discussion', 'co.attach': 'Attach files', 'co.dropHere': 'Drop files to attach',
    'task.boxTitle': 'Tasks', 'task.pickAssignee': '— Assign to —', 'task.whatToDo': 'What needs to be done?', 'task.none': 'No open tasks.', 'task.doneTasks': 'Done', 'task.doneBy': 'by', 'cv.expand': 'Show', 'cv.collapse': 'Hide', 'cv.title': 'Contract validation (AI)', 'cv.open': 'Open contract', 'cv.viewPdf': 'View', 'cv.hidePdf': 'Hide', 'cv.validate': 'Validate with AI', 'cv.hint': 'Click “Validate with AI” to check the signed contract against the claim (name, address, insurance, policy #, signing date).', 'cv.noContract': 'No contract on file for this claim yet.', 'cv.signed': 'Signed', 'cv.daysAgo': '{d} days ago', 'cv.noAi': 'Direct comparison (AI unavailable).', 'cv.analyze': 'Analyze contract', 'cv.reanalyze': 'Re-analyze', 'cv.analyzeHint': 'A contract/LOR PDF is uploaded in Files. Click “Analyze contract” to read it with AI and check it against the claim.', 'cv.fromFile': 'Analyzed from the uploaded PDF',
    'ird.homeowner': 'Homeowner', 'ird.hoName': 'Name', 'ird.hoEmail': 'Email', 'ird.hoPhone': 'Phone', 'ird.typeOfClaim': 'Type of claim',
    'loss.title': 'Loss info', 'loss.dateOfLoss': 'Date of loss', 'loss.typeOfLoss': 'Type of loss', 'loss.history': 'History', 'loss.current': 'current',
    'ird.saved': 'Saved.',
    'ird.fee': 'Fee',
    'ird.feeFromContractor': 'default from contractor',
    'ird.feeFromState': "default from the state's settings",
    'ird.feeNone': 'no default — set the fee',
    'cci.address': 'Address', 'cci.intakeForm': 'Intake form (HOQ)',
    'cci.dateOfLoss': 'Date of loss',
    'cci.state': 'State',
    'cci.language': 'Preferred language',
    'cci.gateCode': 'Gate code',
    'cci.gateCodeHint': 'Gated-community access code',
    'sch.gateHelp': 'Access code for the gated community — shown to the inspector on site.',
    'cci.acceptedLock': 'Accepted — super-manager only',
    'cci.superOnly': 'This claim is accepted; only a super-manager can edit the info.',
    'cci.locked': 'This claim is accepted — only a super-manager can edit it.',
    'nav.teams': 'Teams',
    'nav.inspectors': 'Inspectors',
    'nav.messaging': 'Messaging',
    'nav.notifications': 'Notifications',
    'notif.markAll': 'Mark all read',
    'ntf.subUnread': '{n} to act on', 'ntf.subClear': 'All caught up', 'ntf.filter': 'Filter', 'ntf.unread': 'To do', 'ntf.all': 'All',
    'ntf.pushSummary': 'Browser push notifications', 'ntf.colMe': 'For you', 'ntf.colMeHint': 'You were named, assigned, or replied to', 'ntf.colGroups': 'Your groups', 'ntf.colGroupsHint': 'A team or department you belong to was named',
    'ntf.emptyMeUnread': 'Nothing pending for you', 'ntf.emptyMe': 'No personal notifications yet', 'ntf.emptyGroupsUnread': 'Nothing pending for your groups', 'ntf.emptyGroups': 'No group notifications yet',
    'ntf.kMention': 'Mentioned you', 'ntf.kMentionGroup': 'Mentioned your group', 'ntf.kAssignment': 'Assigned', 'ntf.kSms': 'SMS reply', 'ntf.kMessage': 'Message', 'ntf.kEmail': 'Email', 'ntf.kComplaint': 'Complaint', 'ntf.kKudos': 'Kudos', 'ntf.kEom': 'Employee of the month', 'ntf.kTwin': 'Possible duplicate', 'ntf.kShare': 'Screen share', 'ntf.kSystem': 'System',
    'ntf.now': 'just now', 'ntf.minAgo': '{n} min ago', 'ntf.hAgo': '{n} h ago', 'ntf.dAgo': '{n} d ago',
    'ntf.reply': 'Reply', 'ntf.open': 'Open', 'ntf.done': 'Done', 'ntf.reopen': 'Reopen', 'ntf.replied': 'Replied', 'ntf.cancel': 'Cancel', 'ntf.send': 'Send reply', 'ntf.sending': 'Sending…',
    'ntf.replyPh': 'Write your reply…', 'ntf.replyHint': 'Posts in the {dept} thread of this claim. ⌘/Ctrl+Enter to send.',
    'notif.markUnread': 'Mark as unread — still to act on', 'notif.newTag': 'NEW', 'notif.seen': 'Seen',
    'notif.empty': 'No notifications yet. Mentions (@you) and assignments show up here.',
    'notif.pushOn': 'Enable browser notifications',
    'notif.enablePush': 'Enable notifications',
    'notif.pushHelp': 'Get a browser push when someone @mentions you or a claim is assigned to your team.',
    'notif.pushDenied': 'Browser permission denied — enable notifications for this site.',
    'notif.pushErr': 'Could not enable push on this browser.',
    'notif.setupTitle': 'Notifications',
    'notif.setupHelp': 'Turn on push so you get notified the moment you get a new message, @mention, or assignment — even when this tab is in the background.',
    'notif.pushActive': 'Notifications are on',
    'notif.pushResync': 'Re-sync',
    'notif.pushResynced': 'Notifications re-synced',
    'notif.pushTest': 'Send test',
    'notif.pushTestSent': 'Test sent — you should see a notification.',
    'notif.pushTestNoSub': 'This browser is not subscribed yet — tap Re-sync.',
    'notif.pushTestHint': "if nothing shows up, check your system's notification settings for this browser (Windows: Settings → Notifications; macOS: System Settings → Notifications).",
    'notif.pushTestFailed': 'Delivery failed (code {code}) — tap Re-sync and try again.',
    'notif.pushTestPartial': '{failed} device(s) failed — tap Re-sync on those devices.',
    'notif.pushTestWaiting': 'Sent — waiting for this browser to confirm it arrived…',
    'notif.pushTestDelivered': 'Delivered: this browser received the notification.',
    'notif.pushTestOsHint': "if you still don't see it on screen, the notification is being hidden by your system (Windows: Settings → Notifications → Chrome; macOS: System Settings → Notifications → Chrome; also check Focus / Do Not Disturb).",
    'notif.pushTestNoAck': 'It never reached this browser. The subscription is stale — tap Re-sync, then test again.',
    'notif.pushTestOldSw': 'This browser is still running an older version of the notification worker, so it cannot confirm delivery. Close every tab of this app and open it again, then test.',
    'notif.pushTestShowFailed': 'The push DID reach this browser, but showing the notification failed: {error}. The connection is fine — the problem is the notification display.',
    'notif.pushNoVapid': 'Push is not configured on the server — tell the administrator.',
    'notif.pushOtherDevice': 'This computer is not registered yet — your notifications are going to another device. Tap Re-sync here.',
    'notif.pushNeedsResync': 'Almost there — re-sync needed',
    'notif.pushResyncHelp': 'Permission is granted but this device is not registered on the server (this can happen after an update). Tap Re-sync to start getting notifications.',
    'notif.pushBlockedTitle': 'Notifications are blocked',
    'notif.pushBlockedHelp': 'You blocked notifications for this site. Turn them back on in your browser: tap the lock icon next to the address bar → Notifications → Allow, then re-check. On iPhone: Settings → Notifications → find this app.',
    'notif.pushRecheck': 'Re-check',
    'notif.pushUnsupported': 'This browser does not support push notifications. Try Chrome, Edge, or Safari (iOS 16.4+ installed to Home Screen).',
    'notif.iosInstall1': 'To get notifications on iPhone/iPad, first add this app to your Home Screen:',
    'notif.iosInstall2': 'Tap Share → “Add to Home Screen”, then open it from the icon and enable notifications here.',
    'nav.contractorInbox': 'Contractor Inbox',
    'nav.jobflow': 'JobFlow',
    'jf.search': 'Search contractor…',
    'jf.noEmail': 'no email on file',
    'jf.notInvited': 'Not invited',
    'jf.noResults': 'No contractors match.',
    'jf.pickContractor': 'Pick a contractor on the left to manage their JobFlow access.',
    'jf.notProvisionedHelp': 'This contractor is not on JobFlow yet. Send the invite to create their company (free plan, 3 users) and email the owner a link to set their password. Plan changes are done from Contractor settings.',
    'jf.adminEmailPh': 'Owner email for the invite',
    'jf.sendInvite': 'Send invitation',
    'jf.defaultsNote': 'Free plan · 3 users',
    'jf.inviteUser': 'Invite user',
    'jf.firstName': 'First name',
    'jf.lastName': 'Last name',
    'jf.invited': 'Invitation sent.',
    'jf.resent': 'Invitation re-sent',
    'jf.resetSent': 'Password reset sent',
    'jf.viewOpened': 'Opened the JobFlow view of {name} (read-only, 30 min).',
    'jf.viewAs': 'View their JobFlow',
    'jf.resendInvite': 'Resend invite',
    'jf.resetPassword': 'Reset password',
    'jf.colUser': 'User',
    'jf.colRole': 'Role',
    'jf.colStatus': 'Status',
    'jf.colLastLogin': 'Last login',
    'jf.noUsers': 'No users in this company yet.',
    'jf.pendingInvite': 'Invite pending',
    'jf.active': 'Active',
    'jf.suspended': 'Suspended',
    'jf.notConfigured': 'JobFlow is not configured on the server (missing URL/key) — tell the administrator.',
    'jf.role.company_admin': 'Admin',
    'jf.role.office': 'Office',
    'jf.role.sales_team': 'Sales',
    'jf.role.roof_inspector': 'Inspector',
    'jf.role.roof_crew': 'Crew',
    // JOBFLOW P2-9 — Contractor Inbox
    'ci.title': 'Contractor Inbox',
    'ci.empty': 'No messages.',
    'ci.allDepts': 'All departments',
    'ci.v_open': 'Open', 'ci.v_mine': 'Assigned', 'ci.v_unassigned': 'Unassigned', 'ci.v_closed': 'Closed',
    'ci.viewAs': 'View as', 'ci.viewAsMe': 'Me', 'ci.viewAsOn': 'Viewing as {name}',
    'ci.addAsPhotos': 'Add as Photos', 'ci.addAsAtr': 'Add as ATR',
    'ci.addAsPhotosHint': 'Sets this link as the claim photos link.',
    'ci.addAsAtrHint': 'Adds this link to the claim as the ATR video.',
    'ci.addedPhotos': 'Added as Photos', 'ci.addedAtr': 'Added as ATR',
    'ci.search': 'Search client, claim # or message…',
    'cph.title': 'Contractor Photos', 'cph.sec_photos': 'Contractor Photos', 'cph.sec_files': 'Contractor Files', 'cph.filesEmpty': 'No contractor files in this period.', 'cph.markReviewed': 'Reviewed', 'cph.reviewedBy': 'Reviewed — {n}',
    'cph.subtitle': 'Everything the contractors send from JobFlow: photos, albums and CompanyCam links.',
    'cph.k_all': 'Everything', 'cph.k_image': 'Photos', 'cph.k_album': 'Albums',
    'cph.allContractors': 'All contractors',
    'cph.lastDays': 'Last {n} days',
    'cph.count': '{fotos} photos · {albums} albums · {links} links',
    'cph.album': 'Album',
    'cph.albumLinks': 'CompanyCam albums',
    'cph.openAlbum': 'Open album',
    'cph.today': 'Today', 'cph.zip': 'Download folder', 'cph.expand': 'Show the photos', 'cph.collapse': 'Hide the photos', 'cph.copyAddress': 'Copy the address', 'cph.pasteLink': 'Paste the CompanyCam link…', 'cph.zipHint': 'Downloads every photo of this client as a ZIP, ready to upload to CompanyCam.', 'cph.nPhotos': '{n} photos', 'cph.yesterday': 'Yesterday',
    'cph.dayN': '{n}d here', 'cph.dayZero': 'today',
    'cph.daysHint': 'Days this link has been sitting here. The contractor link is usually a CompanyCam invitation — until someone accepts it and pastes the real album, the photos are not here.',
    'cph.pendingOnly': 'Only waiting for the album',
    'cph.awaitingAlbum': 'album pending',
    'cph.resolved': 'album pasted',
    'cph.reviewed': 'Reviewed', 'cph.reviewedTag': 'reviewed',
    'cph.expired': 'Expired', 'cph.expiredTag': 'link expired',
    'cph.tab_pending': 'Album pending', 'cph.tab_reviewed': 'Reviewed',
    'cph.tab_expired': 'Expired', 'cph.tab_all': 'All',
    'cph.dropPhotos': 'Photos',
    'cph.newLinkPh': 'Paste the real album link (after accepting the invitation)…',
    'cph.saveLink': 'Save link',
    'cph.pickFiles': 'Choose photos',
    'cph.dropHint': 'or drop the photos here — they go straight to the claim',
    'cph.saving': 'Saving…', 'cph.uploading': 'Uploading',

    'cph.emptyHint': 'Nothing arrived in this period. Photos uploaded in JobFlow only land here if the contractor attaches them to the claim or shares the CompanyCam album.',
    'nav.contractorPhotos': 'Contractor Photos',
    'nav.clientPortal': 'Client Portal',
    // ClaimRoute (pedido del dueño 2026-10-05): la oficina ve la app de un inspector tal como él la ve.
    'nav.claimRoute': 'ClaimRoute',
    'inspv.title': 'ClaimRoute — the inspector’s app',
    'inspv.hint': 'Pick an inspector to see their app exactly as they see it on their phone, so you can guide them. View only: nothing you tap changes anything.',
    'inspv.searchPh': 'Inspector name…',
    'inspv.today': '{n} today',
    'inspv.missing': '{n} without report',
    'inspv.pick': 'Pick an inspector on the left to see their app.',
    'inspv.none': 'No inspectors match.',
    'inspv.loadFailed': 'Could not load the inspectors.',
    'inspv.retry': 'Try again',
    'inspv.viewing': 'You are seeing {name}’s app',
    'inspv.viewOnly': 'View only',
    'inspv.refresh': 'Refresh',
    'inspv.pushOn': 'Notifications on',
    'inspv.pushOff': 'Notifications OFF on their phone',
    'inspv.autoRefresh': '“My day” refreshes on its own every 30 seconds.',
    // SETTINGS → CLIENT PORTAL (una sola sección, pedido del dueño 2026-09-28).
    'cps.settingsTab': 'Client Portal',
    'cps.encendido': 'Client Portal on for this company',
    'cps.modo': 'Mode',
    'cps.modoDryRun': 'Dry run — nobody gets in',
    'cps.modoPiloto': 'Pilot — only the claims I pick',
    'cps.modoAll': 'All claims',
    'cps.dosLlaves': 'Two keys, on purpose: this switch AND PORTAL_ENABLED in Railway. The same rule as everything else that talks to clients.',
    'cps.tabDocumentos': 'Documents',
    'cps.tabRecordatorios': 'Reminders',
    'cps.tabContacto': 'Contact & status',
    'cps.tabActividad': 'Activity',
    'cps.vetoTitulo': 'This list is a veto.',
    'cps.vetoTexto': 'A type that is not checked here never reaches the client — not even if someone marks that file by hand in the claim. Everything starts unchecked.',
    'cps.autoContrato': 'The signed agreement becomes visible on its own',
    'cps.autoCartas': 'Insurance company letters become visible on their own',
    'cps.archivos': '{n} files',
    'cps.nuncaSeMuestra': 'never shown',
    'cps.recordatoriosOn': 'Text reminders on',
    'cps.desde': 'On since {fecha} — the worker only looks at what changed after that.',
    'cps.sinEncenderNunca': 'Never turned on. When you turn it on, the server stamps the moment so the first run does not sweep the whole history.',
    'cps.cadaDias': 'Every how many days',
    'cps.tope': 'Stop after how many reminders',
    'cps.hora': 'Send hour (office time)',
    'cps.horaAyuda': 'Minimum 9 — the company texts 8 states and part of Tennessee is Central, where 8:00 ET is 7:00 AM.',
    'cps.silencio': 'Skip if any text went out in the last N hours',
    'cps.silencioAyuda': 'Nothing counts texts together, so without this a client can get several the same day from different automations.',
    'cps.porCorrida': 'Max per run',
    'cps.soloHabiles': 'Weekdays only',
    'cps.tipos': 'What to remind about',
    'cps.tipoDocs': 'Documents we are waiting for',
    'cps.tipoContrato': 'Agreement sent and not signed',
    'cps.telefono': 'Office phone shown to the client',
    'cps.whatsapp': 'WhatsApp (optional)',
    'cps.horario': 'Office hours',
    'cps.congelar': 'Hold back bad news on sensitive stages',
    'cps.congelarAyuda': 'On HOLD, Denied, Claim Not Accepted, ATR Rejected and Cancelled the portal shows a neutral line and alerts the claim team, instead of telling someone alone on a Sunday night.',
    'cps.montos': 'Show amounts',
    'cps.montosAyuda': 'Leave this off until the RCV fix is deployed and backfilled: some claims still carry our estimate amount instead of the insurance company\'s.',
    'cps.actividadAyuda': 'A client-facing channel that stops working looks exactly like a quiet day: the sign-in always answers 200 so it does not reveal which phones exist, and a text that fails does it silently.',
    'cps.kpiCodigos': 'Codes sent (24h)',
    'cps.kpiVerificados': 'Codes used',
    'cps.kpiFallidos': 'Texts that failed',
    'cps.kpiSesiones': 'Active sessions',
    'cps.kpiClaims': 'Claims with activity (7d)',
    'cps.kpiDocs': 'Documents shared',
    'cps.guardar': 'Save',
    'cps.guardado': 'Saved.',
    'cps.reset': 'Back to defaults',
    'cps.errorCargar': 'We could not load the settings.',
    'cps.errorGuardar': 'We could not save. Try again.',
    // EQUIPO: a quién le muestra el portal su correo. Dos fuentes distintas, y la pantalla lo dice —
    // los PA ya tienen casilla pública (mailboxes) y los account managers todavía no existen.
    'cps.tabEquipo': 'Team emails',
    'cps.eqAyuda': 'These are the only emails the portal shows the homeowner. Nobody\'s login address is ever shown: that one is a credential.',
    'cps.eqPaTitulo': 'Public adjusters',
    'cps.eqPaFuente': 'Read only — these come from the shared PA mailboxes (Settings → Mailboxes), which is also where incoming mail is routed. Change them there.',
    'cps.eqSinCasilla': 'No public mailbox — the client will not see an email for this person.',
    'cps.eqSinPa': 'No public adjusters on file.',
    'cps.eqAmTitulo': 'Account managers',
    'cps.eqAmFuente': 'Read only — this is each person\'s personal mailbox (Settings → Mailboxes). Change it there.',
    'cps.eqSinBuzon': 'No mailbox yet — the client will not see an email for this person.',
    'cps.eqEsSuLoginAviso': 'This is also the address they sign in with.',
    'cps.eqSinAm': 'No account manager is assigned to any claim team yet.',
    // CLIENT PORTAL — la pantalla del staff (pedido del dueño 2026-09-28). Estas claves son del
    // STAFF y van en el diccionario del app; el PORTAL del cliente tiene su propio diccionario
    // (src/portal/i18n.ts) para no bajarle a un homeowner las 6.000 claves de la oficina.
    'cp.titulo': 'Client Portal',
    'cp.buscarLabel': 'Find the homeowner',
    'cp.buscarPlaceholder': 'Name, address, claim # or phone',
    'cp.elegiUno': 'Search for a homeowner to see exactly what they see.',
    'cp.vistaCliente': 'Client view',
    'cp.soloLectura': 'read only — nothing here can be signed or submitted',
    'cp.acceso': 'Portal access',
    'cp.portalEncendido': 'Portal on',
    'cp.telefono': 'Phone on file',
    'cp.telefonoVerificado': 'Phone verified',
    'cp.sinVerificar': 'Not verified — the portal will not open',
    'cp.sesiones': 'Sessions',
    'cp.ultimoLogin': 'Last sign-in',
    'cp.ultimaVisita': 'Last seen',
    'cp.aceptacion': 'Acknowledgment',
    'cp.sinAceptar': 'Not accepted yet',
    'cp.eventos': 'Recorded events',
    'cp.apagado': 'Portal turned off',
    'cp.verificarTelefono': 'Verify phone',
    'cp.quitarVerificacion': 'Remove verification',
    'cp.enviarAcceso': 'Text them a code',
    'cp.revocar': 'Revoke access',
    'cp.apagarClaim': 'Turn portal off for this claim',
    'cp.encenderClaim': 'Turn portal back on',
    'cp.activityLogPdf': 'Activity log (PDF)',
    'cp.activityLogCsv': 'CSV',
    'cp.documentos': 'Documents the client can see',
    'cp.documentosAyuda': 'Everything starts hidden. The document-type list in Settings is a veto: it wins over marking a file by hand.',
    'cp.sinDocumentos': 'No documents on this claim yet.',
    'cp.mostrar': 'Show to the client',
    'cp.ocultar': 'Hide from the client',
    'cp.marcadoAMano': 'set by a person',
    'cp.motivo.tipo_prohibido': 'never shown (checks, internal notes)',
    'cp.motivo.documento_generico': 'company document, not this claim',
    'cp.motivo.del_contratista': 'came from the contractor',
    'cp.motivo.tipo_no_permitido': 'type not allowed in Settings',
    'cp.motivo.no_marcado': 'not marked',
    'cp.motivo.archivado': 'archived',
    'cp.motivo.adjunto_hijo': 'attachment of another file',
    'cp.si': 'Yes',
    'cp.no': 'No',
    'cp.errorBuscar': 'We could not search right now. Try again.',
    'cp.errorPanel': 'We could not load this claim. Try again.',
    'cp.errorVista': 'We could not open the client view. Try again.',
    'cp.errorAccion': 'That did not go through. Try again.',
    'ci.photosReceived': 'Photos received',
    'ci.photosSearchPh': 'Search homeowner, contractor or claim #…',
    'ci.photosEmpty': 'No photos yet',
    'ci.openClaim': 'Open claim',
    'ci.replyPh': 'Reply to the contractor… (Enter sends, Shift+Enter = new line)',
    'ci.noteEdited': 'edited',
    'ci.noteMentionHint': '@Name notifies that person.',
    'ci.sendAndClose': 'Send and close',
    'ci.resolve': 'Resolve',
    'ci.resolved': 'Resolved',
    'ci.assignTeam': 'Assign to a claim team',
    'ci.noTeams': 'This claim has no teams assigned',
    'ci.st_new': 'NEW', 'ci.st_assigned': 'ASSIGNED',
    'ci.filesFromContractor': 'Files from contractor',
    'ci.noFiles': 'The contractor hasn’t uploaded files yet.',
    'ci.followupChip': 'CO follow-up · {n}d late',
    'ci.followupChipHint': 'The contractor follow-up (every 3 days) is due on this claim.',
    'ci.msgChip': '{n} CO msg · {h}h',
    'ci.msgChipHint': 'Unanswered contractor messages (1-day SLA). Click to open the contractor chat.',
    'ci.attachHint': 'Attach files — they travel to JobFlow with your reply',
    'chat.contractorBoard': 'Contractor board',
    'ci.state.new': 'New',
    'ci.state.assigned': 'Assigned',
    'ci.state.answered': 'Answered',
    'ci.assignMe': 'Assign to me',
    'ci.assignedTo': 'Assigned to {name}',
    'ci.reply': 'Reply',
    'ci.replyPlaceholder': 'Write a reply to the contractor…',
    'cr.messages': 'Messages',
    'cr.newDm': 'New',
    'cr.new': 'New',
    'cr.dmTab': 'Direct',
    'cr.searchPerson': 'Search a person…',
    'cr.newGroup': 'Group',
    'cr.groupName': 'Group name',
    'cr.createGroup': 'Create group',
    'cr.selectConversation': 'Select a conversation.',
    'cr.noMessages': 'No messages yet — say hi!',
    'cr.typeMessage': 'Type a message…',
    'cr.send': 'Send',
    'cr.reply': 'Reply',
    'cr.replyInThread': 'Reply — goes to the update where you were mentioned',
    'nav.crDashboard': 'Dashboard',
    'nav.crScheduled': 'Scheduled',
    'nav.crCalendar': 'Calendar',
    'nav.timeOff': 'Time off',
    'nav.crUploads': 'Uploads',
    'nav.crReports': 'Reports',
    'nav.inspectorHistory': 'Inspector History',
    'ih.title': 'Inspector inspection history',
    'ih.help': 'Full record of every inspection an inspector performed — kept in the database even after they are terminated. Use it as official support if a legal question arises about who inspected a property and when.',
    'ih.inspector': 'Inspector',
    'ih.pickInspector': 'Select an inspector…',
    'ih.terminated': 'Terminated',
    'ih.from': 'From',
    'ih.to': 'To',
    'ih.downloadCsv': 'Download CSV',
    'ih.pickToStart': 'Select an inspector to see their inspection history.',
    'ih.visits': 'visits',
    'ih.completed': 'completed',
    'ih.date': 'Date',
    'ih.claim': 'Claim #',
    'ih.client': 'Client',
    'ih.address': 'Address',
    'ih.type': 'Type',
    'ih.status': 'Status',
    'ih.checkin': 'Check-in',
    'ih.checkout': 'Check-out',
    'ih.gps': 'GPS',
    'ih.miles': 'Miles',
    'ih.notes': 'Notes',
    'ih.evidence': 'Evidence',
    'ih.noShow': 'no-show',
    'ih.in': 'in',
    'ih.out': 'out',
    'ih.check': 'check',
    'ih.none': 'No inspections found for this inspector in the selected range.',
    'nav.crActivity': 'Activity',
    'cr.toSchedule': 'To schedule',
    'cr.hideSide': 'Hide side panel',
    'cr.showSide': 'Show side panel',
    'cr.noToSchedule': 'Nothing pending to schedule.',
    'cr.lightDays': 'Light days — these inspectors are under 3 visits. Add more before the day comes.',
    'cr.visit1': 'visit',
    'cr.visitN': 'visits',
    'cr.searchCal': 'Search client, address, inspector',
    'cr.view.month': 'Month',
    'cr.view.week': 'Week',
    'cr.view.day': 'Day',
    'cr.more': 'more',
    'cr.seeAllDay': 'See every inspection on this day', 'cr.noActivityDay': 'No visits recorded for this day.',
    'cr.noShow': 'No-show',
    'cr.tripCharge': 'Trip charge',
    'cr.in': 'In',
    'cr.out': 'Out',
    'cr.duration': 'Duration',
    'cr.today': 'Today',
    'cr.dayNotes': 'Day notes', 'cr.dayNotesEmpty': 'No notes for this day yet.', 'cr.dayNotesPh': 'Add a note for the day (e.g. rainy day)…',
    'cr.allInspectors': 'All inspectors',
    'cr.up.all': 'All',
    'cr.up.pending': 'Pending',
    'cr.up.uploaded': 'Uploaded',
    'cr.watchVideo': 'Watch video',
    'cr.awaitingVideo': 'Awaiting video upload',
    'atr.notes': 'Notes', 'atr.notesPh': 'Write a note about this ATR…', 'atr.hasNote': 'note',
    'cr.searchUploads': 'Search by client, address, claim # or inspector…',
    'cr.uploadedOn': 'Uploaded',
    'cr.dWaiting': 'd waiting',
    'cr.rescheduleAtr': 'Reschedule ATR',
    'cr.nextInspection': 'Next inspection',
    'cr.fieldAdjuster': 'Field Adjuster',
    'cr.fieldAdjusterHelp': 'Adjuster name / contact. Edits are tracked in the timeline.',
    'cr.fieldAdjusterPh': 'e.g. DA John Doe · ph: 555-1234 · email: claims@carrier.com',
    'cr.inspectorNotesTitle': 'Notes for the inspector',
    'cr.inspectorNotesHelp': 'Special requirements / what to expect. The inspector sees this in their app.',
    'cr.inspectorNotesPh': 'e.g. Gate code 1234 · dog in back yard · meet adjuster at front',
    'cr.saveNotes': 'Save notes',
    'cr.noteSent': 'Sent to the inspector', 'cr.noteSentShort': 'sent to the inspector', 'cr.noNotesYet': 'No notes yet — the first one you save shows up here with your name and the time.', 'cr.noteByOffice': 'Office',
    'cr.mondayUpdates': 'Monday updates',
    'cr.mondayUpdatesHelp': 'Read and write the client’s Monday notes here — no need to open Monday.',
    'cr.mondayUpdatesPh': 'Write an update — it posts to this client’s Monday item…',
    'cr.draftUpdate': 'Draft update',
    'cr.postToMonday': 'Post to Monday',
    'cr.schedulingActivity': 'Scheduling activity', 'cr.by': 'by',
    'cr.noSchedulingActions': 'No scheduling actions yet.',
    'cr.clear': 'Clear',
    'cr.inspector': 'Inspector',
    'cr.daysWorked': 'Days',
    'cr.noShows': 'No-shows',
    'cr.miles': 'Miles',
    'cr.total': 'Total',
    'cr.pay': 'Pay',
    'cr.rep.payroll': 'Payroll', 'cr.rep.pdf': 'Download PDF',
    'cr.rep.analytics': 'Analytics',
    'cr.rep.schedulers': 'Schedulers',
    'cr.rep.clients': 'Client history',
    'cr.rep.noSchedulers': 'No appointments booked in this range.',
    'cr.rep.scheduler': 'Scheduler',
    'cr.rep.booked': 'Booked',
    'cr.rep.active': 'Active',
    'cr.rep.canceled': 'Canceled',
    'cr.rep.searchPh': 'Search by client name, address or claim #…',
    'cr.rep.searchHint': 'Type at least 2 characters to search.',
    'cr.rep.noClients': 'No claims found.',
    'cr.rep.lastVisit': 'Last visit',
    'cr.an.avgPay': 'Avg pay / inspector',
    'cr.an.activeInsp': 'Active inspectors',
    'cr.act.payroll': 'Payroll review',
    'cr.act.audit': 'Audit trail',
    'cr.sch.week': 'Week',
    'cr.sch.month': 'Month',
    'cr.sch.all': 'All',
    'cr.sview.board': 'Board',
    'cr.sview.month': 'Month',
    'cr.noScheduled': 'No scheduled appointments.',
    'cr.unassigned': 'Unassigned',
    'cr.showingDay': 'Showing',
    'cr.snapshotNote': 'latest day with imported activity (data is a snapshot)',
    'cr.noInspectorsToday': 'No inspectors scheduled today.',
    'cr.noVisitsToday': 'No visits today.',
    'cr.report': 'report',
    'cr.onSite': 'on site',
    'cr.onTime': 'on time',
    'cr.lateLc': 'late',
    'cr.step.onWay': 'On the way',
    'cr.step.checkIn': 'Check in',
    'cr.step.started': 'Started',
    'cr.step.completed': 'Completed',
    'cr.tomorrow': 'tomorrow',
    'cr.resolve': 'Resolve',
    'cr.openFullClaim': 'Open full claim',
    'cr.photos': 'Photos',
    'cr.viewReport': 'View report',
    'cr.reassign': 'Reassign',
    'cr.reassignTo': 'Reassign inspector',
    'cr.current': 'current',
    'cr.schedule': 'Schedule',
    'cr.visit': 'Visit',
    'cr.noClaimLinked': 'No claim linked to this appointment',
    'sch.title': 'Schedule inspection',
    'sch.rescheduleTitle': 'Reschedule inspection',
    'sch.rescheduleShort': 'Reschedule',
    'sch.urgentReschedule': 'Urgent reschedule',
    'sch.urgentTag': 'URGENT',
    'sch.urgentRescheduleTag': 'URGENT reschedule',
    'sch.urgentHint': 'Needs a new date as soon as possible. The claim stays tagged URGENT until it is rebooked.',
    'cd.lorNotSent': 'LOR not sent to insurance', 'cd.claimNumberInvalid': 'That is not a claim number. A claim number has digits (e.g. 11-0R2D398). Leave it empty if the carrier has not assigned one yet.',
    'cd.lorNotSentHint': 'The Letter of Representation has not been sent to the insurance company yet, so the claim is not filed.',
    'cr.distance': 'Distance',
    'dist.title': 'Distance between two addresses',
    'dist.from': 'From',
    'dist.to': 'To',
    'dist.calc': 'Calculate',
    'dist.result': '{miles} mi · about {min} min driving',
    'dist.estimated': 'Estimated (straight line × 1.3): Google routes are not configured.',
    'dist.openMaps': 'Open in Google Maps',
    'dist.notFound': 'Google could not find one of the addresses. Check the street, city and state.',
    'dist.error': 'Could not calculate the distance.',
    'sch.remove': 'Remove',
    'sch.removeConfirm': 'Remove this appointment from the calendar? It will be canceled.',
    /* ── Optimize routes (optimizador del día) ── */
    'opt.button': 'Optimize routes',
    /* ── Traspaso de visitas entre inspectores (Settings → Scheduling) ── */
    'trf.title': 'Transfer visits between inspectors',
    'trf.subtitle': 'Move all the upcoming visits of one inspector to another, for a date range or every one that exists. Times do not change; both inspectors get a summary notice.',
    'trf.from': 'From inspector',
    'trf.to': 'To inspector',
    'trf.scopeRange': 'Date range',
    'trf.scopeAll': 'All upcoming visits',
    'trf.count': 'Count visits',
    'trf.apply': 'Transfer {n} visits',
    'trf.confirm': 'Transfer {n} visits from {from} to {to}? Times stay the same.',
    'trf.preview': '{from} has {n} upcoming visits in this scope:',
    'trf.previewHint': 'Nothing has moved yet. Confirm with the button above.',
    'trf.none': '{from} has no upcoming visits in this scope.',
    'trf.done': '{n} visits transferred from {from} to {to}.',
    'trf.failed': 'Could not transfer. Try again.',
    'opt.title': 'Optimize routes',
    'opt.subtitle': 'Re-assigns the visits of this day between inspectors so they drive as little as possible. Appointment times stay; ATRs can move.',
    'opt.calculating': 'Calculating…',
    'opt.step.load': 'Loading the visits of the day',
    'opt.step.routes': 'Getting real drive times',
    'opt.step.search': 'Searching for a better distribution',
    'opt.noStops': 'No inspector visits on this day.',
    'opt.noChanges': 'This day is already well distributed.',
    'opt.noChangesHint': 'No reassignment saves enough driving to be worth the change.',
    'opt.gain': 'Save {min} min of driving ({pct}%) with {n} changes',
    'opt.gainOne': 'Save {min} min of driving ({pct}%) with 1 change',
    'opt.conflictsFixed': 'Also fixes {n} late arrivals',
    'opt.conflictsFixedOne': 'Also fixes 1 late arrival',
    'opt.before': 'Now',
    'opt.after': 'Proposed',
    'opt.driving': 'driving',
    'opt.visits': 'visits',
    'opt.late': 'late arrivals',
    'opt.inspector': 'Inspector',
    'opt.total': 'Total',
    'opt.changes': 'Changes',
    'opt.kind.swap': 'Swap',
    'opt.kind.reassign': 'Reassign',
    'opt.kind.assign': 'Assign',
    'opt.kind.shift': 'Move time',
    'opt.kind.retime': 'New time',
    'opt.kind.bump': 'Another day',
    'opt.kind.add': 'Add',
    'opt.kind.reschedule': 'Reschedule',
    'opt.chg.reschedule': '{label} ({time}): nobody can cover it today → back to the queue, reschedule for another day — call the homeowner',
    'opt.chg.rescheduleMove': '{label} ({time}) moves to {date} at {newTime} with {to} — call the homeowner',
    'opt.atr.keep': 'Keep the proposal',
    'opt.atr.cancel': 'Send it back to the queue instead',
    'opt.removeInspector': 'Remove from the day',
    'opt.includeInspector': 'Include again',
    'opt.chg.add': '{label} ({type}, waiting {days} d in the queue) is added to {to} at {newTime}',
    'opt.chg.bumpCost': '+{add} min of driving that day',
    'opt.chg.bumpCancel': '{label} ({type}) leaves this day → canceled, back to the scheduling queue',
    'opt.bump.cancel': 'Cancel it (back to the queue)',
    'opt.bump.move': 'Move to {date} at {time} with {to} (+{add} min there)',
    'opt.selected': '{k} of {n} selected',
    'opt.applyN': 'Apply {k} changes',
    'opt.applyOne': 'Apply 1 change',
    'opt.toggleHint': 'Uncheck to leave this one as it is',
    'opt.opt.pending': 'Add ATRs waiting in the queue when they are on the way',
    'opt.newBadge': 'New',
    'opt.chg.reassign': '{label} ({time}) goes from {from} to {to}',
    'opt.chg.swap': '{label} ({time}): {from} → {to}, in exchange for {with}',
    'opt.chg.swapPair': '{a} ({timeA}): {fromA} → {toA} ⇄ {b} ({timeB}): {fromB} → {toB}',
    'opt.sinBaseNote': '* No home base configured: the route starts from the office.',
    'opt.chg.assign': '{label} ({time}) is assigned to {to}',
    'opt.chg.shift': '{label} moves from {time} to {newTime} ({delta} min) — call the homeowner',
    'opt.chg.shiftNote': 'and moves to {newTime} ({delta} min) — call the homeowner',
    'opt.chg.retimeNote': 'and moves to {newTime} ({delta} min)',
    'opt.chg.retime': '{label} ({type}) moves from {time} to {newTime} with {to}',
    'opt.chg.bump': '{label} ({type}) leaves this day → {date} at {newTime} with {to}',
    'opt.chg.bumpNoTarget': '{label} ({type}) leaves this day → back to the scheduling queue',
    'opt.between': 'between {prev} ({a} min) and {next} ({b} min)',
    'opt.afterStop': 'after {prev} ({a} min)',
    'opt.beforeStop': 'before {next} ({b} min)',
    'opt.opt.shift': 'Allow moving inspections up to 30 min',
    'opt.opt.bump': 'Allow moving ATRs to another day',
    'opt.opt.idle': 'Include inspectors with no visits that day',
    'opt.opt.keep': 'Keep each inspector\'s number of visits',
    'opt.recalc': 'Recalculate',
    'opt.apply': 'Apply changes',
    'opt.applying': 'Applying…',
    'opt.applied': '{n} changes applied',
    'opt.preview': 'Preview on calendar',
    'opt.previewBar': 'Previewing the proposal',
    'opt.details': 'Details',
    'opt.discard': 'Discard',
    'opt.close': 'Close',
    'opt.map.before': 'Current routes',
    'opt.map.after': 'Proposed routes',
    'opt.cal.current': 'Current calendar',
    'opt.cal.proposed': 'Proposed calendar',
    'opt.mapHint': 'Straight lines between stops, one color per inspector; the numbers are the order of the day.',
    'opt.warn.no_home': '{name} has no home base configured; the office is used as the start point.',
    'opt.warn.estimated': '{n} drive times are estimates (no real route available).',
    'opt.warn.no_geo': '{n} visits without coordinates were left out.',
    'opt.warn.off_today': '{name} has the day off but still has visits.',
    'opt.locked': '{n} visits already under way stay as they are.',
    'opt.estimatedRoutes': 'Drive times are estimates: real routes are not configured.',
    'opt.dayChanged': 'The day changed since the calculation. Recalculate.',
    'opt.failed': 'Could not calculate. Try again.',
    'opt.home': 'Home',
    'opt.fromPrev': 'from {prev}',
    'opt.lateBy': 'arrives {min} min late',
    'opt.office': 'Office',
    'opt.fromLabel': 'from {name}',
    'opt.wasAt': 'was {time}',
    'opt.removedBadge': 'Leaves the day',
    'sch.searchClaims': 'Search client, address, or claim #…',
    'sched.todo': 'To do', 'sched.allTab': 'All', 'sched.todoHint': 'To do = claims already filed with the insurance (they have a claim number), ready to schedule. All also shows the ones not filed yet.', 'sched.notFiled': 'Not filed yet', 'sched.notFiledHint': 'No claim number yet: the insurance does not have this claim, so there is nothing to schedule.', 'sched.notFiledN': '{n} not filed yet (see All)', 'schType.inspection': 'Inspection', 'schType.adjuster_meeting': 'Adjuster meeting', 'schType.atr': 'ATR', 'schType.photos': 'Photos',
    'schType.atr_on_site': 'ATR on site', 'schType.check_pickup': 'Check pickup', 'schType.material_sample': 'Material sample', 'schType.repair_video': 'Repair video', 'schType.custom': 'Custom',
    'sch.subtitle': 'Recommended slots — best inspector, drive time and weather.',
    'sch.kind.inspector': 'Inspector',
    'sch.kind.contractor': 'Contractor',
    'sch.kind.none': 'No inspector',
    'sch.manual': 'Set a specific date & time (backfill a past visit)',
    'sch.pickManually': 'Pick manually',
    'sch.cancelForNow': 'Cancel for now',
    'sch.cancelForNowHint': 'This parks the claim in Needs Reschedule and cancels the appointment. You can re-book it later.',
    'sch.confirmCancel': 'Cancel appointment',
    'sch.inspector': 'Inspector',
    'sch.dateTime': 'Date & time',
    'sch.contractorName': 'Contractor name',
    'sch.reason': 'Reason (optional)',
    'sch.reasonFull': 'Full note — explain what happened and anything else about the schedule (goes in the claim report)',
    'ia.tag': 'Inspector alert',
    'ia.dismiss': 'Dismiss',
    'ia.answered': 'Answered',
    'ia.answeredHint': 'I already answered the inspector — turn this alert off for everyone',
    'cph.filesAllReviewed': 'All files reviewed — nothing pending.',
    'cph.reviewedSection': 'Reviewed',
    // Templates por departamento (Settings → Templates, manager+)
    'set.tabTemplates': 'Templates',
    'tpl.smsBody': 'Text message', 'tpl.smsBodyPh': 'Write the SMS as it should go out…',
    'em.tplFromView': 'This queue',
    // Insurance board editable (2026-08-11)
    'ins.whoEdits': 'Who can edit this board',
    'ins.managersAlways': 'Managers always',
    'ins.boardFields': 'Board fields',
    'ins.addField': 'Add field',
    'ins.fieldLabelPh': 'Field name (e.g. Supplement email)',
    'ins.kShort': 'Short text', 'ins.kLong': 'Long text', 'ins.kNumber': 'Number', 'ins.kDate': 'Date', 'ins.kStatus': 'Status',
    'ins.optionsPh': 'Status options, comma separated',
    'ins.newOption': 'Add a status option',
    'ins.newOptionPrompt': 'New status option:',
    'ins.history': 'History — who changed what',
    'ins.historyEmpty': 'No changes recorded yet.',
    // Pestañas de Claim Review (2026-08-11)
    'crv.all': 'All', 'crv.working': 'Working on', 'crv.done': 'Done',
    'crv.doneEmpty': 'No decisions yet.',
    'crv.colClient': 'Client', 'crv.colDecision': 'Decision', 'crv.colBy': 'By', 'crv.colTook': 'Working time', 'crv.colWhen': 'When',
    'crv.tookElapsed': 'From reaching Claim Review to the decision: {d} (includes nights and weekends)',
    'crv.dAcceptedNew': 'Approved — new claim', 'crv.dAcceptedExisting': 'Approved — existing', 'crv.dDenied': 'Denied',
    'sch.confirmBook': 'Book this time',
    'sch.confirmReschedule': 'Reschedule to this time',
    'sch.bookFor': 'Book for',
    'sch.rescheduleTo': 'Reschedule to',
    'sch.bookedOk': 'Inspection scheduled',
    'sch.rescheduledOk': 'Inspection rescheduled',
    'dnd.hint': 'Drag to change the time or move it to another inspector',
    'dnd.title': 'Move this visit?',
    'dnd.time': 'Time: {from} → {to}',
    'dnd.inspector': 'Inspector: {from} → {to}',
    'dnd.sms': 'The homeowner will get a text message with the new time, and the change is logged in Scheduling.',
    'dnd.move': 'Move',
    'dnd.moving': 'Moving…',
    'sch.dayDistribution': 'Day distribution',
    'sch.clickWindow': 'click a green window to schedule there',
    'sch.badDate': 'Enter a complete date and time before scheduling.',
    'sch.causePh': 'Cause…',
    'sch.cause.inspector': 'Inspector',
    'sch.cause.homeowner': 'Homeowner',
    'sch.cause.weather': 'Weather',
    'sch.cause.office': 'Office',
    'sch.cause.other': 'Other',
    'sch.conflictWarn': 'This inspector already has a visit at that time.',
    'sch.tightWarn': 'This slot may be tight for drive time.',
    'sch.bookAnyway': 'Book anyway?',
    'sch.noSlots': 'No slots',
    'sch.noGeo': 'This claim has no property location yet — add the address to get recommendations, or pick a time manually.',
    'sch.noInspectors': 'No inspectors available.',
    'sch.noneThisWeek': 'No recommended slots this week — try the next week or pick manually.',
    'cr.filter.all': 'All',
    'cr.filter.messages': 'Messages',
    'cr.filter.events': 'Events',
    'cr.noActivity': 'No recent activity.',
    'cr.inspectorReports': 'Inspector reports',
    'cr.noReports': 'No reports for this day.',
    'cr.completed': 'Completed',
    'cr.late': 'Late',
    // Reporte tardío (mig 0482): el inspector lo escribió días después desde su app, sin GPS.
    'cr.lateReport': 'Late report',
    'cr.lateReportVisit': 'visit of {date}',
    'cr.lateReportHint': 'Written from the field app days after the visit, with no on-site check-out (no GPS). The check-out time shown is the scheduled end, not a measured one.',
    'cr.atrVideos': 'ATR videos',
    'cr.noVideos': 'No videos yet.',
    'cr.video': 'Video',
    'nav.intakeFinder': 'Intake Finder',
    'ifind.help': 'Every intake form a client has filled in, with its link. Search by name, address, phone or email — the phone matches by digits, so any format works.',
    'ifind.searchPh': 'Name, address, phone or email…',
    'ifind.colName': 'Client',
    'ifind.colAddress': 'Address',
    'ifind.colPhone': 'Phone',
    'ifind.colClaim': 'Claim',
    'ifind.colSent': 'Submitted',
    'ifind.colLink': 'Form link',
    'ifind.open': 'Open',
    'ifind.copyLink': 'Copy link',
    'ifind.copied': 'Copied',
    'ifind.copyManual': 'Copy the link:',
    'ifind.oldForm': 'Monday form',
    'ifind.noClaim': 'No claim yet',
    'ifind.none': 'No intake forms yet.',
    'ifind.noneFor': 'Nothing found for “{q}”.',
    'nav.intakeReview': 'Intake Review',
    'nav.newClaims': 'New Claims', 'nc.title': 'New Claims', 'nc.day': 'Day', 'nc.week': 'Week', 'nc.month': 'Month', 'nc.none': 'No new claims (Leads) right now.', 'nc.daysHere': 'Days in intake', 'nc.dN': '{n}d', 'nc.search': 'Search by name, address, contractor, #, stage…', 'nc.expand': 'Expand', 'nc.fee': 'Fee', 'nc.pa': 'PA', 'nc.openForm': 'Open form', 'nc.fromForm': 'On the form',
    'nav.mgmtDashboard': 'Management dashboard',
    // Dashboards por departamento (2026-08-09)
    'todo.smsTitle': 'SMS to answer',
    'todo.mitTitle': 'Mitigation follow-ups due',
    'todo.mitNoNote': 'No follow-up note yet',
    'todo.overdueDays': '{n}d overdue',
    'todo.dueToday': 'Due today',
    'ash.title': 'Assignment history',
    'ash.system': 'System',
    'ash.am': 'Account manager',
    'ash.team': 'Team',
    'ash.empty': 'No assignment changes yet.',
    'ash.none': 'Removed',
    'amp.fallbackHint': 'No account manager set — showing the Payments board assignee (legacy data). Picking someone saves them as the real account manager.',
    'hist.open': 'Open the original',
    'hist.collapse': 'Collapse',
    'hist.collapseAll': 'Collapse all',
    'hist.attachments': 'Attachments',
    'hist.detailError': 'Could not load the full content',
    'hist.from': 'From',
    'hist.to': 'To',
    'hist.duration': 'Duration',
    'hist.result': 'Result',
    'hist.noRecording': 'No recording for this call.',
    'hist.aiSummary': 'AI summary',
    'hist.transcript': 'Transcript',
    'hist.fullScreen': 'Full screen',
    'hist.nothingMore': 'Nothing more to show for this entry.',
    'schd.toSchedule': 'To be scheduled',
    'schd.toScheduleHint': 'waiting for an appointment',
    'schd.welcomeCalls': 'Welcome Calls',
    'schd.welcomeCallsHint': 'calls to do',
    'schd.newBookings': 'New bookings',
    'schd.last7d': 'last 7 days',
    'schd.readyToFile': 'Ready to be filed',
    'schd.oldestFirst': 'oldest first',
    'schd.readyEmpty': 'Nothing waiting to be filed.',
    'schd.daysShort': 'd',
    'schd.daysWaiting': 'days waiting',
    'schd.inspNext7': 'Inspections — next 7 days',
    'schd.today': 'Today',
    'mgd.newToday': 'New today',
    'mgd.newWeek': 'New this week',
    'mgd.newMonth': 'New this month',
    'mgd.activeClaims': 'Active claims',
    'mgd.riskRed': 'Red flags',
    'mgd.riskYellow': 'Yellow flags',
    'mgd.alertsOpen': 'Open alerts',
    'mgd.callAlerts': 'Call alerts',
    'mgd.arrivals14': 'Arrivals by day (last 14 days)',
    'mgd.emailsYesterday': 'Emails sent yesterday',
    'mgd.callsYesterday': 'Calls yesterday',
    'mgd.person': 'Person',
    'mgd.sent': 'Sent',
    'mgd.calls': 'Calls',
    'mgd.minutes': 'Minutes',
    'mgd.topContractors': 'Top contractors (30 days)',
    'mgd.redList': 'Red claims',
    'mgd.seeBoard': 'See risk board',
    'mgd.noRed': 'No claims in red',
    'mgd.daysRed': '{n}d in red',
    'mgd.empty': 'Nothing to show',
    'ind.title': 'Intake Dashboard',
    'ind.newToday': 'New today',
    'ind.newWeek': 'New this week',
    'ind.claimReview': 'In Claim Review',
    'ind.missingPhotos': 'Missing photos',
    'ind.contractsSent': 'Contracts sent',
    'ind.contractsPending': 'Missing contract',
    'ind.waitingDocs': 'Waiting Documents',
    'ind.waitingDocsSub': '{n} answered by contractor',
    'ind.tasksOpen': 'Open tasks',
    'ind.contractorPhotos': 'Contractor Photos',
    'ind.contractorPhotosSub': 'Photo album links uploaded by each contractor (CompanyCam)',
    'ind.new7d': '+{n} · 7d',
    'ind.cpSeeAll': 'See all ({n}) →',
    'ind.cpEmpty': 'No photo links yet.',
    'ind.unassignedEmails': 'Unassigned emails',
    'ind.unassignedNone': 'No unassigned emails',
    'ind.pulse': 'Department pulse',
    'ind.noStageFilter': 'Opens the full claims list (no stage filter for this yet)',
    'ind.loadError': 'Could not load the intake dashboard',
    'pulse.title': 'Pulse',
    'pulse.unassigned': 'Unassigned emails',
    'pulse.mine': 'My emails',
    'pulse.tasks': 'Open tasks',
    'pulse.sms': 'Open SMS',
    'pulse.contractor': 'Contractor unread',
    'pulse.global': 'Company-wide',
    'pulse.dept_intake': 'Intake',
    'pulse.dept_claims': 'Claims',
    'pulse.dept_supplements': 'Supplements',
    'pulse.dept_scheduling': 'Scheduling',
    'pulse.dept_payments': 'Payments',
    'cpd.title': 'My Claims dashboard',
    'cpd.approved30d': 'Approved (30d)',
    'cpd.pending': 'Pending',
    'cpd.readyToFile': 'To file',
    'cpd.bonus': 'My bonus',
    'cpd.empty': 'Nothing waiting here.',
    'nav.coverageDetector': 'Coverage Detector',
    'nav.agenda': 'Agenda',
    'cov.title': 'Coverage Detector',
    'cov.pickClaim': 'Search a claim to read its policy and property…',
    'cov.orNewClient': 'Or — client not in the system yet',
    'cov.newClientHint': "Drop their policy PDF below to read it with AI, no claim needed. If they end up becoming a claim later, you can re-upload it there.",
    'sched.appt': 'Scheduled appointment',
    'sched.tabAgenda': 'Agenda',
    'sched.tabQueue': 'To schedule',
    'sched.queueEmpty': 'No claims waiting to be scheduled.',
    'sched.history': 'Show history',
    'sched.upcoming': 'Show upcoming',
    'sched.waiting': 'Waiting',
    'sched.tabWeek': 'Week',
    'sched.tabBoard': 'Board',
    'sched.unassigned': 'Unassigned',
    'sched.thisWeek': 'This week',
    'sched.noWeek': 'No appointments this week.',
    'common.noResults': 'No results',
    'common.loadingDots': 'Loading…',
    // Settings del ⚙ de cada working view (plantillas de email + días del follow-up).
    'fv.file': 'File',
    'fv.openTab': 'Open in a tab',
    'fv.error': 'Could not open the file.',
    // ── Auto follow-up al adjuster por el estimado (Supplements) ──
    'afu.title': 'Auto follow-up',
    'afu.settingsTitle': 'Auto follow-up to the adjuster',
    'afu.settingsHint': 'When our estimate goes out by email and the claim moves to Supplementing, the system replies in that same email thread every few days asking the adjuster to review it. It stops on its own the moment the adjuster (or anyone at the carrier) writes back, when the claim leaves the stage, or when someone turns it off on the claim.',
    'afu.toggleOn': 'Automatic follow-ups are ON',
    'afu.toggleOff': 'Automatic follow-ups are OFF',
    'afu.dryRunLabel': 'Test mode (log only, send nothing)',
    'afu.dryRunHint': 'In test mode the system records what it would have sent, and nobody receives anything.',
    'afu.dryRun': 'Test mode',
    'afu.systemOff': 'System off',
    'afu.offHint': 'The sequence is armed but the system is off: nothing goes out until it is turned on.',
    'afu.noEnv': 'Not enabled on the server',
    'afu.noEnvHint': 'SUPPLEMENT_FOLLOWUP_ENABLED is not set in Railway. The toggle here is not enough: this key must be set on purpose.',
    'afu.stateLive': 'Live', 'afu.stateDryRun': 'Test mode', 'afu.stateNoEnv': 'On here, off on the server', 'afu.stateOff': 'Off',
    'afu.runNow': 'Run now', 'afu.runNowHint': 'Runs one cycle right now instead of waiting up to 5 minutes. Respects the toggle and test mode.', 'afu.ranOk': 'Cycle ran',
    'afu.stat.active': 'Active claims', 'afu.stat.dueNow': 'Due now', 'afu.stat.sentToday': 'Sent today', 'afu.stat.sent7d': 'Sent last 7 days',
    'afu.stat.dryRunToday': 'Would have sent today', 'afu.stat.stoppedByReply': 'Stopped by a reply (30d)', 'afu.stat.exhausted': 'No reply after all (30d)',
    'afu.tab.general': 'Settings', 'afu.tab.templates': 'Templates', 'afu.tab.activity': 'Activity',
    'afu.everyDays': 'Send every (days)', 'afu.everyDaysHint': 'Counted from our last email to the carrier on that claim (the estimate, the previous follow-up, or one a person sent).',
    'afu.maxSends': 'Maximum follow-ups', 'afu.maxSendsHint': 'After the last one the sequence stops and the team is notified to call. Never more than there are templates.',
    'afu.window': 'Send window (Eastern, hours)', 'afu.windowHint': 'Each claim gets a fixed offset of up to 75 minutes so they do not all go out at the same minute.',
    'afu.cap': 'Max per recipient per day', 'afu.capHint': 'A shared carrier inbox will not get more than this many of our follow-ups in one day.',
    'afu.businessDays': 'Business days only (Mon–Fri, no federal holidays)',
    'afu.stopOnCarrier': 'Also stop when anyone else at the carrier writes on the claim (same domain), not only the adjuster',
    'afu.quoteOriginal': 'Quote the original estimate email below the text, like a normal reply',
    'afu.eligible': 'Runs while the Supplements status is', 'afu.eligibleHint': 'Comma-separated. Leaving these statuses stops the sequence.',
    'afu.stopsTitle': 'What stops a sequence', 'afu.autoReplyRule': 'An out-of-office or automatic reply does not count as a response: it is noted and the next follow-up is pushed one cycle.',
    'afu.templatesHint': 'One template per follow-up, in order: #1 goes first, the last one is the most insistent. Subject is always “RE: <the estimate email subject>”. Placeholders:',
    'afu.signature': 'Signature (goes under every template)',
    'afu.aboutDay': 'about day {n}', 'afu.preview': 'Preview', 'afu.restoreOne': 'Restore this template', 'afu.remove': 'Remove',
    'afu.addTemplate': '+ Add template', 'afu.restoreAll': 'Restore the 20 defaults', 'afu.restoreAllConfirm': 'Replace all templates and the signature with the defaults? (Not saved until you click Save.)',
    'afu.unsaved': 'Unsaved changes', 'afu.invalidConfig': 'Invalid settings (check the numbers and that every template has text).',
    'afu.activeList': 'Claims being followed up', 'afu.activeEmpty': 'No active sequences. One starts automatically when an estimate is emailed to the carrier.',
    'afu.recentStops': 'Recently stopped', 'afu.recentStopsEmpty': 'Nothing stopped yet.', 'afu.sentLower': 'sent', 'afu.daysCol': 'Days',
    'afu.none': 'Not running', 'afu.noneHint': 'It starts by itself when the estimate is emailed to the carrier.', 'afu.noneHintStart': 'There is an email to the carrier on this claim: you can start the follow-ups on it.',
    'afu.active': 'Active', 'afu.paused': 'Paused', 'afu.stopped': 'Stopped',
    'afu.to': 'To', 'afu.subject': 'Subject', 'afu.estimateSent': 'Estimate sent', 'afu.daysAgo': '{n} days ago', 'afu.by': 'by',
    'afu.sent': 'Sent', 'afu.next': 'Next', 'afu.nextSlot': 'next business slot', 'afu.last': 'Last',
    'afu.autoReplySeen': 'Auto-reply received {d} — not counted as a response, next one pushed a cycle.',
    'afu.pausedBy': 'Paused by {who} on {d}', 'afu.stoppedOn': 'Stopped {d}', 'afu.seeReply': 'see the reply',
    'afu.pause': 'Pause', 'afu.resume': 'Resume', 'afu.stop': 'Turn off', 'afu.start': 'Start follow-ups', 'afu.sendNow': 'Send next now',
    'afu.sendNowHint': 'Sends the next follow-up right now (skips the cadence and the time window). In test mode it only logs.',
    'afu.sendNowConfirm': 'Send the next follow-up to the adjuster right now?', 'afu.sendNowDryConfirm': 'Test mode: this will only log what would be sent. Continue?',
    'afu.stopConfirm': 'Turn off the automatic follow-ups for this claim? You can start them again later.',
    'afu.pausedOk': 'Paused', 'afu.resumedOk': 'Resumed', 'afu.stoppedOk': 'Turned off', 'afu.startedOk': 'Started', 'afu.sentOk': 'Done', 'afu.err': 'Error', 'afu.loadErr': 'Could not load the auto follow-up.',
    'afu.wouldSend': 'would send', 'afu.template': 'template', 'afu.dayN': 'day {n}', 'afu.manual': 'manual', 'afu.opened': 'opened', 'afu.open': 'open', 'afu.text': 'text', 'afu.hide': 'hide',
    'afu.showAll': 'Show all ({n})', 'afu.showLess': 'Show less', 'afu.previousRounds': '{n} earlier round(s) on this claim.',
    'afu.sendStatus.failed': 'failed', 'afu.sendStatus.suppressed': 'suppressed', 'afu.sendStatus.sending': 'sending',
    'afu.reason.replied': 'The adjuster replied', 'afu.reason.carrier_wrote': 'Someone at the carrier wrote', 'afu.reason.carrier_estimate': 'A new insurance estimate came in',
    'afu.reason.manual': 'Turned off by hand', 'afu.reason.stage': 'The claim left the stage', 'afu.reason.archived': 'The claim was archived',
    'afu.reason.superseded': 'A new estimate was sent (new sequence)', 'afu.reason.exhausted': 'All follow-ups sent, no reply', 'afu.reason.bounced': 'The email bounced',
    'afu.reason.suppressed': 'Address on the suppression list', 'afu.reason.disabled': 'The system was turned off',
    'vset.title': 'View settings',
    'vset.settings': 'Settings',
    'vset.templates': 'Email templates',
    'vset.templatesHelp': 'These templates only show up in the email module of this view. Anyone can create them; only managers can delete them.',
    'vset.tplNew': 'New template',
    'vset.tplName': 'Template name (e.g. "COC sent to adjuster")',
    'vset.tplSubject': 'Subject (optional — the claim number is filled in by default)',
    'vset.tplBody': 'Message…',
    'vset.tplNone': 'No templates yet in this view.',
    'vset.tplNoSubject': 'No subject',
    'vset.tplDeleteConfirm': 'Delete the template “{name}”?',
    'vset.tplDeleteManagerOnly': 'Only managers can delete templates.',
    'vset.followUp': 'Follow-up and alerts',
    'vset.superManagerOnly': 'super-manager only',
    'vset.fuMode': 'Follow-up for this view',
    'vset.fuOverdue': 'Yes — by days overdue (department cadence)',
    'vset.fuCalendar': 'Yes — every N days from arrival',
    'vset.fuDays': 'No follow-up — but count days with a deadline',
    'vset.fuNone': 'No follow-up and no deadline',
    'vset.fuEveryDays': 'Days after it lands here',
    'vset.fuDaysMax': 'Max days in this view',
    'vset.urgentAfter': 'Urgent alert after (days waiting)',
    'vset.managerAfter': 'Manager alert after (days waiting)',
    'vset.blankDefault': 'Blank = {n} days',
    'vset.dayColors': 'Days counter color',
    'vset.dayColorsHelp': 'The circle with the days in the queue row: green while recent, yellow as it ages, red when it is overdue.',
    'vset.greenUpTo': 'Green up to (days)',
    'vset.yellowUpTo': 'Yellow up to (days) — red after that',
    'vset.errYellowBeforeGreen': 'The yellow limit cannot be lower than the green limit.',
    'vset.noAlertsHelp': 'With no follow-up there are no urgent or manager alerts: this view only counts the days.',
    'vset.errManagerBeforeUrgent': 'The manager alert cannot come before the urgent one.',
    'vset.errSave': 'Could not save.',
    'vset.errNoView': 'This queue is not a configurable view yet — it has no entry in Settings → Sidebar menus.',
    'dept.search': 'Search name, address, claim # or phone…', 'dept.teamFilter': 'Team',
    'dept.underConstruction': 'Department under construction. Queues:',
    'dept.noStatuses': 'No statuses configured yet.',
    'dept.noClaims': 'No claims in this status.',
    'dept.noInRange': 'No claims in the selected date range.',
    'dept.enteredOn': 'Entered this status on',
    'dept.rangeAll': 'All',
    'dept.rangeToday': 'Today', 'dept.rangeLastWeek': 'Last week', 'dept.rangeLastMonth': 'Last month',
    'dept.rangeWeek': 'This week',
    'dept.rangeMonth': 'This month',
    'dept.rangeDate': 'By date',
    'dept.from': 'From',
    'dept.to': 'To',
    'cd.departments': 'Departments',
    'cd.property': 'Property',
    'cd.companycamEmbedNote': 'If it stays blank, CompanyCam blocks embedding — use “Open in new tab”.',
    'cd.propLoad': 'Load photo + roof',
    'cd.update': 'Update',
    'cd.propHint': 'Load the house photo and roof (squares/pitch) from Google.',
    'cd.roofSquares': 'Roof squares',
    'cd.pitch': 'Pitch',
    'cd.propFail': 'Could not load property info.',
    'asg.title': 'Assignment',
    'asg.accountManager': 'Account manager',
    'asg.claimTeam': 'Claim team',
    'asg.supplementsTeam': 'Supplements team',
    'asg.paymentsTeam': 'Payments team',
    'asg.none': 'None',
    'asg.previous': 'previous',
    'asg.saveFail': 'Could not save the assignment.',
    'em.showQuoted': 'Show quoted text',
    'em.hideQuoted': 'Hide quoted text',
    'req.duplicate': 'There is already a pending {type} request in the Scheduling queue — delete it below first if it was a mistake.',
    'csearch.placeholder': 'Search this claim…',
    'csearch.noResults': 'No results',
    'csearch.searching': 'Searching…',
    'csearch.kind.update': 'Update',
    'csearch.kind.case_overview': 'Case Overview',
    'csearch.kind.board_update': 'Board update',
    'csearch.kind.email': 'Email',
    'csearch.kind.follow_up': 'Follow-up',
    'csearch.kind.file': 'File',
    'csearch.kind.sms': 'SMS',
    'copyq.label': 'Copy claim to…',
    'copyq.addToView': 'Add to view',
    'copyq.whyPh': 'Why is it going to this queue? (posts as a department update)',
    'copyq.copyBtn': 'Copy',
    'copyq.notePrefix': 'Copied to',
    'copyq.confirm': 'Copy this claim to',
    'copyq.done': 'Claim copied to',
    'copyq.alreadyIn': 'This claim is already in "{view}" — it was not added again.',
    'copyq.removeFromView': 'Remove from "{view}"',
    'copyq.removeConfirm': 'Remove this claim from "{view}"? It will disappear from that queue.',
    'copyq.fail': 'Could not copy the claim to that queue.',
    'gm.members': 'members',
    'gm.addMember': 'Add member',
    'gm.autoManaged': 'Auto-managed group (all inspectors + Scheduling). Members re-sync automatically.',
    'cd.policyAI': 'Policy (AI)',
    'cd.policyHint': 'Upload the policy PDF to extract coverages, deductibles and red flags.',
    'cd.analyzingAI': 'Analyzing with AI…',
    'cd.policyFail': 'Could not process the policy.',
    'cd.extractFailed': 'Extraction failed. Try again.',
    'cd.insurer': 'Insurer',
    'cd.policyNum': 'Policy #',
    'cd.coverageDates': 'Coverage',
    'cd.valuation': 'Valuation',
    'cd.dwelling': 'Dwelling',
    'cd.otherStructures': 'Other Structures',
    'cd.dedAop': 'AOP deductible',
    'cd.dedWind': 'Wind/Hail deductible',
    'cd.redFlags': 'Red flags',
    'cd.askPolicy': 'Ask the policy… (e.g. does it cover wind/hail?)',
    'cd.ask': 'Ask',
    'cd.rayFail': 'Could not answer.',
    'cd.appointments': 'Appointments (Scheduling)',
    'cd.book': 'Book',
    'cd.suggest': 'Suggest times',
    'cd.suggestHide': 'Hide times',
    'cd.reqSched': 'Request scheduling',
    'cd.requestedBy': 'requested by',
    'cd.reqDelete': 'Delete', 'cd.reqDeleteHint': 'Delete this request (the record stays, with who deleted it and why)',
    'cd.reqDeletedBy': 'Deleted by', 'cd.reqDoneBy': 'Done by', 'cd.reqDeleteReason': 'Why is this request being deleted? (required — it stays on the record)',
    'cd.reqDeleteReasonRequired': 'A reason is required to delete the request.',
    'cd.reqSchedDone': 'Sent to the Scheduling queue (ATR to Schedule)',
    'cd.apptType': 'Type',
    'cd.reportSoon': 'Inspector report / ATR — coming from ClaimRoute',
    'cd.onMyWay': 'On my way',
    'cd.checkedIn': 'Checked in',
    'cd.started': 'Started',
    'cd.checkedOut': 'Checked out',
    'cd.checkPhoto': 'Check photo',
    'cd.noShowPhoto': 'No-show photo',
    'cd.video': 'Video',
    'cd.rescheduleCause': 'Reschedule cause',
    'cd.inspectorReport': 'Inspector report', 'cd.atrFeedback': 'ATR feedback', 'cd.roofCondition': 'Roof condition', 'cd.atrOpinion': 'Inspector opinion on the ATR',
    'cd.noReport': 'No report recorded for this visit.', 'cd.addReport': 'Add report (office)', 'cd.editReport': 'Edit report', 'cd.reportNotesPh': 'Inspection report notes…', 'cd.reportVideoPh': 'Video link (optional)', 'cd.reportSaved': 'Report saved',
    'cd.atrSince': 'ATR since',
    'cd.inspectorNotes': 'Inspector notes',
    'cd.deprDeadline': 'Depreciation recovery deadline',
    'cd.deprDaysLeft': '{d} days left',
    'cd.deprOverdueBy': 'Overdue by {d} days',
    'cd.deprNotSet': 'Not set.',
    'cd.deprDays': 'Days',
    'cd.deprHint': 'Days from today until the recovery deadline.',
    'alert.whole': 'Whole company',
    'alert.goToSource': 'Go to the message / file behind it',
    'alert.resolve': 'No longer needed',
    'alert.messagePh': 'Urgent note for the team…',
    'alert.add': 'Add alert',
    // Chip "sin responder" sobre el mensaje del contratista + Reply desde la alerta (2026-08-03).
    'chat.unanswered': 'Not answered yet',
    'chat.unansweredHint': "Nobody has replied to this contractor message. It clears itself as soon as someone answers — here, in the Contractor Inbox, or from the alert.",
    'alert.reply': 'Reply',
    'alert.replyTo': 'Replying to {name}',
    'alert.replyPh': 'Write your reply to the contractor…',
    'alert.replyHint': 'It goes to the contractor in JobFlow and clears this alert.',
    'alert.replySend': 'Send reply',
    'alert.new': 'Add urgent alert',
    'cd.notesPh': 'Notes',
    'cd.noAppts': 'No appointments for this claim.',
    'cd.complete': 'Complete',
    'cd.cancel': 'Cancel',
    'cd.canceledBy': 'Canceled by',
    'cd.notesThisInspection': 'Notes for this inspection',
    'cd.notesThisInspectionPh': 'Only for this visit (the inspector sees this one)',
    'cd.bestTimes': 'Best times (by proximity, load and urgency)',
    'cd.bookThis': 'Book this',
    'cd.noSlots': 'No available slots in the horizon.',
    'cd.driveMin': 'min drive',
    'cd.noInspectors': 'No inspectors configured (set them in Inspectors with location and hours).',
    'cd.suggestFail': 'Could not suggest times. Does the property have a location? Load it in the "Property" panel.',
    'cd.negCoach': 'Negotiation Coach (Supplements)',
    'cd.ourEstimate': 'Our estimate (Xactimate)',
    'cd.theirEstimate': "Adjuster's estimate",
    'cd.analyze': 'Analyze',
    'cd.negHint': 'Upload both estimates to see gaps and rebuttals.',
    'cd.ours': 'Ours',
    'cd.adjuster': 'Adjuster',
    'cd.gap': 'Gap',
    'cd.rebuttal': 'Rebuttal',
    'cd.strategy': 'Strategy',
    'cd.uploadBoth': "Upload both PDFs (ours and the adjuster's).",
    'cd.analyzeFail': 'Could not analyze.',
    'dir.searchIns': 'Search insurance…',
    'dir.newIns': '+ New insurer',
    'dir.pickIns': 'Pick an insurer to see its playbook.',
    'dir.name': 'Name',
    'dir.contactName': 'Point of contact (who we call)',
    'dir.phone': 'Phone',
    'dir.email': 'Email',
    'dir.website': 'Website',
    'dir.address': 'Address',
    'dir.portal': 'Portal / URL',
    'dir.commsEmail': 'Communications email (for estimates)',
    'sup.firstEstimate': 'First Estimate',
    'sup.mitigation': 'Mitigation Estimate',
    'sup.mitFollowup': 'Mitigation Follow Up',
    'sup.review': 'Review Estimate',
    /* EL CIERRE DEL REVIEW (pedido del dueño 2026-08-20). "Ready to Estimate" es la palabra
       elegida para el chip: dice lo que el estimador necesita saber —que ya puede armarlo— y no
       solo que alguien lo miró. */
    'sup.revTitle': 'Instructions for the estimator',
    'sup.revNone': 'Not reviewed',
    'sup.revReady': 'Ready to Estimate',
    'sup.revNoInitial': 'No initial estimate', 'sup.revNoInitialHint': 'This claim has no Proactive estimate on file: the order to the estimator is to build it (the sketch, photos and the insurance estimate are in Files). The order goes out anyway; the .ESX rule does not apply.',
    'sup.chipBc': 'Building code', 'sup.chipBcNo': 'No building code', 'sup.chipBcUnknown': 'Building code?', 'sup.chipBcUnknownHint': 'Not set yet — mark it on the claim card (or run the Coverage detector on the policy)',
    'sup.chipPolicyTitle': 'Policy type (claim card)', 'sup.chipPolicyUnknown': 'Policy type?', 'sup.chipPolicyUnknownHint': 'Not set yet — fill the policy type on the claim card',
    'sup.revReadyHelp': 'Reviewed by supplements and ready for the estimator to build it',
    'sup.revHelp': 'Has supplements closed the review of this estimate yet?',
    'sup.revOrders': 'What the estimator has to do',
    'sup.revOrdersPh': 'What has to be modified, added or removed from the estimate…',
    'sup.revBy': 'Written by',
    'sup.revSaveReady': 'Save — ready to estimate',
    'sup.revSaveHint': 'Saving marks the claim Ready to Estimate and puts it in the estimator\u2019s tab.',
    'ei.include': 'Include in the estimate', 'ei.includeHint': 'Tells the estimator to add this invoice to the estimate: it goes in the order and in the estimator guide', 'ei.listTitle': 'Instructions for the estimator — include these invoices in the estimate', 'ei.guideTitle': 'Invoices to include in the estimate', 'ei.view': 'View', 'ei.remove': 'Remove from the instructions',
    'sup.emailOrderTitle': 'Email & order to the estimator', 'sup.emailOrderPreview': 'The email that goes out with the estimate, Save — ready to estimate and Send order to estimator',
    'sup.emailNoAnalysisHint': 'No AI analysis on this claim yet: you can still write the email and send the order to the estimator with the instructions. “Generate email” needs the analysis.', 'sup.emailNeedsAnalysis': 'Run the AI analysis first',
    'sup.revDaysWithEstimator': '{n}d with the estimator',
    'sup.revCheckStale': 'from an earlier estimate',
    'sup.revCheckTitle': 'What you uploaded vs what was asked',
    'sup.revCheckRun': 'Check with AI',
    'sup.revCheckAgain': 'Check again',
    'sup.revCheckHint': 'Runs the AI over the uploaded estimate and tells you whether it covers the disputed items, the ones written by hand and the instructions. It is a heads-up, not a gate — it never blocks sending.',
    'sup.revCheckCovers': 'Covers everything asked',
    'sup.revCheckMissingChip': '{n} missing',
    'sup.revCheckOk': 'The estimate covers everything that was asked',
    'sup.revCheckMissing': '{n} item(s) from the order are not in the estimate',
    'sup.revCheckNoEstimate': 'No estimate uploaded yet',
    'sup.revCheckUnreadable': 'The estimate could not be read — check the PDF',
    'sup.revCheckNothing': 'Nothing was ordered yet: no disputed items, no manual items, no instructions',
    'sup.revEmailRequired': 'Write the email first — it is what goes out with the estimate',
    'sup.revEmailFrozenMsg': 'The order already went out — this email can no longer be changed',
    'sup.revSendOrder': 'Send order to estimator',
    'sup.revOrderSent': 'Order sent',
    'sup.revOrderAlready': 'The order already went out',
    'sup.revOrderSentTo': 'Order sent to {n}',
    'sup.revOrderSentNobody': 'Order sent — no estimator assigned yet, nobody was notified',
    'sup.revReopen': 'Reopen review',
    'sup.revReadyDone': 'Saved — marked Ready to Estimate, the estimator can build it now',
    'sup.revReopened': 'Review reopened',
    'sup.revEmpty': 'Write the instructions for the estimator before saving',
    'sup.revPreviewNone': 'No instructions written yet',
    'sup.noReady': 'Nothing is ready to estimate yet',
    /* La guía del estimador en pantalla (copiable) — la misma que el PDF. */
    'eg.title': 'Estimator guide — copy & paste',
    'eg.preview': 'Per-item actions, AI notes and photo links, ready to copy into the estimate.',
    'eg.instructions': 'Instructions from supplements',
    'eg.copy': 'Copy',
    'eg.copied': 'Copied',
    'eg.copyItem': 'Copy item',
    'eg.copyNote': 'Copy the AI note',
    'eg.replaceWith': 'Change item to',
    'eg.measurements': 'Measurements',
    'eg.copyLink': 'Copy the photo link',
    'eg.copyAll': 'Copy everything',
    'eg.pdf': 'Open the PDF',
    'eg.notAnalyzed': 'Run the AI analysis first — the guide is built from it.',
    'eg.secDispute': 'Dispute — keep our amounts',
    'eg.secRemove': 'Remove or reduce — accept theirs',
    'eg.secPending': 'Pending — no decision yet',
    'eg.keep': 'KEEP',
    'eg.delete': 'DELETE',
    'eg.reduce': 'REDUCE TO',
    'eg.review': 'REVIEW',
    'eg.ourRcv': 'Our original RCV',
    'eg.conceded': 'Conceded (let go)',
    'eg.adjusted': 'Adjusted estimate',
    'eg.theirOffer': 'Their offer',
    /* Links de fotos por partida, en el panel de dispute / let go. */
    'neg.photoLinks': 'Photo links',
    'neg.photosClaimCam': 'Photos from ClaimCam',
    'neg.photosFor': 'Photos for {item}',
    'neg.photoLinksBtn': 'Links & uploads',
    'neg.photoPh': 'Paste the photo link (CompanyCam, Drive…)',
    'neg.photoAdd': 'Add',
    'neg.photoHelp': 'These links travel to the estimator guide — on screen and as clickable links in the PDF.',
    'sup.reviewCopy': 'In the Review Estimate queue since', 'hero.undo': 'Undo', 'hero.undoConfirm': 'Undo "{d}"? The claim goes back to the stage, approval date, team and queues it had before.', 'hero.dec_approved': 'Approved', 'hero.dec_approved_for_repair': 'Approved for repair', 'hero.dec_denied': 'Denied', 'chat.dupHint': 'Monday sent this same note several times — collapsed here; nothing was deleted.', 'rpa.bypass': 'Bypass authorization', 'rpa.bypassPh': 'Why are you skipping the homeowner authorization?', 'rpa.bypassConfirm': 'Bypass', 'rpa.bypassNeedReason': 'Give a reason — it is recorded for audit.', 'rpa.bypassDone': 'Bypassed. The claim leaves this queue.', 'rpa.bypassHelp': 'Super-manager only · the reason is recorded for audit', 'cd.bypassNeedReason': 'Give a reason — it is recorded for audit.', 'cd.bypassConfirm': 'Bypass and authorize', 'cd.bypassDone': 'Payment authorized (authorization bypassed).', 'sup.reviewCopyTag': 'copy',
    'teams.boxTitle': 'Teams', 'teams.claims': 'Claims', 'teams.supplements': 'Supplements',
    'teams.teamOf': 'Team', 'teams.noPerson': 'No one assigned', 'teams.personHint': 'The person of this position in the claim team (who gets @mentions and the work)',
    'ihd.title': 'Inspections done', 'ihd.today': 'today', 'ihd.oneDay': '1 day ago', 'ihd.daysAgo': '{d} days ago', 'ihd.video': 'Video',
    'ihd.openReport': 'Open the inspection report', 'ihd.openVideo': 'Open the video', 'ihd.checkPhoto': 'Check-out photo', 'ihd.late': 'Late report', 'ihd.lateHint': 'The inspector closed this visit days later (late report).',
    'teams.payments': 'Payments', 'teams.none': 'no team',
    'badge.supPreApproved': 'Supplement pre-approved',
    'badge.supResolved': 'Supplement resolved',
    'sup.supplementing': 'Supplementing',
    'sup.preApproved': 'Pre-approved',
    'sup.resolved': 'Supplement Resolved',
    'sup.settlement': 'Settlement Process',
    'sup.others': 'Others',
    'sup.showMore': 'Show {n} more',
    'sup.readyToSend': 'ready to send', 'sup.readyToSendHint': 'Days since the first estimate was uploaded and is waiting to be sent to the insurance.', 'sup.inStatus': 'in status',
    'sup.stNone': 'No estimate',
    'rm.aiSummary': 'What this roof has — AI',
    'neg.notes': 'Notes',
    'neg.notesHint': 'Writes each note from your own note on that item. Items without one get the default building-code argument.',
    'neg.myNote': 'My note to guide the AI on this item',
    'sup.esxStale': 'This .ESX belongs to estimate {a}. The current estimate is {b}, uploaded later with a different total — upload the .ESX for {b}.',
    'sup.sentButEsxMissing': 'Email sent, but the claim stays in First Estimate: the current estimate has no .ESX. Upload it and press "Sent (outside app)".',
    'sup.sentButStays': 'Email sent, but the claim could not leave First Estimate:',
    'sup.esxBlockSend': 'Not sent: the current estimate has no .ESX. Upload the .ESX of this estimate first.',
    'neg.photoUpload': 'Drop photos here (or click) — the files, not a link',
    'neg.photoUploadHelp': 'Uploaded photos are saved to the claim files and listed in the estimator guide; the estimator downloads them all in one ZIP to upload them to Xactimate.',
    'neg.photoOnlyImages': 'Only image files (JPG, PNG, HEIC…).',
    'eg.uploadedPhotos': 'Uploaded photos',
    'eg.photosZip': 'Download photos (ZIP)',
    'eg.photosZipHint': 'All photos uploaded to this review, one folder per line item — to upload them to Xactimate.',
    'esxReq.bypassBtn': "I can't upload it — bypass with a reason",
    'esxReq.bypassTitle': 'Bypass the .ESX (your name and the reason stay on the estimate)',
    'esxReq.bypassPh': 'e.g. the estimator is out until Monday; the ESX will be uploaded then',
    'esxReq.bypassHelp': 'Anyone can bypass, but the reason is required and the estimate will show "Bypassed by" with your name.',
    'esxReq.bypassConfirm': 'Bypass and continue',
    'esxReq.reasonRequired': 'Write the reason (at least a few words).',
    'sup.esxBypassedBy': 'ESX bypassed by',
    'sup.esxChipBypassed': 'ESX bypassed',
    'ntf.capped': 'Showing the {shown} most recent to-dos; {hidden} older ones are still pending. Mark these done to see the rest.',
    'undo.smsTo': 'SMS to',
    'risk.ev.noAudio': 'The recording could not be played (no audio file for this call).',
    'undo.emailTo': 'Email to', 'undo.sendingIn': 'Sending in {n} s — forgot something? Undo.', 'undo.sendingNow': 'Sending…', 'undo.sent': 'Sent', 'undo.failed': 'Could not send:', 'undo.undo': 'Undo', 'undo.navHint': 'Leaving this screen sends it right away.', 'undo.queued': 'Sending in 10 s — Undo at the bottom left if you forgot something.', 'undo.undone': 'Not sent — your draft is back.',
    'chat.translate': 'Translate', 'chat.translating': 'Translating…', 'chat.translation': 'Translation', 'chat.showOriginal': 'Show original', 'chat.showTranslation': 'Show translation', 'chat.translateFailed': 'Could not translate — try again', 'chat.translateHint': 'English → Spanish, or Spanish → English. The translation is saved with the update.',
    'nav.supVerifiedMeasurements': 'Verified measurements',
    'vm.title': 'Verified measurements', 'vm.help': 'Every verified roof report ordered from the claim card (1ESX): who asked, whether it was approved, what the provider says, and the files once delivered.',
    'vm.pendingCount': '{n} to approve', 'vm.gear': 'Who can approve', 'vm.gearHint': 'Choose who can approve or deny verified measurements', 'vm.gearTitle': 'Who can approve verified measurements', 'vm.gearHelp': 'Only the people checked here can approve or deny an order. The master can always.',
    'vm.tabPending': 'To approve', 'vm.tabInProgress': 'In progress', 'vm.tabDelivered': 'Delivered', 'vm.tabClosed': 'Denied / failed', 'vm.empty': 'Nothing here.',
    'vm.stPending': 'Pending approval', 'vm.stApproved': 'Approved — placing order', 'vm.stOrdered': 'Ordered — waiting for the provider', 'vm.stDelivered': 'Delivered', 'vm.stDenied': 'Denied', 'vm.stFailed': 'Failed',
    'vm.paymentPending': 'Provider: payment pending', 'vm.requested': 'Requested by', 'vm.report': 'Report', 'vm.approvedBy': 'Approved by', 'vm.deniedBy': 'Denied by', 'vm.deliveredAt': 'Delivered', 'vm.providerSays': 'Provider', 'vm.payment': 'payment', 'vm.providerOrder': 'Provider order', 'vm.denialNote': 'Reason', 'vm.crmStatus': 'CRM status', 'vm.noStage': 'no stage', 'vm.workingView': 'Working view', 'vm.noWorkingView': 'Not in any working view',
    'vm.approve': 'Approve', 'vm.deny': 'Deny', 'vm.approveConfirm': 'Approve the paid verified report for {name}? The order is placed with the provider right away.', 'vm.denyPrompt': 'Reason for denying (the requester sees it):', 'vm.notAllowed': 'You are not on the list of people who can approve. Ask the owner (gear at the top right).', 'vm.waitingApprover': 'Waiting for an approver.', 'vm.fileMissing': 'That file is not available.', 'vm.photoHouse': 'House', 'vm.photoSatellite': 'Satellite',
    'neg.myNoteBtn': 'My note',
    'neg.myNotePh': 'e.g. the adjuster left 0 SQ by mistake, it should be 29.37 SQ',
    'neg.myNoteEmpty': 'Nothing yet — click to write what you want argued here.',
    'neg.noItemsRerun': 'The analysis came back without line items even though the totals differ. Re-run the analysis.', 'neg.allDecided': 'All items decided.', 'neg.noGapsSection': 'No {section} gaps — switch section.', 'sup.analysisNoItems': 'The analysis came back without line items (the totals differ). Nothing was saved — run it again.', 'sup.analysisTruncated': 'The analysis ran too long and was cut off before the item list. Nothing was saved — run it again.',
    'neg.myNoteHelp': 'This is the seed: Notes turns it into a proper note. Leave it empty and the AI argues by building code.',
    'neg.letGoShow': 'Show let go',
    'neg.letGoHint': 'Bring back the ones you let go, in case one was let go by mistake.',
    'pdfc.button': 'Compare PDFs',
    'pdfc.letGo': 'Let go',
    'pdfc.dispute': 'Dispute',
    'pdfc.undo': 'Disputing · undo',
    'pdfc.letGone': 'Let go · undo',
    'pdfc.stDisputed': 'disputing',
    'pdfc.stLetGo': 'let go',
    'pdfc.note': 'My note for this item',
    'pdfc.noteEmpty': 'Nothing yet — click and write what you want argued here.',
    'pdfc.aiNote': 'AI note',
    'pdfc.photos': 'Photos',
    'pdfc.openPhotos': 'Open this item\u2019s photos in another tab',
    'pdfc.noPhotos': 'This item has no photo links yet',
    'pdfc.p_missing': 'missing',
    'pdfc.p_quantity': 'wrong measurement',
    'pdfc.p_unit_price': 'wrong unit price',
    'pdfc.p_price_list': 'old price list',
    'pdfc.p_both': 'measurement + price',
    'pdfc.noDetail': 'No detailed breakdown for this item.',
    'pdfc.missing': 'Missing from their estimate.',
    'pdfc.title': 'Both estimates, side by side',
    'pdfc.items': 'Items',
    'pdfc.ours': 'Our estimate',
    'pdfc.theirs': 'Insurance estimate',
    'pdfc.page': 'page',
    'pdfc.noFile': 'That estimate has no file to open.',
    'pdfc.noFiles': 'Neither estimate has a file to open. Upload them and analyze again.',
    'pdfc.noPages': 'This analysis ran before page numbers were recorded — click an item and both PDFs open at page 1. Regenerate the analysis to get the jump.',
    'neg.editNote': 'Edit this note',
    'neg.openPhoto': 'Open',
    'rm.ourSketch': 'Our roof sketch (AI)',
    'rm.sketchNotRead': 'The file is here, but nobody has read it as a roof report yet.',
    'rm.readSketch': 'Read it with AI',
    'rm.view': 'View',
    'rm.noNumbersYet': 'The report is here but its numbers have not been read yet.',
    'rm.whatsDifferent': "What's different — AI",
    'rm.whatsDifferentDo': "Ask the AI what's different",
    'rm.facetCount': 'How many',
    'rm.aiSummaryDo': 'Summarize the report with AI',
    'mod.roofMeasPreview': 'Order the verified report; the PDF, the ESX and the AI briefing land here.',
    /* SKETCH READY / ESTIMATE READY (pedido del dueño 2026-08-20): son el chip de la fila Y las
       pestañas que filtran. "Uploaded" en ámbar se leía como pendiente justo cuando ya estaba
       hecho, y es lo que el estimador viene a buscar. */
    'sup.stReady': 'Estimate ready',
    'sup.stAcceptedShort': 'accepted',
    'sup.sketchReady': 'Sketch ready',
    'sup.copyAddress': 'Copy the address',
    'sup.noSketchReady': 'No sketch is ready yet.',
    'sup.noEstimateReady': 'No estimate is ready yet.',
    'sup.stUploaded': 'Uploaded',
    'sup.stVerified': 'AI-read',
    'sup.stAccepted': 'Estimate done',
    'sup.fromReview': 'From Claim Review',
    'sup.verifyClaude': 'Read & verify with AI',
    'sup.verifyDone': '✓ AI read the estimate.',
    'sup.verifyReading': "Reading the estimate… the check fills in by itself in about 2 minutes.",
    'sup.mClient': 'Client',
    'sup.mAddress': 'Address',
    'sup.mClaim': 'Claim #',
    'sup.item': 'Item',
    'sup.qty': 'Qty',
    'sup.price': 'Price',
    'sup.accept': 'Accept',
    'sup.accepted': 'Accepted',
    'sup.estimateBy': 'Estimate by',
    'sup.preApToContractor': 'The {n} item(s) also go to the contractor as pending documents ("Supplement pre-approved … we need this in order to get it paid"), so the photos come back without chasing them.',
    'dept.claims': 'Claims',
    'dept.payments': 'Payments',
    'dept.supplements': 'Supplements',
    'cdw.claimStatus': 'Claim status',
    'cdw.paymentStatus': 'Payment status',
    'cdw.changeClaimStatus': 'Change the claim status',
    'cdw.changePaymentStatus': 'Change the payment status',
    'cdw.noStatus': 'no view',
    'cdw.notHere': 'not in this dept.',
    'supd.reviewsDone': 'Supplements — review estimates done',
    'supd.unitReview': 'reviews',
    'supd.hintReviews': 'Counted per claim reviewed, not per time Analyze was pressed: re-running the analysis of the same claim is part of reviewing it.',
    'supd.estimatesDone': 'Supplements — estimates done',
    'supd.thisMonth': 'This month',
    'supd.periodToday': 'Today',
    'supd.periodWeek': 'This week',
    'supd.periodMonth': 'This month',
    'sup.addNote': 'Add a note',
    'sup.total': 'Total',
    'sup.viewBoard': 'View full board',
    'sup.emptyCol': 'No claims here.',
    'sup.searchPh': 'Search name, claim #, contractor, carrier…',
    'sup.squares': 'squares',
    'sup.estimate': 'estimate',
    'sup.uploadedBy': 'uploaded by',
    'sup.delEst': 'Delete',
    'sup.delEstConfirm': 'Delete this uploaded estimate? (in case the wrong file was uploaded)',
    'sup.delEstDone': '✓ Estimate deleted. You can upload the correct file.',
    'sup.roofDiagram': 'Roof diagram (AI reads it)',
    'sup.roofDiagramUpload': 'Upload roof diagram / report — AI reads squares + pitch',
    'sup.roofRead': 'Roof read',
    'sup.esxExport': 'Export ESX (beta)',
    'sup.esxExportHelp': 'Convert the read measurements into an ESX for Xactimate. Experimental — verify the import.',
    'sup.esxBetaNote': 'Beta — verify import in Xactimate. Native ESX comes from the paid provider (1ESX).',
    'sup.roofFile': 'Uploaded file',
    'sup.roofFileNone': 'File not available.',
    'sup.accTitle': 'Quantify items (count by hand)',
    'sup.accSaved': 'Items saved',
    // Time tracking
    'work.start': 'Working on it',
    'work.stop': 'Stop',
    'work.stopReason': 'Why are you stopping? (missing something, an issue, switching tasks…)',
    'work.since': 'for {m} min',
    'work.taken': 'Someone is already working on this.',
    'work.claimReview': 'Claim review',
    'fu.next': 'Next follow-up',
    'mgr.title': 'Follow-ups & tracking', 'mgr.subtitle': "where this claim is and what's falling behind",
    'mgr.inStage': 'time in this stage', 'mgr.here': 'here', 'mgr.overdue': 'overdue', 'mgr.next': 'next',
    'mgr.lastFu': 'Last follow-up', 'mgr.noFu': 'No follow-up yet', 'mgr.lastActivity': 'last activity',
    'mgr.notePh': 'Write an update (or why there is no follow-up)…', 'mgr.post': 'Follow up',
    'msg.toTask': 'Task', 'msg.react': 'React', 'msg.taskTitle': 'Task title:', 'msg.taskCreated': '✓ Task created in their To-Do.',
    'work.roofSketch': 'Roof sketch',
    'work.review': 'Review',
    'work.estimate': 'Estimate',
    'work.mitigation': 'Mitigation',
    'work.task.roof_sketch': 'Roof sketch', 'work.task.estimate': 'Estimate', 'work.task.mitigation': 'Mitigation', 'work.task.estimate_analysis': 'Estimate analysis',
    // Roof Measurements
    'rm.title': 'Roof measurements',
    'rm.free': 'Free report',
    'rm.freeHelp': 'Generate a free satellite-derived roof report (Google Solar). Estimate — verify before submitting.',
    'rm.verified': 'Verified ($)',
    'rm.verifiedRequested': '✓ Verified measurement requested — pending super-manager approval',
    'sup.vmRequested': 'Verified measurement requested',
    'sup.vmReady': 'Verified measurement ready',
    'sup.vmFailed': 'Verified measurement failed',
    'rm.verifiedHelp': 'Order a certified paid roof report. Requires super-manager approval before any money is spent.',
    'rm.reportType': 'Report type (1ESX product)',
    'rm.reportTypeLocked': 'Employees can only order this 1ESX product. A super-manager can choose another one.',
    'rm.empty': 'No roof measurements yet. Generate a free report or request a verified one.',
    'rm.kindFree': 'Free (satellite)',
    'rm.kindVerified': 'Verified',
    'rm.pendingLine': 'Verified report requested by {by} ({provider}) — needs approval.',
    'rm.needsSuper': 'A super-manager must approve before the paid order is placed.',
    'rm.failedTitle': 'The verified order failed at the provider',
    'rm.orderedWaiting': 'Order placed — 1ESX is preparing the report. The PDF/ESX will appear here and in the claim Files when delivered.',
    'rm.retry': 'Retry order',
    'rm.approve': 'Approve & order',
    'rm.deny': 'Deny',
    'rm.denyPrompt': 'Reason for denying this paid report request?',
    'rm.squares': 'Squares',
    'rm.area': 'Total area',
    'rm.pitch': 'Predominant pitch',
    'rm.byPitch': 'Squares by pitch',
    'rm.facets': 'Facets (pitch)',
    'rm.history': 'History ({n})',
    'rm.noFile': 'File not available.',
    'rm.esxBeta': 'Xactimate ESX — experimental on free reports; verify import.',
    'sup.roofReadNone': 'Uploaded, but AI could not read squares/pitch. Check the file.',
    'sup.fromRoofDiagram': 'from roof diagram',
    'sup.google': 'Google (satellite)',
    'sup.ourDiagram': 'Our diagram',
    'sup.esxTitle': 'Xactimate file (.ESX)',
    'sup.esxUpload': 'Upload the .ESX (Xactimate source) so anyone can keep working it',
    'sup.esxReplace': 'Replace .ESX (upload a newer Xactimate file)',
    'sup.esxDownload': 'Download .ESX',
    'sup.esxUploaded': 'ESX uploaded',
    'sup.esxJustUploaded': 'ESX uploaded just now',
    'sup.esxNone': 'no .ESX yet',
    'sup.plUpToDate': 'up to date',
    'sup.plOutdated': 'outdated',
    'sup.plMoAbbr': 'mo',
    'sup.esxSaved': '✓ .ESX saved. Anyone on the team can download it.',
    'sup.esxNote': 'The .ESX is the editable Xactimate source — download it to keep working the estimate.',
    'sup.measYes': 'Measurements ✓',
    'sup.measNo': 'No measurements',
    'sup.emailBodyPh': 'Message to the insurance (optional). Our estimate is attached automatically.',
    'sup.deptUpdates': 'Supplement Department Updates',
    'sup.insuranceFirst': 'First insurance estimate (initial approval)',
    'sup.gapUpHelp': 'How much the insurance went UP from its first estimate',
    'sup.insuranceLast': 'Insurance last estimate',
    'sup.gapHelp': 'Gap between our estimate and the insurance one',
    'sup.teamFilter': 'Team',
    'sup.teamNone': 'No team',
    'sup.teamMine': 'Mine',
    'sup.onlyMine': 'Showing only your claims — {n} more in the department.',
    'sup.seeAll': 'See them all',
    'sup.filterAll': 'All',
    'sup.filterTodo': 'To do',
    'sup.noPending': 'Nothing waiting on info here.',
    'sup.filterWorking': 'Working on',
    'sup.noWorking': 'Nobody is working on a claim here right now.',
    'sup.preApTitle': 'Pre-approved items (from the insurance estimate)',
    'sup.preApHelp': 'Check the items from the insurance estimate that the adjuster pre-approved. You will send photos for these so they get paid.',
    'sup.preApNoCands': 'No insurance estimate items yet — add them manually below.',
    'sup.preApReading': 'Reading the insurance estimate items',
    'sup.preApPricePh': 'Price $',
    'sup.totalIncrement': 'Total increment',
    'cal.all': 'All',
    'cal.hiddenByPeriod': '{n} more outside {period} — the date filter is hiding them.',
    'cal.seeAll': 'See all dates',
    'sup.historic': 'historic',
    'sup.inQueueHint': 'Still in this queue (same number as the menu badge)',
    'sup.historicHint': 'Already closed — shown here to measure the month, not pending work',
    'cal.day': 'Day',
    'cal.week': 'Week',
    'cal.month': 'Month',
    'cal.today': 'Today',
    'cal.prev': 'Previous',
    'cal.next': 'Next',
    'cal.empty': 'Nothing in this period.',
    'cal.asGrid': 'Show as a calendar grid', 'cal.asList': 'Show as a list',
    'sup.preApManualPh': 'Add an item manually…',
    'sup.preApNotePh': 'What are we waiting for / what do they pre-approve?',
    'sup.preApNoteOptPh': 'Note (optional) — what they pre-approve / what we expect.',
    'sup.preApNote': 'Add a note (what they pre-approve / what we expect).',
    'sup.preApPickOne': 'Check at least one pre-approved item first.',
    'sup.preApSelected': 'selected',
    'sup.preApTotal': 'Pre-approved',
    'sup.preApBadge': 'Pre-approved',
    'sup.preApProof': 'Items proof',
    'sup.preApConfirm': 'Save as Pre-approved',
    'sup.preApItems': 'Pre-approved items + photos',
    'sup.preApNoItems': 'No items saved.',
    'sup.preApUrlPh': 'CompanyCam link (photos of this item)',
    'sup.preApUrlSaved': '✓ Link saved',
    'sup.preApEmailTitle': 'Send photos to insurance',
    'sup.preApEmailPh': 'Message (optional). The pre-approved items + photo links are included.',
    'sup.preApSendEmail': 'Send email with photos',
    'ip.title': 'Info Pending',
    'ip.waiting': 'waiting',
    'ip.allIn': 'All received',
    'ip.errTooLong': "Couldn't save it. The text may be too long (max 2000 characters) or empty.",
    'ip.errPerm': "You don't have permission to change this claim's pending items.",
    'ip.errGeneric': "Couldn't save it. Try again — if it keeps failing, send this code to support",
    'ip.addPh': 'What do you need? (e.g. roof photos)',
    'ip.add': 'Add',
    'ip.openPhotos': 'Open photos (CompanyCam)', 'ip.empty': 'Nothing pending. Add what you need to keep estimating.',
    'ip.uploadedTag': 'uploaded',
    'ip.file': 'file',
    'ip.upload': '⬆ Upload',
    'ip.dropHere': 'Drag the file here or click to upload',
    'ip.view': 'View',
    'ip.del': 'Remove',
    'ip.delConfirm': 'Remove this pending item?',
    'ip.uploaded': '✓ Uploaded. It moved out of Info Pending.',
    'ip.fuTitle': 'Follow-up (so it doesn’t slip)', 'ip.internalNotes': 'Internal notes',
    'ip.fuPh': 'Follow-up note (chased insurance / contractor…)',
    'ip.fuNext': 'Next follow-up:',
    'ip.fuSave': 'Save',
    'ip.itemFu': 'Follow up on:',
    'ip.fuOverdue': 'overdue',
    'ip.fuToday': 'today',
    'ip.fuClear': 'Clear date',
    'ip.fuAlsoContractor': 'This note also posts to the Contractor board.',
    'ip.fuSaved': '✓ Follow-up saved',
    // LO QUE LLEGÓ POR EL CLIENT PORTAL y espera que una persona lo mire. El item sigue en 'waiting'
    // a propósito: nadie avanza el claim hasta que alguien abra el archivo.
    'ip.toReview': 'to review',
    'ip.arrived': 'The homeowner sent this through the {via} on {fecha} — nobody has reviewed it yet.',
    'ip.review': 'Reviewed',
    'ip.returnIt': 'Ask again',
    'ip.returnConfirm': 'Send this back as still pending? The homeowner will keep getting reminders for it.',
    'ip.reviewedOk': '✓ Reviewed. It moved out of pending.',
    'ip.returnedOk': 'Back to pending — the homeowner will be asked again.',
    'sup.sentExt': 'Sent (outside app)',
    'sup.sentExtHelp': 'Mark as already sent outside the app and remove it from this column. The claim keeps its normal flow.',
    'sup.sentExtDate': 'Sent on:',
    'sup.sentExtNote': 'Temporary — for estimates already sent before using the app.',
    'sup.sentExtConfirm': 'Mark this estimate as sent outside the app and remove it from the board? (temporary, for backlog)',
    'sup.sentExtDone': '✓ Marked as sent. Removed from the board; the claim continues its flow.',
    'nav.supDashboard': 'Dashboard',
    'nav.supBoard': 'Board',
    'supd.title': 'Supplements Dashboard',
    'supd.estimator': 'Estimator',
    'supd.all': 'Everyone',
    'supd.firstEstimate': 'First Estimate',
    'supd.mitigation': 'Mitigation Estimate',
    'supd.supplementing': 'Supplementing',
    'supd.daysWaiting': 'days in stage',
    'supd.estimatesToday': 'Estimates done today',
    'supd.speed': 'Speed (avg time)',
    'supd.person': 'Person',
    'supd.done': 'Done',
    'supd.avg': 'Avg',
    'supd.median': 'Median',
    'supd.sketchesToday': 'Sketches done today',
    'supd.estimatesTodayList': 'Estimates done today',
    'supd.sketches': 'Sketches',
    'supd.estimates': 'Estimates',
    'supd.activityToday': "Today's activity",
    'supd.activityOn': 'Activity on selected day',
    'supd.date': 'Date',
    'supd.backToToday': 'Back to today',
    'supd.toDo': 'to do',
    'supd.topSketcher': 'Top sketcher',
    'supd.topEstimator': 'Top estimator',
    'supd.topAnalyzer': 'Top analyzer',
    'supd.analyses': 'Analyses',
    'supd.pending': 'To do',
    'supd.doneToday': 'Done today',
    'supd.noneToday': 'Nothing done yet today',
    'supd.client': 'Client',
    'supd.by': 'By',
    'supd.time': 'Time',
    'supd.amount': 'Amount',
    'supd.view': 'View',
    'supd.followupsToday': 'Follow-ups in Supplementing today',
    'supd.unitEst': 'est.',
    'supd.unitFu': 'f/u',
    'sup.board': 'Supplements',
    'sup.viewLines': 'Lines', 'sup.sortTitle': 'Sort the lists', 'sup.sortDefault': 'Sort: oldest first', 'sup.sortNextFu': 'Sort: follow-up due first', 'sup.sortNoFu': 'Sort: longest without follow-up',
    'sup.viewCards': 'Cards',
    'sup.estimator': 'Assigned estimator',
    'sup.estimatorLocked': 'only a super-manager can assign',
    'sup.diagram': 'Roof diagram / sketch',
    'sup.diagramUpload': '⬆ Upload diagram / sketch',
    'sup.diagramUploaded': 'Diagram uploaded to Files',
    'sup.photoHouse': 'House',
    'sup.photoRoof': 'Roof',
    'sup.insEstimate': 'Insurance estimate',
    'sup.insParsed': 'Parsed — amounts saved (also in Payments)',
    'sup.depreciation': 'Depreciation',
    'sup.netClaim': 'Net claim',
    'sup.roofFull': 'AI: full roof replacement approved — suggest Approved',
    'sup.roofPartial': 'AI: partial roof repair — use Approved for Repairs',
    'sup.ourCounter': 'Our counter-offer (latest)',
    'sup.ourLast': 'Our last estimate (sent)',
    'sup.chipStarted': 'Supplement process started', 'sup.chipPreApproved': 'Pre-approved',
    'sup.chipResolved': 'Supplement resolved', 'sup.chipCocSent': 'COC sent',
    'sup.chipHelp': 'Where the supplement stands: it started when our counter offer went out, and it ends at pre-approved or resolved.',
    'sup.ourSupplement': 'Our supplement (sent)',
    'sup.insResponseUpload': "⬆ Upload the insurance's response estimate",
    'sup.disputeReady': '✓ Dispute / let-go analysis ready — also in Review Estimate',
    'sup.rcvAsking': 'RCV we are asking',
    'sup.rcvApproving': 'RCV they approve',
    'sup.noNumbers': 'No parsed numbers for this file',
    'sup.getNumbers': 'Get numbers (AI)',
    'sup.viewEstimate': 'View',
    'sup.noOurEstimate': 'No estimate created yet.',
    'sup.negotiation': 'Negotiation summary',
    'sup.asking': 'Asking for',
    'sup.disputing': 'Disputing',
    'sup.negotiationPending': 'Will be filled from the negotiation app.',
    'sup.negAnalyze': 'Analyze estimates (AI)',
    'rs.summaryTitle': 'What we are asking differently vs the insurance estimate',
    'rs.disputingPriceList': 'Disputing the price list',
    'rs.missingItems': 'Missing items',
    'rs.noNoteYet': 'No note or photos yet — add them in the item detail',
    'rs.photo': 'Photo',
    'rs.wrongMeasurement': 'Wrong measurement',
    'rs.noDiffs': 'No meaningful differences found vs the insurance estimate.',
    'rs.showDetail': 'Show item-by-item detail',
    'rs.supplementNote': 'The estimate you upload here is the SUPPLEMENT sent to the insurance (not a comparison estimate).',
    'rs.attached': '✓ Estimate will be attached to the email',
    'rs.uploadPreviousOnly': 'Upload our PREVIOUS estimate only',
    'rs.noPreviousEstimate': 'No previous estimate done',
    'rs.sentDate': 'Sent',
    'rs.receivedDate': 'Received',
    'rs.uploadSupplementOnly': '⬆ Upload our SUPPLEMENT estimate only',
    'sup.beingAnalyzed': 'Being analyzed by {u}',
    'sup.negDone': 'Analysis ready',
    'sup.negRerun': 'Re-run analysis',
    'sup.needInsEst': 'Upload the insurance estimate first',
    'sup.gap': 'Gap',
    'sup.missing': 'missing from theirs',
    'sup.dispute': 'Dispute',
    'sup.letGo': 'Let go',
    'sup.genNotes': 'Generate dispute notes',
    'sup.notesDone': 'dispute notes generated — shown under each item',
    'sup.nothingDisputed': 'No items marked to dispute',
    'sup.genEmail': 'Generate dispute email',
    'sup.regenEmail': 'Regenerate',
    'sup.emailFromOrder': 'From the order',
    'sup.emailSeededHint': 'Pre-filled with the dispute email approved in Review Estimate. Attach the estimate and send it.',
    'sup.emailFromOrderHint': 'This is the email supplements wrote before sending the order. It is what goes out. Press Edit to correct it: the saved version is the one that is sent.',
    'sup.emailFrozenEdit': 'Edit',
    'sup.emailFrozenSave': 'Save email',
    'sup.emailFrozenCancel': 'Cancel',
    'sup.emailFrozenEditingHint': 'You are editing the email that goes out with the order. Save it: the estimator and the send use the saved text.',
    'sup.emailFrozenSaved': 'Email saved — this is the version that goes out',
    'sup.ourEstimateShort': 'Our estimate',
    'sup.prevAnalyses': 'Previous analyses',
    'sup.prevAnalysesPreview': '{n} earlier round(s) — what we were arguing before',
    'sup.sendEstimate': 'Send to insurance',
    'sup.sendEstimateHint': 'Sends this estimate attached, with the email written above, from the supplements mailbox',
    'sup.sendEstimateConfirm': 'Send this estimate to the insurance with the email written above?',
    'sup.emailSubjectPh': 'Subject (defaults to the claim number)',
    'sup.emailWritePh': 'Write the email, or paste the one you already wrote. Plain text — it goes out exactly like this.',
    'sup.improveEmail': 'Improve with AI',
    'sup.improveEmailHint': 'AI rewrites what you wrote — it keeps your argument and never adds numbers or facts you did not write',
    'sup.sendNoEstimateConfirm': 'There is no estimate uploaded yet. Send the email without it?',
    'sup.esxRequired': 'Upload the .ESX of this estimate to continue',
    'sup.esxRequiredHint': 'Without the .ESX the estimate cannot be worked on again in Xactimate — it has to be rebuilt from scratch. It gets attached to this estimate, not saved as a separate file.',
    'sup.esxNeedsEstimate': 'Upload the estimate first: the .ESX is attached to it',
    'sup.revOrdersMissing': 'Write the instructions for the estimator first (the box at the top of the card)',
    'sup.emailPreview': 'Email preview — review before sending',
    'sup.editHtml': 'Edit HTML',
    'sup.sendEmailNow': 'Send email',
    'sup.regenAnalysis': 'Regenerate analysis',
    'sup.regenConfirm': 'Re-run the analysis (e.g. to switch it to the current language)? Your dispute/let-go decisions and notes are kept.',
    'sup.estimatorGuide': 'Estimator guide (PDF)',
    'sup.revisedPreview': 'Preview revised estimate (PDF)', 'sup.revisedGenerate': 'Generate revised estimate',
    'sup.opMode': 'O&P:', 'sup.opKeep': 'as in our estimate', 'sup.opAdd': 'add (overhead + profit)', 'sup.opRemove': 'remove',
    'sup.opHint': 'Overhead & Profit in the generated estimate. "Add" puts the percentages from Settings → Supplements → Estimating on every item that does not carry it; items that already have it keep theirs; invoices never carry O&P.',
    'sup.revisedConfirm': 'Generate the revised estimate from the current decisions? It is saved in Files as a new Proactive estimate version (no AI involved).',
    'sup.revisedDone': 'Revised estimate #{n} generated · RCV ${rcv}', 'sup.revisedWarnings': 'warning(s) inside the PDF',
    'sup.revisedNeedsReading': 'Our estimate has not been read yet; the reading was queued. Try again in a minute.', 'sup.revisedNeedsAnalysis': 'Run the analysis first.',
    'sup.revisedPreviewWaiting': 'Reading our estimate (about 2 minutes). The PDF will open here by itself when it is ready — you can leave this tab open.', 'sup.revisedPreviewTimeout': 'The reading is taking longer than usual. Close this tab and try the preview again in a few minutes; if it keeps happening, open the estimate in Files and press Read estimate.',
    'sup.negStillWorking': 'The analysis is still running on the server (it may be reading an estimate first). It will appear here in a few minutes; reload if needed.',
    'neg.matchUnconfirmed': 'match not confirmed',
    'neg.matchUnconfirmedHint': 'The app could not confirm which insurance line this item corresponds to; check it before treating it as not paid.',
    // Counter offer adjunto al email, cambio de partida estructurado y Price lists (dueño 2026-10-08).
    'nav.supPriceLists': 'Price lists',
    'sup.emailAttachment': 'Attachment',
    'sup.emailDetach': 'Send without the estimate',
    'sup.emailAttachBack': 'Attach the estimate again',
    'sup.emailNoAttachment': 'No estimate attached — generate the revised estimate or upload one below.',
    'sup.sendEmailWithEstimate': 'Send email with estimate',
    'sup.sendWithEstimateConfirm': 'Send this email to the insurance with "{name}" attached? The claim moves to Supplementing.',
    'sup.esxGenerated': 'Generated · no ESX needed',
    'sup.esxGeneratedHint': 'Generated by the app from the review decisions: it carries its own line-item JSON, so no .ESX is required.',
    'sup.revisedDoneCounter': 'Counter offer {n} generated · RCV ${rcv} — attached to the email below',
    'neg.replaceSwap': 'Activity',
    'neg.replaceSwapDr': 'Detach & reset',
    'neg.replaceSwapRr': 'Remove & replace',
    'neg.replaceSwapHint': 'instead of what the line says now',
    'neg.replaceQty': 'Quantity only',
    'neg.replaceQtyHint': 'the unit price stays',
    'neg.replaceQtyWas': 'was {q}',
    'neg.replaceText': 'Different item',
    'pl.title': 'Price lists',
    'pl.subtitle': 'Xactimate price lists by state: the official file of each month plus what the app learns from every estimate it reads. The revised estimate takes its prices from here.',
    'pl.alertsTitle': 'Price lists needed',
    'pl.alertsNone': 'All set for {month}: every region in use has its official price list.',
    'pl.neededTitle': 'Missing for {month} — upload the official file',
    'pl.neededSeen': 'seen: {codes}',
    'pl.uploadThis': 'Upload it',
    'pl.learnedOnlyTitle': 'Known only from estimates (no official file)',
    'pl.learnedOnlyHint': 'Prices are the median of what the estimates we read printed — useful, but not the catalog. Upload the official file to make them official.',
    'pl.learnedOnlyChip': '{n} learned items',
    'pl.uploadTitle': 'Upload the official price list',
    'pl.uploadHint': "PDF as Xactimate prints the price list, OR an estimate PDF from Xactimate with the items you want (quantities do not matter: each line's unit price is read into the memory, which takes about 2 minutes), or CSV / TSV with columns Cat / Sel (or Code), Act, Description, Unit, Unit Price. Re-uploading the same code replaces its prices.",
    'pl.code': 'Price list code',
    'pl.codeHint': 'Use the code as Xactimate prints it: region + month + year, e.g. GAAT8X_OCT26.',
    'pl.state': 'State',
    'pl.fileLabel': 'Drop the PDF (or CSV / TSV) here',
    'pl.uploading': 'Uploading…',
    'pl.uploadBtn': 'Upload',
    'pl.uploadDone': '{code}: {n} items loaded ({skipped} rows skipped).',
    'pl.columnsUsed': 'Columns used',
    'pl.errCode': 'Invalid price list code.',
    'pl.errXlsx': 'Excel files are not read directly: save it as CSV first.',
    'pl.errEstimate': "That CSV is an estimate export without a unit price column (quantity + Total). Export it with a Unit Price column, or upload the estimate PDF: its line items are read with their unit prices.",
    'pl.readingEstimate': "Reading the estimate… its unit prices will be in {code} in about 2 minutes (this page updates on its own).",
    'pl.readFailed': "The estimate could not be read: {msg}",
    'pl.fromEstimate': "Read from an estimate: one unit price per line item, quantities ignored.",
    'pl.detectedCode': "The PDF says price list {detected}; its prices were stored under {code} as typed.",
    'pl.recentUploads': "Recent uploads",
    'pl.stReading': "Reading…",
    'pl.stFailed': "Failed",
    'pl.nItems': "{n} items",
    'pl.errHeaders': 'Could not find the columns in the file.',
    'pl.errNoItems': 'No line items with a price were recognized in the file.',
    'pl.errParse': 'The file could not be read.',
    'pl.knownTitle': 'Known price lists',
    'pl.knownEmpty': 'Nothing yet: upload a file or read an estimate.',
    'pl.month': 'Month',
    'pl.official': 'Official',
    'pl.learned': 'Learned',
    'pl.lastSeen': 'Last seen',
    'pl.lastUpload': 'Last upload',
    'pl.noUpload': 'never',
    'pl.browse': 'Items',
    'pl.itemsCount': '{n} items · {up} official · {ln} learned',
    'pl.searchPh': 'Search by description or code…',
    'pl.itemsEmpty': 'No items match.',
    'pl.colCode': 'Code',
    'pl.colDesc': 'Description',
    'pl.colUnit': 'Unit',
    'pl.colPrice': 'Unit price',
    'pl.colSource': 'Source',
    'pl.srcOfficial': 'Official',
    'pl.srcLearned': 'Learned · {n}',
    'sup.negRunning': 'Analyzing',
    'sup.aiReading': 'AI reading the estimate (can take up to a couple minutes)',
    'sup.saveNewEst': '⬆ Save our new estimate (PDF)',
    'sup.quickCompare': 'Quick price compare',
    'sup.insPaying': 'Insurance is paying',
    'sup.weAsk': "We're asking",
    'sup.ourPrev': 'Our previous estimate',
    'sup.apart': 'Apart',
    'sup.insurance': 'Insurance',
    'sup.proactiveVsIns': 'Proactive vs Insurance',
    'sup.analyzeAiTitle': 'Analyze with AI',
    'sup.analyzedTag': 'analyzed',
    'sup.supplementUploaded': 'Supplement estimate',
    'sup.supplementAmt': 'Supplement (difference)',
    'sup.uploadSupDirect': '⬆ Upload supplement estimate (PDF)',
    'sup.quickCompareHint': 'Upload our estimate to see the difference vs the insurance estimate — no AI review needed.',
    'sup.sendEstTitle': 'Send estimate to adjuster',
    'sup.sendEstMsgPlaceholder': 'Message to the adjuster (optional)…',
    'sup.sendEstBtn': 'Send estimate to adjuster',
    'sup.sendEstNeedEst': 'Upload our estimate first (it gets attached).',
    'sup.sendEstConfirm': 'Send the estimate to the adjuster by email, with our estimate attached?',
    'sup.mitEstimate': 'Mitigation estimate',
    'sup.noMitEstimate': 'No mitigation estimate on file',
    'sup.mitLast': 'Last follow-up',
    'sup.mitNext': 'Next follow-up',
    'sup.mitNotePh': 'Follow-up note (what you did / what you\'re waiting for)…',
    'sup.mitNoteReq': 'Write a follow-up note first',
    'sup.mitLog': 'Log follow-up',
    'sup.mitLogged': 'Follow-up logged',
    'sup.mitResolve': 'Resolve',
    'sup.mitResolveConfirm': 'Mark this mitigation follow-up as done (removes it from the list)?',
    'sup.mitResolved': 'Mitigation follow-up resolved',
    'sup.emailTo': 'Email to (insurance)',
    'sup.emailContractor': 'Email contractor (follow-up)',
    'sup.emailHomeowner': 'Email homeowner',
    'qe.to': 'To (email)',
    'qe.toMulti': 'To (email — one or more)',
    'qe.toMultiHint': 'You can add several recipients separated by comma, semicolon or space.',
    'qe.subject': 'Subject',
    'qe.bodyPh': 'Write your message…',
    're.bold': 'Bold', 're.italic': 'Italic', 're.underline': 'Underline', 're.strike': 'Strikethrough', 're.highlight': 'Highlight', 're.bullets': 'Bullet list', 're.numbered': 'Numbered list', 're.link': 'Insert link', 're.linkPrompt': 'Link URL:', 're.emoji': 'Emoji', 're.ai': 'AI writing assistant', 're.aiImprove': 'Improve text', 're.aiTranslate': 'Translate to English', 're.aiShorten': 'Shorten text', 're.gifSearch': 'Search GIFs…', 're.gifOff': 'GIFs are not configured yet (missing GIPHY key).',
    're.textSize': 'Text size', 're.sizeSmall': 'Small', 're.sizeNormal': 'Normal', 're.sizeLarge': 'Large', 're.sizeHuge': 'Huge',
    'nem.modeClaim': 'To a homeowner / claim', 'nem.modeFree': 'No claim (contractor or any address)', 'nem.fromDept': 'Send from:', 'nem.pickContractor': 'Pick a contractor',
    'nem.fromMine': 'My email — {email}', 'nem.mineNote': 'Goes out from YOUR mailbox (your real address).',
    'qe.body': 'Message',
    'qe.send': 'Send email',
    'qe.sent': 'Email sent',
    'qe.needFields': 'Enter a recipient and subject',
    'qe.noClose': "Doesn't close the task",
    'em.title': 'Email',
    'em.insurance': 'Insurance',
    'em.contractor': 'Contractor',
    'em.ccLabel': 'Copy:',
    'em.ccNoEmail': 'No email on file for this claim',
    'em.ccTo': 'copy → {list}',
    'em.ccShort': 'cc',
    'em.useTemplate': 'Use a template',
    'em.homeowner': 'Homeowner',
    'em.invalidEmailHint': 'Not a valid email — check for a space or missing part',
    'em.recatMove': 'Move to…',
    'em.recatHint': 'Wrong mailbox? Move this email to the correct category (Insurance / Contractor / Homeowner).',
    'em.recatDone': 'Moved to {cat}',
    'em.received': 'Received',
    'em.delivered': 'Delivered', 'em.download': 'Download',
    'em.opened': 'Opened',
    'em.clicked': 'Clicked',
    'em.addToFiles': 'Add to claim files',
    'em.addedToFiles': 'Added {n} file(s) to the claim.',
    'inbox.loadErr': 'Could not refresh the inbox — showing what was loaded before. Retrying…', 'inbox.retry': 'Retry',
    'inbox.title': 'Inbox', 'inbox.deptInbox': 'Department inbox', 'inbox.search': 'Search emails (sender, subject, body, claim…)', 'inbox.empty': 'No emails in this department yet.', 'inbox.openClaim': 'Open claim',
    'inbox.mail': 'Mail', 'inbox.selectOne': 'Select an email to read it.', 'inbox.reply': 'Reply', 'inbox.subject': 'Subject', 'inbox.subjectPh': 'Subject of the reply', 'inbox.to': 'To', 'inbox.toPh': 'Recipient email', 'inbox.toOptions': 'Known addresses for this thread', 'inbox.replyPh': 'Write your reply to the client…',
    'inbox.claim': 'Claim', 'inbox.moveTo': 'Move to mailbox', 'inbox.internalChat': 'Internal chat', 'inbox.internalHint': 'Team-only notes on this email (not sent to the client).', 'inbox.noNotes': 'No internal notes yet.', 'inbox.notePh': 'Write an internal note…',
    'inbox.assignFirst': 'Assign this email to a claim to reply.', 'inbox.noClaimSend': 'Not linked to a claim — it will send as a standalone email (e.g. to a contractor).', 'inbox.searchClaim': 'Search a claim (name / claim #)…', 'inbox.assignee': 'Assigned to', 'inbox.unassignedPerson': 'Unassigned', 'inbox.assignToMe': 'Assign to me', 'inbox.conversations': 'Conversations', 'inbox.convHO': 'HO', 'inbox.convAll': 'All', 'inbox.convEmpty': 'No emails with this homeowner yet.', 'inbox.openThisEmail': 'Open this email', 'inbox.category': 'From (category)', 'inbox.cat_homeowner': 'Homeowner', 'inbox.cat_contractor': 'Contractor', 'inbox.cat_insurance': 'Insurance', 'inbox.catSuggested': 'Auto-detected from the sender', 'inbox.sendClose': 'Send and close', 'inbox.attachments': 'attachment(s)', 'inbox.newClaimAI': 'New claim from this email', 'inbox.creatingClaim': 'Creating…',
    'inbox.myEmails': 'My assigned emails', 'inbox.unassignedTag': 'Unassigned', 'inbox.newEmail': 'New email', 'inbox.hideDetails': 'Hide details', 'inbox.showDetails': 'Details', 'inbox.toggleDetails': 'Show/hide the details panel (more room on small screens)', 'inbox.labels': 'Labels', 'inbox.labelNew': 'New label', 'inbox.labelNamePh': 'Label name', 'inbox.labelDelete': 'Delete label (removes it from all emails)', 'inbox.labelDeleteConfirm': 'Delete label "{name}"? It will be removed from all emails.', 'inbox.fAll': 'All', 'inbox.fReceived': 'Received', 'inbox.fSent': 'Sent', 'nav.myMail': 'My Mail', 'nav.smsInbox': 'SMS Inbox',
    'sms.title': 'SMS Inbox', 'sms.search': 'Search phone, text, or claim…', 'sms.empty': 'No SMS conversations yet.', 'sms.selectOne': 'Select a conversation.', 'sms.noClaim': 'No claim', 'sms.daysInStatus': 'Days in this status', 'sms.contractor': 'Contractor', 'sms.replyPh': 'Type an SMS reply… (Enter sends)', 'sms.failed': 'failed to send', 'sms.sendFailed': 'The SMS could not be sent (check RingCentral).', 'sms.v_open': 'Open', 'sms.v_mine': 'My SMS', 'sms.v_unassigned': 'Unassigned', 'sms.v_closed': 'Closed', 'sms.partyTitle': 'Who is this thread with?', 'sms.partyHomeowner': 'Homeowner', 'sms.partyInsurance': 'Insurance', 'inbox.vOpen': 'Open', 'inbox.vUnassigned': 'Unassigned', 'inbox.noClaim': 'No claim', 'inbox.hasClaim': 'Claim', 'inbox.vNoClaim': 'No claim', 'inbox.vAssigned': 'Assigned', 'inbox.vClosed': 'Closed', 'inbox.vOutbox': 'Outbox', 'inbox.addTeammate': 'Teammate', 'inbox.addTeammatePh': 'Add a teammate…', 'inbox.addTeammateHint': 'Goes in copy and gets the conversation assigned.', 'upd.available': 'A new version of the app is available.', 'upd.reload': 'Update now', 'bon.approvedCount': 'approved this month', 'bon.colClient': 'Client', 'bon.colInsurance': 'Insurance', 'bon.colApproved': 'Approved', 'bon.colStage': 'Stage', 'bon.noClaims': 'No approvals for this team in the month.', 'bon.unattributed': 'Approved with no team', 'bon.unattributedHint': 'They count for nobody — assign them a Claims team.', 'bon.colAttribute': 'Credit to', 'bon.pickTeam': 'Pick a team…', 'bon.suggested': '(suggested)', 'bon.attribute': 'Seal', 'bon.col.milestone': 'Milestone', 'bon.from.send': 'from the last email to the carrier', 'bon.from.supplementing': 'from entering Supplementing', 'bon.from.carrier': 'from the new carrier estimate', 'bon.from.previous': 'from the previous resolution', 'bon.from.approval': 'from the approval', 'bon.roundN': 'round {n}', 'bon.prevRound': 'previous', 'bon.openRound': 'new round, not closed yet', 'bon.openRoundHint': 'The carrier sent a higher estimate after the last Resolved / Pre-approved. It counts the month the team presses the button again.', 'bon.supClockHint': 'Days run from the last real email the team sent to the carrier before the button (every new send restarts the clock); without one, from entering Supplementing; without that, from the approval. A claim the carrier reopens counts again as a new round.', 'bon.supDaysHint': 'Counted from the last real email to the carrier before the button; every new send restarts the clock.', 'bon.mPreApproved': 'Pre-approved', 'bon.mResolved': 'Resolved', 'bon.approvedOn': 'Claim approved on', 'bon.noApprovalDate': 'This claim has no approval date — there are no days to count.', 'bon.noGain': 'no gain', 'bon.byBypass': 'granted', 'bon.bypass': 'grant', 'bon.bypassHint': 'Grant the bonus even though it is outside the window. Open the claim first and read the follow-up.', 'bon.bypassAsk': 'Why are you granting it? (e.g. the carrier stalled, the team followed up weekly)', 'bon.bypassBy': 'Granted by', 'bon.whoCanBypass': 'Who can grant out-of-window supplements', 'bon.whoCanBypassHint': 'Only these people see the grant checkbox. Separate from editing the tiers.',  'bon.rcvUnknown': 'no estimate', 'bon.rcvUnknownHint': 'No insurance estimate has been read for this claim yet — the amount is unknown, not zero.', 'bon.rcvFromEstimate': 'From the insurance estimate', 'bon.rcvFromClaim': 'From the Monday field — no insurance estimate read yet', 'bon.supN': 'supplement #', 'roster.title': 'Right now', 'roster.working': 'working', 'roster.break': 'on break', 'roster.done': 'clocked out', 'roster.missing': "didn't clock in", 'roster.off': 'no schedule', 'roster.lateBy': 'late by {m}', 'roster.since': 'for', 'roster.editSchedules': 'Schedules', 'roster.schedules': 'Work schedules', 'roster.schedulesHint': 'Who works which days and hours. Without this nobody can ever show up late — the clock measures lateness against this.', 'roster.noScheduleWarn': '{n} people have no schedule loaded, so we cannot tell whether they are late.', 'roster.loadThem': 'Load them', 'roster.showOff': 'Show the {n} with no schedule', 'roster.hideOff': 'Hide those with no schedule', 'roster.noSchedule': 'no schedule', 'roster.daysWord': 'days', 'roster.overnight': 'overnight', 'roster.copyToAll': 'Copy to everyone with no schedule', 'roster.copyConfirm': 'Give this same schedule to the {n} people who have none?', 'roster.dow0': 'Sunday', 'roster.dow1': 'Monday', 'roster.dow2': 'Tuesday', 'roster.dow3': 'Wednesday', 'roster.dow4': 'Thursday', 'roster.dow5': 'Friday', 'roster.dow6': 'Saturday', 'prof.language': 'Language', 'prof.availability': 'Availability', 'prof.viewProfile': 'View my profile', 'tpl.title': 'Email templates', 'tpl.new': 'New template', 'tpl.edit': 'Edit template', 'tpl.help': 'Write them once here instead of pasting from Word — pasting from Word breaks the formatting, and it breaks it for the client too.', 'tpl.empty': 'No templates yet.', 'tpl.name': 'Name', 'tpl.namePh': 'e.g. Ask about a check', 'tpl.dept': 'Department', 'tpl.allDepts': 'All departments', 'tpl.order': 'Order', 'tpl.activeLabel': 'Active', 'tpl.off': 'off', 'tpl.subject': 'Subject', 'tpl.body': 'Body', 'tpl.bodyPh': 'Write the email as it should go out…', 'tpl.chipsHelp': 'Insert claim data:', 'tpl.needName': 'Give the template a name.', 'tpl.deleteConfirm': 'Delete the template "{n}"?', 'crv.allDays': 'All days', 'crv.totalsOn': 'Decided on {d}:', 'crv.noneBy': '{n} decided nothing here.', 'crv.clearWho': 'Show everyone', 'crv.totals90': 'Decided in the last 90 days:', 'crv.totalAll': '{n} in total', 'crv.noUser': 'No user', 'crv.prevDay': 'Previous day', 'crv.nextDay': 'Next day', 'crv.jumpDay': 'Jump to a day…', 'crv.doneEmptyDay': 'No decisions on {d}.', 'att.tab': 'Attendance', 'att.p_day': 'Day', 'att.p_week': 'Week', 'att.p_month': 'Month', 'att.p_year': 'Year', 'att.today': 'Today', 'att.search': 'Search an employee…', 'att.employee': 'Employee', 'att.days': 'Days worked', 'att.late': 'Late', 'att.lateTime': 'Time late', 'att.early': 'Early', 'att.absMarked': 'Absences marked', 'att.noShow': "Didn't clock in", 'att.hours': 'Hours', 'cs.title': 'Who clocks in, and from where', 'cs.hint': 'The location sets the time zone — and the time zone decides the pay period.', 'cs.newLocation': 'New location', 'cs.locationName': 'Location name', 'cs.noLocation': '— no location —', 'cs.workdayLocal': 'works the {tz} day', 'cs.workdayOffice': 'works the US day', 'cs.workdayHint': 'Which calendar day their shift belongs to. Someone in Manila on the US day starts at 21:00 local — on the office clock that is 09:00, one single day instead of a shift split across midnight. Pay rules still come from the location.', 'cs.clockOn': 'clock ON', 'cs.clockOff': 'clock off', 'cs.cantPunch': 'cannot punch: no location', 'cs.scheduleDays': 'schedule: {n} day(s)', 'cs.noSchedule': 'no schedule', 'cs.allSet': 'Everyone can punch and has a schedule.', 'cs.onlyPending': 'Show only what needs fixing', 'cs.showAll': 'Show all ({n} already set)', 'att.worked': 'work logged', 'att.noPunch': 'no punch', 'att.workedHint': 'Time with a task running (the Working on it button). This is not the time clock and is not added to paid hours.', 'att.workedDays': '{d} day(s) with work logged', 'att.spans': '{n} span(s)', 'att.noSchedule': 'no schedule', 'att.openShift': 'still clocked in', 'att.stillIn': 'still in', 'att.lateBy': 'late {m} min', 'att.noDays': 'Nothing recorded in this period.', 'att.totDays': 'Days worked', 'att.totLate': 'Times late', 'att.totLateTime': 'Time late', 'att.totEarly': 'Times early', 'att.totAbsent': 'Days missed', 'att.hint': "Absences marked are the ones someone wrote down; “didn't clock in” are days with a schedule and no shift — counted only from the day the time clock started. Without a schedule loaded nobody can be late or absent.", 'yev.tab': 'Yearly evaluation', 'yev.search': 'Search the employee…', 'yev.pick': 'Pick an employee to see their whole year.', 'yev.since': 'measured since {d}', 'yev.noData': 'nothing recorded yet', 'yev.rank': '#{p} of {n}', 'yev.notRanked': 'not in the ranking', 'yev.attendance': 'Attendance', 'yev.absences': 'Absences', 'yev.absHint': "“Didn't clock in” is counted from the day the time clock started, not from January.", 'yev.complaints': 'Complaints', 'yev.kudos': 'Kudos', 'yev.eom': 'Employee of the Month', 'yev.approvals': 'Claim approvals', 'yev.emails': 'Emails', 'yev.calls': 'Calls', 'yev.total': 'Total', 'yev.upheld': 'Upheld', 'yev.open': 'Open', 'yev.received': 'Received', 'yev.given': 'Given', 'yev.won': 'Won', 'yev.votes': 'Votes received', 'yev.position': 'Position', 'yev.clients': 'Clients reached', 'yev.sent': 'Emails sent', 'yev.minutes': 'Talk time', 'yev.noSchedule': 'No schedule loaded — lateness and absences cannot be measured.', 'yev.aiTitle': 'AI suggestion', 'yev.aiAsk': 'Get a suggestion', 'yev.aiAgain': 'Ask again', 'yev.aiHint': 'A short read of the year for the review conversation. It is told how long each number has been measured, so it will not judge a metric we barely started tracking.', 'yev.aiOff': 'The AI is not configured on this server.', 'conTpl.title': 'Contractor email templates', 'conTpl.help': 'Each template becomes a button on every contractor. Name it "Welcome email" and a Welcome email button appears below, ready to send.', 'conTpl.new': 'New template', 'conTpl.edit': 'Edit template', 'conTpl.empty': 'No contractor templates yet — create one and its button shows up on every contractor.', 'conTpl.name': 'Name', 'conTpl.namePh': 'e.g. Welcome email', 'conTpl.nameHint': 'This is exactly what the button will say.', 'conTpl.needName': 'Give the template a name — the button uses it.', 'conTpl.deleteConfirm': 'Delete the template "{n}"? Its button disappears from every contractor.', 'conTpl.fromLabel': 'Sent from', 'conTpl.fromDefault': 'Claims — default', 'conTpl.from': 'from', 'conTpl.fromShort': 'From:', 'conTpl.bodyPh': 'Write the email as it should reach the contractor…', 'conTpl.chipsHelp': 'Insert contractor data:', 'conTpl.sendTitle': 'Send an email to this contractor', 'conTpl.to': 'To:', 'conTpl.sendNow': 'Send now', 'conTpl.sentTo': 'Sent to {n}', 'conTpl.noEmail': 'This contractor has no email on file — add one above and save before sending.', 'conTpl.lastSent': 'Last sent {d} by {n}', 'conTpl.neverSent': 'Never sent to this contractor', 'conTpl.history': '{n} emails sent to this contractor', 'tplPerm.title': 'Who can create templates', 'tplPerm.help': 'Super-managers always can. Add the teams or people who should be able to as well — no need to promote anyone.', 'tplPerm.choose': 'Choose', 'tplPerm.always': 'Super-managers (always)', 'tplPerm.none': 'Nobody else yet', 'tplPerm.teams': 'Teams', 'tplPerm.people': 'People', 'tplPerm.search': 'Search a team or a person…', 'tplPerm.readonly': 'You can read these templates but not create or edit them. Ask a super-manager for access in Settings → Templates.', 'clock.logoutIn': 'You clocked out — signing you out in {m}.', 'clock.stayIn': 'Stay signed in', 'rpa.collapse': 'Collapse', 'rpa.expand': 'Expand', 'rpa.collapseAll': 'Collapse all', 'rpa.expandAll': 'Expand all', 'smsAlert.titleBanner': '{n} texted and is waiting', 'smsAlert.titleModal': 'Reply to {n}', 'smsAlert.someone': 'A homeowner', 'smsAlert.waiting': 'waiting {m} min', 'smsAlert.reply': 'Reply', 'smsAlert.snooze': 'Later', 'smsAlert.send': 'Send reply', 'smsAlert.replyPh': 'Write your reply…', 'smsAlert.openInbox': 'Open SMS inbox', 'smsAlert.openClaim': 'Open claim', 'smsAlert.noReply': 'No reply needed', 'smsAlert.openThread': 'Open the whole conversation to reply', 'sms.noReplyBy': 'No reply needed — {n}', 'cm.tabEmail': 'Email', 'cm.tabAttendance': 'Attendance', 'em2.title': 'Emails sent', 'em2.summary': '{n} emails from {p} people', 'em2.toClients': 'to {n} clients', 'em2.empty': 'No emails in this period.', 'em2.noAuthor': '{n} with no sender', 'em2.noAuthorHelp': 'Automatic emails that were sent without a user attached. They are counted apart so the totals still match the real volume.', 'em2.backToList': 'Back to the list', 'em2.from': 'From', 'em2.to': 'To', 'bars.title': 'Activity through the day', 'fich.title': 'Time clock', 'fich.open': 'Open the time clock of this day (in, out, breaks) and correct it', 'fich.in': 'In', 'fich.out': 'Out', 'fich.breaks': 'Breaks', 'fich.noBreaks': 'none', 'fich.paid': 'Paid', 'fich.noShift': 'No shift punched this day.', 'fich.edit': 'Edit', 'fich.addBreak': 'Add break', 'fich.removeBreak': 'Remove this break', 'fich.note': 'Note (why you are changing it)', 'fich.notePh': 'e.g. forgot to clock out, was at an inspection…', 'fich.history': 'Corrections', 'fich.system': 'System', 'fich.voided': 'voided', 'fich.added': 'added', 'fich.breakStart': 'break start', 'fich.breakEnd': 'break end', 'fich.breaksCleared': 'breaks cleared', 'fich.breaksBad': 'each break needs start before end, and they cannot overlap', 'bars.active': 'active in the app', 'payd.fromFiles': 'Hours from the files', 'payd.fromFilesHint': '20 minutes before the first delivery of the day (file, email or classified item) → the last one, minus every stretch of 30+ minutes without delivering anything (app clicks do not count; calls and declared tasks do). It only fills the form: review it and save with a reason.', 'payd.fromFilesBasis': 'first {a} · last {b} · {n} files, {m} emails, {k} items', 'payd.fromFilesBreaks': '{n} break(s) with no signal', 'payd.fromFilesSkipped': 'left out, 8+ h apart: {x}', 'pay.fromFilesShort': 'from files', 'pay.inactive': 'deactivated — hours of this period still count', 'payd.periodFromFiles': 'Whole period from the files', 'payd.pfNow': 'Now', 'payd.pfProposed': 'From the files', 'payd.pfBreaks': 'Breaks', 'payd.pfBasis': 'Basis', 'payd.pfOpenDay': 'Click to see the files and classified items of this day', 'payd.pfTotals': 'Period total:', 'payd.pfTotalDays': '{n} day(s) with work', 'payd.pfTotalFiles': '{n} files', 'payd.pfTotalEmails': '{n} emails', 'payd.pfTotalItems': '{n} items classified', 'payd.pfNoFiles': 'nothing that day', 'payd.pfVoid': 'no files or emails → void {n} shift(s): did not work', 'payd.pfMultiple': '2+ shifts — fix with the pencil', 'payd.pfOtherDay': 'the work falls on another date', 'payd.pfUnchanged': 'already the same', 'payd.pfOpen': 'shift still open', 'payd.pfReasonPh': 'Why these hours are being set for the whole period…', 'payd.pfApply': 'Apply to {n} day(s)', 'payd.fromFilesNone': 'No files or emails that day — nothing to suggest.', 'bars.machine': 'machine pulse, not a person', 'bars.idle': 'clocked in, no activity', 'bars.outside': 'off the clock', 'bars.onCall': 'on the phone', 'bars.onTask': 'task running', 'bars.noPunchHint': 'No punch: the % is over their own activity window, not a shift.', 'cdw.tabHistory': 'History', 'hist.title': 'Everything that happened', 'hist.search': 'Search the history…', 'hist.clear': 'Clear filters', 'hist.empty': 'Nothing matches.', 'hist.t_etapa': 'Stage', 'hist.t_nota': 'Notes', 'hist.t_monday': 'CRM', 'hist.t_email': 'Email', 'hist.t_sms': 'SMS', 'hist.t_llamada': 'Calls', 'hist.t_archivo': 'Files', 'hist.t_estimado': 'Estimates', 'hist.t_cheque': 'Checks', 'hist.t_pago': 'Payments', 'hist.t_invoice': 'Invoices', 'hist.t_cita': 'Inspections', 'hist.t_contrato': 'Contract', 'hist.t_coc': 'COC', 'hist.t_welcome': 'Welcome call', 'ck.placeholder': 'Search everything — notes, emails, calls, files…', 'ck.hint': 'Type at least 2 letters. Claims match by name, address, claim # or contractor. From 3 letters it also searches INSIDE notes, emails, SMS, call transcripts and file names.', 'ck.none': 'Nothing found.', 'ck.claims': 'Claims', 'ck.inside': 'Found inside', 'dept.truncated': 'Showing {n} of {total} claims — the list was cut off. Narrow the view or tell Manuel.', "mbh.receiving": "receiving", "mbh.sending": "sending", "mbh.untested": "never checked", "mbh.never": "never", "mbh.agoNow": "just now", "mbh.agoMin": "{n} min ago", "mbh.agoHour": "{n} h ago", "mbh.agoDay": "{n} d ago", "mbh.checkedAgo": "checked {d}", "mbh.staleSince": "last checked {d}", "mbh.failingSince": "failing since {d}", "mbh.panelHint": "Each mailbox shows receiving (IMAP) and sending (SMTP) separately, with when it was last verified. A green badge with an old date turns grey on purpose: a check from two days ago is a memory, not a status.", "mbh.sumNotReceiving": "{n} not receiving", "mbh.sumNotSending": "{n} not sending", "mbh.sumStale": "{n} not verified recently", "mbh.sumAllOk": "all answering", "partners.wh.failedAlert": "{n} deliveries never reached the contractor ({claims} claims)", "partners.wh.failedHint": "A claim that never reached JobFlow is a claim nobody is working on. Re-send them once JobFlow accepts the match by contractor email.", "partners.wh.resendAll": "Re-send all failed", "partners.wh.resendAllConfirm": "Re-send every failed delivery to JobFlow? They are idempotent on their side, so nothing gets duplicated.", "partners.wh.filter.all": "All", "partners.wh.filter.failed": "Failed", "partners.wh.filter.pending": "Pending", "partners.wh.counts": "{ok} delivered · {failed} failed · {pending} pending", "partners.wh.none": "No deliveries for this filter.", "partners.wh.event": "Event", "partners.wh.noLead": "No lead on JobFlow's side — match by contractor email", "partners.wh.noEmail": "contractor has no email on file", "dir.emailRouting": "Where they receive our emails", "dir.emailRoutingHint": "Leave empty and they get it at the general contract email above. Change one and only that department moves — fixing the general email keeps dragging the ones you never touched.", "dir.paymentsEmail": "Payments email", "dir.paymentsEmailHint": "Payment receipts and invoices sent from the Pay Queue.", "dir.inheritingGeneral": "Inheriting the general email: {email}", "dir.customEmail": "Custom address", "dir.useGeneral": "Use the general one", "dir.noGeneralEmail": "No general email on file", "dir.noEmailAtAll": "No address: nothing will be sent to this contractor", 'em2.noSubject': '(no subject)', 'coc.notCocTitle': 'Not the COC?', 'coc.notCocHelp': "Pick what this file really is. It stays in the claim's files, but leaves the COC queue.", 'coc.notCocPick': 'Pick the right type…', 'coc.notCocBtn': 'Change type', 'coc.notCocDone': 'File moved out of COC — it is now {type}', 'coc.notCocFailed': "The type couldn't be changed", 'q.needsSupplement': 'A new insurance estimate came in — this claim needs a supplement. It stays in its own column; this is only the flag.', 'q.needsSupplementDays': 'Needs supplement · {n}d', "cm.truncated": "Showing {shown} of {total} — the list is capped at {limit}. Narrow the filter or the period to see the rest.", "inbox.errClaimNotFound": "That claim no longer exists in the system (it may have been deleted or merged). Search the claim again and pick it from the list.", "inbox.errEmailNotFound": "We could not find that email in this inbox — it may have been deleted, or it belongs to your personal mailbox, which cannot be assigned from here. Refresh the inbox and try again.", "inbox.errAssignFailed": "Something went wrong assigning the email to the claim. Refresh the inbox to see whether it went through before trying again; if it keeps failing, pass the claim number and the email subject to IT — the failure is already logged.", "inbox.errPickClaim": "Pick a claim from the list before assigning the email.", "inbox.errNotAssignedYet": "That email is not linked to a claim yet. Assign it to a claim first and the attachments will follow.", "supd.whoDidThem": "Who did them", "supd.clickName": "click a name to see the detail", "supd.followupsBy": "Follow-ups by", "supd.open": "Open", "supd.nothingHere": "Nothing to show", "supd.loadError": "Could not load the detail", "supd.hintTodayCard": "Counts work sessions finished and estimates uploaded on the selected day (one per claim).", "supd.hintDoneCard": "Counts our uploaded estimate files — a different source than the daily card above, so the numbers will not match.", 'eh.coverage': 'Only {p}% of inbound email is being archived', 'eh.rawNoData': 'no data — nothing archived', 'nav.risk': 'Risk', 'risk.chipRed': 'At risk', 'risk.chipYellow': 'Needs attention', 'risk.title': 'At-risk claims', 'risk.sub': 'What is NOT being done. Every other queue shows what to do; an abandoned claim shows up in none of them.', 'risk.red': 'Red', 'risk.yellow': 'Yellow', 'risk.green': 'OK', 'risk.live': 'Live claims', 'risk.empty': 'Nothing at risk. Enjoy it.', 'risk.s_silencio': 'Silent', 'risk.s_email_sin_responder': 'Email unanswered', 'risk.s_sms_sin_responder': 'SMS unanswered', 'risk.s_etapa_estancada': 'Stuck in stage',
    'risk.s_amenaza_legal': 'Legal threat', 'risk.help_amenaza_legal': 'The homeowner mentioned a lawyer, attorney, lawsuit or legal action in an SMS or email, or a monitored call was flagged as a legal issue (last 60 days). It does not switch off by replying: dismiss it when a manager has handled it.', 'risk.quiet5': 'No updates 5+ days', 'risk.s_amenaza_cancelar': 'Threatened to cancel', 'risk.s_queja_abierta': 'Open complaint', 'risk.s_coc_vencido': 'COC overdue',
    'risk.s_contractor_sin_respuesta': 'Contractor unanswered', 'risk.s_cheque_no_llega': 'Expected check missing', 'risk.s_followup_vencido_manager': 'Follow-up past manager alert', 'risk.s_cita_reagendada': 'Appointment rescheduled', 'risk.s_welcome_call_pendiente': 'Welcome call waiting', 'risk.s_reclamo_sin_filear': 'Claim not filed', 'risk.s_payment_auth_demorada': 'Payment authorization stalled',
    'risk.help_contractor_sin_respuesta': 'The contractor wrote in the Contractor Inbox and nobody answered', 'risk.help_cheque_no_llega': 'A check has been expected since a date and none has arrived', 'risk.help_followup_vencido_manager': 'A department follow-up is so overdue it already triggered the manager alert', 'risk.help_cita_reagendada': 'The inspection was rescheduled several times (here the threshold is TIMES, not days)', 'risk.help_welcome_call_pendiente': 'The welcome call is still not done after N days in the queue', 'risk.help_reclamo_sin_filear': 'Contract signed but the claim has not been filed with the insurance (pre-file stages only)', 'risk.help_payment_auth_demorada': 'The payment authorization was requested and the homeowner has not responded',
    'risk.tab': 'Risk score', 'risk.settingsTitle': 'Risk score — signals and points', 'risk.settingsHelp': 'These signals build the 0–100 score of the risk board (/risk) and the claim card. Weight = points the signal adds (the score caps at 100). Days = minimum days for the signal to fire (for "Threatened to cancel" it is the look-back window). Changes apply immediately — no deploy needed.',
    'risk.colSignal': 'Signal', 'risk.colWeight': 'Points', 'risk.colThreshold': 'Days', 'risk.colActive': 'Active', 'risk.scalesWithDays': 'grows with the days until it hits its cap',
    'risk.addPh': 'Add a signal from the system…', 'risk.addBtn': 'Add', 'risk.saved': '✓ Saved — the board recalculates on the next load',
    'risk.configBtn': 'Configure score', 'risk.editorsTitle': 'Who can configure this', 'risk.editorsHint': 'They can open this panel, change points/days and grant access to others. The master (★) always can.',
    'risk.ev.title': 'Each signal, one by one — what fired it and what to do about it.', 'risk.ev.openClaim': 'Open claim', 'risk.ev.listen': 'Listen to the call', 'risk.ev.summary': 'Call summary', 'risk.ev.reply': 'Reply', 'risk.ev.replyPh': 'Type an SMS reply…', 'risk.ev.sent': '✓ Reply sent', 'risk.ev.openMail': 'Open the claim to answer this email', 'risk.ev.lastFollowUp': 'Last follow-up', 'risk.ev.overdue': 'overdue {d}d', 'risk.ev.lastActivity': 'Last activity on the file', 'risk.ev.waitingDays': 'Waiting {d} days in the welcome-call queue', 'risk.ev.since': 'Expected since', 'risk.ev.signedOn': 'Contract signed on', 'risk.ev.requestedOn': 'Authorization requested on', 'risk.ev.cocDays': 'COC waiting {d} days to be sent', 'risk.ev.noDetail': 'No extra detail for this signal.', 'risk.ev.assign': 'Assign as a task', 'risk.ev.assignTo': 'Team or person…', 'risk.ev.people': 'People', 'risk.ev.notePh': 'Note for the assignee (what exactly to do)…', 'risk.ev.assignBtn': 'Assign task', 'risk.ev.assigned': '✓ Task assigned to {name} — it shows in their To Do with the claim linked.', 'risk.ev.emailBtn': 'Email about this', 'risk.ev.smsBtn': 'Text the homeowner', 'risk.ev.contactSent': '✓ Sent — answering turns this signal off and the score drops on the next reload.', 'risk.ev.contactHint': 'Answering from here counts: this signal turns off and the score drops.', 'risk.ev.noPhone': 'This claim has no phone on file.', 'risk.ev.dismiss': 'Nothing to do here — dismiss', 'risk.ev.dismissed': '✓ Dismissed — the score drops on the next reload. New evidence turns it back on by itself.', 'risk.ev.dismissWhy': 'Why is there nothing to do? (e.g. the call was misread, this message needs no reply)',
    'risk.levelsHelp': 'Levels: 0–29 green · 30–59 yellow · 60+ red. "Stuck in stage" fires when the claim doubles the typical time (p75) of its own stage — that baseline recalculates itself from the portfolio.',
    'risk.help_silencio': 'Nobody touched the file (no messages, emails, SMS, files or stage changes)', 'risk.help_email_sin_responder': 'The client emailed and nobody replied', 'risk.help_sms_sin_responder': 'The client texted and nobody replied', 'risk.help_etapa_estancada': 'Sitting in its stage far longer than its peers', 'risk.help_amenaza_cancelar': 'A monitored call flagged anger/threat, or the client asked to CANCEL by SMS or email (literal text; thumbs-down alerts don\'t count)', 'risk.help_queja_abierta': 'There is an open complaint tied to this claim', 'risk.help_coc_vencido': 'The COC is in the queue and has not been sent', 'sh.title': 'Failed silently', 'sh.times': 'times', 'sh.d1': 'Today', 'sh.d7': 'Last 7 days', 'sh.d30': 'Last 30 days', 'sh.empty': 'Nothing failed silently in this period.', 'sh.help': 'Errors the code swallows so they do not break the request. They are real failures — a module can be down for hours and everything still looks fine.', 'sh.days': 'on {n} days', 'sh.detail': 'Detail', 'sh.dismiss': 'Dismiss', 'sh.dismissConfirm': 'Dismiss this failure? If it happens again it comes back.', 'sh.since': 'since', 'bars.modeDay': 'Day', 'bars.modeWeek': 'Week', 'bars.empty': 'Nobody clocked in or used the app that day.', 'bars.callTotal': '{h} on calls today', 'bars.callTotalWeek': '{h} on calls this week', 'bars.callTime': 'Time on the phone this day (RingCentral)', 'mbd.title': 'Department mailboxes', 'mbd.hint': 'payments@, supplements@, claims@ — mail lands in the Department Inbox, not in one person\u2019s inbox. Load the password once and it comes in by IMAP, with no provider in between.', 'mbd.notSet': 'not configured', 'mbd.password': 'Password', 'mbd.hasPassword': 'saved', 'mbd.test': 'Test', 'mbd.testOk': 'Receiving and sending OK', 'mbd.syncNow': 'Sync now', 'mbd.synced': '{n} new email(s)', 'mbd.syncedShort': 'Synced', 'mbd.groupPa': 'PA mailboxes (what the office writes from)', 'mbd.groupDept': 'Department mailboxes', 'mbd.remove': 'Remove', 'mbd.removed': 'Removed', 'mbd.removeAsk': 'Remove the {n} mailbox? It stops being polled. The emails already downloaded stay.', 'bars.delivered': 'Work delivered this day — a purple gap with deliveries is work done outside the CRM', 'bars.artSketch': 'sketches', 'bars.artSketch1': 'sketch', 'bars.artEstimate': 'estimates', 'bars.artEstimate1': 'estimate', 'bars.rawFiles': 'files', 'bars.noDeliveries': 'Nothing uploaded this day.', 'bars.classifiedHint': 'Catalog items classified this day in Price lists → Items. Work done inside the CRM, so it does not count as delivered.', 'bars.classifiedList': 'Items classified', 'bars.openItem': 'Open in Price lists → Items', 'payd.actItems': 'Items classified', 'bars.openFile': 'Open the file', 'bars.unnamedFile': '(no name)', 'bars.fromEmailShort': 'from email', 'bars.fromEmail': 'Archived from email — work done inside the CRM, so it does not count as delivered', 'bars.fakeActivity': 'Nobody was touching the app in these 15 minutes: the only signal is an open tab checking in on its own every 5 minutes. It does not count as worked time — and it is NOT proof of anything the person did. Leaving a tab open is not faking activity.', 'bars.disclaimer': 'Green is activity IN THE APP and blue is time on the phone, from the RingCentral call log. What still does not show up is work that leaves no digital trace — an inspection, a meeting, reading a PDF in another tab — so purple is not proof of idle time. Use it to see the shape of the day, not to judge a single gap.', 'eom.email': 'Email', 'eom.emailHelp': 'Points for emails sent this month, counted by DISTINCT client (not per send) and capped — otherwise whoever writes the most always wins and kudos stop mattering. The number in brackets is how many clients.',  'inbox.selectAll': 'Select all', 'inbox.bulkClose': 'Close', 'inbox.bulkReopen': 'Reopen', 'inbox.bulkTrash': 'Move to trash', 'inbox.bulkTrashConfirm': 'Move {n} conversations to trash?', 'inbox.vTrash': 'Trash', 'inbox.trash': 'Trash', 'inbox.restore': 'Restore', 'inbox.close': 'Close', 'inbox.reopen': 'Reopen', 'inbox.resolvedBy': 'Resolved by', 'inbox.mentionHint': 'Type @ to tag a teammate — they get a notification + a direct message with a link.', 'inbox.notesNotForMailbox': 'Emails from your personal mailbox have no internal notes — they live in your own inbox, not in the shared one. Assign the email to a claim to discuss it with the team.', 'inbox.mailboxNoAssign': 'This email lives in your personal mailbox, so it cannot be assigned to a claim, a person or a team from here.', 'inbox.pickClaim': 'Pick the claim this email is for:', 'inbox.changeClaim': 'Change claim', 'inbox.pickClaims': 'Add the homeowners this email is for (you can add several):', 'inbox.addAnotherClaim': 'Add another homeowner…', 'inbox.primaryClaim': 'Primary (reply-to)', 'inbox.composeFor': 'Compose email for {n} homeowner(s)', 'inbox.dropAttach': 'Drop a file to attach', 'inbox.attachFromClaim': 'Attach from claim files', 'inbox.attachToClaim': 'Attach to claim', 'inbox.attachOne': 'Attach', 'inbox.attachAll': 'Attach all', 'inbox.attached': 'In claim files', 'inbox.decision': 'Estimate decision', 'inbox.decApproved': 'Approved', 'inbox.decApprovedRepair': 'Approved for repair',
    'em.sent': 'Sent',
    'em.noHistory': 'No emails yet with this recipient.',
    'em.from': 'From',
    'em.to': 'To',
    'em.by': 'Sent by',
    'em.tName': 'Name',
    'em.tAddress': 'Address',
    'em.tContractor': 'Contractor',
    'em.tRcv': 'RCV',
    'em.tClaim': 'Claim #',
    'em.tInsurance': 'Insurance',
    'em.attachSupplement': 'Attach supplement estimate',
    'em.attachInsurance': 'Attach insurance estimate',
    'em.history': 'Email history',
    // Hilo de correos unificado (components/email/EmailThread, 2026-09-02).
    'et.new': 'New email', 'et.reply': 'Reply', 'et.orphanReply': 'Reply — the email it answers is not in this list (another tab, or it never reached the claim)',
    'et.replyBtn': 'Reply to this email', 'et.replyingTo': 'Replying to {who} · {when} — the email will go out in that same conversation.', 'et.cancelReply': 'Cancel reply',
    'et.inReplyTo': 'In reply to {who} · {when}', 'et.original': 'Opened this conversation',
    'et.msgs': '{n} emails', 'et.noSubject': '(no subject)',
    'et.expandAll': 'Expand all', 'et.collapseAll': 'Collapse all', 'et.maximize': 'Full screen', 'et.minimize': 'Exit full screen',
    'et.newestFirst': 'Newest first', 'et.oldestFirst': 'Oldest first',
    'et.sent': 'Sent', 'et.received': 'Received', 'et.staff': 'Proactive staff',
    'et.from': 'From', 'et.to': 'To', 'et.cc': 'Cc', 'et.moreRecipients': '+{n} more',
    'et.delivered': 'Delivered', 'et.opened': 'Opened', 'et.notOpened': 'Not opened yet', 'et.clicked': 'Link clicked',
    'et.trackHint': 'Delivery tracking: sent → delivered → opened → link clicked',
    'et.justNow': 'just now', 'et.ago_min': '{n} min ago', 'et.ago_hour': '{n} h ago', 'et.ago_day': '{n} d ago', 'et.ago_week': '{n} wk ago', 'et.ago_month': '{n} mo ago', 'et.ago_year': '{n} yr ago',
    'et.attachments': '{n} attachment(s)', 'et.loadFailed': 'Could not load the emails.',
    'em.communication': 'Email communication',
    'em.attachFile': 'Attach a file',
    'tplp.count': '{n} templates',
    'tplp.search': 'Search a template…',
    'tplp.noMatch': 'No template matches that search.',
    'tplp.hint': 'Click a template to fill in the subject and the message.',
    'att.title': 'Attach files from this claim',
    'att.count': '{n} files',
    'att.searchPh': 'Search by name, type, invoice, who uploaded…',
    'att.noMatch': 'Nothing matches that search.',
    'att.footHint': 'Pick one or several — the amount is on the right, with the date and who uploaded it.',
    'att.selected': '{n} selected',
    'att.attachOne': 'Attach',
    'att.attachN': 'Attach {n} files',
    'att.select': 'Select',
    'att.already': 'Already attached',
    'att.preview': 'Preview the file',
    'att.by': 'by {name}',
    'att.fromEmail': 'from an email',
    'att.fromJobflow': 'from JobFlow',
    'att.generated': 'generated by the system',
    'att.voided': 'Voided',
    'att.contractorInvoice': 'Contractor invoice',
    'att.gProactive': 'Proactive estimates',
    'att.gInsurance': 'Insurance estimates',
    'att.gInvoices': 'Invoices',
    'att.gContracts': 'Contracts / LOR',
    'att.gChecks': 'Checks & payments',
    'att.gCoc': 'COC',
    'att.gPolicy': 'Policy',
    'att.gPhotos': 'Photos',
    'att.gAtr': 'ATR / videos',
    'att.gOther': 'Other documents',
    'em.uploadDoc': 'Upload / drop a document (AI reads it)',
    'em.pickAdjuster': 'Use an adjuster email',
    'em.noFiles': 'No files to attach yet',
    'em.kindEsx': 'Xactimate (.ESX)',
    'em.kindProactive': 'Proactive estimate',
    'em.kindInsurance': 'Insurance estimate',
    'em.kindInvoice': 'Invoice',
    'em.kindDoc': 'Document',
    'em.uploaded': 'Uploaded — available to attach',
    'sup.estimateSaved': 'Estimate saved — send when ready',
    'sup.uploadFirst': 'Upload the estimate first',
    'sup.attachNote': 'Only the estimate is attached (not the roof diagram).',
    'sup.assignEstimator': '— Assign estimator (round-robin) —',
    'sup.peShort': 'Proactive Estimate',
    'sup.peNone': 'No estimate uploaded yet.',
    'sup.peUpload': '⬆ Upload our first estimate (PDF)',
    'sup.peReplace': '⬆ Replace estimate (PDF)',
    'sup.peReading': 'Reading the estimate…',
    'sup.peSaved': 'Saved as Proactive Estimate',
    'sup.sendInsurance': '✉ Email to insurance',
    'sup.sendConfirm': 'Email this estimate to the insurance company?',
    'sup.sentTo': 'Sent to',
    'sup.noEmail': 'This insurance has no communications email — add it in Directory → Insurance.',
    'sup.noEmailShort': 'No insurance email set',
    'sup.noPe': 'Upload the estimate first.',
    'sup.waitingFor': 'Waiting for',
    'sup.fuSaved': '✓ Follow-up saved.',
    'sup.fuSave': 'Log follow-up',
    'sup.fuNotePh': 'Follow-up note…',
    'sup.lastFu': 'Last',
    'sup.nextFu': 'Next',
    'sup.fuHistory': 'Follow-up history',
    'sup.fuNone': 'No follow-ups yet with this client.',
    'sup.due': 'DUE',
    'sup.insUpload': '⬆ Upload insurance estimate',
    'sup.insReplace': '⬆ Replace insurance estimate',
    'sup.insUploaded': '✓ Insurance estimate uploaded (parsing).',
    'sup.preApprovedPrompt': 'What are we waiting for? (e.g. paid when photos are sent)',
    'sup.movedPreApproved': '✓ Moved to Pre-approved.',
    'sup.resolved2': 'Resolved',
    'sup.resolvedConfirm': 'Mark this supplement as resolved?',
    'sup.movedResolved': '✓ Moved to Supplement Resolved.',
    'sup.agreeQuestion': "Agree with the carrier's estimate? Close it here",
    'sup.btnResolved': 'Supplement Resolved',
    'sup.btnPreApproved': 'Supplement Pre-approved',
    'sup.resolveConfirm': "Mark as Resolved? We agree with the carrier's estimate and there is nothing to answer. The insurance estimate is marked as resolved, the claim leaves Review Estimate and goes to Waiting Project Completion.",
    'sup.preApprovePrompt': 'What is the carrier pre-approving? (e.g. "roof + gutters approved, waiting on photos")',
    'sup.initialApproval': 'Initial approval',
    'sup.lastApproved': 'Last approved',
    'sup.increment': 'Increment (gain)',
    'sup.daysToClose': 'days',
    'sup.noOutcome': 'No estimate amounts captured yet.',
    'pa.tab': 'Public Adjuster',
    'pa.title': 'Public Adjusters',
    'pa.hint': 'Individual PAs. Assign one to a claim team (Teams → Claims) — that team\'s members become the PA\'s assistants, and the PA name auto-fills the contract for signature.',
    'pa.add': 'New PA',
    'pa.name': 'Name',
    'pa.employee': 'Employee',
    'pa.license': 'License #',
    'pa.licensesTitle': 'Licenses by state',
    'pa.licensesHint': 'Add a license per state. A claim from a state where this PA has no license will not be auto-assigned to this PA or their claim teams.',
    'pa.addLicense': 'Add state license', 'pa.viewFile': 'View', 'pa.uploadFile': 'License file', 'pa.pickStateFirst': 'pick state',
    'pa.contractEmail': 'Email for contracts',
    'pa.contractEmailHint': 'Same central email for everyone — change only if it differs.',
    'pa.phone': 'Phone',
    'pa.email': 'Email',
    'pa.empty': 'No public adjusters yet.',
    'pa.deleteConfirm': 'Delete this public adjuster?',
    'dteam.slot.payments': 'Payments',
    'dteam.slot.supplements': 'Supplements',
    'dteam.slotEmpty': '— nobody yet —',
    'dteam.slotFallback': 'while empty, the account manager covers it',
    'dteam.slotReassigned': '{n} claims in Payments were re-assigned.',
    'dteam.slotAddPerson': '+ Add person',
    'dteam.slotRemove': 'Remove from this position',
    'dteam.slotShared.payments': 'Several people: the team\'s claims are split evenly among them. Each claim keeps one owner.',
    'dteam.slotShared.supplements': 'Several people: they all work the team\'s supplements together.',
    'dteam.pa': 'Public Adjuster',
    'dteam.noPa': '— No PA —',
    'dteam.paEmpty': 'Add PAs in the Public Adjuster tab first.',
    'dir.phones': 'Phones (comma separated)',
    'dir.deprDays': 'Depreciation recovery deadline (days)',
    'depr.title': 'Depreciation deadlines approaching',
    'depr.left': '{d}d left',
    'depr.overdue': 'Overdue {d}d',
    'comms.all': 'All',
    'comms.homeowner': 'Homeowner',
    'comms.contractor': 'Contractor',
    'comms.insurance': 'Insurance',
    'comms.empty': 'No messages yet.',
    'comms.loadFailed': 'The history could not be loaded — this is not an empty claim.',
    'comms.pickToSend': 'Pick a recipient (Homeowner / Contractor / Insurance) to send a new message.',
    'comms.to': 'To (email)',
    'comms.phone': 'To (phone)',
    'comms.subject': 'Subject',
    'comms.addCc': 'Add CC / BCC', 'comms.cc': 'CC (they see each other)', 'comms.bcc': 'BCC (hidden from the others)', 'comms.uploadNew': 'Upload from my computer…', 'comms.uploading': 'Uploading…', 'comms.preview': 'Preview the file', 'comms.attachToEmail': 'Attach to email',
    'comms.attach': 'Attach', 'comms.mmsHint': 'Goes as MMS — carriers cut off large files.',
    'comms.message': 'Message…',
    'cdt.status': 'Department status',
    'cdt.team': 'Claim team (this department)',
    'cdt.assignedTeam': 'Assigned team (estimator)',
    'cdt.uploadFiles': 'Upload files',
    'cdt.uploadFilesHelp': 'Drop or pick any document — AI reads it, classifies it, and files it in the claim.',
    'cdt.uploadDrop': 'Upload / drop a document',
    'cdt.fileClassified': 'File read, classified & filed',
    'cdt.fileDoc': 'Document',
    'cdt.noAssignedTeam': 'No team assigned yet.',
    'cdt.reassign': 'Reassign team',
    'chat.general': 'General chat',
    'chat.deptUpdates': 'Department updates',
    'chat.all': 'All',
    'chat.empty': 'No messages yet.',
    'chat.write': 'Write an update…',
    'chat.like': 'Like', 'chat.reply': 'Reply', 'chat.replyPh': 'Write a reply…', 'chat.seeMore': 'See more', 'chat.seeLess': 'See less', 'chat.kudos': 'Kudos',
    'chat.downloadAll': 'Download all files', 'chat.clickToOpen': 'Click to open',
    'chat.replyPlaceholder': 'Write a reply and mention others with @', 'chat.seenBy': 'Seen by',
    'chat.showEmail': 'View full email', 'chat.hideEmail': 'Hide email', 'chat.emailErr': 'Could not load the email.',
    'chat.postTo': 'Post to channel',
    'chat.willPost': 'Will also post to:',
    'hero.claimStatus': 'Claim status', 'hero.paymentsStatus': 'Payments status', 'hero.inSystem': 'In system',
    'hero.daysIn': '{d}d in this stage',
    'hero.approved': 'Approved',
    'hero.approvedRepair': 'Approved for repair',
    'hero.denied': 'Denied',
    'hero.hold': 'Hold',
    'hero.cancel': 'Cancel',
    'hero.cancelConfirm': 'Cancel this claim? It will move to Claim CANCELLED.',
    'hero.holdReason': 'Request to put this claim on HOLD (needs Super Manager approval). Reason:',
    'hero.cancelReason': 'Request to CANCEL this claim (needs Super Manager approval). Reason:',
    'hero.reqSent': 'Request sent to Super Manager',
    'twin.title': 'This client has {n} other claim record — check it before adding money here',
    'twin.holds': 'has {inv} invoice(s) · {chk} check(s) · {pay} payment(s)',
    'twin.empty': 'no invoices or checks',
    'twin.archived': 'archived',
    'twin.active': 'active',
    'twin.byNumber': 'same claim number',
    'twin.byAddress': 'same owner and address',
    'hero.reqError': 'Could not send the request.',
    'sup.createSupplement': 'Supplement sent → Supplementing',
    'sup.sendToReview': 'Send to review',
    'sup.sentToReview': 'Sent to Review Estimate',
    'sup.movedSupplementing': '✓ Moved to Supplementing.',
    'cd.claimType': 'Type of loss',
    'cd.policyDrop': 'Drag the policy PDF here or click to upload',
    'fuo.title': 'Follow-ups overdue',
    'fuo.never': 'No update yet',
    'fuo.daysAgo': 'last {d}d ago',
    'fuo.every': 'every {d}d',
    'dir.howToWork': 'How to work with this insurer',
    'dir.tricks': 'Tricks / internal notes',
    'dir.searchCon': 'Search contractor…',
    'dir.newCon': '+ New contractor',
    'dir.contractorsCount': '{n} contractors',
    'dir.pickCon': 'Pick a contractor (or create one).',
    'dir.feeRate': 'Fee rate (%)',
    'dir.roundRobin': 'Round-robin (spread this contractor’s claims)',
    'dir.rrNone': 'No round-robin — use the default team',
    'dir.rrTeams': '{n} teams',
    'dir.rrHint': 'Every claim from this contractor goes to the default team above.',
    'dir.rrOnHint': 'Claims from this contractor rotate through the teams in this round-robin, each with its own PA. The default team above is ignored while this is set.',
    'dir.defaultTeam': 'Default team (cascades to claim)',
    'dir.none': '— None —',
    'dir.pricingNotes': 'Pricing notes (sensitive)',
    'dir.contractSection': 'Contract (fee & PA)',
    'dir.matchEmail': 'Contractor email (match key from intake form)',
    'dir.feePct': 'Fee % (PA contract)',
    'dir.billingFeePct': 'Fee % we charge',
    'dir.billingFeeHint': 'What Proactive bills on this contractor’s claims — the default for every new claim of theirs. Not the same as the PA contract %: the difference is the contractor’s share.',
    'cf.title': 'Contractor fee invoice',
    'cf.newBtn': '+ Contractor fee',
    'cf.help': 'Pays the contractor their share of the claim fee (the 5 or 7 points between the PA contract % and what we charge). Pick the contractor — it does not have to be the one on the claim.',
    'cf.badge': 'Contractor fee',
    'cf.badgeHelp': 'Paid by Proactive to the contractor. No insurance check behind it and no homeowner authorization needed.',
    'cf.contractor': 'Contractor',
    'cf.contractPct': 'PA contract',
    'cf.billingPct': 'We charge',
    'cf.sharePct': 'Their share',
    'cf.rcv': 'RCV approved ($)',
    'cf.feePct': 'Fee % to pay',
    'cf.modoPct': 'Percentage of RCV',
    'cf.modoFlat': 'Flat amount',
    'cf.flat': 'Amount to pay ($)',
    'cf.flatSeExcede': 'The flat amount cannot exceed the approved RCV.',
    'cf.amount': 'Amount to pay:',
    'cf.create': 'Create invoice',
    'paybl.no_check_on_claim': 'this claim has no check to pay from. Add the check first, or use a contractor fee / adjustment invoice, which needs none.',
    'paybl.check_bounced': 'the claim’s check BOUNCED — chase another one.',
    'paybl.check_not_found': 'the check on the payment no longer exists.',
    'paybl.ho_authorization_required': 'paying the contractor needs the homeowner’s authorization. Request it, or a super-manager can bypass it with a reason.',
    'paybl.payment_amount_mismatch': 'the amount does not match the invoice payable. Reload the page.',
    'paybl.invoice_not_found': 'the invoice no longer exists.',
    'paybl.forbidden': 'only a manager or above can authorize a payment.',
    'paybl.bypass_requires_super_manager': 'only a super-manager can pay without the homeowner’s authorization.',
    'paybl.bypass_reason_required': 'the bypass needs a reason.',
    'paybl.check_not_available': 'the bank has not cleared the check yet.',
    'paybl.authorization_not_confirmed': 'the homeowner’s authorization is not confirmed yet.',
    'paybl.proof_required': 'attach the payment proof first.',
    'paybl.verification_not_passed': 'the proof did not pass verification.',
    'paybl.already_paid': 'this payment was already sent.',
    'dir.rcvPct': 'RCV %',
    'dir.acvPct': 'ACV %',
    'dir.paName': 'PA name',
    'dir.paLicense': 'PA license #',
    'dir.paPhone': 'PA phone',
    'dir.paEmail': 'PA email',
    'dir.contractorsDenied': 'Only super-manager can see the contractors directory.',
    'teams.newPh': 'New team name…',
    'teams.create': 'Create team',
    'teams.empty': 'No teams yet. Create the first one.',
    'teams.delete': 'Delete',
    'teams.noMembers': 'No members.',
    'teams.addMember': 'Add member…',
    'teams.add': 'Add',
    'teams.confirmDelete': 'Delete this team?',
    'teams.deletedEmailsUnassigned': 'Team deleted. {n} email(s) assigned to it went back to unassigned.',
    'teams.deleteFailed': "Couldn't delete the team.",
    'teams.denied': 'Only super-manager can manage teams.',
    'role.accountManager': 'Account Manager',
    'role.assistant': 'Assistant',
    'role.pa': 'PA',
    'insp.help': 'Mark who does inspections, their capacity and home (geocoded). The scheduling engine uses this.',
    'insp.user': 'User',
    'insp.isInspector': 'Inspector',
    'insp.maxDay': 'Max/day',
    'insp.payType': 'Pay type',
    'insp.payRate': 'Rate ($)',
    'insp.tripFee': 'Trip fee ($)',
    'insp.perDay': 'Per day',
    'insp.perInspection': 'Per inspection',
    'insp.home': 'Home',
    'insp.homeSet': '✓ set — change…',
    'insp.homePh': 'Home address…',
    'insp.denied': 'Only super-manager.',
    'insp.fieldTitle': 'Field inspectors',
    'insp.hi': 'Hi',
    'insp.onSchedule': 'On schedule',
    'insp.inProgress': 'In progress',
    'insp.job': 'job',
    'insp.today': 'Today',
    'insp.tomorrow': 'Tomorrow',
    'insp.noToday': 'No appointments today.',
    'insp.noTomorrow': 'Nothing scheduled tomorrow.',
    'insp.inspections': 'inspections',
    'insp.workMiles': 'work miles',
    'insp.timeOff': 'Time off',
    'insp.push.title': 'Notifications',
    'insp.push.enable': 'Turn on notifications',
    'insp.push.on': 'Notifications ON',
    'insp.push.test': 'Send test',
    'insp.push.testSent': '✓ Test sent — check your phone',
    'insp.push.testFail': 'Test failed — try again',
    'insp.push.denied': 'Blocked in your browser — allow notifications for this site in browser settings.',
    'insp.push.iosHint': 'On iPhone: first add this app to your Home Screen (Share → Add to Home Screen), then open it from there to enable notifications.',
    'insp.mapsApp': 'Maps app',
    'insp.language': 'Language',
    'insp.logout': 'Log out',
    'insp.tab.day': 'My day',
    'insp.tab.schedule': 'Schedule',
    'insp.tab.uploads': 'Uploads',
    'insp.tab.messages': 'Messages',
    'insp.tab.profile': 'Profile',
    'insp.fieldHelp': 'All scheduling inspectors (including imported ones that are not app users). Set their home address so the engine can score proximity and draw drive-time windows.',
    'insp.startsFromOffice': 'Starts from office (company car)',
    'insp.startsFromOfficeHelp': 'When on, the daily route starts from the office instead of this inspector’s home (they drive a company vehicle).',
    'insp.officeTitle': 'Office — route start',
    'insp.officeHelp': 'Company office address. Used as the route start for inspectors marked “starts from office”. Pick a Google suggestion to verify it.',
    'insp.imported': 'imported',
    'insp.timeOffTitle': 'Time off',
    'insp.timeOffHelp': 'Mark days an inspector is unavailable. The scheduling engine excludes those days from recommendations and green windows.',
    'insp.pickInspector': 'Inspector…',
    'insp.reasonPh': 'Reason (optional)',
    'insp.addTimeOff': 'Add time off',
    'insp.noTimeOff': 'No time off scheduled.',
    'insp.workingDays': 'Working days',
    'insp.saveDays': 'Save days',
    'insp.payTitle': 'Users — inspector flag & pay (payroll)',
    'insp.addInspector': 'Add inspector',
    'insp.addNamePh': 'Inspector name…',
    'insp.terminate': 'Terminate',
    'insp.terminateConfirm': 'Terminate {name}? Their upcoming inspections will be reassigned to the other inspectors, and they will be deactivated.',
    'insp.terminatedOk': 'Inspector terminated. {n} upcoming inspection(s) reassigned.',
    'insp.terminateFail': 'Could not terminate.',
    'insp.terminatedList': 'Terminated / inactive',
    'insp.reactivate': 'Reactivate',
    'day.mon': 'Mon', 'day.tue': 'Tue', 'day.wed': 'Wed', 'day.thu': 'Thu', 'day.fri': 'Fri', 'day.sat': 'Sat', 'day.sun': 'Sun',
    'intake.none': 'No pending submissions.',
    'intk.formTitle': 'Intake form',
    'intk.questionsTitle': 'Intake questions', 'intk.missing': 'Missing', 'intk.missingHint': 'This lead was not filled through the intake form. Complete the questions and remember the welcome call after acceptance.',
    'intk.submittedOn': 'Submitted',
    'intk.viewFilled': 'View filled form',
    'intk.copyLink': 'Copy link',
    'intk.copied': 'Copied',
    'intk.sendHint': 'Send this link to the homeowner — it shows the same form with their answers and the date they submitted it.',
    'intk.showAnswers': 'Show answers',
    'intake.formLink': 'Public intake form link',
    'intake.formLinkHint': 'Share this link or add it as a button on your website. Anyone who submits it becomes a lead and gets the contract.',
    'intake.copy': 'Copy link',
    'intake.copied': 'Copied',
    'intake.openForm': 'Open form',
    'intake.approve': 'Approve',
    'intake.reject': 'Reject',
    'sched.none': 'No upcoming appointments. Book them from a claim.',
    'sched.viewClaim': 'View claim →',
    'sched.noDate': 'No date',
    'claims.viewList': 'List',
    'claims.viewCard': 'Cards',
    'claims.noPhoto': 'No photo',
    // Módulo COC (Certificate of Completion)
    'coc.tab': 'COC',
    'coc.stNotUploaded': 'Not Uploaded',
    'coc.stUploaded': 'Uploaded',
    'coc.stSent': 'Sent',
    'coc.badgeCoc': 'COC',
    'coc.trkReceived': 'COC received', 'coc.trkSent': 'Sent to insurance', 'coc.trkAck': 'Acknowledged by insurance', 'coc.trkAckBy': 'marked by', 'coc.trkMarkAck': 'Mark acknowledged', 'coc.trkUnack': 'Undo acknowledge',
    'coc.badgePhotos': 'Photos',
    'coc.uploadTitle': 'Certificate of Completion',
    'coc.uploadBtn': '⬆ Upload COC',
    'coc.uploading': 'Uploading…',
    'coc.viewFile': 'View file',
    'coc.removeFile': 'Remove file', 'coc.removeHelp': 'Take this file out of the COC. It is archived, not deleted (Files → Archived).', 'coc.removeConfirm': 'Remove "{name}" from the COC? The file goes to Archived and the claim leaves the COC queue.', 'coc.removedDone': 'File removed from the COC — it is in Files → Archived.',
    'coc.photosTitle': 'Job photos link',
    'coc.photosPlaceholder': 'https:// (Drive / Dropbox / CompanyCam)',
    'coc.deptFollowUp': 'Claims follow-up',
    'coc.photosChip': 'Photos link',
    'coc.photosSave': 'Save link',
    'coc.photosUpload': 'or drag the photos here to upload them',
    'coc.willAttachPhotos': '{n} photo(s) attached',
    'coc.photosOpen': 'Open photos',
    'coc.aiTitle': 'AI check — completion amount vs latest insurance amount',
    'coc.aiHelp': 'Claude reads the completion amount off the COC. Confirm it (or correct it) before sending.',
    'coc.cocAmount': 'COC amount',
    'coc.rcvApproved': 'Approved RCV',
    'coc.latestInsurance': 'Latest insurance amount',
    'coc.fromInsEstimate': 'from the latest insurance estimate',
    'coc.fromClaimField': "from the claim's RCV field — no insurance estimate on file",
    'coc.inQueue': 'In the Claims → COC queue since',
    'coc.amountMatch': '✓ Amounts match',
    'coc.amountMismatch': '⚠ Mismatch — COC differs from the insurance amount',
    'coc.amountMissing': 'No amount read from the COC — enter it manually.',
    'coc.extracted': 'read by AI',
    'coc.confirmed': 'confirmed',
    'coc.confirmBtn': 'Confirm amount',
    'coc.editBtn': '✎ Edit',
    'coc.saveBtn': 'Save',
    'coc.cancelBtn': 'Cancel',
    'coc.genTitle': 'Generate COC',
    'coc.genHelp': 'Landscape certificate for the insurance company: homeowner, contractor, build date and where to send the checks. It is saved in Files as the COC of this claim.',
    'coc.genWithAmount': 'Generate with amount',
    'coc.genWithoutAmount': 'Generate without amount',
    'coc.genModalWith': 'Generate COC — with amount',
    'coc.genModalWithout': 'Generate COC — without amount',
    'coc.genPickAmount': 'Amount on the certificate',
    'coc.genInsurance': 'Highest insurance estimate',
    'coc.genOurs': 'Highest Proactive estimate',
    'coc.genNone': 'No estimate on file',
    'coc.genCustom': 'A different amount',
    'coc.genBuildDate': 'Build date',
    'coc.genBuildSaved': 'Saved from the last COC generated for this claim.',
    'coc.genBuildJobflow': 'From JobFlow (install date set by the contractor).',
    'coc.genBuildMissing': 'Not on file: enter the date the job was built.',
    'coc.genNoClaimNumber': 'This claim has no insurance claim number yet: the certificate will print the Proactive file # ({n}).',
    'coc.genAlreadySent': 'The COC was already sent to the insurance company. This one will be saved in Files and will not replace it.',
    'coc.genNoContractor': 'This claim has no contractor: the contractor section will be empty.',
    'coc.genWhatHappens': 'Generate saves the PDF in Files as the COC of this claim (ready to send to the adjuster below). Preview only opens it, nothing is saved.',
    'coc.genPreview': 'Preview',
    'coc.genGenerate': 'Generate COC',
    'coc.genGenerating': 'Generating…',
    'coc.genDone': 'COC generated: {name}',
    'coc.genDoneFilesOnly': 'COC generated and saved to Files (the COC already sent was not replaced): {name}',
    'coc.genErrBuildDate': 'Enter the build date.',
    'coc.genErrFuture': 'The build date cannot be in the future.',
    'coc.genErrAmount': 'Pick or type an amount greater than zero.',
    'coc.genErr': 'The COC could not be generated. Try again.',
    'coc.openTab': 'Open in a new tab',
    'coc.pickRecipient': 'Pick recipient (insurance / adjuster)',
    'coc.willAttachCoc': 'COC attached',
    'coc.willIncludePhotos': 'Job photos link included',
    'coc.attachHint': 'Drag a file here to attach it (it is also saved in the claim Files)',
    'coc.attachUpload': 'Choose file',
    'coc.attachExisting': 'Attach a file already in the claim',
    'coc.sendTitle': 'Send to adjuster',
    'coc.pickAdjuster': 'Pick adjuster',
    'coc.to': 'To',
    'coc.subject': 'Subject',
    'coc.message': 'Message',
    'coc.includePhotos': 'Include photos link',
    'coc.sendBtn': '✉ Send Email to Adjuster',
    'coc.sending': 'Sending…',
    'coc.sentOn': 'Sent on {when}',
    'coc.sentOutside': 'Sent outside the app',
    'coc.sentOutsideWhen': 'When was it sent?',
    'coc.sentOutsideConfirm': 'Mark as sent',
    'coc.sentTo': 'to {to}',
    'coc.historyTitle': 'Email history',
    'coc.historyNone': 'No emails sent yet.',
    'coc.historyPhotos': 'photos link included',
    'coc.queueToSend': 'To Send',
    'coc.queueSent': 'Sent',
    'coc.daysInQueue': 'Days in Queue: {n}',
    'coc.colHomeowner': 'Homeowner',
    'coc.colClaim': 'Claim #',
    'coc.colInsurance': 'Insurance',
    'coc.colTeam': 'Claims team',
    'coc.queueEmpty': 'No claims in the COC queue yet — upload a COC or a photos link on a claim.',
    'coc.needSomething': 'Upload the COC or a photos link first.',
    'coc.sendFailed': 'The email could not be sent. Try again.',
    // ---- Share screen (compartir pantalla en vivo; docs/SHARE-SCREEN-SPEC.md §4.9) ----
    'share.button': 'Share screen',
    'share.sharingWith': 'Sharing with {name}',
    'share.otherTab': 'Sharing from another tab',
    'share.viewing': 'Viewing {name}',
    'share.pickTitle': 'Share your screen with…',
    'share.search': 'Search a colleague',
    'share.pickHint': 'Pick who, then choose the screen or window in your browser. Your microphone goes with it; you can mute anytime. Nothing is sent until they accept.',
    'share.everyone': 'Everyone',
    'share.nobody': 'Nobody to share with right now.',
    'share.inApp': 'In the app',
    'share.idle': 'Idle',
    'share.notInApp': 'Not in the app',
    'share.busySharing': 'Sharing screen',
    'share.busyViewing': 'Watching a screen',
    'share.cancelledPicker': 'Nothing was shared.',
    'share.macPermTitle': 'Your Mac is blocking screen recording',
    'share.macPermBody': 'Open System Settings → Privacy & Security → Screen & System Audio Recording, turn on {browser}, then quit and reopen it.',
    'share.tryAgain': 'Try again',
    'share.ringing': 'Ringing {name}… {s}s',
    'share.cancel': 'Cancel',
    'share.offlineSent': "{name} doesn't have the app open — we sent a notification.",
    'share.busy': '{name} is already in a screen share.',
    'share.notEnabled': "{name} doesn't have screen share yet.",
    'share.notEnabledMe': 'Screen share is not enabled for you yet.',
    'share.incomingTitle': '{name} wants to share their screen with you',
    'share.incomingHint': 'You will see and hear what they chose to share, and they will hear you. Nothing is recorded.',
    'share.expiresIn': 'Expires in {s}s',
    'share.accept': 'Accept',
    'share.decline': 'Decline',
    'share.connecting': 'Connecting to {name}…',
    'share.screenOf': "{name}'s screen",
    'share.live': 'LIVE',
    'share.answeredElsewhere': 'Answered in another tab',
    'share.gone': 'This request already expired or was cancelled.',
    'share.declined': '{name} declined.',
    'share.noAnswer': '{name} did not answer.',
    'share.missed': '{name} tried to share their screen with you at {time}',
    'share.popOut': 'Pop out',
    'share.poppedOut': 'Playing in the floating window',
    'share.enlarge': 'Enlarge',
    'share.dragCorner': 'Drag the corner to enlarge',
    'share.openWindow': 'Open in a window',
    'share.openScreen2': 'Open on 2nd screen',
    'share.fullscreen': 'Full screen',
    'share.exitFullscreen': 'Exit full screen',
    'share.fit': 'Fit',
    'share.actual': '1:1',
    'share.sharper': 'Sharper text',
    'share.smoother': 'Smoother motion',
    'share.minimize': 'Minimize',
    'share.restore': 'Restore',
    'share.leave': 'Leave',
    'share.bringBack': 'Bring back',
    'share.inWindow': 'Viewing in a separate window',
    'share.movedBack': 'The screen went back to the app.',
    'share.quality.good': 'Good connection',
    'share.quality.fair': 'Unstable',
    'share.quality.poor': 'Poor connection',
    'share.relayed': 'Relayed',
    'share.popupBlocked': 'Your browser blocked the window. Allow pop-ups for app.claimsproactive.com and try again.',
    'share.reconnecting': 'Reconnecting…',
    'share.lost': 'Connection lost with {name}.',
    'share.again': 'Share again with {name}',
    'share.serverRestart': 'App is updating — the screen keeps streaming.',
    'share.slow': 'Slow connection',
    'share.sessionSoon': 'Your session closes in 5 min — click to stay signed in',
    'share.sessionCut': 'Your session closes at {time}',
    'share.endedBy': '{name} ended the screen share.',
    'share.viewerLeft': '{name} left.',
    'share.stop': 'Stop',
    'share.muteMic': 'Mute',
    'share.unmuteMic': 'Unmute',
    'share.micDenied': 'Microphone blocked — sharing without your voice.',
    'share.mute': 'Mute',
    'share.unmute': 'Tap to hear audio',
    'share.error': 'Something went wrong with the screen share.',
    'share.auditTitle': 'Screen shares',
    'share.rateLimited': 'Too many requests — wait a minute.',
    'share.connectingShort': 'Connecting…',
    'share.yourBrowser': 'your browser',
    // [rev.3] audio en vivo, botón dividido e inspectores (spec §4.9)
    'share.modeLive': 'Share live',
    'share.modeRecord': 'Record a video',
    'share.comingSoon': 'Coming soon',
    'share.mutedBy': 'Muted by {name}',
    'share.audioOn': 'Audio on',
    'share.noMic': 'No microphone — sharing without your voice',
    'share.systemAudio': 'System audio',
    'share.systemAudioNA': "System audio isn't available in {browser}; only your voice is shared",
    'share.systemAudioFull': 'Share the entire screen to include system audio',
    'share.headphones': 'Use headphones to avoid echo',
    'share.volume': 'Volume',
    'share.soundOn': 'Sound on',
    'share.soundOff': 'Sound off',
    'share.phoneHint': 'Phone — can watch, no audio until they tap',
    'share.onJob': 'On a job',
    'share.fieldTeam': 'Field team',
    'share.videoPip': 'Picture in picture',
    // Audio de ida y vuelta (spec §4.10, 2026-09-04): el que mira también habla.
    'share.viewerMicOn': 'Your microphone is on — {name} can hear you',
    'share.viewerNoMic': "No microphone — {name} can't hear you",
    'share.turnOnMic': 'Turn on my microphone',
    'share.viewerMuted': '{name} muted their microphone',
    'share.hearViewer': 'Tap to hear {name}',
    'share.clickToHear': 'Click anywhere to hear {name}',
    'share.letHear': "Click so {name} can hear you",
    'share.muteMe': 'Mute my mic',
    'share.unmuteMe': 'Unmute my mic',
    // Malla multi-espectador (spec §14): un sharer, varios viewers, agregar en vivo.
    'share.sharingWithN': 'Sharing with {n} people',
    'share.plusN': '+{n} more',
    'share.addPeople': 'Add people',
    'share.addHint': 'Pick who else should watch. They join the same screen you are already sharing — nothing restarts.',
    'share.shareWithN': 'Share with {n}',
    'share.addN': 'Add {n}',
    'share.shareWith': 'Share with {name}',
    'share.addOne': 'Add {name}',
    'share.roster': 'People',
    'share.nWatching': '{n} watching',
    'share.othersWatching': '{n} more watching',
    'share.remove': 'Remove',
    'share.rInvited': 'Invited',
    'share.rConnecting': 'Connecting',
    'share.rWatching': 'Watching',
    'share.rLeft': 'Left',
    'share.qualityReduced': 'Quality reduced',
    'share.qualityReducedHint': 'More viewers means each one gets a smaller share of your upload. Fewer viewers or a faster connection restores quality.',
    'share.broadcastFull': 'Full — up to {max} people can watch at once',
    'share.hearAll': 'Tap to hear everyone',
    'share.letHearAll': 'Click so everyone can hear you',
    // ---- Record: grabar un video tipo Loom (docs/SHARE-SCREEN-SPEC.md §4.12.7) ----
    'rec.setupTitle': 'Record your screen',
    'rec.setupHint': 'You pick what to record in the next step: your entire screen, a window or a tab. Your voice and the screen go into one video.',
    'rec.mic': 'Microphone',
    'rec.micDefault': 'Default microphone',
    'rec.micNone': 'No microphone found',
    'rec.micOff': 'No microphone (record without voice)',
    'rec.systemAudio': 'System audio',
    'rec.systemAudioHint': 'Sounds from what you record (Chrome, Edge, Opera)',
    'rec.camera': 'Camera bubble',
    'rec.start': 'Start recording',
    'rec.countdown': 'Recording starts in {n}',
    'rec.rec': 'REC',
    'rec.controlTitle': 'Recording controls',
    'rec.pause': 'Pause',
    'rec.resume': 'Resume',
    'rec.pausedLabel': 'Paused',
    'rec.stop': 'Stop',
    'rec.cancel': 'Cancel recording',
    'rec.cancelConfirm': 'Discard this recording?',
    'rec.pausedNet': 'Paused — waiting for the upload to catch up',
    'rec.limitSoon': '5 minutes left (30 min max)',
    'rec.limitReached': 'Stopped at 30 minutes (the maximum)',
    'rec.recordingLabel': 'Recording: {surface}',
    'rec.surfaceMonitor': 'entire screen',
    'rec.surfaceWindow': 'window',
    'rec.surfaceBrowser': 'tab',
    'rec.surfaceScreen': 'screen',
    'rec.previewTitle': 'Your recording',
    'rec.titlePh': 'Title',
    'rec.uploadingParts': 'Uploading {a}/{b}…',
    'rec.finalizing': 'Finishing the upload…',
    'rec.remaining': 'about {t} left',
    'rec.uploaded': 'Uploaded',
    'rec.uploadedProcessing': 'Uploaded — processing. You can send it now.',
    'rec.uploadPaused': 'Upload paused — offline',
    'rec.retryUpload': 'Retry upload',
    'rec.waitUpload': 'Wait for the upload to finish',
    'rec.processing': 'Processing…',
    'rec.sendTo': 'Send to…',
    'rec.pickPeople': 'Choose who receives it',
    'rec.selectedN': '{n} selected',
    'rec.send': 'Send',
    'rec.nobody': 'Nobody found',
    'rec.attach': 'Attach to claim',
    'rec.searchClaim': 'Search a claim (name, address, claim #)',
    'rec.channel': 'Channel',
    'rec.channelGeneral': 'General',
    'rec.attachNote': 'Message (optional)',
    'rec.attached': 'Attached to claim {claim}',
    'rec.alreadyAttached': 'This recording is already attached to a claim',
    'rec.contractorNo': "Recordings can't be sent to the contractor",
    'rec.copyLink': 'Copy link',
    'rec.linkCopied': 'Link copied',
    'rec.download': 'Download',
    'rec.delete': 'Delete',
    'rec.keep': 'Keep',
    'rec.keepHint': 'Keep it — it will not expire',
    'rec.kept': 'Kept — it will not expire',
    'rec.expires': 'Expires {date}',
    'rec.expiresSoon': 'Your recording "{title}" expires in 7 days — open it and press Keep to save it',
    'rec.expired': 'Recording expired',
    'rec.deleted': 'Recording deleted',
    'rec.noAccess': "You don't have access to this recording",
    'rec.sentTo': 'Sent to {n}',
    'rec.seenBy': 'Seen by {n}',
    'rec.watchedToEnd': '{n} watched to the end',
    'rec.openWindow': 'Open in a window',
    'rec.speed': 'Speed',
    'rec.pip': 'Picture in picture',
    'rec.fullscreen': 'Full screen',
    'rec.statusReady': 'Ready',
    'rec.statusFailed': 'Failed',
    'rec.statusUploading': 'Uploading',
    'rec.noSeek': 'No seek bar',
    'rec.mine': 'My recordings',
    'rec.mineEmpty': 'No recordings yet',
    'rec.rename': 'Rename',
    'rec.unfinished': 'Unfinished recording ({d})',
    'rec.recover': 'Recover',
    'rec.recovered': 'Recording recovered — only what was uploaded before the tab closed is kept',
    'rec.recoverIncomplete': "It can't be recovered: the uploaded parts don't form a video. Discard it.",
    'rec.defaultTitle': 'Recording {date}',
    'rec.discard': 'Discard',
    'rec.discardConfirm': 'Discard the unfinished recording? What was uploaded will be deleted.',
    'rec.failedUpload': 'Upload failed — download it before closing',
    'rec.uploadStuck': 'Upload failed — press Retry upload',
    'rec.failedUploadLeave': 'The upload failed. Close without the video? Download it first if you need it.',
    'rec.failedRemux': 'We couldn\'t process "{title}". It still plays, without a seek bar.',
    'rec.dm': '{name} sent you a recording: {title} ({d})',
    'rec.popupBlocked': 'Your browser blocked the control window. Use the REC bar here or allow pop-ups.',
    'rec.nothing': 'Nothing was recorded.',
    'rec.noMic': 'No microphone — recording without your voice',
    'rec.notSupported': "This browser can't record the screen",
    'rec.startFailed': 'The recording could not start',
    'rec.error': 'Something went wrong with the recording.',
    'rec.auditTitle': 'Recordings',
    // Enviar por departamentos, banner "nuevo video", sección /recordings (pedido del dueño 2026-09-10).
    'nav.recordings': 'Screen recordings',
    'rec.departments': 'Departments',
    'rec.people': 'People',
    'rec.wholeDept': 'The whole team',
    'rec.newVideo': '{name} sent you a video: {title}',
    'rec.watch': 'Watch',
    'rec.bannerDismiss': 'Dismiss',
    'rec.pageReceived': 'Sent to me',
    'rec.pageMine': 'My recordings',
    'rec.receivedEmpty': 'No videos have been sent to you yet',
    // HO Updates semanales (2026-09-10).
    'hou.runStarted': 'Started: {kind} for the week of {period}. It runs in the background; watch the progress on the HO Updates page (refresh).',
    'hou.runInProgress': 'A run of this kind is already in progress. Wait for it to finish.',
    'hou.contractor': 'Contractor',
    'hou.daysInStatus': '{n}d in this status',
    'hou.weekItems': 'Week items ({n})',
    'hou.itemsModalTitle': 'What feeds this update',
    'hou.itemsModalHint': 'Uncheck what should stay out, then regenerate.',
    'hou.itemsModalFoot': 'Unchecking is saved right away. The text only changes when you regenerate.',
    'hou.regenWith': 'Regenerate with these items',
    'hou.close': 'Close',
    'hou.extTitle': 'Claim team phone extensions',
    'hou.extHint': 'Each update ends with {phone} plus the extension of the claim team. Leave empty to show the number only.',
    'hou.extSave': 'Save extensions',
    'hou.sem_red': 'Needs review',
    'hou.sem_yellow': 'Not reviewed',
    'hou.sem_green': 'Ready',
    'hou.sem_gray': 'Not going out',
    'hou.willSend': 'Will be sent',
    'hou.willSendDry': 'Test mode: nothing goes out. {n} would be sent (green, yellow and red alike).',
    'hou.willSendAll': '{n} go out at {time}: green, yellow and also the red ones, unless someone skips them (policy: send everything).',
    'hou.willSendHold': '{n} go out at {time}. The red ones are held until someone approves them.',
    'hou.quiet': 'Quiet weeks',
    'hou.selectAll': 'Select all shown ({n})',
    'hou.selected': '{n} selected',
    'hou.approveSel': 'Approve selected',
    'hou.skipSel': 'Skip selected',
    'hou.unskipSel': 'Send after all',
    'hou.approveSelConfirm': 'Approve {n} updates? They will go out as they are.',
    'hou.skipSelConfirm': 'Skip {n} updates this week?',
    'hou.unskipSelConfirm': 'Put {n} skipped updates back?',
    'hou.bulkDone': '{n} updated',
    'nav.hoUpdates': 'HO Updates',
    'hou.tab': 'HO Updates',
    'hou.settingsTab': 'Homeowner updates',
    'hou.modeOff': 'Off',
    'hou.modeDryRun': 'Test mode',
    'hou.modePilot': 'Pilot',
    'hou.modeLive': 'Live',
    'hou.modeDryRunHint': 'drafts are generated, nobody receives anything',
    'hou.modePilotHint': 'only the selected claim teams receive it',
    'hou.modeLiveHint': 'every eligible claim receives it',
    'hou.noEmail': 'No email',
    'hou.noPhone': 'No phone',
    'hou.noContact': 'No email or phone on file: nothing to send.',
    'hou.pause': 'Turn off updates',
    'hou.resume': 'Turn updates back on',
    'hou.pauseReason': 'Reason (optional)',
    'hou.pausedBy': 'Updates off — by {name}', 'hou.outsideTitle': 'Found, but not in this week\'s list', 'hou.out_stage': 'this stage does not get updates', 'hou.out_no_contact': 'no email or phone', 'hou.out_pending': 'eligible, no update generated this week', 'hou.lastUpdate': 'last update {date}',
    'hou.thisWeek': 'This week',
    'hou.now': 'now',
    'hou.cutOn': 'cut on {date}',
    'hou.itemsCount': '{n} items',
    'hou.stageNow': 'Stage',
    'hou.waitingOn': 'waiting on',
    'hou.nextVisit': 'next visit',
    'hou.generateDraft': 'Generate draft now',
    'hou.regenerateDraft': 'Regenerate draft',
    'hou.generating': 'Generating…',
    'hou.noClaude': 'The AI is not configured on this server (CLAUDE_API_KEY).',
    'hou.noteTitle': 'Note for this week\'s update',
    'hou.notePh': 'Something the homeowner must be told this week…',
    'hou.addNote': 'Add',
    'hou.deleteNote': 'Delete note',
    'hou.emptyWeek': 'Nothing recorded this week yet. The update will still go out as a reassurance note.',
    'hou.exclude': 'Leave out of the update',
    'hou.include': 'Put back in the update',
    'hou.who_staff': 'Staff',
    'hou.who_homeowner': 'Homeowner',
    'hou.who_insurance': 'Insurance',
    'hou.who_adjuster': 'Adjuster',
    'hou.who_contractor': 'Contractor',
    'hou.who_system': 'System',
    'hou.who_unknown': 'Unknown',
    'hou.previous': 'Previous weeks',
    'hou.noUpdatesYet': 'No updates yet for this homeowner.',
    'hou.publicLink': 'Public link',
    'hou.linkHits': '{n} opens',
    'hou.loadError': 'Could not load the updates',
    'hou.weekOf': 'Week of {date}',
    'hou.quietWeek': 'Quiet week',
    'hou.needsReview': 'Needs review',
    'hou.st_draft': 'Draft',
    'hou.st_held': 'Held for review',
    'hou.st_approved': 'Approved',
    'hou.st_skipped': 'Skipped',
    'hou.st_sent': 'Sent',
    'hou.st_failed': 'Failed',
    'hou.st_superseded': 'Superseded',
    'hou.r_cifra': 'Unverified number',
    'hou.r_monto': 'Amount in text',
    'hou.r_largo': 'Too long',
    'hou.r_corto': 'Too short',
    'hou.r_idioma': 'Wrong language',
    'hou.r_etapa': 'Sensitive stage',
    'hou.r_ia': 'AI asked for review',
    'hou.clickToEdit': 'Click to edit',
    'hou.editedBy': 'Edited by {name} · {when}',
    'hou.staffNotes': 'Notes for the staff',
    'hou.nextStep': 'Next step',
    'hou.omitted': 'Left out',
    'hou.tr_generated': 'Generated',
    'hou.tr_reviewed': 'Reviewed',
    'hou.tr_notReviewed': 'Not reviewed',
    'hou.tr_sent': 'Sent',
    'hou.tr_email': 'Email',
    'hou.tr_delivered': 'Delivered',
    'hou.tr_opened': 'Opened',
    'hou.tr_notOpened': 'Not opened yet',
    'hou.tr_sms': 'SMS',
    'hou.tr_viewed': 'Link viewed',
    'hou.tr_notViewed': 'Link not opened yet',
    'hou.saved': 'Saved',
    'hou.cancel': 'Cancel',
    'hou.approve': 'Looks good',
    'hou.skip': 'Skip this update',
    'hou.unskip': 'Send after all',
    'hou.regenerate': 'Regenerate',
    'hou.regenConfirm': 'Regenerate this draft with the AI? Your edits will be replaced.',
    'hou.sendNow': 'Send now',
    'hou.sendConfirm': 'Send this update to the homeowner now (email + SMS)?',
    'hou.dryRunBlocked': 'Test mode: nothing is sent. Change the mode in Settings → Homeowner updates.',
    'hou.queueTitle': 'HO Updates',
    'hou.s_total': 'Total',
    'hou.s_viewed': 'Viewed',
    'acr.tab': 'Acronyms', 'acr.title': 'Office acronyms', 'acr.hint': 'Whenever someone writes one of these in a message, it shows with a dotted underline and the meaning appears on hover. The AI that writes the weekly homeowner update reads them with these meanings too, and never guesses another one.', 'acr.acronym': 'Acronym', 'acr.meaning': 'Meaning', 'acr.add': 'Add', 'acr.acronymPh': 'e.g. HO', 'acr.meaningPh': 'e.g. Homeowner', 'acr.rule': '2 to 8 capital letters or digits. Adding one that already exists updates its meaning.', 'acr.empty': 'No acronyms yet.', 'acr.deleteConfirm': 'Remove {acronym}?', 'acr.saved': 'Saved.', 'acr.by': 'added by {who}', 'acr.invalid': 'The acronym must be 2 to 8 capital letters or digits.',
    'hou.tabQueue': 'Queue', 'hou.tabViews': 'Views', 'hou.viewsHint': 'Who opened this week\'s update and how. This no longer sends notifications: it lives here.', 'hou.viewsStats': '{viewed} of {sent} sent were opened ({pct}%) · {views} views · via SMS {sms} · via email {email}', 'hou.viewsEmpty': 'Nobody has opened this week\'s update yet.', 'hou.viaCol': 'Opened from', 'hou.viaSms': 'the SMS link', 'hou.viaEmail': 'the email link', 'hou.viaLink': 'the link', 'hou.firstOpened': 'First opened', 'hou.lastOpened': 'Last opened', 'hou.viewedBadge': 'Opened ×{n}',
    'ntf.mentionsOnly': 'Mentions only', 'ntf.mentionsOnlyHint': 'Show only what someone wrote to you with @', 'ntf.emptyMentions': 'No mentions here.',
    'hou.s_bounced': 'Bounced',
    'hou.s_noContact': 'No contact',
    'hou.onlyReview': 'Needs review',
    'hou.onlyYourTeam': 'Your claim team\'s updates', 'hou.mine': 'Mine',
    'hou.allStatuses': 'All statuses',
    'hou.searchPh': 'Homeowner, claim # or address',
    'hou.queueEmpty': 'No updates for this week yet.',
    'hou.settingsTitle': 'Homeowner weekly updates',
    'hou.settingsIntro': 'Every week, every homeowner with an active claim receives a short update written by the AI from what the claim recorded: email plus SMS with a link.',
    'hou.enabled': 'Enabled',
    'hou.mode': 'Mode',
    'hou.twoKeys': 'Two keys on purpose: this switch AND WEEKLY_UPDATE_ENABLED=true on the server. In test mode nobody receives anything.',
    'hou.pilotTeams': 'Pilot claim teams',
    'hou.noTeams': 'No claim teams yet',
    'hou.generateOn': 'Generate',
    'hou.sendOn': 'Send',
    'hou.smsWindow': 'SMS only between (hours)',
    'hou.scheduleHint': 'Office time (Eastern). On a federal holiday the run moves to the next business day.',
    'hou.reviewPolicy': 'Review',
    'hou.rp_sendAll': 'Send everything (unreviewed goes out too)',
    'hou.rp_holdFlagged': 'Hold the flagged ones until approved',
    'hou.rp_holdAll': 'Hold everything until approved',
    'hou.quietWeekPolicy': 'Week with no news',
    'hou.qw_note': 'Send a "we\'re on it" note',
    'hou.qw_skip': 'Skip that week',
    'hou.includeAmounts': 'Allow dollar amounts in the text',
    'hou.includeContractor': 'Include the Contractor channel',
    'hou.notifyFirstView': 'Notify the account manager on first view',
    'hou.notifyBounce': 'Notify on bounce',
    'hou.stages': 'Eligible stages',
    'hou.aiInstructions': 'Instructions for the AI',
    'hou.aiHint': 'Tone and style. The non-negotiable rules (no invented numbers, no jargon, no internal problems) live in the code and cannot be edited here.',
    'hou.model': 'Model',
    'hou.channels': 'Email and SMS',
    'hou.fromDept': 'Send from',
    'hou.officePhone': 'Office phone',
    'hou.emailSubject': 'Email subject',
    'hou.smsTemplate': 'SMS text',
    'hou.segments': 'segments',
    'hou.unicodeSms': 'accents make it 70 chars per segment',
    'hou.placeholders': 'Placeholders',
    'hou.testTitle': 'Try it with a real claim',
    'hou.testHint': 'Generates this week\'s draft for that claim (nothing is sent) so you can tune the instructions.',
    'hou.testClaimPh': 'Claim id',
    'hou.testRun': 'Generate draft',
    'hou.testNeedsId': 'Enter the numeric id of a claim.',
    'hou.runGenerate': 'Run generation now',
    'hou.runSend': 'Run send now',
    'hou.runGenConfirm': 'Generate the drafts of the current week for every eligible claim now?',
    'hou.runSendConfirm': 'Send every draft/approved update of the most recent week now? (Nothing is sent in test mode.)',
    // ── Super Board (/super-board): el tablero único de la office manager ──
    'nav.superBoard': 'Super Board',
    'team.superBoardHelp': 'Super Board access (the list decides, not the role)',
    'team.superBoardOn': 'Has the Super Board',
    'team.superBoardMaster': 'The master always has it',
    'sb.title': 'Super Board',
    'sb.subtitle': 'Everything you supervise, in one place',
    'sb.tabDashboard': 'Dashboard',
    'sb.tabEvaluation': 'Evaluation',
    'sb.updatedAgo': 'updated {s}s ago',
    'sb.updating': 'updating…',
    'sb.tvMode': 'TV mode',
    'sb.tvExit': 'Exit TV mode',
    'sb.loadError': 'Could not load this block. It will retry on its own.',
    'sb.retry': 'Retry',
    'sb.nothing': 'Nothing here right now',
    'sb.justNow': 'just now',
    'sb.agoMin': '{n} min ago',
    'sb.agoH': '{n} h ago',
    'sb.agoD': '{n} d ago',
    'sb.kActive': 'Active claims',
    'sb.kNew': 'New today',
    'sb.kToday': 'today',
    'sb.kWeek': 'this week',
    'sb.kMonth': 'this month',
    'sb.kClaimReview': 'In Claim Review',
    'sb.kOldest': 'oldest {d} d',
    'sb.kToFile': 'To file',
    'sb.kMedian': 'median {d} d',
    'sb.kWelcome': 'Welcome calls to do',
    'sb.kApprovals': 'Pending approvals',
    'sb.kLast14': 'arrivals, last 14 days',
    'sb.byTeam': 'By team',
    'sb.byAm': 'By account manager',
    'sb.noTeam': 'No team',
    'sb.noAm': 'No account manager',
    'sb.filterOn': 'Showing only: {name}',
    'sb.clearFilter': 'Show all',
    'sb.qToFile': 'To file',
    'sb.qToFileHelp': 'Ready to be filed: welcome call done and accepted after Claim Review',
    'sb.qWelcome': 'Welcome call',
    'sb.qWelcomeHelp': 'Same count as the Scheduling queue',
    'sb.qWaitingDocs': 'Waiting documents',
    'sb.qApprovals': 'Approvals',
    'sb.median': 'median',
    'sb.oldest': 'oldest',
    'sb.seeList': 'See list',
    'sb.approve': 'Approve',
    'sb.reject': 'Reject',
    'sb.rejectWhy': 'Why? (optional)',
    'sb.confirmReject': 'Confirm reject',
    'sb.requestedBy': 'by {name}',
    'sb.noApprovals': 'No approvals waiting. Nice.',
    'sb.kind_cancel_claim': 'Cancel claim',
    'sb.kind_archive': 'Archive',
    'sb.kind_hold': 'Hold',
    'sb.kind_release_letter': 'Release letter',
    'sb.actionFailed': 'Could not do that: {msg}',
    'sb.crTitle': 'Claim Review',
    'sb.crCount': '{n} claims',
    'sb.crOne': '1 claim',
    'sb.crOldest': 'the oldest has been there {d} days',
    'sb.crEmpty': 'No claims in Claim Review right now.',
    'sb.crHint': 'One bar per claim. Height = days in Claim Review. Click a bar to open the review.',
    'sb.crLegendOk': 'under 1 day',
    'sb.crLegendWarn': '1 to 3 days',
    'sb.crLegendLate': 'over 3 days',
    'sb.crOpen': 'Open claim review',
    'sb.crValidations': '{n} checks done',
    'sb.alTitle': 'Urgent alerts',
    'sb.alEmpty': 'Nothing urgent. Enjoy it.',
    'sb.alRisk': 'Risk',
    'sb.alCall': 'Call',
    'sb.alClaim': 'Claim alert',
    'sb.alInspection': 'Inspection',
    'sb.alOps': 'Operations',
    'sb.alSystem': 'System',
    'sb.alEvidence': 'See evidence',
    'sb.alOpenClaim': 'Open claim',
    'sb.alResolve': 'Resolve',
    'sb.alReview': 'Mark reviewed',
    'sb.alExonerate': 'Exonerate',
    'sb.alListen': 'Listen',
    'sb.alDismiss': 'Dismiss',
    'sb.alSeeAll': 'See all',
    'sb.alCases': '{n} cases',
    'sb.alScore': 'score {n}',
    'sb.kOfQueue': 'of {n} in the queue',
    'sb.tab_needed': 'To do',
    'sb.tab_all': 'All',
    'sb.alTotRisk': '{r} red · {y} amber in the risk board',
    'sb.alTotCalls': '{n} call alerts pending',
    'sb.alTotClaim': '{n} claim alerts open',
    'sb.alTotOps': '{n} cases in operations alerts',
    'sb.bcTitle': 'Broadcast',
    'sb.bcNoAccess': 'You do not have Broadcast access.',
    'sb.bcEmployees': 'Employees',
    'sb.bcContractors': 'Contractors',
    'sb.bcSubject': 'Subject',
    'sb.bcBody': 'Message',
    'sb.bcInApp': 'Also show it as a bar inside the app',
    'sb.bcSend': 'Send now',
    'sb.bcSending': 'Sending…',
    'sb.bcSent': 'Sent',
    'sb.bcRecent': 'Recent',
    'sb.bcReadBy': 'opened by {a} of {b}',
    'sb.bcConfirm': 'Send this broadcast to {aud} now?',
    'sb.bcOpenModule': 'Open Broadcast',
    'sb.officeTitle': 'Office pulse',
    'sb.clockedIn': 'clocked in',
    'sb.onBreak': 'on break',
    'sb.late': 'late',
    'sb.missing': 'not clocked in',
    'sb.todayTitle': 'Today',
    'sb.approvedWeek': 'approved this week', 'sb.approvedMonth': 'approved this month', 'sb.approvedYear': 'approved this year', 'sb.approvedFilter': 'By month / year', 'sb.wholeYear': 'Whole year', 'sb.approvedInPeriod': 'approved in this period', 'sb.kSupReady': '1st estimates ready to send', 'sb.kSupReadySub': 'estimate done, still in First Estimate', 'sb.kSupInfoPending': 'Info pending', 'sb.kSupInfoPendingSub': 'claims in Supplements waiting for info', 'sb.kQuiet5': 'No updates 5+ days', 'sb.kQuiet5Sub': 'nobody touched the file', 'sb.kLegal': 'Legal threat', 'sb.kLegalSub': 'homeowner mentioned lawyer / lawsuit', 'sb.pTitle': 'What happened', 'sb.pWeekOf': 'Week of', 'sb.p_day': 'Day', 'sb.p_week': 'Week', 'sb.p_month': 'Month', 'sb.pApproved': 'Approved', 'sb.pSeeList': 'see which', 'sb.pHideList': 'hide list', 'sb.pNoApproved': 'No approvals in this period.', 'sb.pNew': 'New claims', 'sb.pChecks': 'Checks noted', 'sb.pKudos': 'Kudos', 'sb.pFiles': 'Files uploaded', 'sb.pEmails': 'Emails sent', 'sb.pCalls': 'Calls', 'sb.pSms': 'SMS sent', 'sb.approvedToday': 'claims approved',
    'sb.checksToday': 'checks recorded',
    'sb.kudosToday': 'kudos',
    'sb.comingTitle': 'Who is next',
    'sb.comingEmpty': 'No evaluations in the next 30 days.',
    'sb.seeEvaluation': 'Open Evaluation',
    'sb.state_working': 'working',
    'sb.state_break': 'on break',
    'sb.state_out': 'left for the day',
    'sb.state_missing': 'did not clock in',
    'sb.state_off': 'off today',
    'sb.listTitle_afiliar': 'To file',
    'sb.listTitle_welcome': 'Welcome call',
    'sb.listTitle_waiting_docs': 'Waiting documents',
    'sb.listTitle_team': 'Team: {name}',
    'sb.listTitle_am': 'Account manager: {name}',
    'sb.listTitle_claim_review': 'Claim Review',
    'sb.listTotal': '{n} claims',
    'sb.colClaim': 'Claim',
    'sb.colContractor': 'Contractor',
    'sb.colStage': 'Stage',
    'sb.colDays': 'Days',
    'sb.listCut': 'Showing the first {n} of {total}',
    'sb.evTitle': 'Evaluations',
    'sb.evSub': 'A two-month review after hire, then every anniversary. Dates come from the hire date.',
    'sb.evOverdue': 'Overdue',
    'sb.evThisWeek': 'This week',
    'sb.evThisMonth': 'This month',
    'sb.evLater': 'Later',
    'sb.evNoDate': 'No hire date',
    'sb.evKind_two_month': '2-month review',
    'sb.evKind_annual': '{n}-year review',
    'sb.evKind_custom': 'Scheduled review',
    'sb.evIn': 'in {d} d',
    'sb.evAgo': '{d} d ago',
    'sb.evToday': 'today',
    'sb.evHired': 'Hired {date}',
    'sb.evMonths': '{n} months',
    'sb.evYears': '{n} years',
    'sb.evLate': '{n} late',
    'sb.evNoShow': '{n} no-show',
    'sb.evNoSchedule': 'no schedule loaded',
    'sb.evWarnings': '{n} warnings',
    'sb.evCallAlerts': '{n} call alerts',
    'sb.evComplaints': '{n} complaints',
    'sb.evKudos': '{n} kudos',
    'sb.evSince': 'since {date}',
    'sb.evDone': 'Done {date}',
    'sb.evNext': 'Next evaluation',
    'sb.evSearch': 'Search a person',
    'sb.evColPerson': 'Person',
    'sb.evColNext': 'Next evaluation',
    'sb.evColYear': 'This year',
    'sb.dsMarkDone': 'Mark as done',
    'sb.dsNotes': 'Notes of the evaluation',
    'sb.dsSave': 'Save notes',
    'sb.dsSaved': 'Saved',
    'sb.dsSchedule': 'Schedule a review',
    'sb.dsScheduleDate': 'Date',
    'sb.dsYear': 'The year in numbers',
    'sb.dsAttendance': 'Attendance',
    'sb.dsWorked': '{n} days worked',
    'sb.dsEarly': '{n} early',
    'sb.dsComplaintsUpheld': '{n} upheld',
    'sb.dsEom': '{n} EOM wins',
    'sb.dsApprovals': 'Approvals',
    'sb.dsEmails': 'Emails',
    'sb.dsCalls': 'Calls',
    'sb.dsRank': '#{p} of {n}',
    'sb.dsMinutes': '{n} min',
    'sb.dsHrNotes': 'Manager notes',
    'sb.dsNoteWarning': 'Warning',
    'sb.dsNoteRecognition': 'Recognition',
    'sb.dsNoteNote': 'Note',
    'sb.dsNotePlaceholder': 'Write it as you would say it to the person',
    'sb.dsAddNote': 'Add note',
    'sb.dsDeleteNote': 'Delete',
    'sb.dsCallAlerts': 'Call alerts and complaints this year',
    'sb.dsExonerated': 'exonerated',
    'sb.dsReviewed': 'reviewed',
    'sb.dsComplaints': 'Complaints',
    'sb.dsPast': 'Past evaluations',
    'sb.dsNone': 'None yet',
    'sb.dsFullEval': 'Open the full yearly evaluation',
    'sb.dsMeasuredSince': 'measured since {date}',
    'sb.dsNoData': 'not measured yet',
    // ── Board de TV (/tv): la pared de la oficina ──
    'tv.title': 'Office pulse',
    'tv.tab_pulso': 'Pulse',
    'tv.updated': 'updated {s}s ago',
    'tv.loadError': 'Could not refresh. Showing the last data.',
    'tv.kNewToday': 'New claims today',
    'tv.kClaimReview': 'In Claim Review',
    'tv.kToFile': 'To file',
    'tv.kWelcome': 'Welcome calls',
    'tv.kEstimates': 'Estimates to send',
    'tv.kCalls': 'Calls today',
    'tv.kEmails': 'Emails today',
    'tv.kSms': 'Texts today',
    'tv.s_claim_review': 'Claim Review',
    'tv.sub_claim_review': 'days in review',
    'tv.s_claim_accepted': 'Accepted, not filed',
    'tv.sub_claim_accepted': 'days since the claim was accepted',
    'tv.s_ready_to_file': 'Ready to file',
    'tv.sub_ready_to_file': 'days waiting to be filed with the insurance',
    'tv.s_claim_in': 'Filed, waiting on insurance',
    'tv.sub_claim_in': 'days since the claim was filed',
    'tv.s_coc': 'COC to send',
    'tv.sub_coc': 'days in the COC queue',
    'tv.s_review_estimate': 'Review estimate',
    'tv.sub_review_estimate': 'days waiting for the estimate review',
    'tv.days': 'days',
    'tv.dShort': 'd',
    'tv.oldest': 'oldest',
    'tv.median': 'median',
    'tv.none': 'Nothing waiting',
    'tv.legendOk': 'on time',
    'tv.legendWarn': 'watch',
    'tv.legendLate': 'late',
    'tv.oldestToNewest': 'oldest → newest, one bar per claim',
    'tv.oldestIs': 'Oldest: {who} · {d} days',
    'nav.officePulse': 'Office pulse',
    'tv.tapForList': 'tap to see the list',
    'tv.more': '+{n} more',
    'tv.oneClaim': '1 claim',
    'tv.claims': '{n} claims',
    'tv.colClient': 'Client',
    'tv.colContractor': 'Contractor',
    'tv.colDays': 'Days',
    'tv.openClaim': 'Open claim',
    'tv.fullscreen': 'Full screen',
    'tv.exitFullscreen': 'Exit full screen',
    'tv.fullscreenHint': 'On the TV it hides the browser bar and the Windows taskbar',
    'tv.groupToday': 'Today',
    'tv.groupPending': 'Pending',
    'tv.kFiled': 'Filed today',
    'tv.kReviewed': 'Reviewed today',
    'tv.top': 'Top',
    'tv.noTop': 'nobody yet',
    'tv.colTime': 'Time',
    'tv.colWho': 'Who',
    'tv.colWhat': 'What',
    'tv.callIn': 'inbound',
    'tv.callOut': 'outbound',
    'tv.accepted': 'Accepted',
    'tv.notAccepted': 'Not accepted',
    'tv.l_nuevos': 'New claims today',
    'tv.l_afiliados': 'Filed today',
    'tv.l_revisados': 'Reviewed today in Claim Review',
    'tv.l_llamadas': "Today's calls",
    'tv.l_correos': 'Emails sent today',
    'tv.l_sms': 'Texts sent today',
    'tv.l_estimados': 'Estimates ready to send',
    'tv.nothingToday': 'Nothing yet today',
    'tv.s_welcome_call': 'Welcome calls to do',
    'tv.sub_welcome_call': 'days since the claim was accepted, no welcome call yet',
    'tv.s_acv_check': 'ACV check',
    'tv.sub_acv_check': 'days waiting for the first check, no sent date',
    'tv.s_coc_check': 'COC check',
    'tv.sub_coc_check': 'days since the COC was sent, waiting for the depreciation check',
    'espera.tabAdjuster': 'Adjuster meeting', 'espera.tabReinspection': 'Reinspection', 'espera.tabAtr': 'ATR',
    'tv.tab_scheduling': 'Scheduling',
    'tv.inspectors': 'Inspectors today',
    'tv.noInspectorsToday': 'No inspections scheduled for today',
    'tv.unassigned': 'No inspector',
    'tv.visits': '{done}/{total} visits',
    'tv.est_inspecting': 'Inspecting',
    'tv.est_adjuster_no_show': 'Adjuster no-show',
    'tv.est_checked_in': 'Checked in at {h}',
    'tv.est_late': 'Late {m} min',
    'tv.est_en_route_late': 'On the way · late {m} min',
    'tv.est_en_route': 'On the way',
    'tv.est_next': 'Next at {h}',
    'tv.est_done': 'Done for today',
    'tv.est_off': 'Free',
    'tv.next7': 'Inspections · next 7 days',
    'tv.today': 'Today',
    'tv.waitTitle': 'Waiting to be scheduled',
    'tv.waitSub': 'days waiting for a date',
    'tv.reports': 'Inspection reports',
    'tv.reportsToday': 'today',
    'tv.reportsYesterday': 'yesterday · none yet today',
    'tv.noReports': 'No reports yet',
    'tv.lateBy': 'late {m} min',
    'tv.field': 'Field messages and alerts',
    'tv.fieldSub': 'last 24 hours',
    'tv.noField': 'Nothing new from the inspectors',
    'tv.alert_no_show': 'Adjuster no-show',
    'tv.alert_reschedule': 'Rescheduled from the field',
    'tv.alert_urgent_message': 'Urgent message',
    'tv.message': 'Message',
    'tv.answered': 'answered',
    'tv.soundOn': 'Siren on',
    'tv.soundOff': 'Siren off',
    'tv.soundTap': 'Tap the screen to enable the siren',
    'tv.soundHint': 'Sounds when an inspector sends a message or a field alert comes in',
    'tv.alarmTitle': 'Field update',
    'tv.alarmClose': 'Close',
    'ic.title': 'Inspection contact',
    'ic.hint': 'Who to call on the insurance side if the inspection needs to be rescheduled.',
    'ic.company': 'Inspection company',
    'ic.companyPhone': 'Company phone',
    'ic.inspector': 'Inspector name',
    'ic.inspectorPhone': 'Inspector phone',
    'ic.empty': 'No inspection contact yet.',
    'ic.add': 'Add contact',
    'ic.edit': 'Edit',
    'ic.save': 'Save',
    'ic.cancel': 'Cancel',
    'ic.setBy': 'Set by',
    'ic.history': 'History',
    'ic.needOne': 'Fill in at least one field.',
    'lor.extTitle': 'The LOR went out through another system',
    'lor.extWhere': 'Where was it submitted?',
    'lor.extPortal': 'Carrier portal', 'lor.extEmailOther': 'Email from another system', 'lor.extFax': 'Fax', 'lor.extMail': 'Mail', 'lor.extPhone': 'Phone', 'lor.extOther': 'Other',
    'lor.extDetail': 'Details', 'lor.extDetailPh': 'Portal name, confirmation number, who received it…',
    'lor.extDetailRequired': 'Say where it was submitted (portal name, confirmation…).',
    'lor.extConfirm': 'Mark as sent and move to Claim in',
    'lor.extHint': 'This stays on record with your name, and the claim moves to Claim in right away (claim number and claim type still required).',
    'lor.extFiled': 'LOR marked as sent and the claim moved to Claim in.',
    'lor.confirmBtn': 'Confirm the LOR was sent to the insurance',
    'lor.confirmSent': 'LOR sent to the insurance',
    'lor.confirmSentOnly': 'LOR confirmed. The claim did not move to Claim in:',
    'lor.confirmNotReady': 'the claim is not in Ready to File / Claim Accepted.',
    'lor.sentNotFiled': 'LOR sent, but the claim could not be filed automatically:',
    'eg.theirLine': 'Insurance estimate',
    'eg.ourLine': 'Ours',
    'eg.why': 'Why lower',
    'eg.noDetail': 'The analysis has no quantity or unit price for this line. Re-run Analyze to get them.',
    'cdw.insurance': 'Insurance',
    'cdw.inspection': 'Inspection',
    'cdw.inspectionDone': 'done',
    'cdw.noInspection': 'not scheduled',
    'sup.esxChipOk': 'ESX',
    'sup.esxChipMissing': 'No ESX',
    // ---- Client concerns (resolve.html → CRM) ----
    'nav.concerns': 'Client concerns',
    'concerns.title': 'Client concerns',
    'concerns.subtitle': 'What homeowners send from the "resolve a problem" page on the website.',
    'concerns.search': 'Search name, phone, email, address, claim…',
    'concerns.none': 'No concerns here.',
    'concerns.status.new': 'New', 'concerns.status.in_review': 'In review', 'concerns.status.resolved': 'Resolved', 'concerns.status.all': 'All',
    'concerns.sit.not_signed': 'Did not sign', 'concerns.sit.contractor': 'Contractor issue', 'concerns.sit.slow': 'Claim is slow',
    'concerns.sit.fee': 'Fee question', 'concerns.sit.cancel': 'Wants to cancel', 'concerns.sit.other': 'Other',
    'concerns.eval.explain': 'Explain', 'concerns.eval.needs_call': 'Needs a call', 'concerns.eval.escalate': 'Escalate',
    'concerns.match': 'Claim match', 'concerns.match.exact': 'Exact', 'concerns.match.probable': 'Probable', 'concerns.match.none': 'No match',
    'concerns.claim': 'Claim', 'concerns.noMatch': 'No claim matched',
    'concerns.lang': 'Language', 'concerns.close': 'Close',
    'concerns.phone': 'Phone', 'concerns.email': 'Email', 'concerns.address': 'Address',
    'concerns.linkClaim': 'Link claim', 'concerns.unlinkClaim': 'Unlink', 'concerns.linkClaimPlaceholder': 'Claim ID',
    'concerns.aiSummary': 'AI summary', 'concerns.aiPending': 'AI summary pending (it runs right after the ticket arrives; regenerate if it never showed up).',
    'concerns.aiFailed': 'The AI could not generate the summary. Try again in a minute.',
    'concerns.regenerate': 'Regenerate summary', 'concerns.regenerating': 'Generating…',
    'concerns.clientSays': 'What the client says', 'concerns.fileShows': 'What the file shows',
    'concerns.draft.en': 'Reply draft (EN)', 'concerns.draft.es': 'Reply draft (ES)',
    'concerns.copy': 'Copy', 'concerns.copied': 'Copied',
    'concerns.statusLabel': 'Status', 'concerns.assignee': 'Assigned to', 'concerns.unassigned': 'Unassigned',
    'concerns.resolvedAt': 'Resolved', 'concerns.notes': 'Internal notes', 'concerns.notesPlaceholder': 'What was done, who called, outcome…',
    'concerns.saveNotes': 'Save notes',
    // ── Correo del seguro: de dónde salió / por qué no hay (email box) + dashboard de Supplements ──
    'qe.insEmailMissing': 'No email on file for this carrier. Add the claims email in the Insurance card, or add the adjuster with their email:',
    'qe.insEmailFromAdjuster': 'Email of the adjuster on file for this claim.',
    'qe.insEmailFromDetails': 'General email from the Insurance card (not the claims inbox). Double-check before sending.',
    'supd.sent': 'Sent', 'supd.sentByEmail': 'Sent by email', 'supd.notSentByEmail': 'Not sent by email yet',
    // ── Reviews (pedido de reseña por SMS) ──
    'rev.settingsTab': 'Reviews',
    'rev.settingsTitle': 'Review requests (Google)',
    'rev.settingsIntro': 'When a claim reaches a closing stage, the homeowner gets ONE text signed by the assigned Public Adjuster asking for a review, with a tracked short link. One reminder if they do not click. Never more than once per claim, no incentives, everyone gets it.',
    'rev.enabled': 'Send review requests automatically',
    'rev.enabledHint': 'Off. Only claims that reach a trigger stage AFTER you turn this on will get a request — older claims are never texted.',
    'rev.enabledSince': 'On since {date}. Claims that reached a trigger stage before that date are not texted.',
    'rev.links': 'Review links',
    'rev.linksHint': '* The text message sends people to the Google link. Paste your business review link exactly as Google gives it.',
    'rev.triggerStages': 'Send when the claim enters',
    'rev.reminderDays': 'Reminder after (days)',
    'rev.sendHour': 'Send at (hour, office time)',
    'rev.weekdaysOnly': 'Weekdays only',
    'rev.rulesHint': 'Skipped automatically when the claim has no phone, the number replied STOP, there is an open client concern, or the claim is cancelled. Texts go out once a day at the hour above.',
    'rev.reportTitle': 'Review requests',
    'rev.allStatuses': 'All statuses',
    'rev.cSent': 'sent', 'rev.cClicked': 'clicked', 'rev.cRate': 'click rate', 'rev.cPending': 'pending', 'rev.cSkipped': 'skipped',
    'rev.empty': 'No review requests yet.',
    'rev.colClaim': 'Claim', 'rev.colPa': 'Signed by', 'rev.colLang': 'Lang', 'rev.colStatus': 'Status', 'rev.colSent': 'Sent', 'rev.colReminded': 'Reminded', 'rev.colClicked': 'Clicked',
    'rev.st_pending': 'Pending', 'rev.st_sent': 'Sent', 'rev.st_reminded': 'Reminded', 'rev.st_clicked': 'Clicked', 'rev.st_skipped': 'Skipped',
    'rev.skip_no_phone': 'no phone', 'rev.skip_opted_out': 'replied STOP', 'rev.skip_open_concern': 'open concern', 'rev.skip_cancelled': 'claim cancelled', 'rev.skip_disabled': 'feature off', 'rev.skip_no_review_link': 'no Google link',
    'rev.claimTitle': 'Google review request',
    'rev.claimHelp': 'Texts the homeowner now, signed by the Public Adjuster, with the tracked link. Only once per claim.',
    'rev.claimBtn': 'Send review request now',
    'rev.claimConfirm': 'Send the review request text to the homeowner now? It can only be sent once per claim.',
    'rev.claimSent': 'Review request sent.',
    'rev.claimSkipped': 'Not sent: {reason}.',
    'rev.claimAlready': 'This claim already had a review request.',
    'files.esxOnly': 'Only a .ESX file can be dropped on an estimate.',
    'files.esxDropHint': 'or drop the .ESX on this row',
    'files.esxDropHere': 'Drop ESX here',
    'files.esxUploaded': 'ESX uploaded',
    // Contractor invoices (Manuel 2026-09-30)
    'cinv.title': 'Contractor invoices', 'cinv.previewEmpty': 'No contractor invoices yet', 'cinv.previewUnpaid': '{n} invoice(s) · {u} unpaid', 'cinv.previewPaid': '{n} invoice(s) · all paid',
    'cinv.hint': 'Invoices the contractor sends for this claim. Without a file it stays pending (and shows up in Info Pending and in JobFlow); when the file arrives by any path it lands here and in Files as "Contractor invoice", and the AI reads it.',
    'cinv.add': 'Add invoice', 'cinv.name': 'Name', 'cinv.namePh': 'e.g. Tarp invoice', 'cinv.amount': 'Amount', 'cinv.contractor': 'Contractor', 'cinv.contractorDefault': "Claim's contractor",
    'cinv.dropHere': 'Drop the invoice file here (PDF or image)', 'cinv.dropOptional': 'Drop the invoice file here — or leave it pending', 'cinv.needName': 'Give the invoice a name.',
    'cinv.pending': 'Pending', 'cinv.received': 'Received', 'cinv.paid': 'Paid', 'cinv.markPaid': 'Paid', 'cinv.undoPaid': 'Undo paid', 'cinv.view': 'View',
    'cinv.delete': 'Delete', 'cinv.deleteConfirm': 'Delete the invoice "{n}"? If it was still pending, its Info Pending item goes too.', 'cinv.save': 'Save', 'cinv.cancel': 'Cancel',
    'cinv.aiRead': 'Read by AI from the file', 'ft.contractor_invoice': 'Contractor invoice',
    // Visit types (Settings → Scheduling), Manuel 2026-09-30
    'vt.title': 'Visit types', 'vt.hint': 'Every kind of visit the inspectors do, with how long it takes on the calendar and the buffer the scheduler keeps between visits (on top of the drive time). Built-in types can be edited but not turned off.',
    'vt.type': 'Type', 'vt.duration': 'Duration', 'vt.buffer': 'Buffer', 'vt.status': 'Status', 'vt.builtin': 'built-in', 'vt.active': 'Active', 'vt.off': 'Off',
    'vt.turnOff': 'Turn off', 'vt.turnOn': 'Turn on', 'vt.add': 'Add a visit type', 'vt.newPh': 'e.g. ATR on site', 'vt.create': 'Create',
    // Check types (Settings → Payments), Manuel 2026-10-02
    'ckt.title': 'Check types', 'ckt.hint': 'The options in the "Type" dropdown of every check. Built-in ones stay; add the ones the office needs (e.g. Mitigation). Removing one keeps it on the checks that already have it.',
    'ckt.builtin': 'Built-in', 'ckt.newPh': 'e.g. Mitigation', 'ckt.add': 'Add', 'ckt.delete': 'Remove', 'ckt.deleteConfirm': 'Remove the check type "{n}" from the dropdown?',
    // Training (mig 0472), Manuel 2026-10-02
    'nav.training': "Training",
    'trn.title': "Training",
    'trn.searchPh': "Search videos, guides and files…",
    'trn.newSection': "New section",
    'trn.newLesson': "New lesson",
    'trn.editLesson': "Edit lesson",
    'trn.results': "{n} results for \"{q}\"",
    'trn.noResults': "Nothing matches that search yet.",
    'trn.onbIntro': "Everyone who joins starts here: who we are, what a public adjuster does and how a claim moves through the company. Read each one in order and mark it as read.",
    'trn.inboxIntro': "Videos sent from Record land here. Only super managers see this list: watch it, write the explanation and move it to its section.",
    'trn.inboxEmpty': "Nothing waiting to be sorted.",
    'trn.sectionEmpty': "No lessons in this section yet.",
    'trn.progress': "{a} of {b} read",
    'trn.video': "Video",
    'trn.filesN': "{n} files",
    'trn.suggested': "Suggested: {s}",
    'trn.suggestedShort': "suggested",
    'trn.read': "Read",
    'trn.openVideo': "Open video",
    'trn.videoGone': "This video is no longer available.",
    'trn.videoProcessing': "The video is still processing… it will show up here in a few minutes.",
    'trn.open': "Open",
    'trn.download': "Download",
    'trn.files': "Files",
    'trn.saveFailed': "Couldn't save. Try again.",
    'trn.deleteConfirm': "Delete the lesson \"{n}\"?",
    'trn.senderNote': "Note from {n}:",
    'trn.moveTo': "Move to",
    'trn.moveOther': "Move to another section",
    'trn.pickSection': "Pick a section…",
    'trn.move': "Move",
    'trn.orderLabel': "Order in this section",
    'trn.orderUp': "Move up",
    'trn.orderDown': "Move down",
    'trn.inboxHint': "Tip: open Edit to write the explanation or attach files before (or after) moving it.",
    'trn.readDone': "Read ✓ (click to undo)",
    'trn.markRead': "I read and understood this",
    'trn.uploadFailed': "The upload failed. Check your connection and try again.",
    'trn.needTitle': "Give it a title.",
    'trn.needLink': "Paste the video link.",
    'trn.needVideo': "Upload the video first (or choose another option).",
    'trn.badLink': "That link doesn't look valid.",
    'trn.fTitle': "Title",
    'trn.fTitlePh': "e.g. How to file a new claim",
    'trn.fSection': "Section",
    'trn.fVideo': "Video",
    'trn.vKeep': "Keep current",
    'trn.vUpload': "Upload",
    'trn.vLink': "Link",
    'trn.vNone': "No video",
    'trn.vKeepRec': "The recording made in the app stays as the video.",
    'trn.uploading': "Uploading… {p}%",
    'trn.fBody': "Explanation",
    'trn.fBodyPh': "Write what the video teaches, the steps, what to watch out for…",
    'trn.addFiles': "Add files",
    'trn.filesHint': "PDFs, images and videos are shown embedded; anything else can be downloaded.",
    'trn.nameEn': "Name (English)",
    'trn.nameEs': "Name (Spanish)",
    'trn.renameSection': "Rename",
    'trn.deleteSection': "Delete section",
    'trn.sectionNotEmpty': "Move or delete its lessons first.",
    'trn.deleteSectionConfirm': "Delete this section?",
    'trn.sendToTraining': "Training",
    'trn.sendTitle': "Send to Training",
    'trn.sendHint': "It goes to the Training inbox; a super manager moves it to its section and writes the explanation.",
    'trn.sendDept': "Department",
    'trn.sendDeptAny': "Let them decide",
    'trn.sendNotePh': "Note for the super managers (optional)",
    'trn.sendBtn': "Send to Training",
    'trn.sent': "Sent to Training ✓",
    'trn.alreadySent': "This video is already in Training.",
    'trn.recInTraining': "This video is used in Training. Ask a super manager to remove it from Training first.",

    // ─── PROACTIVE AI (mig 0473, Manuel 2026-10-02) ───
    // El nombre de la sección es ESTA constante (y su par en i18n.es.ts): cambiarlo es tocar esta línea.
    'nav.ai': "Proactive AI",
    'ai.subtitle': "Pick an assistant and start a conversation. Your conversations are private to you.",
    'ai.notice': "Conversations in this section may be reviewed by management.",
    'ai.forbidden': "This section is for the office team.",
    'ai.noAssistants': "No assistants available for your role yet. Ask a manager.",
    'ai.settings': "Settings",
    'ai.newAssistant': "New assistant",
    'ai.manageAssistants': "Assistants",
    'ai.usageLine': "This month: {used} of {limit}",
    'ai.blocked': "You reached your monthly AI limit. Ask a manager to raise it.",
    'ai.cardAttachments': "Accepts files",
    'ai.newConversation': "New conversation",
    'ai.noConversations': "No conversations yet. Start one!",
    'ai.rename': "Rename",
    'ai.renamePrompt': "New title",
    'ai.delete': "Delete",
    'ai.deleteConfirm': "Delete this conversation? You won't see it anymore.",
    'ai.untitled': "New conversation",
    'ai.back': "Assistants",
    'ai.backToList': "Conversations",
    'ai.placeholder': "Write your message…",
    'ai.send': "Send",
    'ai.stop': "Stop",
    'ai.stopped': "Stopped.",
    'ai.attach': "Attach a file",
    'ai.attachHint': "PDF or images",
    'ai.attachTooBig': "That file is too large (max {mb} MB).",
    'ai.attachType': "Only PDF, images and text files can be attached.",
    'ai.uploading': "uploading…",
    'ai.copy': "Copy",
    'ai.copied': "Copied",
    'ai.thinking': "Thinking…",
    'ai.partial': "The answer was cut short.",
    'ai.emptyThread': "Say hello, or paste what you need help with.",
    'ai.err.default': "The model could not answer right now. Try again in a moment.",
    'ai.err.ai_not_configured': "The AI section is not configured yet. Ask Manuel to add the OpenRouter key.",
    'ai.err.ai_limit_reached': "You reached your monthly AI limit. Ask a manager to raise it.",
    'ai.err.ai_rate_limited': "The model is busy right now. Try again in a moment.",
    'ai.err.ai_timeout': "The model took too long. Try again or shorten your message.",
    'ai.err.ai_no_credits': "The AI account has no credits left. Tell a manager.",
    'ai.err.ai_bad_key': "The AI provider rejected our key. Tell a manager.",
    'ai.err.ai_model_not_found': "This assistant's model is not available. Tell a manager.",
    'ai.err.assistant_inactive': "This assistant was deactivated by management. You can still read the conversation.",
    'ai.err.attachments_not_allowed': "This assistant does not accept files.",
    'ai.err.conversation_not_found': "This conversation is not available.",
    'ai.err.network': "No connection. Check your internet and try again.",
    'ai.err.stream_cut': "The connection dropped before the answer finished.",

    // ─── PROACTIVE AI → engranaje (súper acceso) ───
    'aia.title': "Proactive AI settings",
    'aia.forbidden': "Only people with super access, or on the \"Who can create\" list, can open this.",
    'aia.tab.assistants': "Assistants",
    'aia.tab.access': "Super access",
    'aia.tab.review': "Conversation review",
    'aia.tab.usage': "Usage & limits",
    'aia.tab.creators': "Who can create",
    'aia.titleCreator': "Proactive AI · Assistants",
    'aia.creatorScopeHint': "You can create and edit assistants. Only the ones you created can be deleted; model settings, private sections, conversation review and usage are for super access.",
    'aia.creatorsTitle': "Who can create assistants",
    'aia.creatorsHint': "People on this list get the \"+ New assistant\" button in Proactive AI and the Assistants tab here: they create, edit, duplicate and order assistants, and delete the ones they created. They do not see model settings, private sections they are not a member of, conversation review, usage or costs. Anyone with super access can always create.",
    'aia.creatorsWho': "On the list ({n}): {names}",
    'aia.creatorsNobody': "Nobody on the list yet. People with super access can always create.",
    'aia.viaSuper': "super access",
    'aia.hasSuperAccess': "This person already has super access, so they can always create assistants.",
    'aia.roleCannotCreate': "Inspectors and the TV user can't create assistants.",
    'aia.noPeople': "No one matches.",
    'aia.createdBy': "by {name}",
    'aia.notYours': "created by someone else",
    'aia.onlyOwnDelete': "You can only delete the assistants you created.",
    'aia.modelsTitle': "Models & attachments",
    'aia.modelsSummary': "Default: {def} · Approved list: {n}",
    'aia.allModels': "all models",
    'aia.defaultModel': "Default model for new assistants",
    'aia.defaultModelHint': "Each assistant can pick its own model; this is just the starting point.",
    'aia.fallbackModel': "Fallback model",
    'aia.fallbackModelHint': "If the assistant's model fails or times out, the answer is retried once with this one.",
    'aia.noFallback': "No fallback",
    'aia.maxAttachment': "Max attachment size (MB)",
    'aia.zdr': "Strict zero data retention",
    'aia.zdrHint': "Only routes to providers that keep nothing. Fewer models available. Off by default (owner's decision 2026-10-02).",
    'aia.approved': "Approved models",
    'aia.approvedN': "{n} approved — assistants can only use these",
    'aia.approvedNone': "none selected — every model is allowed",
    'aia.searchModel': "Search models…",
    'aia.noModels': "No models match.",
    'aia.showAllModels': "Show models outside the approved list",
    'aia.perMTok': "per M tokens (in / out)",
    'aia.context': "context",
    'aia.readsImages': "reads images",
    'aia.noImages': "does not read images",
    'aia.assistantsTitle': "Assistants",
    'aia.assistantsHint': "What employees see as cards. Order here is the order on their screen. Instructions never reach their browser.",
    'aia.newAssistant': "New assistant",
    'aia.editAssistant': "Edit assistant",
    'aia.noAssistants': "No assistants yet. Create the first one.",
    'aia.systemHint': "System assistants have a fixed job (the inspector's voice dictation at check-out). Edit their instructions and model; they can't be deleted.",
    'aia.system': "System",
    'aia.inactive': "Inactive",
    'aia.inspectors': "inspectors (check-out dictation)",
    'aia.sees': "Who sees it",
    'aia.visAll': "Everyone",
    'aia.visSpecific': "Specific roles or departments",
    'aia.visNobody': "nobody",
    'aia.visNobodyWarn': "Pick at least one role or department, or nobody will see it.",
    'aia.attachments': "attachments",
    'aia.convCount': "{n} conversations",
    'aia.moveUp': "Move up",
    'aia.moveDown': "Move down",
    'aia.activate': "Activate",
    'aia.deactivate': "Deactivate",
    'aia.duplicate': "Duplicate",
    'aia.delete': "Delete",
    'aia.deleteConfirm': "Delete \"{name}\"? Existing conversations stay readable.",
    'aia.name': "Name",
    'aia.namePh': "e.g. Emails to adjusters",
    'aia.nameRequired': "The name is required.",
    'aia.description': "Short description",
    'aia.descriptionPh': "What it's for, in one line",
    'aia.icon': "Icon",
    'aia.instructions': "Instructions (system prompt)",
    'aia.instructionsPh': "How it should work: tone, length, rules, format, what to never do…",
    'aia.instructionsHint': "Every change here is saved as a version with who and when.",
    'aia.model': "Model",
    'aia.modelFromAi': "Model: the “Dictation (whole app)” one in Settings → AI — the same for everything dictated in the app. Only the instructions are edited here.", 'aia.modelFromAiShort': "model: Settings → AI → Dictation",
    'aia.modelNotApproved': "That model is not on the approved list.",
    'aia.allowAttachments': "Allow attachments",
    'aia.allowAttachmentsHint': "PDF, images and text files. PDFs with text are read as text; scanned ones go through OCR.",
    'aia.modelNoImagesWarn': "This model does not read images: photos attached by employees will be ignored. PDFs still work.",
    'aia.active': "Active",
    'aia.activeHint': "Inactive: hidden from employees; their conversations stay readable.",
    'aia.whoSees': "Who sees it",
    'aia.roles': "Roles",
    'aia.departments': "Departments",
    'aia.refDocs': "Reference documents",
    'aia.refDocsHint': "PDF or text the assistant uses as context (examples of emails, internal guides).",
    'aia.refDocsSaveFirst': "Save the assistant first, then add documents.",
    'aia.addRefDoc': "Add document",
    'aia.uploading': "Uploading {name}…",
    'aia.removeFile': "Remove document",
    'aia.removeFileConfirm': "Remove this document from the assistant?",
    'aia.noTextExtracted': "no text could be extracted (scanned?)",
    'aia.refTypeNotAllowed': "Reference documents must be PDF or text files.",
    'aia.versions': "History ({n} versions)",
    'aia.accessTitle': "Who has super access",
    'aia.accessHint': "Super access = this settings page, managing assistants, reviewing anyone's conversations, usage and costs. The master always has it. The list can never be empty.",
    'aia.accessWho': "Today ({n}): {names}",
    'aia.person': "Person",
    'aia.role': "Role",
    'aia.grantedBy': "Granted by",
    'aia.always': "always",
    'aia.cannotRevokeSelf': "You can't remove your own access.",
    'aia.listEmpty': "Someone has to keep super access.",
    'aia.reviewTitle': "Conversation review",
    'aia.reviewHint': "Read-only. Deleted conversations stay here. Every time you open someone else's conversation it is logged.",
    'aia.readOnlyNotice': "Read-only view. Opening this conversation was logged with your name and the time.",
    'aia.allPeople': "All people",
    'aia.allAssistants': "All assistants",
    'aia.from': "From",
    'aia.to': "To",
    'aia.searchText': "Search in messages…",
    'aia.noConversations': "No conversations match.",
    'aia.when': "Last activity",
    'aia.assistant': "Assistant",
    'aia.titleCol': "Title",
    'aia.msgs': "Msgs",
    'aia.cost': "Cost",
    'aia.deletedByUser': "deleted by the employee",
    'aia.backToList': "Back to the list",
    'aia.viewedBy': "Viewed by",
    'aia.usageTitle': "Usage & limits",
    'aia.prevMonth': "Previous month",
    'aia.nextMonth': "Next month",
    'aia.spent': "spent this month",
    'aia.answers': "answers",
    'aia.activePeople': "people used it",
    'aia.nearLimit': "at {pct}%+ of their limit",
    'aia.chartPeople': "Spent vs limit per person",
    'aia.chartLegend': "Bar = spent this month; the mark = that person's limit. Orange from the alert % on, red when blocked.",
    'aia.used': "Spent",
    'aia.limit': "Limit (USD)",
    'aia.default': "default",
    'aia.resetDefault': "Back to the default ({n})",
    'aia.invalidLimit': "Enter a valid amount.",
    'aia.tokens': "Tokens in→out",
    'aia.lastUsed': "Last used",
    'aia.byAssistant': "By assistant",
    'aia.people': "People",
    'aia.byMonth': "Last 12 months",
    'aia.defaultsTitle': "Defaults & alerts",
    'aia.defaultLimit': "Default monthly limit per person (USD)",
    'aia.defaultLimitHint': "Applies to everyone without their own limit. Reaching it blocks new messages until raised.",
    'aia.alertPct': "Alert at (%)",
    'aia.alertPctHint': "At this % and at 100 %, the person and everyone with super access get a notification (once per month each).",

    // ─── Dictado por voz del inspector (check-out) ───
    'insp.voice.start': "Dictate what happened",
    'insp.voice.hint': "Tap, say what happened during the inspection, tap again. It comes back written in professional English for you to review.",
    'insp.voice.stop': "Stop",
    'insp.voice.recording': "Listening… speak normally, in Spanish or English.",
    'insp.voice.processing': "Transcribing and writing it up…",
    'insp.voice.heard': "What we heard",
    'insp.voice.use': "Use this text",
    'insp.voice.retry': "Dictate again",
    'insp.voice.noMic': "Microphone not available or permission denied. Type the notes.",
    'insp.voice.tooShort': "That was too short. Try again.",
    'insp.voice.notConfigured': "Voice notes are not set up yet. Type the notes.",
    'insp.voice.limit': "You reached your monthly AI limit. Type the notes or ask the office to raise it.",
    'insp.voice.failed': "Could not process the recording. Try again or type the notes.",
    'insp.voice.unsupported': "This browser can't record audio. Type the notes.",

    // ─── PROACTIVE AI: homeowner en la conversación + generador de prompt ───
    'ai.claimPick': "Pick a homeowner",
    'ai.claimSearchPh': "Homeowner, address or claim #…",
    'ai.claimNoHits': "No claims match.",
    'ai.claimRemove': "Remove the homeowner from this conversation",
    'ai.claimAttachedHint': "The assistant reads this claim's file (card, timeline, emails, appointments, files) before answering.",
    'ai.claimEmptyHint': "Tip: pick a homeowner above and the assistant will check the claim file and suggest what it finds.",
    'aia.allowClaimContext': "Can pick a homeowner (reads the claim file)",
    'aia.allowClaimContextHint': "The employee selects a claim; the assistant reviews the card, timeline, emails, appointments and files, uses them in the answer and suggests what it found.",
    'aia.builderTitle': "Write the prompt with AI",
    'aia.builderHint': "Describe in your own words what this assistant should do and how it should behave. The AI turns it into the full, detailed prompt below and suggests the best model for the job.",
    'aia.builderBrief': "What do you need it to do?",
    'aia.builderBriefPh': "e.g. Responds to insurance adjusters' emails about our estimates. Serious but polite, always defends our scope, never promises amounts, ends with a clear next step…",
    'aia.builderTone': "Character",
    'aia.tone.professional': "Professional",
    'aia.tone.friendly': "Friendly",
    'aia.tone.direct': "Direct & concise",
    'aia.tone.empathetic': "Empathetic",
    'aia.tone.formal': "Formal (legal / insurance)",
    'aia.tone.persuasive': "Persuasive advocate",
    'aia.tone.teacher': "Teacher / explainer",
    'aia.builderLength': "Answer length",
    'aia.len.very_short': "Very short",
    'aia.len.short': "Short",
    'aia.len.medium': "Medium",
    'aia.len.detailed': "Detailed",
    'aia.builderLanguage': "Answer language",
    'aia.lang.match': "Same as the employee writes",
    'aia.lang.english': "English",
    'aia.lang.spanish': "Spanish",
    'aia.lang.both': "English + Spanish",
    'aia.builderAudience': "Who reads the output",
    'aia.aud.adjusters': "Insurance adjusters",
    'aia.aud.homeowners': "Homeowners",
    'aia.aud.contractors': "Contractors",
    'aia.aud.internal': "Our office",
    'aia.aud.mixed': "Mixed / depends",
    'aia.builderFormat': "Output format",
    'aia.fmt.auto': "Whatever fits",
    'aia.fmt.paragraphs': "Paragraphs",
    'aia.fmt.bullets': "Bullet points",
    'aia.fmt.email': "Ready-to-send email",
    'aia.fmt.steps': "Numbered steps",
    'aia.builderNever': "It must never…",
    'aia.builderNeverPh': "e.g. promise amounts, give legal advice, mention fees",
    'aia.builderGenerate': "Generate the prompt",
    'aia.builderGenerating': "Writing the prompt…",
    'aia.builderDone': "Prompt generated. Review it below, edit if you want, then save.",
    'aia.builderSuggested': "Suggested model",
    'aia.builderUseModel': "Use this model",
    'aia.builderModelInUse': "In use",
    'aia.builderRegenerate': "Generate again",
    'aia.briefRequired': "Write what you need first.",
    'aia.claimFile': "claim file",
    // Training: Improve with AI, Manuel 2026-10-02
    'trn.aiImprove': "Improve with AI",
    'trn.aiWorking': "Improving…",
    'trn.aiUndo': "Undo",
    'trn.aiHint': "Reads the title, explanation and files and rewrites it as a clear lesson for a new employee — always in English (you can write it in Spanish).",
    'trn.aiFailed': "The AI couldn't improve it this time. Your text is unchanged; try again.",
    'trn.aiNothing': "Write a title or some notes first.",
    // Training: dictar + hashtags, Manuel 2026-10-02
    'trn.dictate': "Dictate",
    'trn.dictStop': "Stop",
    'trn.dictListening': "Listening… speak in English or Spanish, then press Stop.",
    'trn.dictHint': "Say it out loud (English or Spanish). The AI transcribes it, translates it to English and turns it into a clear lesson.",
    'trn.dictNoMic': "Couldn't use the microphone. Check the browser permission.",
    'trn.dictTooShort': "The recording was too short. Try again.",
    'trn.dictNotHeard': "Couldn't understand the audio. Try again closer to the mic.",
    'trn.fTags': "Hashtags",
    'trn.tagsHint': "Used by the search box. \"Improve with AI\" and \"Dictate\" suggest them; edit freely.",
    'trn.tagSearch': "Search lessons with this hashtag",
    'inbox.mailboxAdoptHint': 'This email lives in your personal mailbox: assigning it copies it into the team inbox (and the claim) so others can work it.',
    'smsAlert.assignTo': 'Assign to…', 'smsAlert.assignTitle': 'Hand this conversation to someone: it goes to their To Do and the alert moves to them.',

    // ─── Dictado genérico (botón del engranaje) ───
    'ai.dict.start': "Dictate",
    'ai.dict.hint': "Speak in English or Spanish; the text goes into the box as you said it.",
    'ai.dict.stop': "Stop",
    'ai.dict.transcribing': "Transcribing…",
    'ai.dict.noMic': "Microphone not available or permission denied.",
    'ai.dict.tooShort': "That was too short. Try again.",
    'ai.dict.notConfigured': "Dictation is not configured yet.",
    'ai.dict.failed': "Could not transcribe the recording. Try again.",
    'ai.dict.unsupported': "This browser can't record audio.",

    // ─── PROACTIVE AI: pestañas por departamento ───
    'ai.tabGeneral': "General",
    'ai.tabsLabel': "Sections",
    'ai.tabEmpty': "No assistants in this section yet.",
    'aia.section': "Section (tab the employee sees it in)",
    'aia.sectionHint': "General = the first tab, for everyone's everyday tools. A department = its own tab. This is grouping only; who can see it is set below.",
    'aia.sectionEmpty': "Nothing here yet.",

    // ─── PROACTIVE AI: respuesta limpia, copiar todo, fórmula de uso ───
    'ai.copyAll': "Copy text",
    'ai.copyAllHint': "Copies the whole answer as clean text, ready to paste (the note below is not copied).",
    'ai.noteLabel': "Note for you (not copied)",
    'ai.howtoTitle': "How to use it",
    'ai.howtoDefault': "Put what you RECEIVED in \"quotes\" (the email or message), then write what you want to answer or do. You get back only the final text, ready to copy.",
    'ai.howtoClaim': "Pick the homeowner (top right) and it also checks the claim file for context.",
    'ai.howtoShow': "How to use it",
    'aia.usageHint': "How to use it (the employee sees this at the top)",
    'aia.usageHintPh': "e.g. Paste the adjuster's email in \"quotes\", then write what you want to answer. Pick the homeowner so it checks the claim.",
    'aia.usageHintHint': "The formula in one or two lines. Empty = the generic formula (what you received in quotes + what you want to say). The prompt generator fills it for you.",

    // ─── PROACTIVE AI: secciones privadas (Human Resources, …) ───
    'ai.tabPrivate': "Private section",
    'aia.privateSections': "Private sections",
    'aia.privateSectionsHint': "A private section is its own tab that ONLY its members (and the master) can see, with its assistants. Add the people, then put assistants in it from each assistant's Section field. Super access lets you manage it here, but to use its assistants you must be a member too.",
    'aia.noSections': "none",
    'aia.noMembers': "no members yet — nobody sees it",
    'aia.members': "Members",
    'aia.saveMembers': "Save members ({n})",
    'aia.searchPerson': "Search a person…",
    'aia.newSection': "Add section",
    'aia.newSectionPh': "New private section name",
    'aia.sectionNotEmpty': "Move its assistants to another section first.",
    'aia.sectionExists': "A section with that name already exists.",
    'aia.deleteSectionConfirm': "Delete the section \"{name}\"?",
    'aia.convCountAssistants': "{n} assistants",
    'aia.sectionPrivateHint': "Private section: only its members see this assistant, no matter what \"Who sees it\" says below.",
    'aia.modelsRecommended': "Recommended",
    'aia.modelsCount': "{n} models, grouped by provider. Type above to search (e.g. gpt, claude, gemini).",

    'aia.builderSelected': "Model selected for this job",
    'aia.builderCost': "≈ {cost} per 100 answers",
    'aia.builderCheaper': "Cheaper: {name} (≈ {cost})",
    'aia.builderStronger': "Stronger: {name} (≈ {cost})",
    'aia.builderKeepPrev': "Go back to {name}",
    'aia.level.simple': "Simple job",
    'aia.level.standard': "Standard job",
    'aia.level.advanced': "Advanced job",
    'team.fullName': 'Full name', 'team.fullNamePh': 'e.g. Ana Perez', 'team.emailLogin': 'Email (used to sign in)', 'team.emailPh': 'e.g. ana@claimsproactive.com', 'team.emailInvalid': 'The Email field needs a real email address (e.g. ana@claimsproactive.com). The full name goes in the first field.',
    'rm.paymentPendingTitle': 'Waiting for payment at 1ESX', 'rm.paymentPendingBody': 'The order is placed but 1ESX has it on hold until it is paid, so the report is not being prepared. Pay it in the 1ESX portal (My account → Orders); once paid, the PDF/ESX arrive here on their own.',
    // ESX required modal (Manuel 2026-10-05)
    'esxReq.title': 'Upload the .ESX of this estimate', 'esxReq.body': 'Every Proactive estimate must have its Xactimate .ESX file. Upload it now to continue.',
    'esxReq.for': 'Estimate:', 'esxReq.drop': 'Drop the .ESX here or click to choose it', 'esxReq.uploading': 'Uploading the .ESX…',
    'esxReq.onlyEsx': 'That is not an .ESX file', 'esxReq.noSkip': 'This window closes on its own once the .ESX is uploaded. The claim cannot move forward without it.',
    'sup.createdBy': 'Created by', 'sup.createdMonday': 'Imported from Monday — author not recorded', 'sup.createdUnknown': 'Author not recorded',
    // Settings → AI (mig 0485): un modelo por función, OpenRouter y el gasto.
    'aim.tab': "AI",
    'aim.title': "AI models",
    'aim.intro': "Everything in the app that uses AI, which model each thing runs on today, and what it has cost. Pick a simple model for simple jobs and keep the strong ones for the hard ones.",
    'aim.forbidden': "Only the people on the Proactive AI access list can see this.",
    'aim.spent': "Spent this month",
    'aim.spentEst': "Includes an estimate: calls sent straight to Claude do not report their cost, so it is calculated from the tokens at list price.",
    'aim.calls': "AI calls",
    'aim.balance': "OpenRouter balance",
    'aim.balanceUnknown': "Could not read it",
    'aim.problems': "Errors · fallbacks",
    'aim.assistantsSpent': "Employee assistants",
    'aim.routeTitle': "Send everything through OpenRouter",
    'aim.routeOn': "ON — every function below goes through OpenRouter. If OpenRouter fails, that call goes straight to Claude and it is noted here as a fallback.",
    'aim.routeOff': "OFF — everything goes straight to Claude, as it always has. You can already choose a cheaper Claude model per function; models from other companies (GPT, Gemini…) need this switch on.",
    'aim.routeNoKey': "The OpenRouter key is not set in Railway (OPENROUTER_API_KEY).",
    'aim.turnOn': "Turn on",
    'aim.turnOff': "Turn off",
    'aim.confirmOnTitle': "Before turning it on",
    'aim.confirmOnPace': "These functions are spending about {avg} per day. With {left} of balance that is roughly {days} days.",
    'aim.confirmOnNoPace': "There is not enough history yet to say how long the balance lasts. It is {left} today.",
    'aim.confirmOnShared': "It is the same balance the employees’ assistants use. If it runs out, their assistants stop answering; the functions on this page keep working through Claude directly.",
    'aim.confirmOnDo': "Turn on OpenRouter",
    'aim.lowBalance': "Low balance: at the current pace it lasts about {days} days. Add credit in OpenRouter (and turn on auto top-up).",
    'aim.byDay': "Spend per day",
    'aim.noUsageYet': "Nothing recorded yet for this month. The count starts with the first call after this screen was deployed.",
    'aim.colFunction': "What it does",
    'aim.colModel': "Model",
    'aim.colMonth': "This month",
    'aim.default': "default",
    'aim.change': "Change",
    'aim.backToDefault': "Back to default ({m})",
    'aim.price': "{in} in · {out} out per 1M tokens",
    'aim.suggest': "Suggested: {m}",
    'aim.suggestWhy': "A simple job: a cheaper model of the same family does it. About {pct}% cheaper per call.",
    'aim.use': "Use it",
    'aim.runningOther': "Running on {m} until OpenRouter is turned on.",
    'aim.setBy': "Chosen by {who}",
    'aim.test': "Test",
    'aim.instr': "Rules",
    'aim.instrCustom': "custom",
    'aim.instrTitle': "Rules for: {f}",
    'aim.instrDefaultTitle': "What the app already tells the model (fixed — shown so your rules don't contradict it)",
    'aim.instrHint': "Your rules are added at the end of what the app already tells the model, on every call of this function, and win over its style rules. The output format (the tool, the HTML, the markers) stays as the app needs it.",
    'aim.instrPh': "The rules this function will always follow. Generate them from your words above, or write them here.",
    'aim.instrSave': "Save rules",
    'aim.instrClear': "Remove my rules",
    'aim.err.ai_instructions_not_editable': "This function does not take custom instructions.",
    'aim.err.ai_instructions_too_long': "Too long: 6,000 characters max.",
    'aim.testing': "Testing…",
    'aim.testOk': "Works — {s}s through {via}",
    'aim.testFail': "Failed: {err}",
    'aim.testHint': "Sends a small real request through this function’s route, with the same kind of file it reads.",
    'aim.via.openrouter': "OpenRouter",
    'aim.via.anthropic': "Claude direct",
    'aim.nCalls': "{n} calls",
    'aim.nErrors': "{n} failed",
    'aim.nFallbacks': "{n} by fallback",
    'aim.noCalls': "No calls",
    'aim.avgMs': "avg. {s}s",
    'aim.tier.simple': "Simple",
    'aim.tier.standard': "Standard",
    'aim.tier.complex': "Complex",
    'aim.auto': "Runs on its own",
    'aim.onClick': "On click",
    'aim.in.pdf': "PDF",
    'aim.in.image': "Image",
    'aim.in.text': "Text",
    'aim.pick': "Choose a model",
    'aim.search': "Search a model…",
    'aim.recommended': "Recommended",
    'aim.needsOpenRouter': "needs OpenRouter on",
    'aim.onlyCompatible': "Only models that can do this job are listed ({n}).",
    'aim.modelsFailed': "The model list from OpenRouter did not load. You can see what is set, but not change it right now.",
    'aim.otherTitle': "Other AI in the app",
    'aim.fixedModel': "Fixed model",
    'aim.openGear': "Open the Proactive AI gear",
    'aim.nAssistants': "{n} active assistants · {m} answers this month",
    'aim.audioMin': "{n} min of audio",
    'aim.notMeasured': "Billed by the provider; not measured here",
    'aim.err.ai_needs_openrouter': "Models that are not Claude only work through OpenRouter. Turn the switch on first.",
    'aim.err.ai_model_no_files': "This function sends PDFs and that model does not read them.",
    'aim.err.ai_model_no_images': "This function sends images and that model does not read them.",
    'aim.err.ai_model_no_tools': "This function needs a model that supports tool calls.",
    'aim.err.ai_models_unavailable': "Could not load the model list from OpenRouter. Try again.",
    'aim.err.ai_model_not_found': "That model is not in the OpenRouter list.",
    'aim.err.ai_not_configured': "The OpenRouter key is not set.",
    'aim.err.generic': "Could not save. Try again.",
    'hou.modelMoved': "The model is chosen in Settings → AI",
    'aim.g.general': "Whole app",
    'aim.g.estimates': "Estimates & supplements",
    'aim.g.roof': "Roof",
    'aim.g.policies': "Policies",
    'aim.g.payments': "Payments & checks",
    'aim.g.files': "Files & intake",
    'aim.g.contracts': "Contracts",
    'aim.g.comms': "Messages",
    'aim.g.calls': "Calls",
    'aim.g.people': "People & training",
    'aim.g.legacy': "Old code — no screen uses it",
    'aim.f.supp_compare': "Our estimate vs. the insurance estimate", 'aim.f.supp_compare.d': "Supplements: the app pairs the line items of the two readings and computes every difference itself (amounts, quantities, unit prices, pages); this model only explains each difference, picks the category and playbook item, and resolves the ambiguous pairings. Short answers now; the PDFs go to the model only when a reading cannot be made.",
    'aim.f.supp_consistency': "Consistency of our new estimate", 'aim.f.supp_consistency.d': "Checks that our revised estimate covers each item in dispute.",
    'aim.f.supp_order_check': "Review Estimate: order vs. estimate", 'aim.f.supp_order_check.d': "Checks whether the estimator’s line items cover what Supplements asked for.",
    'aim.f.supp_dispute_notes': "Dispute notes per line item", 'aim.f.supp_dispute_notes.d': "Writes the dispute note for each disputed line item.",
    'aim.f.supp_dispute_email': "Dispute email to the carrier", 'aim.f.supp_dispute_email.d': "Drafts the dispute email with the disputed items and their photo links.",
    'aim.f.supp_improve_email': "Polish a dispute email", 'aim.f.supp_improve_email.d': "Improves an email the person wrote, keeping the facts and the links.",
    'aim.f.supp_item_note': "Note of a manually added item", 'aim.f.supp_item_note.d': "Rewrites the note of a line item added by hand.",
    'aim.f.supp_rebuttal': "Live rebuttal script", 'aim.f.supp_rebuttal.d': "Writes what to answer when the adjuster objects, during the call.",
    'aim.f.estimate_backfill': "Estimate maintenance scripts", 'aim.f.estimate_backfill.d': "One-off scripts that re-read old estimate PDFs (totals, classification). They only run when someone launches them by hand.",
    'aim.f.roof_reader': "Roof report reader", 'aim.f.roof_reader.d': "Reads the roof measurement report (Roofr, EagleView, Hover — PDF, image or CSV): squares, pitch, ridges, valleys, facets.",
    'aim.f.roof_summary': "Roof measurements summary", 'aim.f.roof_summary.d': "A short briefing written when the verified report arrives.",
    'aim.f.roof_compare': "Sketch vs. verified report", 'aim.f.roof_compare.d': "Explains the difference between our sketch and the verified measurements. The numbers are compared by the app, not by the model.",
    'aim.f.policy_extraction': "Coverage detector (policy reader)", 'aim.f.policy_extraction.d': "Reads the whole policy: coverages, limits, deductibles, exclusions, building code, red flags and claim strategies, with quotes and page numbers.",
    'aim.f.policy_chat': "Ray — questions about the policy", 'aim.f.policy_chat.d': "The chat that answers questions about a policy, with citations.",
    'aim.f.check_parser': "Check reader", 'aim.f.check_parser.d': "Reads the scanned check: number, amount, payee, insurer, claim number and date, to pre-fill Checks Received.",
    'aim.f.payment_proof': "Proof of payment check", 'aim.f.payment_proof.d': "Compares the bank’s proof of payment with the expected amount and payee before the payment emails go out.",
    'aim.f.check_scan': "Printed check reader", 'aim.f.check_scan.d': "Transcribes the printed check (photo or PDF) so the amount, the payee and the check number can be cross-checked. The model only READS: the comparison is done in code.",
    'aim.f.bank_doc_reading': "Contractor bank document", 'aim.f.bank_doc_reading.d': "Reads the W9, voided check or bank letter the contractor sends and pulls out the full account number and routing, so every proof of payment can be checked against the account on file.",
    'aim.f.invoice_parser': "Historical invoice reader", 'aim.f.invoice_parser.d': "Reads an old Proactive invoice: number, date, approved RCV, fee and totals.",
    'aim.f.contractor_invoice': "Contractor invoice reader", 'aim.f.contractor_invoice.d': "Reads the invoice a contractor uploads: vendor, number, date and total.",
    'aim.f.payment_summary': "Payment summary email", 'aim.f.payment_summary.d': "Writes the wording of the payment summary email. The amounts are put in by the app, not by the model.",
    'aim.f.price_list_import': "Price list import (PDF)", 'aim.f.price_list_import.d': "Reads the monthly Xactimate price list PDF uploaded in Supplements → Price lists when the code cannot parse its layout or it is scanned: every item with its unit price.",
    'aim.f.estimating_item_explain': "Estimator guide (item explanation)", 'aim.f.estimating_item_explain.d': "Writes the guidance card of a catalog item for the Estimating Tool (Settings → Supplements → Items): what it is, when it goes in the estimate, how it is measured and what adjusters dispute. Text only; a card written by hand is never overwritten.",
    'aim.f.estimating_room_ai': "Estimate a room with AI", 'aim.f.estimating_room_ai.d': "Estimating Tool: the estimator writes or dictates what happened in a room and the model suggests the catalog items and macro lines that apply, with quantities from the room measurements, for the estimator to tick. Two short calls with a tool; nothing is saved by itself.",
    'aim.f.estimating_items_photo': "Items from a Xactimate photo", 'aim.f.estimating_items_photo.d': "Price lists → Items: a screenshot of the Xactimate item list is read row by row (code, description, unit, price) and loaded into the catalog with the official price of the chosen price list; the office sees which items are new. One call with a tool.",
    'aim.f.file_classifier': "File classifier", 'aim.f.file_classifier.d': "Looks at every file uploaded to a claim and says what it is (estimate, policy, check, COC, photo…), with a short summary. Runs on every upload: the job with the most volume.",
    'aim.f.intake_email': "Lead from an email", 'aim.f.intake_email.d': "Pulls the data of a new lead out of an incoming email.",
    'aim.f.contract_reader': "Signed contract reader", 'aim.f.contract_reader.d': "Reads an uploaded contract / LOR: name, address, insurer, policy number, date and signatures.",
    'aim.f.contract_validation': "Contract vs. claim comparison", 'aim.f.contract_validation.d': "Compares the contract’s data with the claim’s and explains the differences.",
    'aim.f.ho_updates': "Weekly homeowner update", 'aim.f.ho_updates.d': "Writes the weekly update for every active claim: about 1,400 per run. The biggest recurring batch.",
    'aim.f.ho_draft': "Homeowner update draft (Scheduling)", 'aim.f.ho_draft.d': "Drafts a short update for the homeowner from the claim’s status and appointments.",
    'aim.f.contractor_update': "Contractor update draft", 'aim.f.contractor_update.d': "Drafts the update for the contractor from the latest notes of the claim.",
    'aim.f.text_rewrite': "Improve / shorten / translate buttons", 'aim.f.text_rewrite.d': "The AI buttons of the text editor all over the app.",
    'aim.f.concern_summary': "Client concern summary", 'aim.f.concern_summary.d': "When a homeowner files a concern on the website: what they say, what the file shows, and reply drafts in English and Spanish.",
    'aim.f.call_summary': "Call summary and alerts", 'aim.f.call_summary.d': "For every recorded call matched to a claim: summary, who said what, and the alerts of Call Monitoring. The audio is turned into text first (Whisper, below).",
    'aim.f.call_apology': "Apology draft after a call alert", 'aim.f.call_apology.d': "Drafts the apology to the homeowner (SMS or email) from a call alert.",
    'aim.f.call_coaching': "Coaching message to the employee", 'aim.f.call_coaching.d': "Drafts the manager’s message to the employee about a call alert.",
    'aim.f.chat_translate': "Chat update translation", 'aim.f.chat_translate.d': "The Translate button on a claim chat update: English ↔ Spanish, saved per message.",
    'aim.f.call_alert_translate': "Call alert translation", 'aim.f.call_alert_translate.d': "Translates each call alert finding into Spanish when the app is in Spanish (cached per alert).",
    'aim.f.kudos_judge': "Kudos merit check", 'aim.f.kudos_judge.d': "Decides whether the work behind a kudo shows real merit. Runs every 5 minutes.",
    'aim.f.yearly_review': "Yearly evaluation suggestion", 'aim.f.yearly_review.d': "Writes a suggestion for an employee’s yearly evaluation from their numbers.",
    'aim.f.training_lesson': "Training lesson writer", 'aim.f.training_lesson.d': "Turns rough notes or a dictation into a Training lesson.",
    'aim.f.policy_legacy': "Old policy reader", 'aim.f.policy_legacy.d': "The reader from before the Coverage detector. It is still in the code, but no screen calls it.",
    'aim.f.negotiation_legacy': "Old estimate comparison", 'aim.f.negotiation_legacy.d': "The comparison from before the Supplements one. It is still in the code, but no screen calls it.",
    'aim.f.transcription': "Speech to text (Whisper)", 'aim.f.transcription.d': "Turns audio into text: call recordings, the inspector’s dictated check-out, and dictation in Training and Proactive AI. A fixed OpenAI model; it does not go through OpenRouter.",
    'aim.f.welcome_call': "Welcome call (voice agent)", 'aim.f.welcome_call.d': "The automatic welcome call to the homeowner. It is a Bland.ai service with its own account and its own bill.",
    'aim.f.assistants': "Proactive AI assistants", 'aim.f.assistants.d': "The employees’ assistants and the inspector’s dictated check-out. Each one has its own model, chosen in the Proactive AI gear; they already go through OpenRouter.",
    // ── Playbook de disputas: las dos funciones de IA (Settings → AI) ──
    'aim.f.dictation': "Dictation (whole app)", 'aim.f.dictation.d': "Every microphone in the app: Whisper transcribes word for word and THIS model organizes it — the dispute playbook (Settings → Supplements), the inspector's check-out notes, the Proactive AI chat, the brief when creating an assistant, and Training lessons. One model for all dictation, by the owner's rule; new dictation screens use it too.",
    'aim.f.prompt_writer': "Prompt writer (whole app)", 'aim.f.prompt_writer.d': "Every “Create / Generate prompt” button in the app: the Proactive AI assistants (gear) and the dispute playbook. One model for all of them — the smartest you can afford: it writes instructions that then run thousands of times.",
    // ── Playbook de disputas (Settings → Supplements) + medidas y rebuttals en Review Estimate ──
    'dpb.title': 'Dispute playbook', 'dpb.items': 'items', 'dpb.rebuttals': 'rebuttals',
    'dpb.hint': 'The line items the adjusters usually cut, each with the arguments we use to dispute them. Add them one at a time below: the exact Xactimate name, when it gets disputed, and each rebuttal dictated on its own. Then “Create prompt”: the Review Estimate analysis uses this playbook to offer the rebuttal options under every disputed item.',
    'dpb.loadErr': 'Could not load the playbook.', 'dpb.errAi': 'AI is not configured on the server.',
    'dpb.organize': 'Organize with AI', 'dpb.organizing': 'Organizing…', 'dpb.clear': 'Clear', 
    'dpb.aliasesPh': 'Also written as (comma separated): starter, starter row, asphalt starter', 'dpb.addRebuttal': 'Add rebuttal', 
    'dpb.savedN': 'Saved: {i} item(s), {r} new rebuttal(s)', 'dpb.baseTitle': 'The playbook', 'dpb.addItem': 'Add item', 'dpb.itemNamePh': 'Item name, e.g. Starter course',
    'dpb.rebuttalsPh': 'One rebuttal per line (English)', 'dpb.empty': 'No items yet. Dictate above or add one by hand.', 'dpb.fromAi': 'from AI', 'dpb.timesUsed': 'Times chosen in analyses',
    'dpb.retire': 'Retire this rebuttal (it stays in saved analyses)', 'dpb.retireConfirm': 'Retire this rebuttal? It will no longer be offered; analyses that already chose it keep it.',
    'dpb.retireItem': 'Retire item', 'dpb.retireItemConfirm': 'Retire this item and all its rebuttals? Saved analyses keep what they chose.', 'dpb.newRebuttalPh': 'New rebuttal for this item…',
    'dpb.measTitle': 'Roof measurements', 'dpb.measHint': 'Our measurements are manual (Roofr) unless there is a delivered 1ESX verified-measurements order. With manual measurements, if the carrier is under ours by up to this many squares, the carrier is probably right and quantities are not disputed; above ours is accepted; beyond the tolerance the analysis raises a red alert and asks who is right.',
    'dpb.tolerance': 'Tolerance (roof only)',
    'dpb.wasteDefault': 'Default waste factor', 'dpb.wasteDefaultHint': 'install = tear off × (1 + waste). Each claim can set its own in Review Estimate; with “Insurance is right” their tear off is accepted and the install must carry this waste.',
    'dpb.promptTitle': 'The prompt for the analysis', 'dpb.promptActive': 'Version {v} active', 'dpb.promptNone': 'No prompt created yet — the analysis uses the playbook as-is',
    'dpb.createPrompt': 'Create prompt', 'dpb.promptNeedsItems': 'Add at least one item with a rebuttal first', 'dpb.promptCreated': 'Prompt v{v} created and active',
    'dpb.promptHint': 'The “Prompt writer” (Settings → AI, the same one for every prompt button in the app) turns the playbook plus the owner rules into the instructions the estimate comparison receives. Each click creates a new version; you can go back to an older one.',
    'dpb.active': 'Active', 'dpb.useThis': 'Use this version', 'dpb.fallbackShow': 'Show what the analysis receives today (playbook as-is)',
    'dpb.addTitle': 'Add an item — one at a time', 'dpb.addHint': 'Type the item name exactly as Xactimate writes it, mark when it gets disputed, then dictate each rebuttal with its own microphone (dictating in the last row opens the next one). “Organize with AI” rewrites them in clean English; you review and add the item.',
    'dpb.itemNameExact': 'Item name — exactly as Xactimate writes it', 'dpb.itemNameExactPh': 'e.g. Asphalt starter - universal starter course',
    'dpb.whenTitle': 'Disputed when', 'dpb.whenHint': 'Marks every rebuttal of this item (you can adjust each one in the preview). Nothing marked = the rebuttals show in any situation.',
    'dpb.when.missing': 'Missing from their estimate', 'dpb.when.quantity': 'Wrong quantity (measurement)', 'dpb.when.unit_price': 'Wrong unit price',
    'dpb.tag.missing': 'missing', 'dpb.tag.quantity': 'quantity', 'dpb.tag.unit_price': 'unit price',
    'dpb.rowsTitle': 'Rebuttals — one at a time', 'dpb.rowPh': 'Dictate or type ONE argument, as you would tell it to the adjuster…', 'dpb.addAnother': 'Add another rebuttal',
    'dpb.needNameAndOne': 'The item name and at least one rebuttal are needed', 'dpb.previewItemTitle': 'Preview — fix anything, then add it', 'dpb.addToPlaybook': 'Add to playbook', 'dpb.backToEdit': 'Back to the dictations',
    'neg.measTitle': 'Roof measurements — who is right?', 'neg.measOurs': 'Our measurements', 'neg.measTheirs': 'Insurance measurements accepted',
    'neg.measWasteFactor': 'Waste factor', 'neg.measWasteDefault': 'default from Settings', 'neg.measWasteYours': 'your estimate used {p}%', 'neg.measWasteInstallAt': 'Install at {w}% waste', 'neg.measWasteCarrier': 'carrier {sq} SQ at {p}%', 'neg.measWasteDisputed': 'install line disputed, +{sq} SQ', 'neg.measWasteOk': 'the carrier applied at least that waste — nothing to dispute', 'neg.measWasteIfTheirs': 'if the insurance measurements are accepted', 'neg.measWasteOurEstimate': 'our estimate carries {sq} SQ',
    'neg.measWasteHint': 'Your waste factor for this claim (empty = the default from Settings → Supplements). With “Insurance is right” their tear-off is accepted and the install must carry this waste; if they applied less, the install line is disputed for the difference automatically.',
    'neg.measCompare': 'Compare documents', 'neg.measCompareTitle': 'Roof measurements — ours vs the insurance estimate', 'neg.measCompareHint': 'Our measurements document next to the insurance estimate, opened at its tear-off line', 'neg.measOurDoc': 'Our measurements', 'neg.measOurDocSketch': 'sketch (Roofr)', 'neg.measOurDocVerified': '1ESX verified report', 'neg.measOurDocEstimate': 'our estimate, tear-off line', 'neg.measTheirDoc': 'Insurance estimate', 'neg.measNoDoc': 'No sketch or 1ESX report in Files for this claim: showing our estimate instead.',
    'neg.measTearOff': 'tear off', 'neg.measInstall': 'install', 'neg.measWaste': 'waste', 'neg.measBasisInstall': 'install line, includes waste — no tear-off line found',
    'neg.measByPerson': 'decided by hand', 'neg.measVerified': 'verified', 'neg.measAuto': 'by rule', 'neg.measPickOurs': 'Ours are right', 'neg.measPickTheirs': 'Insurance is right', 'neg.measChange': 'Change',
    'neg.measOursSq': 'Ours', 'neg.measTheirsSq': 'Insurance', 'neg.measDiff': 'Difference', 'neg.measTolerance': 'tolerance', 'neg.measVerified1esx': '1ESX verified', 'neg.measManualSketch': 'manual sketch',
    'neg.measReview': 'Big difference and our measurements are manual: check the measurements and define who is right. Until then, quantity differences stay pending.',
    'neg.measTheirsHint': 'Insurance measurements accepted: {n} quantity reason(s) were let go automatically and are no longer suggested. Unit price and missing items stay.',
    'neg.measOursVerifiedHint': 'Our measurements are verified (1ESX): quantity differences are disputed as usual.',
    'neg.measOursHint': 'Our measurements prevail: quantity differences are disputed as usual.',
    'neg.measUnknown': 'Could not read the roof squares from the estimates; decide by hand if measurements matter here.', 'neg.measPending': 'Decide once; it applies to every line.',
    'neg.plTitle': 'Price list — not disputed', 'neg.plOrder': 'Estimator order #1: update our estimate to the insurance price list ({pl}). Price list differences are not offered as disputes.',
    'neg.rebTitle': 'Rebuttals', 'neg.rebBtn': 'Rebuttals', 'neg.rebAll': 'Select all', 'neg.rebNone': 'Clear all', 'neg.rebEmpty': 'No playbook item matches this line and the AI did not suggest anything. Write your own below, or add the item in Settings → Supplements.',
    'neg.rebSuggested': 'Suggested by the AI (not in the playbook)', 'neg.rebSave': 'Save to playbook', 'neg.rebSaveHint': 'Adds this argument to the playbook item so it is offered on every claim', 'neg.rebUsed': 'Times chosen',
    'neg.rebCustom': 'Your own argument (free text)', 'neg.rebCustomPh': 'Something not in the playbook and not suggested…',
    'neg.rebOther': 'Other situations ({n})',
    'neg.projectPhotos': 'Project photos', 'neg.projectPhotosHint': 'All the photos of this claim: albums (CompanyCam / Drive), uploaded photos and photo reports', 'neg.projectPhotosCount': 'photos', 'neg.projectPhotoReports': 'Photo reports', 'neg.projectPhotosEmpty': 'No photos uploaded to this claim yet. Add the CompanyCam album link above.',
    'neg.replaceBtn': 'Change item', 'neg.replaceTitle': 'Change item to', 'neg.replaceFrom': 'Carrier line', 'neg.replacePh': 'The item the estimator must use instead, as Xactimate writes it…', 'neg.replaceClear': 'Remove the change', 'neg.replaceHelp': 'The estimator gets it in the guide and the order; the dispute note and the email argue for the change; the generated revised estimate applies it (quantity with our unit price; activity or item with the price-list memory). Saving marks the line as disputed.',
    'rs.priceListUpdate': 'Price list — estimator updates it', 'rs.priceListUpdateText': 'Our revised estimate will use the insurance price list ({pl}). Not disputed.',
    'rs.rebuttalsChosen': '{n} argument(s) chosen',
    'rs.replaceWith': 'Change item to: {x}',
    // El counter offer EXACTO y el resumen de Supplementing con el porqué (dueño 2026-10-09).
    'neg.counterExact': 'exact', 'neg.counterApprox': 'approx.',
    'neg.counterExactHint': 'Same total the generated estimate will have: same engine, the decisions of this instant.',
    'neg.counterApproxHint': 'Our estimate has not been read yet: this is the sum with the effective amounts. Read the estimate to get the exact figure.',
    'neg.counterWhy': 'Why not {x} (their offer + the analysis gaps)?',
    'neg.adjReplaced': '{n} item(s) changed (D&R / R&R / new item) at the price-list memory price',
    'neg.adjQty': '{n} item(s) with the quantity changed by hand',
    'neg.adjInvoices': '{n} invoice(s) from the review added as line items',
    'neg.adjAdded': '{n} item(s) written by hand',
    'neg.adjPending': '{n} undecided item(s) kept at our amount',
    'neg.adjTheirsOnly': '{n} line(s) only in the insurance estimate, included at the insurance quantity and price (every item the adjuster pays stays in our estimate)',
    'neg.adjRepriced': '{n} item(s) repriced to the current month price list (the roof has not been replaced: today\'s prices)',
    'neg.adjOther': 'Tax, O&P and rounding on the lines that match',
    'neg.adjOpAdded': 'Overhead & Profit added on {n} item(s) (office choice)',
    'neg.adjOpRemoved': 'Overhead & Profit removed from {n} item(s) (office choice)',
    'neg.adjGo': 'Show this item in the list above',
    'rs.theirOffer': 'Their offer', 'rs.asking': 'Asking', 'rs.counterOffer': 'Counter offer', 'rs.exact': 'exact', 'rs.approx': 'approx.',
    'rs.concededSub': 'conceded {x}', 'rs.askingSub': '{n} item(s)',
    'rs.generatedEstimate': 'Generated: {name} · RCV {rcv}',
    'rs.generatedStale': 'Decisions changed after the estimate was generated: generate it again before sending.',
    'rs.askingItems': 'What we are asking ({n})', 'rs.lettingGoItems': 'What we let go ({n})',
    'rs.was': 'was: {x}', 'rs.weHad': 'we had {a} · now {b}', 'rs.notPaid': 'not paid by the carrier — removed',
    'rs.kindPending': 'not decided yet — kept at our amount', 'rs.kindInvoice': 'invoice from the review', 'rs.kindAdded': 'added by hand',
    'rs.qtyChange': 'quantity {a} → {b} {u}', 'rs.priceToConfirm': 'price to confirm in Xactimate',
    'rs.photosUploaded': '{n} photo(s) uploaded (in the estimate PDF)',
    'rs.nothingAsked': 'Nothing is being asked above the insurance estimate.',
    'rs.approxNote': 'Our estimate has not been read yet: these are the effective amounts, not the generated estimate.',
    'rs.exactFooter': 'Same numbers as the generated estimate (the counter offer attached to the email).',
    'sup.revPriceListOrder': 'Update the estimate to the insurance price list: {pl} (added automatically to the order)',
    // Training: Field (solo en el app) + lecciones por bloques, Manuel 2026-10-06
    'trn.blocks': "Sections",
    'trn.blocksHint': "Build the lesson piece by piece: a video, some text, a photo with its explanation, another video… in any order.",
    'trn.block.text': "Text",
    'trn.block.photo': "Photo",
    'trn.block.video': "Video",
    'trn.addText': "Add text",
    'trn.addPhoto': "Add photo",
    'trn.addVideo': "Add video",
    'trn.blockUp': "Move up",
    'trn.blockDown': "Move down",
    'trn.blockRemoveConfirm': "Remove this section from the lesson?",
    'trn.blockTextPh': "Write this part of the lesson…",
    'trn.blockCaptionPh': "Explain what we see here and what to notice…",
    'trn.blockLinkPh': "…or paste a YouTube / Loom / Vimeo link",
    'trn.blockBadMedia': "A photo section needs an image and a video section needs a video.",
    'trn.privateShort': "Only in the app",
    'trn.privateNote': "Only in the app: these videos and photos can't be downloaded or opened from a link — you have to be logged in.",
    'trn.privateToggle': "Only in the app",
    'trn.privateToggleHint': "Videos, photos and files in this section are shown only to logged-in staff: no download, and a copied link opens nothing.",
    'trn.privateNoLinks': "Only in the app: upload the video here (a YouTube link can be opened by anyone).",
    // Training: cursos con examen (paquete roofr), Manuel 2026-10-06
    'trn.course.passed': "Passed ✓ {s}/{m}",
    'trn.course.notPassed': "Not passed · best {s}/{m}",
    'trn.course.pending': "Course · {n} min · Pending",
    'trn.course.intro': "Course · about {n} min. Do each module and its test, then the final exam. You need {p} of {m} to pass.",
    'trn.course.bestPassed': "Passed ✓ — your best: {s}/{m} ({d})",
    'trn.course.bestFail': "Not passed yet — your best: {s}/{m}. You need {p}.",
    'trn.course.attempts': "{n} attempt(s)",
    'trn.course.retake': "You can take it again any time",
    'trn.course.savedPass': "Result saved: {s}/{m} · Passed ✓",
    'trn.course.savedFail': "Result saved: {s}/{m} · Not passed ({p} needed). Review the modules and try again.",
    'trn.course.saveFailed': "Your result couldn't be saved. Check your connection and open the result screen again.",
    // Training: resultados de los cursos (manager+), Manuel 2026-10-06
    'trn.res.tabCourse': "Course",
    'trn.res.tabResults': "Results",
    'trn.res.summary': "{a} of {n} passed",
    'trn.res.rule': "pass with {p} of {m}",
    'trn.res.f.all': "All",
    'trn.res.f.passed': "Passed",
    'trn.res.f.pending': "Pending",
    'trn.res.name': "Employee",
    'trn.res.dept': "Department",
    'trn.res.best': "Best score",
    'trn.res.attempts': "Attempts",
    'trn.res.last': "Last attempt",
    'trn.res.status': "Status",
    'trn.res.passed': "Passed ✓",
    'trn.res.notPassed': "Not passed",
    'trn.res.notTaken': "Not taken",
    'trn.res.empty': "Nobody in this list.",
    // Training: aviso de video HEVC del iPhone, Manuel 2026-10-06
    'trn.hevcWarn': "\"{n}\" was recorded in HEVC (iPhone \"High Efficiency\"). It uploads fine, but Chrome and Edge on Windows often can't play it. For the next ones: iPhone Settings → Camera → Formats → \"Most Compatible\".",
    // Training → Tests asignados (mig 0557), Manuel 2026-10-29
    'tst.nav': "Tests",
    'tst.title': "Tests",
    'tst.intro': "Tests your managers assign to you. Your answers are saved as you go.",
    'tst.introAdmin': "Assign a test to an employee. You get a notification when they start it and when they submit it, with the result.",
    'tst.mine': "Assigned to you",
    'tst.none': "You don't have any tests assigned.",
    'tst.nQuestions': "{n} questions",
    'tst.assignedBy': "Assigned by {name} · {d}",
    'tst.assignedOn': "Assigned {d}",
    'tst.start': "Start",
    'tst.continue': "Continue",
    'tst.st.assigned': "Not started",
    'tst.st.in_progress': "Taking it now",
    'tst.st.submitted': "Submitted",
    'tst.st.cancelled': "Cancelled",
    'tst.progress': "{a}/{b} answered",
    'tst.submittedOn': "Submitted {d}",
    'tst.banner': "You have a test assigned: {t}",
    'tst.bannerGo': "Open",
    'tst.back': "Back to tests",
    'tst.introSaved': "Your answers are saved as you go: you can close the page and continue later.",
    'tst.introNotify': "Your managers are notified when you start and when you submit.",
    'tst.noteFrom': "Note from {name}:",
    'tst.startTest': "Start the test",
    'tst.qOf': "Question {n} of {m}",
    'tst.prev': "Previous",
    'tst.next': "Next",
    'tst.toReview': "Review and submit",
    'tst.enlarge': "Click the image to open it full size.",
    'tst.saving': "Saving…",
    'tst.saved': "Saved",
    'tst.saveFailed': "Your answer wasn't saved. Check the connection and pick it again.",
    'tst.keys': "Keys A–D answer · ← → move",
    'tst.reviewTitle': "Review your answers",
    'tst.reviewAll': "You answered all {n} questions.",
    'tst.reviewMissing': "{a} of {n} answered. Unanswered questions count as wrong:",
    'tst.submit': "Submit test",
    'tst.submitConfirm': "Submit the test? You can't change your answers afterwards.",
    'tst.submitConfirmMissing': "{k} questions are unanswered and will count as wrong. Submit anyway?",
    'tst.backToQuestions': "Back to the questions",
    'tst.doneTitle': "Test submitted",
    'tst.doneBody': "Thank you! Your answers were sent. Your manager will share the result with you.",
    'tst.doneScore': "Your score: {s} of {m} ({p}%)",
    'tst.cancelledTitle': "This test was cancelled",
    'tst.err.generic': "Something went wrong. Try again.",
    'tst.tabResults': "Assign & results",
    'tst.tabAccess': "Who can assign",
    'tst.assignTitle': "Assign a test",
    'tst.test': "Test",
    'tst.people': "Employees",
    'tst.searchPeople': "Search employees…",
    'tst.alreadyOpen': "Already assigned",
    'tst.note': "Note for the employee (optional)",
    'tst.assignN': "Assign to {n}",
    'tst.assigned': "Assigned to {n}. They got a notification with the link.",
    'tst.skipped': "{n} already had it open.",
    'tst.selectPeople': "Pick at least one employee.",
    'tst.resultsTitle': "Results",
    'tst.f.all': "All",
    'tst.f.in_progress': "Taking it now",
    'tst.f.submitted': "Submitted",
    'tst.f.assigned': "Not started",
    'tst.col.employee': "Employee",
    'tst.col.status': "Status",
    'tst.col.result': "Result",
    'tst.col.assigned': "Assigned",
    'tst.col.time': "Time",
    'tst.since': "since {t}",
    'tst.minutes': "{n} min",
    'tst.review': "Review",
    'tst.cancel': "Cancel",
    'tst.cancelConfirm': "Cancel {name}'s test? If they already started, their answers are discarded.",
    'tst.noResults': "No tests assigned yet.",
    'tst.live': "Updates on its own every 15 s",
    'tst.rv.wrongOnly': "Only wrong ones",
    'tst.rv.allQ': "All questions",
    'tst.rv.noAnswer': "No answer",
    'tst.rv.theirAnswer': "Their answer",
    'tst.rv.correct': "Correct answer",
    'tst.rv.liveNote': "In progress: what they've answered so far.",
    'tst.rv.started': "started {d}",
    'tst.rv.took': "took {n} min",
    'tst.acc.hint': "Only these people can assign tests and see the results. They're also the ones notified when someone starts or submits a test.",
    'tst.acc.master': "Master — always",
    'tst.acc.cantSelf': "You can't remove yourself.",
    'tst.acc.cantEmpty': "The list can't be empty.",
    'tst.acc.person': "Person",
    'tst.acc.role': "Role",
    'tst.acc.grantedBy': "Added by",
    'tst.pv.open': "Preview as employee",
    'tst.pv.banner': "Preview — this is exactly what the employee sees. Nothing is saved and nobody is notified.",
    'tst.pv.restart': "Start over",
    'tst.pv.onlyYou': "Only you see this",
    'tst.pv.result': "Preview result: {s} of {m} ({p}%)",
    'tst.pv.wouldPass': "Would pass",
    'tst.pv.wouldFail': "Would not pass",
    'tst.pass.label': "Pass mark",
    'tst.pass.equals': "= {n} of {m} correct",
    'tst.pass.invalid': "Enter a number from 1 to 100",
    'tst.pass.save': "Save",
    'tst.pass.saved': "Saved",
    'tst.pass.hint': "Applies to tests submitted from now on. Results already submitted keep the pass mark they were graded with.",
    'tst.passed': "Passed",
    'tst.notPassed': "Not passed",
    'tst.f.passed': "Passed",
    'tst.f.failed': "Not passed",
    'tst.rv.passMark': "pass mark {p}%",
    // Settings → AI: reglas por función dictadas y generadas (2026-10-07).
    'aim.briefTitle': "Tell it what you want",
    'aim.briefHint': "Dictate or type, in your own words, how this function should work. Dictation goes through the Dictation model.",
    'aim.briefPh': "e.g. Siempre menciona el código de construcción del estado y pide respuesta en 10 días…",
    'aim.generate': "Generate the rules",
    'aim.generating': "Writing…",
    'aim.generateHint': "The Prompt writer model turns your words into rules and fills the box below. Review and save.",
    'aim.err.brief_required': "Write or dictate what you want first.",
    'aim.err.ai_provider_error': "The model did not answer. Try again.",
    // Lectura única del estimado (mig 0498).
    'aim.f.estimate_reading': "Estimate reader (single reading)",
    'aim.f.estimate_reading.d': "Reads the whole estimate ONCE when it is uploaded (or from \"Read estimate\" in Files): every line item with its page, totals with evidence, structures, uncertain fields. The comparison, round 2, consistency and Review Estimate work from this reading instead of re-reading the PDF.",
    // Lectura única del estimado en Files (mig 0498): chip por fila, botón "Read estimate" y la ventana de la lectura.
    'rd.read': "Read estimate",
    'rd.reread': "Re-read",
    'rd.rereadConfirm': "Read this estimate again from scratch? The current reading will be replaced.",
    'rd.reading': "Reading…",
    'rd.queued': "In queue…",
    'rd.notRead': "Not read",
    'rd.retry': "Retry",
    'rd.failed': "Read failed",
    'rd.items': "{n} items",
    'rd.readIn': "Read in {s} · {model}",
    'rd.readHint': "Read the whole estimate with AI: every line item with its page, totals with evidence, and a math check.",
    'rd.chipHint': "{model} · {s} · {date}",
    'rd.chipHintFailed': "Failed: {err}",
    'rd.open': "Open reading",
    'rd.timeout': "The reading is taking more than 6 minutes. It keeps running on the server; reload the page later to see it.",
    'rd.notFound': "This estimate has no reading yet.",
    'rd.modalTitle': "Estimate reading",
    'rd.jsonHint': "Download the whole reading (meta, reading and validation) as JSON",
    'rd.metaLine': "Read {date} · {model} via {via} · {s} · {tin}→{tout} tokens",
    'rd.copied': "Copied from an identical file",
    'rd.sema.green': "Green",
    'rd.sema.yellow': "Yellow",
    'rd.sema.red': "Red",
    'rd.side.ours': "Ours",
    'rd.side.insurance': "Insurance",
    'rd.side.unknown': "Unknown side",
    'rd.role.carrier': "Carrier",
    'rd.role.public_adjuster': "Public adjuster",
    'rd.role.contractor': "Contractor",
    'rd.role.unknown': "Unknown",
    'rd.conf.high': "High confidence",
    'rd.conf.medium': "Medium confidence",
    'rd.conf.low': "Low confidence",
    'rd.conf.unreadable': "Unreadable",
    'rd.tab.summary': "Summary",
    'rd.tab.totals': "Totals",
    'rd.tab.breakdown': "Breakdown",
    'rd.bd.withoutOp': "Without O&P", 'rd.bd.withoutTax': "Without tax", 'rd.bd.rates': "Tax {tax}% · O&P {op}% of the line item total",
    'rd.bd.base': "Qty × price", 'rd.bd.tax': "Tax", 'rd.bd.bsc': "Base service charges", 'rd.bd.total': "Total", 'rd.bd.fullTotal': "Full total (as printed)",
    'rd.bd.byCategory': "By category", 'rd.bd.byZone': "By structure › area", 'rd.bd.byActivity': "By activity", 'rd.bd.lines': "Lines",
    'rd.tab.checks': "Checks",
    'rd.tab.lines': "Line items",
    'rd.tab.uncertain': "Uncertain & warnings",
    'rd.sec.document': "Document",
    'rd.sec.claim': "Claim",
    'rd.sec.pricing': "Pricing",
    'rd.sec.policy': "Policy",
    'rd.sec.flags': "Flags",
    'rd.sec.structures': "Structures",
    'rd.sec.byCoverage': "By coverage",
    'rd.sec.byStructure': "By structure",
    'rd.sec.lineMismatches': "Line items that do not add up",
    'rd.sec.lowConfidence': "Key fields with low confidence",
    'rd.sec.uncertain': "Uncertain fields",
    'rd.sec.warnings': "Warnings",
    'rd.f.platform': "Platform",
    'rd.f.estimateType': "Estimate type",
    'rd.f.estimateNumber': "Estimate # / name",
    'rd.f.estimateDate': "Estimate date",
    'rd.f.dates': "Created → revised",
    'rd.f.pages': "Pages",
    'rd.f.preparedBy': "Prepared by",
    'rd.f.adjuster': "Adjuster",
    'rd.f.estimator': "Estimator",
    'rd.f.insured': "Insured",
    'rd.f.address': "Property address",
    'rd.f.claimNumber': "Claim #",
    'rd.f.policyNumber': "Policy #",
    'rd.f.dateOfLoss': "Date of loss",
    'rd.f.causeOfLoss': "Cause of loss",
    'rd.f.inspectionDate': "Inspection date",
    'rd.f.priceList': "Price list",
    'rd.f.priceListDate': "Price list date",
    'rd.f.priceListLocation': "Price list location",
    'rd.f.settlementBasis': "Settlement basis",
    'rd.f.coverages': "Coverages",
    'rd.f.deductibles': "Deductibles",
    'rd.f.applied': "applied",
    'rd.f.notApplied': "not applied",
    'rd.f.notes': "Notes",
    'rd.f.roofFull': "Roof full replacement",
    'rd.f.buildingCode': "Building code items",
    'rd.f.codeItems': "Code upgrade items",
    'rd.nItems': "{n} items",
    'rd.col.concept': "Concept",
    'rd.col.value': "Value",
    'rd.col.printedAs': "Printed as",
    'rd.col.page': "Page",
    'rd.col.conf': "Conf.",
    'rd.col.coverage': "Coverage",
    'rd.col.dep': "Dep.",
    'rd.col.deductible': "Deductible",
    'rd.col.net': "Net claim",
    'rd.col.structure': "Structure",
    'rd.col.printedRcv': "Printed RCV",
    'rd.col.linesSum': "Sum of lines",
    'rd.col.check': "Check",
    'rd.col.docSays': "Document says",
    'rd.col.calculated': "Calculated",
    'rd.col.delta': "Delta",
    'rd.col.status': "Status",
    'rd.col.note': "Note",
    'rd.col.desc': "Description",
    'rd.col.printed': "Printed",
    'rd.col.zone': "Area",
    'rd.col.code': "Cat/Sel",
    'rd.col.qty': "Qty",
    'rd.col.unitPrice': "Unit price",
    'rd.col.tax': "Tax",
    'rd.col.field': "Field",
    'rd.col.possibleValue': "Possible value",
    'rd.col.reason': "Reason",
    'rd.tot.line_item_total': "Line item total",
    'rd.tot.base_service_charges': "Base service charges (adjustment)",
    'rd.struck': "Struck through",
    'rd.col.remove': "Remove",
    'rd.col.replace': "Replace",
    'rd.tot.sales_tax': "Sales tax",
    'rd.tot.overhead_profit': "Overhead & profit",
    'rd.tot.rcv': "RCV",
    'rd.tot.grand_total': "Grand total",
    'rd.tot.depreciation': "Depreciation",
    'rd.tot.recoverable_depreciation': "Recoverable depreciation",
    'rd.tot.nonrecoverable_depreciation': "Non-recoverable depreciation",
    'rd.tot.acv': "ACV",
    'rd.tot.deductible': "Deductible",
    'rd.tot.prior_payments': "Prior payments",
    'rd.tot.net_claim': "Net claim",
    'rd.sumsLine': "{n} line items read · sum of line RCV {rcv}",
    'rd.check.lines_vs_line_item_total': "Sum of lines = line item total",
    'rd.check.lines_vs_rcv': "Sum of lines (+ tax, O&P) = RCV",
    'rd.check.line_item_total_plus_tax_op_vs_rcv': "Line item total + tax + O&P = RCV",
    'rd.check.rcv_minus_depreciation_vs_acv': "RCV − depreciation = ACV",
    'rd.check.recoverable_plus_nonrecoverable_vs_depreciation': "Recoverable + non-recoverable = depreciation",
    'rd.check.acv_minus_deductible_and_prior_vs_net_claim': "ACV − deductible − prior payments = net claim",
    'rd.check.grand_total_vs_rcv': "Grand total = RCV",
    'rd.check.structure': "Structure {name}: printed RCV = sum of its lines",
    'rd.sevHigh': "critical",
    'rd.st.ok': "OK",
    'rd.st.mismatch': "Mismatch",
    'rd.st.skipped': "Skipped",
    'rd.noChecks': "No checks could be run (totals not found).",
    'rd.filterPh': "Filter by description, code, #…",
    'rd.allZones': "All structures / areas",
    'rd.showing': "Showing {shown} of {total} ({all} total)",
    'rd.showMore': "Show {n} more",
    'rd.noLines': "No line items match.",
    'rd.noWarnings': "No warnings from the reader.",
    'rd.yes': "Yes",
    'rd.no': "No",
    'rd.tot.paid_when_incurred': "Paid when incurred (withheld from the ACV)",
    'rd.resolved': "{n} resolved by hand",
    'rd.manual': "by hand",
    'rd.acceptedBanner': "Accepted as is by {name} on {date} (was {sema}). {note}",
    // ── Resolver (mig 0510): fix by hand what the reader got wrong ──
    'rd.rs.title': "Resolve",
    'rd.rs.intro': "The reader shows what does not add up; here a person fixes it. Every change is applied by the code, re-checked and logged with who and when. The original reading is kept and re-reading the estimate clears all of this.",
    'rd.rs.action': "What to do",
    'rd.rs.k.add_block': "Add a coverage block the reader did not sum (building codes, mitigation…)",
    'rd.rs.k.add_line': "Add a line item the reader skipped",
    'rd.rs.k.set_figure': "Correct a total the reader misread",
    'rd.rs.k.accept': "Accept the reading as is (the difference has an explanation)",
    'rd.rs.short.add_block': "Block added",
    'rd.rs.short.add_line': "Line added",
    'rd.rs.short.set_figure': "Figure corrected",
    'rd.rs.short.accept': "Accepted as is",
    'rd.rs.label': "Block name",
    'rd.rs.labelPh': "Dwelling – Ordinance or Law – Code Upgrade",
    'rd.rs.amount': "Amount (RCV)",
    'rd.rs.pwi': "Paid when incurred (code upgrade / Ordinance or Law): counts in the RCV, not in the ACV",
    'rd.rs.blockAcv': "ACV of the block (optional)",
    'rd.rs.blockDep': "Depreciation (optional)",
    'rd.rs.page': "Page",
    'rd.rs.desc': "Description",
    'rd.rs.zone': "Structure",
    'rd.rs.area': "Area",
    'rd.rs.code': "Code (CAT SEL ACT)",
    'rd.rs.qty': "Qty",
    'rd.rs.unit': "Unit",
    'rd.rs.up': "Unit price",
    'rd.rs.tax': "Tax",
    'rd.rs.rcv': "RCV",
    'rd.rs.dep': "Depreciation",
    'rd.rs.addToTotals': "Add it to the document totals (uncheck if the printed totals already include it)",
    'rd.rs.notInTotals': "already in the totals",
    'rd.rs.field': "Figure",
    'rd.rs.value': "New value (empty = not printed)",
    'rd.rs.note': "Why",
    'rd.rs.notePh': "e.g. Building codes block printed on page 12; the reader did not add it to the total",
    'rd.rs.apply': "Apply",
    'rd.rs.applying': "Applying…",
    'rd.rs.applied': "Applied resolutions ({n})",
    'rd.rs.none': "Nothing resolved by hand yet.",
    'rd.rs.undo': "Undo",
    'rd.rs.result': "Done. Now: {sema} · RCV {rcv} · ACV {acv}. Files, Payments and the comparisons use these numbers.",
    'rd.rs.needLabelAmount': "Write the block name and an amount greater than zero.",
    'rd.rs.needDescRcv': "Write the description and the RCV of the line.",
    'rd.rs.needNote': "Write why before accepting the reading as is.",
    'rd.rs.err': "Could not apply: {msg}",
    'rd.check.lines_base_vs_line_item_total': "Quantity × unit price of every line = line item total",
    'rd.check.lines_rcv_vs_line_item_total': "Sum of line RCVs = line item total (formats without per-line tax/O&P)",
    'rd.check.lines_rcv_vs_rcv': "Sum of line RCVs (tax and O&P included) = document RCV",
    'rd.check.lines_base_plus_tax_op_vs_rcv': "Quantity × unit price + printed tax + printed O&P = RCV",
    'rd.check.acv_printed_is_net_payment': "Printed \"ACV\" is the net payment after the deductible; ACV = RCV − depreciation is derived",
    // ── CLAIMCAM (dueño 2026-10-10): la app de fotos propia ──
    'nav.claimcam': 'ClaimCam',
    'cc.title': 'ClaimCam',
    'cc.subtitle': 'Every claim is a project. Photos from inspectors, contractors and homeowners land here, tagged and ready for the estimate.',
    'cc.findProject': 'Find a project…',
    'cc.tab.all': 'All',
    'cc.tab.today': "Today's inspections",
    'cc.tab.mine': 'My projects',
    'cc.tab.contractor': 'From contractors',
    'cc.tab.homeowner': 'From homeowners',
    'cc.noResults': 'No projects match.',
    'cc.empty.all': 'No photos yet.',
    'cc.empty.today': 'No inspections scheduled for today.',
    'cc.empty.mine': "You haven't uploaded photos yet.",
    'cc.empty.contractor': 'No contractor photos yet.',
    'cc.empty.homeowner': 'No homeowner photos yet.',
    'cc.emptyHint': 'Search any claim by name, address or claim number to open its project and upload photos.',
    'cc.col.project': 'Project',
    'cc.col.updated': 'Last updated',
    'cc.col.stats': 'Stats',
    'cc.col.recent': 'Recent photos',
    'cc.noName': '(no name)',
    'cc.todayAt': 'Today {time} · {who}',
    'cc.noPhotosYet': 'No photos yet',
    'cc.photos': 'photos',
    'cc.photosN': '{n} photos',
    'cc.externalAlbums': 'external albums',
    'cc.loadMore': 'Load more',
    'cc.projects': 'Projects',
    'cc.openClaim': 'Open claim',
    'cc.internal': 'Internal',
    'cc.missingN': '{n} missing',
    'cc.ptab.photos': 'Photos',
    'cc.ptab.reports': 'Reports',
    'cc.ptab.shares': 'Shared links',
    'cc.ptab.trash': 'Trash',
    'cc.clearSel': 'Clear selection',
    'cc.selected': '{n} selected',
    'cc.actions': 'Actions',
    'cc.project': 'Project',
    'cc.reports': 'Reports',
    'cc.act.tag': 'Tag',
    'cc.act.untag': 'Remove tags',
    'cc.act.area': 'Set area / slope',
    'cc.act.hide': 'Mark internal (hide from client & contractor)',
    'cc.act.unhide': 'Make visible to client & contractor',
    'cc.act.cover': 'Use as cover photo',
    'cc.act.move': 'Move to another project',
    'cc.act.trash': 'Move to trash',
    'cc.act.trashConfirm': 'Move {n} photo(s) to the trash? You can restore them later.',
    'cc.apply': 'Apply',
    'cc.none': 'None',
    'cc.f.dateRange': 'Date range',
    'cc.f.users': 'Users',
    'cc.f.tags': 'Tags',
    'cc.f.area': 'Area',
    'cc.f.clear': 'Clear filters',
    'cc.upload': 'Upload media',
    'cc.dropHere': 'Drop photos here to upload them to this project',
    'cc.emptyProject': 'No photos yet. Drop photos here or click to upload.',
    'cc.uploading': 'Uploading {n}…',
    'cc.uploadsDone': '{n} uploads finished',
    'cc.clear': 'Clear',
    'cc.retry': 'Retry',
    'cc.up.queued': 'Queued',
    'cc.up.processing': 'Preparing',
    'cc.up.uploading': 'Uploading',
    'cc.up.finalizing': 'Saving',
    'cc.up.done': 'Done',
    'cc.up.duplicate': 'Already there',
    'cc.up.error': 'Failed',
    'cc.selectDay': 'Select every photo of this day',
    'cc.noMatch': 'No photos match these filters.',
    'cc.kind.staff': 'Office',
    'cc.kind.inspector': 'Inspector',
    'cc.kind.homeowner': 'Homeowner',
    'cc.kind.contractor': 'Contractor',
    'cc.kind.email': 'Email',
    'cc.kind.import': 'Imported',
    'cc.trashEmpty': 'The trash is empty.',
    'cc.trashHint': 'Deleted photos stay here. Restore brings them back to the project.',
    'cc.restore': 'Restore',
    'cc.side.users': 'Project users',
    'cc.side.noUsers': 'Nobody has uploaded photos yet.',
    'cc.side.collaborators': 'Collaborators',
    'cc.side.noContractor': 'No contractor on this claim.',
    'cc.side.checklist': 'What the roof has',
    'cc.side.missing': 'Missing',
    'cc.side.filterByTag': 'Show only these photos',
    'cc.side.external': 'External albums (CompanyCam / Drive)',
    'cc.side.requests': 'Requested photos',
    'cc.side.requestsH': 'Asked from Info Pending. They complete themselves when a photo with that tag arrives.',
    'cc.rep.new': 'Create new report',
    'cc.rep.fromTemplate': 'Create report from template',
    'cc.rep.addExisting': 'Add to existing report',
    'cc.rep.fromInspection': 'Report from inspection',
    'cc.rep.fromInspectionHint': 'Builds the sections in the inspection order from the photo tags: around the house, gutters, accessories, damage per slope, interior per room, measurements.',
    'cc.rep.titlePh': 'Report title',
    'cc.rep.layout': 'Photo layout',
    'cc.rep.layoutLater': 'can change later',
    'cc.rep.perPage': '{n} per page',
    'cc.rep.charLimit': 'Character limit – {n}',
    'cc.rep.template': 'Template',
    'cc.rep.withSelected': 'With the {n} selected photos.',
    'cc.rep.create': 'Create report',
    'cc.rep.none': 'No reports yet.',
    'cc.rep.open': 'Open',
    'cc.rep.cover': 'Cover page',
    'cc.rep.coverHint': 'The cover shows the title, subtitle, the cover photo of the project and the claim details (insured, property, claim number, carrier).',
    'cc.rep.title': 'Report title',
    'cc.rep.subtitle': 'Report subtitle',
    'cc.rep.sectionN': 'Section {n}',
    'cc.rep.newSection': 'New section',
    'cc.rep.sectionTitle': 'Section title',
    'cc.rep.photoOptions': 'Photo options',
    'cc.rep.layoutDefault': 'Report default ({n} per page)',
    'cc.rep.deleteSection': 'Delete this section? Its photos stay in the project.',
    'cc.rep.summary': 'Section summary',
    'cc.rep.summaryPh': 'Click to add important info or findings.',
    'cc.rep.addPhotos': 'Add photos',
    'cc.rep.addN': 'Add {n}',
    'cc.rep.inReport': 'In report',
    'cc.rep.textPh': 'Click here to add text',
    'cc.rep.projectLoc': 'Project location',
    'cc.rep.removePhoto': 'Remove from report',
    'cc.rep.preview': 'Preview',
    'cc.rep.manage': 'Manage',
    'cc.rep.generate': 'Generate PDF',
    'cc.rep.generating': 'Generating…',
    'cc.rep.settings': 'Report settings',
    'cc.rep.header': 'Photo page header',
    'cc.rep.headerHint': 'shown at the top of each photo page',
    'cc.rep.h.left': 'Left',
    'cc.rep.h.center': 'Center',
    'cc.rep.h.right': 'Right',
    'cc.rep.date': 'Report date',
    'cc.rep.showHide': 'Show / hide',
    'cc.rep.opt.cover': 'Cover page',
    'cc.rep.opt.coverH': 'Title page with the claim details',
    'cc.rep.opt.sectionPages': 'Section title pages',
    'cc.rep.opt.sectionPagesH': 'Show title and summary on a full page',
    'cc.rep.opt.numbers': 'Photo numbers',
    'cc.rep.opt.numbersH': 'Numbers display the photo order',
    'cc.rep.opt.capturedBy': 'Photo captured by',
    'cc.rep.opt.capturedByH': 'Show the user who took the photo',
    'cc.rep.opt.location': 'Location captured',
    'cc.rep.opt.locationH': 'Project the photo was captured in',
    'cc.rep.opt.date': 'Date captured',
    'cc.rep.opt.dateH': 'Time and date the photo was captured',
    'cc.rep.opt.tags': 'Photo tags',
    'cc.rep.opt.tagsH': 'Show the list of photo tags',
    'cc.rep.opt.notes': 'Photo notes',
    'cc.rep.opt.notesH': 'The note dictated or written on the photo',
    'cc.share.btn': 'Share',
    'cc.share.title': 'Share a link',
    'cc.share.selected': 'A gallery of the {n} selected photos.',
    'cc.share.whole': 'A gallery of every visible photo of this project.',
    'cc.share.name': 'Link name',
    'cc.share.namePh': 'e.g. Roof photos for the adjuster',
    'cc.share.expires': 'Expires in',
    'cc.share.days': '{n} days',
    'cc.share.pin': 'PIN (optional)',
    'cc.share.pinPh': 'e.g. 4321',
    'cc.share.create': 'Create link',
    'cc.share.ready': 'Anyone with this link can view and download the photos.',
    'cc.share.pinNote': 'Send the PIN separately: {pin}',
    'cc.share.none': 'No shared links yet.',
    'cc.share.untitled': 'Untitled link',
    'cc.share.wholeShort': 'whole project',
    'cc.share.views': '{n} views',
    'cc.share.until': 'until {d}',
    'cc.share.revoked': 'revoked',
    'cc.share.revoke': 'Revoke',
    'cc.copy': 'Copy',
    'cc.copied': 'Copied',
    'cc.general': 'General',
    'cc.lb.title': 'Photo',
    'cc.lb.edit': 'Edit (arrows, circles, text)',
    'cc.lb.fit': 'Fit',
    'cc.lb.zoomOut': 'Zoom out',
    'cc.lb.zoomIn': 'Zoom in',
    'cc.lb.prev': 'Previous',
    'cc.lb.next': 'Next',
    'cc.lb.annotated': 'annotated',
    'cc.lb.tags': 'Tags',
    'cc.lb.addTags': 'Add tags',
    'cc.lb.area': 'Area / slope',
    'cc.lb.room': 'Room',
    'cc.lb.roomPh': 'e.g. Kitchen',
    'cc.lb.shot': 'Shot',
    'cc.lb.gps': 'GPS',
    'cc.lb.size': 'Size',
    'cc.lb.visibility': 'Visibility',
    'cc.lb.note': 'Note',
    'cc.lb.notePh': 'What does this photo show?',
    'cc.lb.comments': 'Comments',
    'cc.lb.noComments': 'No comments yet.',
    'cc.lb.commentPh': 'Comment on this photo… (⌘/Ctrl+Enter to post)',
    'cc.lb.dept': 'Department',
    'cc.lb.post': 'Post',
    'cc.lb.commentHint': 'The comment goes to the claim updates with the photo attached: to the department you pick and to General.',
    'cc.shot.closeup': 'Close-up',
    'cc.shot.overview': 'Overview',
    'cc.shot.room': 'Room',
    'cc.shot.measure': 'Measurement',
    'cc.vis.all': 'Everyone (client & contractor)',
    'cc.vis.internal': 'Internal only',
    'cc.ed.title': 'Edit photo',
    'cc.ed.hint': 'draw on the photo; the original is kept',
    'cc.ed.select': 'Select',
    'cc.ed.draw': 'Draw',
    'cc.ed.arrow': 'Arrow',
    'cc.ed.line': 'Line',
    'cc.ed.circle': 'Circle',
    'cc.ed.rect': 'Rectangle',
    'cc.ed.text': 'Text',
    'cc.ed.undo': 'Undo',
    'cc.ed.redo': 'Redo',
    'cc.ed.deleteShape': 'Delete selected',
    'cc.ed.clear': 'Clear all',
    'cc.ed.save': 'Save annotated copy',
    'cc.ed.remove': 'Remove annotations',
    'cc.ed.removeConfirm': 'Remove the annotated copy? The original stays.',
    'cc.ed.textPh': 'Type the text…',
    'cc.ed.addText': 'Add',
    'cc.ed.loadFailed': 'Could not load the photo.',
    'cc.inv.btn': 'Roof inventory',
    'cc.inv.title': 'Roof inventory',
    'cc.inv.hint': 'What the roof has: the number on the right; the X on the left if it does not have it. The photos suggest a count; you confirm it.',
    'cc.inv.remove': 'Does not have it',
    'cc.inv.restore': 'Put it back',
    'cc.inv.other': 'Other…',
    'cc.inv.none': 'none',
    'cc.inv.suggested': '{n} in photos',
    'cc.inv.lastSaved': 'Last saved by {who} · {when}',
    'cc.inv.sec.roof': 'Roof',
    'cc.inv.sec.gutters': 'Gutters',
    'cc.inv.sec.house': 'House',
    'cc.inv.sec.interior': 'Interior',
    'cc.inv.sec.other': 'Other',
    'cc.yes': 'Yes',
    'cc.no': 'No',
    'cc.pub.gone': 'This link is no longer available.',
    'cc.pub.goneHint': 'It may have expired or been revoked. Ask the person who sent it for a new one.',
    'cc.pub.error': 'Could not load the photos.',
    'cc.pub.pinTitle': 'This gallery needs a PIN',
    'cc.pub.open': 'Open',
    'cc.pub.until': 'available until {d}',
    'ccs.subtitle': 'The photo app: who can upload, what the camera asks for, the roof inventory list and the report templates.',
    'ccs.sub.general': 'General',
    'ccs.sub.tags': 'Camera chips',
    'ccs.sub.inventory': 'Roof inventory',
    'ccs.sub.templates': 'Report templates',
    'ccs.block': 'Block the inspector check-out when required photos are missing',
    'ccs.blockH': 'Off: the app only warns. On: the inspector cannot close the visit until every required chip has a photo.',
    'ccs.homeowner': 'Homeowners can upload photos from the Client Portal',
    'ccs.homeownerH': 'Their photos show "Homeowner" as the uploader.',
    'ccs.contractor': 'Contractors can upload photos (JobFlow and the capture link)',
    'ccs.contractorH': 'Their photos show the contractor name as the uploader.',
    'ccs.maxPx': 'Large copy size',
    'ccs.maxPxH': 'Longest side of the stored photo. 3000 px ≈ 1.5 MB per photo.',
    'ccs.shareDays': 'Shared links expire after (days)',
    'ccs.shareDaysH': 'Default when creating a link; each link can be changed.',
    'ccs.tagsH': 'The chips the camera shows, in inspection order. Each one can carry a reference photo, Xactimate codes (to attach photos to disputes automatically) and the roof accessory it counts.',
    'ccs.newTag': 'New chip',
    'ccs.counts': 'Counts',
    'ccs.required': 'Required',
    'ccs.off': 'Off',
    'ccs.active': 'Active',
    'ccs.refPhoto': 'Reference photo (click to upload)',
    'ccs.labelEn': 'Name (EN)',
    'ccs.labelEs': 'Name (ES)',
    'ccs.group': 'Group',
    'ccs.xact': 'Xactimate codes (comma separated)',
    'ccs.roofKey': 'Roof accessory key',
    'ccs.invH': 'The list the inspector fills after the roof photos: counts (how many pipe boots) and yes/no (starter at the rakes). Grows over time.',
    'ccs.newItem': 'New item',
    'ccs.kind': 'Type',
    'ccs.kindCount': 'Count',
    'ccs.kindChoice': 'Choice',
    'ccs.options': 'Options (comma separated)',
    'ccs.kindYesNo': 'Yes / No',
    'ccs.section': 'Section',
    'ccs.tagLink': 'Linked camera chip (pre-fills from photos)',
    'ccs.tplH': 'Templates carry the layout, the page header and the Show/Hide switches. "For the insurance company" hides who took the photo and when.',
    'ccs.newTpl': 'New template',
    'ccs.default': 'Default',
    'ccs.hidden': 'Hidden',
    'ccs.showsAll': 'shows everything',
    'ccs.tplName': 'Template name',
    'ip.kind': 'Type',
    'ip.kindFile': 'File',
    'ip.kindPhoto': 'Photo',
    'ip.photoTag': 'Photo tag',
    'ip.photoTagPh': 'Which photo?',
    'ip.addPhotoPh': 'What should they photograph? (goes to the contractor / homeowner)',
    'ip.openInClaimCam': 'Open these photos in ClaimCam',
    'cc.backToProject': 'Back to the project',
    'insp.tab.photos': 'Photos',
    'insp.photosBtn': 'Photos',
    'insp.photosMissing': 'Photos still missing from this inspection (you can still check out):',
    'insp.photosMissingBlock': 'These photos are required before checking out:',
    'cam.title': 'Camera',
    'cam.queue': 'Uploads',
    'cam.noCamera': 'The camera is not available here. Use the phone camera or pick from the gallery.',
    'cam.native': 'Open phone camera',
    'cam.pickChip': 'Pick what you are photographing ↑',
    'cam.side': 'Side of the house',
    'cam.sideOverviewHint': 'no chip: overview of this side',
    'cam.pickRoom': 'Pick the room…',
    'cam.roomNeeded': 'Create the room first: name and measurements.',
    'cam.newRoom': 'New room',
    'cam.area': 'Area / slope',
    'cam.howMany': 'How many does the roof have?',
    'cam.next': 'Next',
    'cam.missingN': '{n} missing',
    'cam.hideAsk': 'Remove "{name}" from this project? It stays in Settings and you can add it back with +.',
    'cam.holdToRemove': 'Hold to remove from this project',
    'cam.addChip': 'Add',
    'cam.hiddenTitle': 'Removed from this project',
    'cam.hiddenNone': 'Nothing removed in this section.',
    'cam.whichOne': '{name}: which one?',
    'cam.other': 'Other',
    'cam.otherPh': 'Type another answer…',
    'cam.skipChoice': 'Skip for now',
    'cam.noteNext': 'Note for the next photo',
    'cam.noteSaved': 'Note added to the last photo',
    'cam.dictate': 'Dictate a note for the photo',
    'cam.addChipTitle': 'Add a chip to this section',
    'cam.searchChips': 'Search chips…',
    'cam.createTag': 'Create "{name}"',
    'cam.tagCreated': '"{name}" added',
    'cam.tagCreateFailed': 'Could not create the chip. Try again.',
    'cam.maxTags': 'Up to {n} chips at a time: the first one was replaced.',
    'cam.gallery': 'Gallery',
    'cam.shoot': 'Take photo',
    'cam.flip': 'Flip camera',
    'cam.done': 'Done',
    'cam.failed': '{n} failed · tap to review',
    'cam.leavePending': '{n} photos are still uploading. Leave anyway? They keep uploading while the app is open.',
    'cam.backToCamera': 'Camera',
    'cam.wrapUp': 'Wrap up',
    'cam.stillUploading': '{n} photos still uploading…',
    'cam.missingTitle': '{n} required photos missing',
    'cam.blockNote': 'Check-out is blocked until these are taken (Settings → ClaimCam).',
    'cam.allRequired': 'All required photos are in.',
    'cam.finish': 'Finish',
    'cam.pickProject': 'Which project?',
    'cam.nearYou': 'Near you',
    'cam.noGps': 'no location',
    'cam.nothingNear': 'No appointments today and nothing within 300 m. Search a claim or create one by address.',
    'cam.newByAddress': 'New project by address',
    'cam.newByAddressH': 'Just the address; the claim is created in Intake.',
    'cam.address': 'Address',
    'cam.homeownerOpt': 'Homeowner (optional)',
    'cam.createAndShoot': 'Create & take photos',
    'cch.hint': 'Your claims with Proactive. Open one to see the photos, upload yours, take photos with the camera or share a link.',
    'cch.noProjects': 'No claims with photos yet.',
    'cch.fullScreen': 'Open full screen',
    'cch.shareN': 'Share {n} selected',
    'cch.shareReady': 'Share link ready:',
    'cap.youAre': 'uploading as {name}',
    'cap.takePhotos': 'Take photos',
    'cap.uploadsOff': 'Photo uploads are turned off for this claim. Contact the office.',
    'cap.requested': 'Photos the office is asking for',
    'cap.requestedH': 'Tap one: the camera opens with that tag already selected. When the photo arrives, the request is marked received.',
    'cap.noPhotos': 'No photos yet.',
    'cap.commentPh': 'Comment on this photo for the Claims team…',
    'cap.commentHint': 'Your comment goes to the Claims department with the photo attached.',
    'aim.f.room_sketch': 'ClaimCam room from a sketch',
    'aim.f.room_sketch.d': 'Reads the photo of a room sketch (name, length × width × height, windows and doors) so the room is created with its measurements. The person reviews before saving.',
    'aim.f.photo_tagging': 'ClaimCam photo tagging',
    'aim.f.photo_tagging.d': 'Looks at every ClaimCam photo when it lands and suggests tags, the area and a short caption (never tags on its own; a person accepts with one tap). Runs on every photo: cheap model.',
    'cc.ai.suggested': 'AI suggests',
    'cc.ai.accept': 'Add',
    'cc.ai.acceptAll': 'Add all',
    'cc.ai.caption': 'AI caption',
    'cc.ai.useCaption': 'Use as note',
    'cc.box.title': 'ClaimCam',
    'cc.box.open': 'Open ClaimCam',
    'cc.box.take': 'Take photos',
    'cc.box.none': 'No photos yet',
    'cc.box.has': 'The roof has',
    'cc.box.missing': 'Missing',
    'cc.box.requested': 'Requested',
    'cc.searchTags': 'Search tags',
    'ccs.xactPh': 'e.g. RFG RIDGV, RFG RIDGC',
    'ccs.roofKeyPh': 'e.g. pipe_boots',
    'cc.ptab.rooms': 'Rooms',
    'room.title': 'Rooms',
    'room.new': 'Add room',
    'room.edit': 'Edit room',
    'room.measure': 'Measure room',
    'room.name': 'Room name',
    'room.namePh': 'e.g. Kitchen',
    'room.length': 'Length',
    'room.width': 'Width',
    'room.height': 'Ceiling height',
    'room.windows': 'Windows',
    'room.doors': 'Doors',
    'room.add': 'Add',
    'room.qty': 'Qty',
    'room.w': 'Width',
    'room.h': 'Height',
    'room.wall': 'Wall',
    'room.wallAuto': 'Auto',
    'room.wall.front': 'Front',
    'room.wall.back': 'Back',
    'room.wall.left': 'Left',
    'room.wall.right': 'Right',
    'room.notesPh': 'Damage, what to estimate…',
    'room.previewHint': 'Enter length, width and height to see the plan and the Xactimate quantities.',
    'room.fromSketch': 'From a sketch (AI)',
    'room.sketchHint': 'Upload a photo of your sketch: the AI reads the measurements and redraws the plan. Review before saving.',
    'room.sketchReading': 'Reading the sketch…',
    'room.sketchFailed': 'Could not read the sketch. Type the measurements.',
    'room.sketchDone': 'Measurements read from the sketch ({conf} confidence): check them.',
    'room.save': 'Save room',
    'room.none': 'No rooms measured yet.',
    'room.deleteConfirm': 'Delete this room and its plan?',
    'room.totals': 'Totals',
    'room.hint': 'Rooms measured by hand during the inspection: name, length × width × height, windows and doors. The quantities are computed like Xactimate (openings subtracted from walls) and the plan is attached to the revised estimate.',
    'cc.dropOnRow': 'Drop photos here to upload them to this project',
    'cc.dupHint': 'This address already has a project for this type of claim. One address = one project, unless it is a different type of claim.',
    'cc.dupOpen': 'Open the existing project',
    'cc.create': 'Create project',
    'cc.createHint': 'New claims get their project automatically. Pick an existing claim that does not have one yet: the Google street view becomes the cover and the roof (satellite) photo is added.',
    'cc.createNone': 'No claims without a project match. It may already be a project: search it in the list.',
    'insp.openClaimCam': 'Open ClaimCam',
    'cc.upd.title': 'Updates',
    'cc.upd.added': '{who} added {n} photos',
    'cc.upd.shareAll': 'Share all',
    'cc.upd.none': 'No photos uploaded yet. Tap the camera to start.',
    'cc.upd.addedOne': '{who} added 1 photo',
    'ccs.camSection': 'Camera section',
    'ccs.sectionAll': 'All sections',
    'ccs.tagsH2': 'The chips the camera shows, by section (Exterior / Interior / Roof): tap the section, then the chip, then shoot. Each chip can carry a reference photo (tap the square), Xactimate codes and the roof accessory it counts.',
    'ai.dict.nothingHeard': 'Nothing was heard. Record again, closer to the mic.',
    'insp.voice.nothingHeard': 'Nothing was heard. Dictate again closer to the phone, or type the notes.',
    'psum.nClauses': '{n} clauses',
    'psum.oneClause': '1 clause',
    'psum.dedShort': 'Ded.',
    'psum.bcShort': 'Bldg. code',
    'ray.title': 'Ask Ray about this policy',
    'ray.hint': 'Answers stay here and are posted to the claim Overview.',
    'ray.placeholder': 'Ask Ray about the policy…',
    'ray.ask': 'Ask Ray',
    'ray.thinking': 'Ray is reading the policy…',
    'ray.posted': "Posted to the claim's Overview",
    'ray.readFirst': 'Read a policy first (Files → type it as Policy)',
    'ray.noPolicy': 'This claim has no policy read yet.',
    'ray.error': 'Ray could not answer. Try again.',
    'ray.loadError': 'Could not load the Ray chat.',
    'ray.page': 'p. {page}',
    'ray.you': 'You',
    'ray.empty': 'No questions yet. Ask Ray anything about this policy.',
    // ── Estimating Tool (2026-10-19) ──
    "est.title": "Estimating Tool",
    "est.what": "the estimating tool",
    "est.name": "Estimate name",
    "est.untitled": "Untitled",
    "est.newEstimate": "New estimate",
    "est.drafts": "Estimates in progress",
    "est.linesShort": "lines",
    "est.allDrafts": "All estimates of this claim",
    "est.origin.blank": "from scratch",
    "est.origin.revised": "counter offer (Review Estimate)",
    "est.origin.reading": "from our estimate",
    "est.origin.macro": "from a macro",
    "est.status.draft": "Draft",
    "est.status.generated": "Generated",
    "est.status.archived": "Archived",
    "est.startFrom": "Start a new estimate",
    "est.fromRevised": "From the counter offer",
    "est.fromRevisedHint": "The Review Estimate decisions (what we keep, what we let go, photos and rebuttals) as an editable estimate.",
    "est.fromMacro": "From a macro",
    "est.fromMacroHint": "The roof or interior template filled with the claim measurements and the ClaimCam inventory; the wizard asks what is missing.",
    "est.fromBlank": "Blank",
    "est.fromBlankHint": "Line by line from the item catalog, with the price list of the month.",
    "est.fromOurEstimate": "Or continue from one of our estimates",
    "est.needsReading": "That estimate has not been read yet; try again in a minute.",
    "est.needsAnalysis": "Run the Review Estimate analysis first.",
    "est.needsOurEstimate": "This claim has no estimate of ours yet.",
    "est.priceListLine": "Price list {code} · {n} items known",
    "est.priceListFallback": "using {code} meanwhile",
    "est.taxLine": "Sales tax {pct}% ({state})",
    "est.measLine": "Measurements: {src} · {sq} SQ",
    "est.noMeas": "No roof measurements yet",
    "est.site.front": "Front of the house · Google",
    "est.site.roof": "Roof · Google satellite",
    "est.site.noPhoto": "No photo yet",
    "est.site.openPhoto": "Open the photo",
    "est.site.openClaimCam": "Open ClaimCam",
    "est.site.photosN": "{n} photos",
    "est.site.noCompanyCam": "No CompanyCam album on this claim",
    "est.site.measVerified": "Verified measurements",
    "est.site.measFree": "Satellite measurements",
    "est.site.measDiagram": "Roof diagram",
    "est.site.measNone": "No measurements yet",
    "est.site.approx": "approximate",
    "est.site.openMeas": "Open the measurements in the claim",
    "est.site.getMeas": "Get measurements in the claim",
    "est.hub.measured": "Measured",
    "est.hub.notMeasured": "No measurements",
    "est.hub.withMeas": "With measurements",
    "est.hub.withoutMeas": "Without measurements",
    "est.hub.measFilterHint": "Roof measurements: verified report, satellite report or a roof diagram read in Files",
    "est.hub.sectionLine": "{p} in progress · {g} generated",
    "est.hub.todoEmptyStep": "Nothing in this step.",
    "est.hub.step.measurements": "Measurements",
    "est.hub.step.claimcam": "ClaimCam",
    "est.hub.step.ready": "Ready to estimate",
    "est.hub.stepHint.measurements": "No roof measurements yet: order the report or read the roof diagram.",
    "est.hub.stepHint.claimcam": "Measured. Organize and tag the roof photos in ClaimCam, then mark it organized.",
    "est.hub.stepHint.ready": "Measured and ClaimCam organized: ready to estimate (roof template by shingle type).",
    "est.hub.ccPhotos": "{n} photos",
    "est.hub.ccNoPhotos": "no ClaimCam photos",
    "est.hub.ccPhotosHint": "Photos in the ClaimCam project",
    "est.hub.ccMissing": "{n} required chips missing",
    "est.hub.ccMissingHint": "Required camera chips with no photo yet",
    "est.hub.ccTagged": "roof tagged",
    "est.hub.shingle": "Shingle: {t}",
    "est.hub.ccOrganized": "ClaimCam organized",
    "est.hub.ccMark": "Mark ClaimCam organized",
    "est.hub.ccUndo": "Undo",
    "est.hub.ccUndoHint": "Back to the ClaimCam step",
    "est.hub.openClaimCam": "Open ClaimCam",
    "est.unsaved": "Unsaved changes",
    "est.conflict": "Someone else saved this estimate. Reload to see their changes.",
    "est.checks": "What am I missing?",
    "est.macros": "Macros",
    "est.theirsOnly": "Insurance only ({n})",
    "est.theirsOnlyTitle": "Paid by the insurance, not in ours",
    "est.theirsOnlyHint": "Lines the insurance estimate pays that are not in this estimate. Click one to add it with their quantity and price (the owner rule: every adjuster item goes in; what we let go is the price or the quantity, never the item).",
    "est.previewPdf": "Preview PDF",
    "est.generate": "Generate estimate",
    "est.generateCounter": "Generate counter offer",
    "est.generateConfirm": "Generate the estimate for {rcv}? It will be saved in Files as a new Proactive Estimate with its reading (no .ESX needed).",
    "est.generated": "Estimate generated · RCV {rcv}",
    "est.generatedCounter": "Counter offer {n} generated · RCV {rcv}",
    "est.empty": "The estimate has no lines.",
    "est.openClaim": "Open claim",
    "est.emptyHint": "Search an item on the left and press Enter, apply a macro, or add a blank line.",
    "est.addLine": "Add line",
    "est.addArea": "Add area",
    "est.newAreaPrompt": "Name of the new area (e.g. Roof, Kitchen, Front Elevation):",
    "est.areaName": "Area",
    "est.areaHint": "Structure › Area. Rename here to move every line of this area.",
    "est.priceMissing": "Price missing lines",
    "est.priceMissingHint": "Fill the unit price of the lines without one from the price list of the month.",
    "est.priced": "{n} line(s) priced · {m} still without price",
    "est.tot.lines": "Lines",
    "est.tot.base": "Line item total",
    "est.tot.tax": "Tax",
    "est.tot.theirs": "Insurance RCV",
    "est.tot.unpriced": "{n} without price",
    "est.tot.missingQty": "{n} without quantity",
    "est.tot.unconfirmed": "{n} price(s) to confirm",
    "est.tot.unconfirmedHint": "Prices from a single learned sample or a similar item: confirm them in Xactimate or type the price.",
    "est.tot.taxPct": "Tax %",
    "est.priceListHint": "Price list of the month for the state of the claim (Settings → Supplements → Estimating → Config).",
    "est.noPriceList": "No price list",
    "est.noPricesYet": "no prices yet",
    "est.catalog": "Items",
    "est.official": "official",
    "est.learned": "learned",
    "est.learnedN": "learned ×{n}",
    "est.fuzzy": "similar item",
    "est.playbook": "playbook",
    "est.itemInfo": "Item card",
    "est.addHint": "Click or Enter to add to the estimate",
    "est.searchPlaceholder": "Code (RFG 300) or words…",
    "est.searchHint": "Type a Xactimate code or words.",
    "est.noItems": "No items match.",
    "est.catalogEmpty": "The catalog is empty: upload a price list or sync it in Settings → Supplements → Estimating.",
    "est.noPrice": "no price",
    "est.col.code": "Code",
    "est.col.desc": "Description",
    "est.col.qty": "Qty",
    "est.col.unit": "Unit",
    "est.col.up": "Unit price",
    "est.col.tax": "Tax",
    "est.col.area": "Area",
    "est.action.keep": "disputed",
    "est.action.qty_changed": "our quantity",
    "est.action.pending": "pending",
    "est.action.their_price": "their price",
    "est.action.their_qty": "their quantity",
    "est.action.their_line": "their line",
    "est.action.remove": "removed",
    "est.action.replace": "replaced",
    "est.action.theirs_only": "insurance only",
    "est.action.unchanged": "unchanged",
    "est.action.added": "added",
    "est.theirsLine": "Insurance line",
    "est.theirsShort": "Ins.",
    "est.originalLine": "Our original line",
    "est.rebuttalsN": "{n} rebuttal(s)",
    "est.confirmPrice": "confirm price",
    "est.priceTheirs": "their price",
    "est.taxOn": "Taxable (click to remove the tax)",
    "est.taxOff": "No tax (click to add it)",
    "est.opOn": "With O&P (click to remove it)",
    "est.opOff": "No O&P (click to add it)",
    "est.duplicate": "Duplicate line",
    "est.photosFor": "Photos for",
    "est.photos.search": "Search by note, area or chip…",
    "est.photos.all": "All",
    "est.photos.what": "the ClaimCam photos",
    "est.photos.none": "This claim has no ClaimCam photos yet.",
    "est.photos.noMatch": "No photos match.",
    "est.photos.selected": "{n} photo(s) on this line · they go in the PDF with a link",
    "est.notInCatalog": "Not in the catalog yet",
    "est.explanation": "Estimator guide",
    "est.notes": "Notes",
    "est.defaultNote": "default",
    "est.lineNote": "Line note",
    "est.lineNoteHint": "Goes under the line in the PDF.",
    "est.rebuttals": "Rebuttals",
    "est.rebuttalsHint": "Click to attach to this line (they print under it).",
    "est.refPhotos": "Reference photos",
    "est.lineStyle": "Style in the PDF",
    "est.lineStyleHint": "Bold = additional item. Underlined = quantity or unit price under dispute.",
    "est.style.normal": "Normal",
    "est.style.bold": "Bold",
    "est.style.underline": "Underlined",
    "est.checksWaiting": "Saving… the checks run on the saved estimate.",
    "est.checksOk": "Nothing missing.",
    "est.check.unpriced": "No price",
    "est.check.missing_qty": "No quantity",
    "est.check.unconfirmed": "Price to confirm",
    "est.check.inventory_not_in_estimate": "Counted in ClaimCam, not in the estimate",
    "est.check.theirs_not_in_ours": "Insurance pays it, we do not have it",
    "est.check.duplicate": "Duplicate line",
    "est.macroApplied": "Macro applied: {n} line(s) added",
    "est.openTool": "Open Estimating Tool",
    "est.openToolHint": "Opens the counter offer as an editable estimate to add what it is missing.",
    "est.generateFirst": "Generate first estimate",
    "est.generateFirstHint": "The roof macro filled with the measurements and the ClaimCam inventory.",
    "est.generatedFirst": "First estimate generated · RCV ${rcv} · {n} lines",
    "est.openToolAfter": "The estimate is in Files. Open it in the Estimating Tool to add what it is missing?",
    "est.yes": "Yes",
    "est.no": "No",
    "est.wiz.title": "Generate from a macro",
    "est.wiz.macro": "Macro",
    "est.wiz.noMacros": "No macros yet. Create one in Settings → Supplements → Estimating → Macros.",
    "est.wiz.room": "Room",
    "est.wiz.noRooms": "This claim has no measured rooms: add them in ClaimCam → Rooms.",
    "est.wiz.walls": "walls",
    "est.wiz.questions": "Questions",
    "est.wiz.prefilledFrom": "Prefilled from {src}",
    "est.wiz.photoMissing": "no photo with the chip \"{tag}\" yet",
    "est.wiz.notInClaim": "Not in the claim: answer it",
    "est.wiz.photosOk": "{n} photo(s)",
    "est.wiz.recalc": "Recalculate",
    "est.wiz.srcVerified": "the verified report",
    "est.wiz.srcFree": "the satellite measurements (approximate)",
    "est.wiz.srcDiagram": "the roof diagram",
    "est.wiz.srcInventory": "the ClaimCam inventory",
    "est.wiz.srcPhotos": "the ClaimCam photos",
    "est.wiz.srcDefault": "the macro default",
    "est.wiz.preview": "Lines that would be added ({n})",
    "est.wiz.skipped": "Skipped",
    "est.wiz.addToDraft": "Add to the estimate",
    "est.wiz.create": "Create the estimate",
    "est.wiz.answerFirst": "Answer {n} question(s) first",
    "est.wiz.photosPendingHint": "Some required photos are missing; you can continue anyway.",
    "est.wiz.pending": "Some questions are still pending.",
    "est.wiz.noMeasurements": "No roof measurements on this claim: the quantities will be blank. Order the report or upload the roof diagram.",
    "est.wiz.approxMeasurements": "Measurements come from satellite (approximate): verify before sending.",
    "est.kind.roof": "Roof",
    "est.kind.interior": "Interior",
    "est.kind.custom": "Custom",
    "est.settings.title": "Estimating Tool",
    "est.settings.tab.items": "Items",
    "est.settings.tab.macros": "Macros",
    "est.settings.tab.config": "Config",
    "est.settings.hint.items": "Every item seen in a price list or an estimate reading is registered here by itself. Add notes (several; the starred one goes by default), reference photos, the estimator guide and the playbook item.",
    "est.settings.hint.macros": "Macros are the templates: lines with a quantity formula over the roof measurements, the ClaimCam inventory and the room, plus the questions the wizard asks when something is missing.",
    "est.settings.hint.config": "Sales tax by state (on the material), O&P 10/10 with a default switch, the Xactimate price list region by state and the macro used by \"Generate first estimate\".",
    "est.settings.allCategories": "All categories",
    "est.settings.allItems": "All items",
    "est.settings.missingExplanation": "Without guide",
    "est.settings.missingNotes": "Without notes",
    "est.settings.missingPhotos": "Without photos",
    "est.settings.missingPlaybook": "Without playbook item",
    "est.settings.sync": "Sync from price lists",
    "est.settings.syncHint": "Brings every item the price-list memory already knows.",
    "est.settings.synced": "{n} new item(s) · {total} in the catalog",
    "est.settings.explainAll": "Write missing guides (AI)",
    "est.settings.explainAllHint": "Writes the estimator guide of the 20 most used items without one (one AI call each).",
    "est.settings.explainAllConfirm": "Write the guide of up to 20 items with AI? Each one is a model call.",
    "est.settings.explained": "{n} guide(s) written · {left} still without",
    "est.settings.aiOff": "AI is not configured (OPENROUTER_API_KEY / CLAUDE_API_KEY).",
    "est.settings.newItem": "New item",
    "est.settings.count": "{n} of {total} items",
    "est.settings.notesN": "{n} note(s)",
    "est.settings.noExplanation": "no guide",
    "est.settings.codeHint": "Category, selector and activity as in Xactimate (optional: without a code the description is the key).",
    "est.settings.category": "Category",
    "est.settings.notesHint": "several; the starred one goes by default, the estimator picks another when adding the item",
    "est.settings.addNote": "Add note",
    "est.settings.explainAi": "Write with AI",
    "est.settings.explainHint": "Rewrites the guide from the code, the notes and the playbook rebuttals.",
    "est.settings.explanationHint": "What it is, when it goes in, how it is measured, what adjusters dispute… (or dictate it)",
    "est.settings.rebuttalsN": "{n} rebuttal(s) in the playbook",
    "est.settings.addPhoto": "Add photo",
    "est.settings.active": "Active",
    "est.settings.newMacro": "New macro",
    "est.settings.macroFromPdf": "Macro from a file (PDF or photo)",
    "est.settings.macroHint": "Mark one roof macro as default: it is the one \"Generate first estimate\" uses.",
    "est.settings.macroReading": "\"{name}\" is being read; its lines will appear in a minute.",
    "est.settings.noMacros": "No macros yet.",
    "est.settings.macroName": "Macro name",
    "est.settings.choosePdf": "Drop the estimate PDF or a photo / screenshot of the item list here, or click to choose",
    "est.settings.macroFromPdfHint": "The reader extracts every line from the PDF or the photo; then write the quantity formulas for the lines that depend on the measurements.",
    "est.settings.readPdf": "Read the file",
    "est.settings.linesQuestions": "{n} lines · {q} questions",
    "est.settings.reading": "Reading…",
    "est.settings.failed": "Failed",
    "est.settings.default": "Default for First Estimate",
    "est.settings.defaultHint": "The macro \"Generate first estimate\" uses.",
    "est.settings.macroDesc": "Description (optional)",
    "est.settings.macroLines": "Lines",
    "est.settings.variables": "Variables",
    "est.settings.varsTitle": "Measurements",
    "est.settings.varsInventory": "ClaimCam inventory",
    "est.settings.varsInventoryHint": "the keys of Settings → ClaimCam → Roof inventory; yes/no count as 1/0",
    "est.settings.functions": "Functions",
    "est.settings.formulaExamples": "Examples: ceil(squares * 1.10) · eave_lf + rake_lf · valley_lf * 3 / 100 · if(pitch >= 7, squares, 0) · condition: layers >= 2",
    "est.settings.formulaPh": "e.g. squares · ceil(squares * 1.1)",
    "est.settings.clickToInsert": "click to add it to the formula you were editing",
    "est.settings.conditionPh": "optional · e.g. layers >= 2",
    "est.settings.functionsHint": "ceil(x) rounds UP to a whole number (not the ceiling) · floor(x) rounds down · round(x, decimals) · max(a, b) · min(a, b) · abs(x) · if(condition, a, b) · waste(x, 10) adds 10 %",
    "est.settings.addFromCatalog": "Add from catalog",
    "est.settings.replaceItem": "Replace with another item",
    "est.settings.pickItemPh": "Search the catalog: code or description…",
    "est.settings.noItems": "No item matches.",
    "est.settings.qtyFormula": "Quantity formula",
    "est.settings.condition": "Condition",
    "est.settings.fixedQty": "fixed qty",
    "est.settings.noLines": "No lines yet.",
    "est.settings.badFormula": "A formula could not be read",
    "est.settings.questions": "Wizard questions",
    "est.settings.questionsHint": "asked only when the claim does not have the value (or always, if marked)",
    "est.settings.addQuestion": "Add question",
    "est.settings.questionLabel": "Question as the estimator reads it",
    "est.settings.qNumber": "Number",
    "est.settings.qYesNo": "Yes / No",
    "est.settings.qChoice": "Choice",
    "est.settings.qText": "Text",
    "est.settings.qDefault": "Default",
    "est.settings.photoTag": "ClaimCam chip",
    "est.settings.photoTagHint": "Requires a photo with this chip (e.g. pipe_boots) before generating.",
    "est.settings.always": "Always ask",
    "est.settings.alwaysHint": "Ask even when the claim already has the value.",
    "est.settings.byState": "By state",
    "est.settings.state": "State",
    "est.settings.taxPct": "Sales tax % (material)",
    "est.settings.priceListRegion": "Price list region",
    "est.settings.addState": "Add state",
    "est.settings.regionHint": "Region as Xactimate names it (GAAT8X = Georgia, Atlanta); empty = the most used one in the memory.",
    "est.settings.overhead": "Overhead %",
    "est.settings.profit": "Profit %",
    "est.settings.waste": "Default waste %",
    "est.settings.opDefault": "O&P on by default",
    "est.settings.firstMacro": "Macro for \"Generate first estimate\"",
    "est.settings.firstMacroAuto": "The default roof macro",
    "est.settings.goPriceLists": "Price lists",
    // ── Estimating hub (2026-10-19) ──
    "nav.supEstimating": "Estimating",
    "est.hub.title": "Estimating",
    "est.hub.subtitle": "Search any client and build the estimate; what is waiting, what is in progress and what was generated.",
    "est.hub.settings": "Items, macros & config",
    "est.hub.searchPlaceholder": "Client name, address, claim number or phone…",
    "est.hub.noResults": "No claims match.",
    "est.hub.estimate": "Estimate",
    "est.hub.todo": "To do",
    "est.hub.all": "All",
    "est.hub.first": "First Estimate",
    "est.hub.review": "Review Estimate",
    "est.hub.todoEmpty": "Nothing waiting in First Estimate or Review Estimate.",
    "est.hub.days": "{n} d",
    "est.hub.hasEstimate": "our estimate",
    "est.hub.noEstimate": "no estimate yet",
    "est.hub.analyzed": "analyzed",
    "est.hub.notAnalyzed": "not analyzed",
    "est.hub.draftsN": "{n} draft(s)",
    "est.hub.inProgress": "In progress",
    "est.hub.inProgressEmpty": "No open drafts.",
    "est.hub.done": "Generated",
    "est.hub.doneEmpty": "Nothing generated in the last 90 days.",
    // ── Estimating wizard v2 (2026-10-19) ──
    "est.photos.add": "Add {n}",
    "est.wiz.photoPlus": "Photos from ClaimCam",
    "est.wiz.drop": "or drop photos here",
    "est.wiz.uploading": "Uploading to ClaimCam…",
    "est.wiz.uploadErrors": "{n} photo(s) could not be uploaded.",
    "est.wiz.addItem": "Add item",
    "est.wiz.addItemHint": "Code or words of the item to add…",
    "est.wiz.swap": "Change item",
    "est.wiz.swapHint": "Code or words of the replacement item…",
    "est.wiz.note": "Note",
    "est.wiz.noteFromCatalog": "Notes of this item in the catalog (click to use one):",
    "est.wiz.amount": "Amount",
    "est.wiz.amountHint": "Qty × unit price, before tax and O&P (the estimate computes them when created)",
    "est.wiz.photosFor": "Photos · {what}",
    // ── Quantify items con ClaimCam (2026-10-19) ──
    "sup.accFromInspector": "Counted by the inspector in ClaimCam",
    "sup.accFromPhotos": "Suggested by the ClaimCam photos with this chip",
    "sup.accPhotos": "{n} photo(s) with this chip in ClaimCam · click to see them and count",
    "sup.accNoPhotos": "No photos with this chip yet · click to look in ClaimCam",
    "sup.accPickHint": "👷 = counted by the inspector · 📷 = suggested by the photos. The photo button opens ClaimCam: select the ones that match and Add writes the count.",
    // ── Estimating rooms (2026-10-19) ──
    "est.wiz.target": "Into: {room}",
    "est.room.add": "Add room / area",
    "est.room.edit": "Edit room",
    "est.room.remove": "Remove room",
    "est.room.removeConfirm": "Remove \"{name}\" and its lines from the estimate?",
    "est.room.name": "Name",
    "est.room.namePlaceholder": "Roof, Detached Garage, Master Bedroom…",
    "est.room.exterior": "Exterior",
    "est.room.interior": "Room",
    "est.room.dims": "Dimensions",
    "est.room.length": "Length",
    "est.room.width": "Width",
    "est.room.height": "Ceiling height",
    "est.room.windows": "Windows",
    "est.room.doors": "Doors",
    "est.room.dimsHint": "Rectangular room: the plan and the quantities are computed as Xactimate does (walls minus openings). Saved in ClaimCam → Rooms too.",
    "est.room.calc": "Calculated quantities",
    "est.room.calcHint": "These are the variables the interior macros use (sf_walls, sf_ceiling, sf_floor, lf_perimeter…).",
    "est.room.create": "Create room",
    "est.room.noDimsHint": "Without dimensions the room is just a name; you can add them later with the edit button.",
    "leave.title": "Unsaved changes",
    "leave.body": "You were working on {what} and the latest changes are not saved yet. Save them before leaving?",
    "leave.thisWork": "this screen",
    "leave.saveFailed": "Could not save: {err}",
    "leave.stay": "Stay here",
    "leave.discard": "Leave without saving",
    "leave.saveAndGo": "Save and continue",
    "leave.saving": "Saving…",
    "est.leave.saveError": "The estimate could not be saved. Check the error at the top and try again.",
    "est.backToHub": "Back to where you came from (Estimating)",
    "plx.title": "Price lists & items",
    "plx.subtitle": "Drop the month's price list here and fill in the items the estimators use. No need to go into Settings.",
    "plx.tabLists": "Price lists",
    "plx.tabItems": "Items",
    "plx.monthMissing": "{n} missing this month",
    "plx.monthComplete": "all price lists for this month are in",
    "plx.monthEmpty": "No price list has been used yet. Drop the first file below.",
    "plx.monthHint": "One card per region we use. Green = this month's file is in. Red = still missing. On the 1st of each month they all turn red until the new files come in.",
    "plx.notUploaded": "Not uploaded yet",
    "plx.missing": "missing",
    "plx.lastHad": "last we had: {code}",
    "plx.dropTitle": "Drop a file to add a price list",
    "plx.dropLabel": "Drag the Xactimate estimate (PDF) or a CSV here, or click to choose",
    "plx.detecting": "Reading the file…",
    "plx.detected": "detected",
    "plx.fromName": "from the file name",
    "plx.notDetected": "no price list code found in the file; type it.",
    "plx.isEstimate": "This is an estimate: the prices will be read line by line in the background (1-2 minutes).",
    "plx.confirmQ": "Is it this price list?",
    "plx.confirmBtn": "Yes, upload",
    "plx.uploaded": "{code} is in: {n} items with price.",
    "plx.advanced": "Advanced",
    "plx.advancedHint": "every known price list, official vs learned prices, item browser",
    "plx.toClassify": "To classify",
    "plx.classifiedN": "Classified",
    "plx.allItems": "All",
    "plx.allClassified": "Everything is classified. Nothing pending.",
    "plx.allGroups": "All groups",
    "plx.searchPh": "Search an item by name or code…",
    "plx.settingsLink": "Settings",
    "plx.moreItems": "{n} more — narrow the search.",
    "plx.copyName": "Copy the item name (to paste in Xactimate)",
    "plx.hasGuidance": "guide",
    "plx.xactDefinition": "Xactimate definition",
    "plx.xactDefinitionHint": "exactly as Xactimate prints it",
    "plx.xactDefinitionPh": "Paste the item definition from Xactimate, word for word.",
    "plx.xactPhoto": "Xactimate photo",
    "plx.addXactPhoto": "Add Xactimate photo",
    "plx.replacePhoto": "Replace",
    "plx.extraPhotos": "Extra photos",
    "plx.guidance": "Note / guide for the estimator",
    "plx.guidancePh": "Write in your words what the estimator should know. Then use Improve with AI: it merges the Xactimate definition with your note.",
    "plx.improveAi": "Improve with AI",
    "plx.improveHint": "Rewrites the guide from the Xactimate definition plus what you wrote here.",
    "plx.playbookHint": "the dispute item and its arguments for this line",
    "plx.openPlaybook": "Open playbook",
    "plx.classified": "Classified (done)",
    "plx.classifiedHint": "Tick when the item's information is complete. It leaves the pending list.",
    "plx.esx.title": "Master ESX (all prices)",
    "plx.esx.hint": "The latest Xactimate ESX with every item and price. To update a month: download it, refresh the prices in Xactimate, and drop the new ESX together with its PDF. The PDF is what gets read (the ESX is encrypted): with the same items or more it becomes the latest and its prices become the month's price list; with fewer items it is rejected for safety. Nothing here can be deleted.",
    "plx.esx.none": "No master ESX yet. Drop the first ESX with its PDF.",
    "plx.esx.latest": "latest",
    "plx.esx.downloadLatest": "Download latest ESX",
    "plx.esx.dropLabel": "Drop the ESX and its PDF here (both files)",
    "plx.photo.title": "Add items from a photo",
    "plx.photo.hint": "Drop a screenshot of the Xactimate item list (or a PDF page). It is read row by row, loaded into the catalog with the price of the chosen price list, and you see which items are new.",
    "plx.photo.priceList": "Price list",
    "plx.photo.group": "Group",
    "plx.photo.missing": "not uploaded yet",
    "plx.photo.drop": "Drop photos of items here",
    "plx.photo.reading": "Reading {name}…",
    "plx.photo.summary": "{items} items read · {nuevos} new · prices in {code}",
    "plx.who.title": "Who classifies",
    "plx.who.none": "Nobody has classified an item yet.",
    "plx.who.today": "Today",
    "plx.who.week": "7 days",
    "plx.who.total": "Total",
    "plx.who.clickHint": "Click to see only the items this person classified",
    "plx.who.by": "Classified by {name}",
    "plx.who.clear": "Show everyone's items again",
    "plx.photo.pickGroup": "Pick the group first: the items go into that button of the Estimating Tool.",
    "plx.photo.groupByCode": "No group chosen: each item goes into the group of its code (RFG → Roof, PNT → Paint…).",
    "plx.photo.saved": "Saved to the catalog: {nuevos} new · {had} already there",
    "plx.photo.pricesIn": "prices in {code}",
    "plx.photo.open": "Open this item in the list",
    "plx.photo.macroFrom": "Create a macro with these {n} items",
    "plx.photo.macroName": "Macro name",
    "plx.photo.macroKind": "Kind",
    "plx.photo.macroCreate": "Create macro",
    "plx.photo.macroDone": "Macro “{name}” created with these items.",
    "plx.photo.new": "new",
    "plx.photo.had": "already had it",
    "plx.photo.noItems": "No items could be read in that image.",
    "plx.nomacro.title": "Not in any macro yet · {n}",
    "plx.nomacro.hint": "Catalog items whose code is not in any macro: what is still missing from your macros. The list shrinks as you add them.",
    "plx.nomacro.none": "Every item in this view is already in a macro.",
    "plx.esx.needBoth": "Drop both files together: the .esx and its .pdf.",
    "plx.esx.rejected": "rejected · {n} items (fewer than the latest)",
    "plx.esx.history": "History (never deleted)",
    "plx.esx.showAll": "Show all ({n})",
    "plx.esx.showLess": "Show less",
    "plx.suggestNotes": "Suggest notes with AI",
    "plx.suggestNotesHint": "Proposes several short notes for the estimate line (what it is and why it goes in), from the Xactimate definition and your note. You tick the ones to keep.",
    "plx.noteCandidates": "Suggested notes · tick the ones to keep",
    "plx.addSelectedNotes": "Add selected ({n})",
    "plx.createDispute": "Create dispute item for this line",
    "plx.orLink": "or link an existing one:",
    "plx.disputesN": "{n} arguments",
    "plx.disputePh": "Write or dictate an argument for when the adjuster leaves this item out or cuts it…",
    "plx.addDispute": "Add",
    "plx.saveFirst": "Save the item first to create its dispute item.",
    "est.side.prices": "Prices in {code}",
    "est.side.act.plus": "Replace (install new)",
    "est.side.act.minus": "Remove only",
    "est.side.act.rr": "Remove & replace",
    "est.side.act.dr": "Detach & reset",
    "est.side.noPrice": "we don't have it",
    "est.side.xact": "What Xactimate says",
    "est.side.notesN": "Notes · {n}",
    "est.side.rebuttalsN": "Playbook · {name} · {n}",
    "est.side.picked": "picked",
    "est.side.pickHint": "Tick the notes that go under this line in the estimate; several can go together.",
    "est.side.showPrices": "Show the other activities' prices",
    "est.side.hidePrices": "Hide the other prices",
    "est.calc.open": "Calculate the quantity with the Xactimate formula",
    "est.calc.formula": "Formula",
    "est.calc.result": "Quantity",
    "est.calc.help": "Click a field to see what it measures.",
    "est.calc.uncalibrated": "formula pending calibration",
    "est.calc.uncalibratedHint": "This formula does not yet match Xactimate's result exactly; the office is measuring it. Check the quantity.",
    "est.calc.f.rafters": "Board feet in a hand framed roof",
    "est.calc.f.truss": "Linear feet of truss",
    "est.calc.title.rafters": "Board Feet in a Hand Framed Roof without a Tie-in",
    "est.calc.title.truss": "Linear Feet of Truss",
    "est.calc.rafters.width": "Rafter width",
    "est.calc.rafters.width.help": "Select the larger of the two dimensions at the end of the rafter. For example, select 8\" if the rafters are 2\" by 8\".",
    "est.calc.rafters.rafter_length": "Rafter length",
    "est.calc.rafters.rafter_length.help": "Enter the length of the rafter from the fascia to the roof's ridge.",
    "est.calc.rafters.roof_length": "Roof length",
    "est.calc.rafters.roof_length.help": "Enter the length of the roof measured parallel to its ridge.",
    "est.calc.rafters.centers": "Rafter centers",
    "est.calc.rafters.centers.help": "Select the distance from the center of one rafter to the center of the next. For example, select 24\" for twenty-four inch centers.",
    "est.calc.rafters.doubled": "Doubled rafters",
    "est.calc.rafters.doubled.help": "Enter the number of doubled rafters. Doubled rafters are used where additional support is needed: air conditioning units, dormers, or framing around chimneys may require extra rafters.",
    "est.calc.truss.length": "Length",
    "est.calc.truss.length.help": "Enter the building dimension perpendicular to the span of the trusses.",
    "est.calc.truss.width": "Width",
    "est.calc.truss.width.help": "This is the width of a typical truss not including overhang. Enter the measurement from bearing point to bearing point of the truss.",
    "est.calc.truss.centers": "Truss centers",
    "est.calc.truss.centers.help": "Select the distance from the center of one truss to the center of the next. For example, select 16\" for sixteen inch centers.",
    "est.side.act.m": "Material only",
    "est.side.act.l": "Installation only",
    "est.side.switchAct": "Click to switch this line to that activity (the price changes with it)",
    "plx.tags": "Tags",
    "plx.tagsHint": "other words people use for this item (slang, damage, Spanish): the search box and the room AI find it by them. Improve with AI adds them; you can edit.",
    "plx.addTag": "Add a tag, Enter",
    "plx.related": "Related items",
    "plx.relatedHint": "\"this one cleans; to replace use…\": the other items that fit a neighbouring case. Improve with AI adds the ones it names and every code the Xactimate definition mentions (only real catalog items); the link is mutual (the other item gets this one too); you can add or remove.",
    "plx.addRelated": "Add a related item by name or code…",
    "est.relatedTo": "related to {name}",
    "est.ai.button": "Estimate with AI",
    "est.ai.title": "Estimate with AI · {room}",
    "est.ai.placeholder": "Write or dictate what happened in this room: full ceiling paint, remove 40 LF of baseboard and install new, carpet replaced…",
    "est.ai.hint": "Describe the damage and the work in your words; the AI looks through the item catalog and the macros and proposes the items, including what usually goes with them (protection, contents, cleaning). You tick the ones that go in.",
    "est.ai.suggest": "Suggest items",
    "est.ai.thinking": "Looking through the catalog…",
    "est.ai.requested": "What you asked for",
    "est.ai.related": "Usually goes with it",
    "est.ai.addSelected": "Add selected ({n})",
    "est.ai.added": "{n} lines added from the AI suggestion.",
    "est.ai.none": "No matching items in the catalog. Try other words, or add the item by hand from the list on the left.",
    "est.ai.missing": "Not found in the catalog: {list}",
    "est.ai.searched": "{n} candidates reviewed",
    "est.ai.macrosUsed": "macros: {list}",
    "est.ai.macroPart": "{n} matching lines",
    "est.ai.fromMacro": "macro: {name}",
    "est.ai.notConfigured": "AI is not configured (OPENROUTER_API_KEY / CLAUDE_API_KEY).",
    "est.room.runMacro": "Run macro",
    "est.room.macroHint": "Apply a macro to this room (you can run several).",
    "est.room.noDimsYet": "No dimensions yet · edit the room to add them and get the plan and quantities.",
    "est.room.sketchBtn": "Sketch image",
    "est.room.sketchShort": "Sketch",
    "est.room.sketchFor": "Sketch image · {room}",
    "est.room.sketchUpload": "Upload the sketch",
    "est.room.sketchOpen": "Open the sketch",
    "est.room.sketchRemove": "Remove the sketch image",
    "est.room.fromEstimate": "From the estimate",
    "est.opt.button": "Optimize",
    "est.opt.title": "Optimize · {room}",
    "est.opt.hint": "Reads what this room pays for and suggests what is missing; add damage in your words to get the related items.",
    "est.opt.paying": "What they are paying for",
    "est.opt.reading": "Reading the room…",
    "est.opt.noSummary": "No lines in this room yet. Describe the damage below.",
    "est.opt.placeholder": "Add damage or work the estimate does not cover: \"the whole floor has to be replaced, it was soaked\"…",
    "est.opt.suggest": "Suggest with this",
    "est.opt.nothing": "Nothing to optimize yet: add lines to the room or describe the damage.",
    "est.inv.button": "Add invoice",
    "est.inv.title": "Add invoice",
    "est.inv.hint": "Pick a file of this claim that has a price (tarp, mitigation, any invoice): it becomes a line with the invoice attached to the estimate.",
    "est.inv.none": "No files with a price on this claim yet. Upload the invoice in Files first.",
    "est.inv.noAmount": "no amount",
    "est.inv.name": "Item name",
    "est.inv.amount": "Amount",
    "est.inv.attached": "Attached: {name} — it goes at the end of the generated PDF.",
    "est.inv.noTax": "The invoice line carries no tax and no O&P.",
    "est.inv.add": "Add as a line",
    "est.inv.attachment": "invoice",
    "est.opt.photos": "ClaimCam photos",
    "est.opt.photosHint": "Browse the claim\u2019s ClaimCam photos and attach them to the ticked lines",
    "est.opt.photosTickFirst": "Tick the lines first, or use the photo button on a line.",
    "est.opt.photosSelected": "{n} ticked line(s)",
    "est.opt.macroGap": "In the macro for this room, not here",
    "rd.rereadHint": "Read the estimate again (brings the room and roof measurements printed under each area)",
    "est.meas.button": "Measurements from the estimate",
    "est.meas.busy": "Reading…",
    "est.meas.hint": "Re-read the source estimate and bring the room and roof measurements into each zone",
    "est.meas.reading": "Re-reading the estimate… about 2 minutes. The measurements will appear in each zone when it finishes.",
    "est.meas.done": "Measurements loaded for {n} zone(s).",
    "est.meas.none": "The estimate prints no measurements for its areas.",
    "est.meas.noSource": "This draft did not come from an estimate file.",
    "est.meas.failed": "The reading failed. Check the file in Files.",
    "est.meas.timeout": "Still reading. Try again in a minute.",
    "est.opt.have": "Already in the estimate · {n}",
    "est.opt.haveNone": "No lines in this room yet.",
    "est.opt.suggested": "Recommended · {n}",
    "est.opt.needed": "Needed for this scope",
    "est.cmp.button": "Compare",
    "est.cmp.hint": "Compare this estimate with the latest one of the other side",
    "est.cmp.title": "Compare",
    "est.cmp.thisIs": "This estimate is {side}.",
    "est.cmp.against": "Compared with:",
    "est.cmp.latest": "latest",
    "est.cmp.none": "The other side has no estimate read yet on this claim.",
    "est.cmp.side.ours": "ours",
    "est.cmp.side.insurance": "the insurance\u2019s",
    "est.cmp.ourTotal": "This estimate",
    "est.cmp.theirTotal": "Theirs ({side})",
    "est.cmp.onlyTheirs": "Only in {side}",
    "est.cmp.different": "Different quantity or price",
    "est.cmp.onlyOurs": "Only in this estimate",
    "est.cmp.nothingHere": "Nothing here.",
    "est.cmp.add": "add",
    "est.cmp.ours": "this",
    "est.cmp.takeQty": "take their qty",
    "est.cmp.takePrice": "take their price",
    "est.cmp.closest": "closest on their side",
    "est.cmp.equal": "{n} line(s) match.",
    // ── Estimating groups (2026-10-20) ──
    "est.group.roof": "Roof",
    "est.group.exterior": "Exterior",
    "est.group.framing": "Framing",
    "est.group.floor": "Floor",
    "est.group.floor_wall": "Floor & Wall",
    "est.group.kitchen": "Kitchen",
    "est.group.dining": "Dining",
    "est.group.living_room": "Living Room",
    "est.group.bedroom": "Bedroom",
    "est.group.bathroom": "Bathroom",
    "est.group.laundry": "Laundry",
    "est.group.office_den": "Office / Den",
    "est.group.garage": "Garage",
    "est.group.basement": "Basement",
    "est.group.stairs": "Stairs",
    "est.groupN": "{n} items",
    "est.groupEmpty": "No items in this group yet (assign them in Settings → Supplements → Estimating → Items)",
    "est.groupsN": "{n} groups",
    "est.groupNoItems": "No items in {group} yet.",
    "est.settings.allGroups": "All groups",
    "est.settings.missingGroup": "Without group",
    "est.settings.groups": "Groups",
    "est.settings.groupsHint": "the big buttons of the Estimating Tool; an item can be in several (drywall: bedroom, living room, basement…)",
    "est.room.shortcuts": "Qty shortcuts",
    "est.room.shortcutHint": "Type {key} in a quantity cell to use this measurement",
    "est.search.searching": "Searching…",
    "est.search.custom": "Keep as a custom item: “{text}”",
    "est.custom": "custom",
    "est.customHint": "Not a catalog item: typed by hand",
    // ── Estimating paste (2026-10-20) ──
    "est.paste.button": "Paste items from Xactimate",
    "est.paste.hint": "One item per line as Xactimate lists them: code, activity (+ − & R), description, unit and unit price. Also \"code | description | unit | price\". Select the groups they belong to; the prices are saved as the official price list of the month.",
    "est.paste.priceList": "Price list of the prices",
    "est.paste.unparsed": "{n} line(s) could not be read (fix them and they will appear in the preview):",
    "est.paste.save": "Save {n} items",
    "est.paste.saveHint": "Re-pasting the same items updates prices and groups; nothing is duplicated.",
    "est.paste.done": "{n} items saved · {nuevos} new · {priced} with official price",
    // ── Estimating groups admin (2026-10-20) ──
    "est.groups.manage": "Groups",
    "est.groups.manageHint": "The big buttons of the Estimating Tool: the Xactimate categories you load (Roof, Paint, Carpet, Contents…). Rename, reorder or retire them; pasting a list with a new group creates it.",
    "est.groups.newPlaceholder": "New group…",
    "est.groups.add": "Add group",
    "est.groups.catHint": "Xactimate category code that owns this group (RFG, PNT…): every item with that code goes here.",
    "est.groups.catsHint": "Paste the Xactimate P.L. Categories list (code and name per line, e.g. \"RFG  ROOFING\"). Each category becomes a group with its code, and every item moves to the group of its code.",
    "est.groups.catsLoad": "Load categories",
    "est.groups.catsDone": "{parsed} categories read · {created} groups created · {moved} items moved to the group of their code.",
    "est.groups.regroup": "Move items by code",
    "est.groups.regroupHint": "Every item whose code owns a group goes to that group only (fixes drywall sitting in Roof).",
    "est.groups.regroupDone": "{moved} items moved to the group of their code.",
    "est.groups.remove": "Retire group",
    "est.groups.removeConfirm": "Retire the group \"{name}\"? Its items keep the tag and the button disappears.",
    // Templates (Management → Templates, mig 0553, dueño 2026-10-28).
    "nav.templates": "Templates",
    "tplh.title": "Templates",
    "tplh.subtitle": "Every email and text-message template the company uses, by department. What you save here is what goes out.",
    "tplh.tab.templates": "Templates",
    "tplh.tab.access": "Access",
    "tplh.new": "New template",
    "tplh.all": "All",
    "tplh.search": "Search by name or text…",
    "tplh.type.all": "All types",
    "tplh.empty": "No templates here yet.",
    "tplh.noMatch": "Nothing matches the search.",
    "tplh.off": "Off",
    "tplh.subject": "Subject",
    "tplh.forbidden": "You do not have access to Templates. Ask the owner to add you in Templates → Access.",
    "tplh.dept.general": "General",
    "tplh.dept.intake": "Intake",
    "tplh.dept.claims": "Claims",
    "tplh.dept.scheduling": "Scheduling",
    "tplh.dept.supplements": "Supplements",
    "tplh.dept.payments": "Payments",
    "tplh.src.composer": "Claim email & SMS",
    "tplh.src.composer.d": "Picked by hand in the email or text box of any claim.",
    "tplh.src.view": "Working view emails",
    "tplh.src.view.d": "Show up in the email box only when the claim is opened from that working view (the ⚙ of the queue).",
    "tplh.src.automatic": "Automatic messages",
    "tplh.src.automatic.d": "Go out on their own when the claim, the payment or the inspection changes status.",
    "tplh.src.followup": "Adjuster follow-ups",
    "tplh.src.followup.d": "Go out on their own in the estimate thread until the adjuster answers: #1 first, the last one is the firmest.",
    "tplh.src.ho_update": "Weekly homeowner update",
    "tplh.src.ho_update.d": "The subject of the weekly email and the text message that links to it, in English and Spanish.",
    "tplh.src.contractor": "Contractor emails",
    "tplh.src.contractor.d": "A button with its name on every contractor file.",
    "tplh.view": "View: {v}",
    "tplh.to.homeowner": "To the homeowner",
    "tplh.to.contractor": "To the contractor",
    "tplh.when.claim": "When the claim enters {v}",
    "tplh.when.payment": "When the payment status is {v}",
    "tplh.when.inspection": "Inspection: {v}",
    "tplh.insp.waiting": "waiting to schedule",
    "tplh.insp.scheduled": "scheduled",
    "tplh.insp.day_of": "inspection day (morning reminder)",
    "tplh.insp.on_the_way": "inspector on the way",
    "tplh.insp.checked_in": "inspector checked in",
    "tplh.insp.done": "inspection done",
    "tplh.insp.atr_day_before": "ATR, morning before (reminder)",
    "tplh.insp.atr_day_of": "ATR, morning of (reminder)",
    "tplh.fu.name": "Follow-up #{n}",
    "tplh.ho.email_subject_en": "Email subject (English)",
    "tplh.ho.email_subject_es": "Email subject (Spanish)",
    "tplh.ho.sms_en": "Text message (English)",
    "tplh.ho.sms_es": "Text message (Spanish)",
    "tplh.ed.new": "New template",
    "tplh.ed.edit": "Edit",
    "tplh.ed.type": "What kind of template?",
    "tplh.ed.back": "← Other kind",
    "tplh.ed.name": "Name",
    "tplh.ed.namePh": "e.g. Ask about the check",
    "tplh.ed.dept": "Department",
    "tplh.ed.view": "Working view",
    "tplh.ed.pick": "Pick one…",
    "tplh.ed.noViews": "This department has no working views",
    "tplh.ed.channel": "Channel",
    "tplh.ed.trigger": "Goes out when",
    "tplh.ed.trigger.claim": "Claim status",
    "tplh.ed.trigger.payment": "Payment status",
    "tplh.ed.trigger.inspection": "Inspection",
    "tplh.ed.status": "Status",
    "tplh.ed.recipient": "To",
    "tplh.ed.homeowner": "Homeowner",
    "tplh.ed.contractor": "Contractor",
    "tplh.ed.body": "Message",
    "tplh.ed.bodyPh": "Write the message…",
    "tplh.ed.chips": "Insert:",
    "tplh.ed.chars": "{n} characters",
    "tplh.ed.active": "Active",
    "tplh.ed.inactive": "Off — not offered and not sent",
    "tplh.ed.autoWarn": "This message goes out on its own: what you save here is what the next person receives.",
    "tplh.ed.fuSignature": "Signed below with: {s}",
    "tplh.ed.delete": "Delete",
    "tplh.ed.deleteConfirm": "Delete \"{n}\"? It cannot be undone.",
    "tplh.ed.discard": "Discard your changes?",
    "tplh.err.changed": "Someone changed this template while you were editing it. Close, reopen it and try again.",
    "tplh.err.needName": "Give it a name.",
    "tplh.err.needBody": "Write the message.",
    "tplh.err.needView": "Pick the working view.",
    "tplh.err.needTrigger": "Pick when it goes out.",
    "tplh.err.last": "The follow-up needs at least one template.",
    "tplh.err.tooLong": "Too long: up to {max} characters.",
    "tplh.acc.title": "Who can open Templates",
    "tplh.acc.hint": "They see, edit, create and delete every template in this section — including the automatic messages that go out on their own. The owner always has access.",
    "tplh.acc.who": "{n} with access: {names}",
    "tplh.acc.search": "Search a person…",
    "tplh.acc.person": "Person",
    "tplh.acc.role": "Role",
    "tplh.acc.grantedBy": "Given by",
    "tplh.acc.master": "Owner — always",
    "tplh.acc.cantSelf": "You cannot remove yourself.",
    "tplh.acc.cantEmpty": "Someone has to keep access.",
    "tplh.acc.noPeople": "Nobody matches.",
    "tplh.acc.editorsHint": "Separate, older permission: these people and teams can also create claim email & SMS templates from Settings → Templates, without opening this section.",
    // Agents (dueño 2026-11-01, mig 0562): el portal de los bots y el botón del hub.
    "nav.agents": "Agents",
    "est.hub.bot": "Estimate with the bot",
    "est.hub.botHint": "The estimator bot builds the roof draft in the Estimating Tool and leaves a report and a task. It does not generate the PDF.",
    "est.hub.botQueued": "Queued. Follow it in Agents → Runs.",
    "est.hub.botNotConfigured": "Managed Agents is not configured (API key).",
    "est.hub.botInactive": "The estimator bot is turned off in Agents.",
    "est.hub.botAlready": "The bot is already working on this claim.",
    "est.hub.botBudget": "The bot reached its monthly budget.",
    "est.hub.botFailed": "Could not queue the bot.",
    "ag.title": "Agents",
    "ag.subtitle": "The bots of the company: what they are doing, what they did, what they cost, and the rules they follow.",
    "ag.forbidden": "This section is only for the people on its access list.",
    "ag.notConfigured": "Managed Agents is not configured yet: the CLAUDE_API_KEY of an Anthropic organization with Managed Agents enabled is missing. Runs will fail until it is set.",
    "ag.tab.dashboard": "Dashboard",
    "ag.tab.agents": "Agents",
    "ag.tab.runs": "Runs",
    "ag.tab.access": "Access",
    "ag.back": "Back",
    "ag.range": "Range",
    "ag.rangeDays": "{n} days",
    "ag.kpi.running": "Running now",
    "ag.kpi.rightNow": "right now",
    "ag.kpi.waitingHuman": "{n} waiting for a person",
    "ag.kpi.runs": "Runs",
    "ag.kpi.claimsTouched": "{n} claims",
    "ag.kpi.success": "Completed",
    "ag.kpi.acceptance": "Accepted by the office",
    "ag.kpi.decisions": "{n} rated",
    "ag.kpi.avgDuration": "Avg. duration",
    "ag.kpi.toolCalls": "{n} tool calls",
    "ag.kpi.costMonth": "Cost this month",
    "ag.kpi.ofBudget": "of {b} budget",
    "ag.live.title": "Working now",
    "ag.live.empty": "No bot is working right now.",
    "ag.live.queued": "Queued, waiting for the worker",
    "ag.live.starting": "Starting…",
    "ag.live.step": "{k}: {n}",
    "ag.live.since": "{d}",
    "ag.live.tools": "tools",
    "ag.chart.runsPerDay": "Runs per day",
    "ag.chart.costPerDay": "Cost per day (USD)",
    "ag.chart.byAgent": "Runs by agent",
    "ag.chart.outcomes": "What the office said",
    "ag.chart.outcomesHint": "Each bot result gets rated by a person: accepted as is, changed, or rejected.",
    "ag.chart.byHour": "Runs by hour of day",
    "ag.chart.byHourHint": "office time",
    "ag.recent.title": "Recent runs",
    "ag.status.queued": "Queued",
    "ag.status.running": "Running",
    "ag.status.waiting_human": "Waiting for a person",
    "ag.status.done": "Done",
    "ag.status.failed": "Failed",
    "ag.status.cancelled": "Cancelled",
    "ag.outcome.accepted": "Accepted",
    "ag.outcome.changed": "Changed",
    "ag.outcome.rejected": "Rejected",
    "ag.outcome.pending": "Not rated yet",
    "ag.runs.agent": "Agent",
    "ag.runs.claim": "Claim",
    "ag.runs.status": "Status",
    "ag.runs.summary": "Summary",
    "ag.runs.duration": "Duration",
    "ag.runs.cost": "Cost",
    "ag.runs.when": "When",
    "ag.runs.empty": "No runs yet.",
    "ag.runs.allAgents": "All agents",
    "ag.runs.allStatuses": "All statuses",
    "ag.k.estimator": "Estimator",
    "ag.k.reviewer": "Draft reviewer",
    "ag.k.round": "Insurance rounds",
    "ag.k.content": "Content director",
    "ag.k.leads": "Lead responder",
    "ag.k.ads": "Ads manager",
    "ag.k.storms": "Storm responder",
    "ag.k.reviews": "Review collector",
    "ag.k.correspondence": "Adjuster correspondence",
    "ag.agent.on": "On",
    "ag.agent.off": "Off",
    "ag.agent.turnOn": "Turn on",
    "ag.agent.turnOff": "Turn off",
    "ag.agent.notAvailable": "Not built yet (phase {n} of the plan).",
    "ag.agent.phase": "Phase {n} · not yet",
    "ag.agent.runningN": "{n} running",
    "ag.agent.runs30": "Runs · 30 d",
    "ag.agent.lastRun": "Last run",
    "ag.agent.budgetMonth": "Budget this month",
    "ag.agent.settings": "Settings",
    "ag.agent.model": "Model",
    "ag.agent.monthlyBudget": "Monthly budget (USD)",
    "ag.agent.runBudget": "Budget per run (USD)",
    "ag.agent.remote": "Anthropic agent",
    "ag.agent.remoteNone": "created on first run",
    "ag.agent.memory": "memory",
    "ag.agent.stats": "Last 30 days",
    "ag.agent.recentRuns": "Recent runs",
    "ag.rules.title": "Rules",
    "ag.rules.hint": "Everything the bot follows that is not code. Change it here and the next run uses it; every change keeps a version with who and when.",
    "ag.rules.kind.list": "list",
    "ag.rules.kind.table": "table",
    "ag.rules.kind.threshold": "threshold",
    "ag.rules.kind.switch": "on / off",
    "ag.rules.kind.if_then": "if / then",
    "ag.rules.kind.text": "text",
    "ag.rules.default": "default",
    "ag.rules.invalid": "That value does not fit this rule.",
    "ag.rules.textPlaceholder": "Write it in your words. It goes into the bot's instructions verbatim.",
    "ag.rules.listPlaceholder": "One item per line",
    "ag.rules.addRow": "Add row",
    "ag.rules.removeRow": "Remove row",
    "ag.rules.when": "When",
    "ag.rules.then": "Then",
    "ag.rules.reason": "Reason (written in the note)",
    "ag.rules.restore": "Restore default",
    "ag.rules.restoreHint": "Back to the built-in value. The history is kept.",
    "ag.rules.history": "History",
    "ag.rules.noHistory": "No changes yet.",
    "ag.rules.updatedBy": "{who} · {when}",
    "ag.run.n": "run #{n}",
    "ag.run.cancel": "Cancel",
    "ag.run.console": "Session in Anthropic",
    "ag.run.tokens": "{i} in · {o} out tokens",
    "ag.run.rulesVersion": "rules v{v}",
    "ag.run.draft": "Draft",
    "ag.run.lines": "lines",
    "ag.run.openDraft": "Open in the Estimating Tool",
    "ag.run.steps": "Steps",
    "ag.run.noSteps": "No steps were recorded.",
    "ag.run.io": "input / output",
    "ag.run.input": "input",
    "ag.run.output": "output",
    "ag.step.tool": "tool",
    "ag.step.message": "message",
    "ag.step.note": "note",
    "ag.step.error": "error",
    "ag.step.review": "reviewer tool",
    "ag.run.report": "Report",
    "ag.run.inProgress": "The bot is still working.",
    "ag.run.noReport": "No report.",
    "ag.run.confidence": "Confidence",
    "ag.conf.high": "high",
    "ag.conf.medium": "medium",
    "ag.conf.low": "low",
    "ag.run.assumptions": "What it assumed",
    "ag.run.unresolved": "For a person to decide",
    "ag.run.noPhoto": "Lines without a photo",
    "ag.run.photoRequests": "Photo requests opened",
    "ag.run.review": "Reviewer",
    "ag.verdict.ready": "ready",
    "ag.verdict.needs_fixes": "needs fixes",
    "ag.verdict.not_defensible": "not defensible",
    "ag.acc.title": "Who can open Agents",
    "ag.acc.hint": "A list, not a role: the owner (master) always enters; the people below only if switched on. Whoever is on the list can change it. Nobody can remove themselves.",
    "ag.acc.who": "{n} with access: {names}",
    "ag.acc.search": "Search people…",
    "ag.acc.person": "Person",
    "ag.acc.role": "Role",
    "ag.acc.grantedBy": "Granted by",
    "ag.acc.master": "Owner · always",
    "ag.acc.cantSelf": "You cannot remove yourself.",
    "ag.acc.cantEmpty": "Someone has to keep access.",
    "ag.rate.title": "Rate this run",
    "ag.rate.hint": "Did the bot's work serve as is? This is what the dashboard measures as productivity.",
    "ag.rate.reason": "Why (optional)",
    "neg.botRound": "Pre-decided by the bot · {n} lines · rules v{v}",
    "neg.botRoundHint": "The insurance rounds bot pre-loaded dispute / let go by the rules in Agents. Review and change what you want; you generate and send.",
    'aim.f.social_reply': "Social media: reply draft", 'aim.f.social_reply.d': "Marketing → Social: for each Facebook / Instagram direct message or post comment, classifies it and drafts the reply in the language of the message using only the verified business facts. Escalates complaints and anything about a specific claim. A person approves and sends unless auto-send is on.",
    'aim.f.marketing_personalize': "Contractor outreach: personalize the message", 'aim.f.marketing_personalize.d': "Marketing → contractor campaigns: fills the sequence template for one prospect using only its public data (trade, city, rating, website) and the approved value proposition. Never invents facts; if it fails, the plain template goes out.",
    'aim.f.marketing_content': "Marketing → Content: write a piece", 'aim.f.marketing_content.d': "Marketing → Content: writes each post, reel or video script in English and Spanish with hashtags from the topic (or a blog article), the brand voice and the never-say list of the Content director. The code picks the image, schedules and publishes.",
    'aim.f.marketing_image': "Marketing → Content: image (Nano Banana)", 'aim.f.marketing_image.d': "The image of each piece, generated with Google's Nano Banana through OpenRouter from the topic, the brand style rules and the assets tagged brand / logo. The model id is the Content director rule 'image_model'.",
    'aim.f.marketing_video': "Marketing → Content: video (Higgsfield)", 'aim.f.marketing_video.d': "A short vertical video for reel pieces, rendered by Higgsfield Cloud from the piece image and the script. Billed by Higgsfield on its own account.",
    "ag.k.alianzas": "Contractor partnerships",
    "ag.k.social": "Social media replies",
    // Marketing → alianzas con contratistas (dueño 2026-11-02, mig 0563)
    'nav.marketing': 'Marketing',
    'mk.title': 'Marketing · Contractor partnerships',
    'mk.sub': 'Find contractors, run approved outreach campaigns (email, SMS, scheduled calls) and handle the replies. Rules (trades, areas, caps, sender, never-say list) live in Agents → Contractor partnerships.',
    'mk.noAccess': 'This section is only for the people on the Agents access list.',
    'mk.all': 'All',
    'mk.search': 'Search…',
    'mk.tab.prospects': 'Prospects',
    'mk.tab.campaigns': 'Campaigns',
    'mk.tab.replies': 'Replies',
    'mk.st.new': 'New',
    'mk.st.qualified': 'Qualified',
    'mk.st.rejected': 'Rejected',
    'mk.st.contacted': 'Contacted',
    'mk.st.replied': 'Replied',
    'mk.st.meeting': 'Meeting',
    'mk.st.converted': 'Converted',
    'mk.st.unsubscribed': 'Unsubscribed',
    'mk.st.bounced': 'Bounced',
    'mk.reason.existing_contractor': 'Already a contractor in the CRM',
    'mk.reason.rating_below_min': 'Google rating below the minimum rule',
    'mk.reason.reviews_below_min': 'Fewer reviews than the minimum rule',
    'mk.reason.no_contact_channel': 'No email or phone',
    'mk.reason.not_operational': 'Not operational on Google',
    'mk.reason.manual': 'Set by hand',
    'mk.reason.reply': 'Asked to stop (reply)',
    'mk.reason.link': 'Unsubscribed via link',
    'mk.reason.suppressed': 'Email bounced / suppressed',
    'mk.pr.searchTitle': 'Find contractors on Google',
    'mk.pr.searchHint': 'Searches Google Places for a trade in a city, saves what it finds and qualifies it by the rules. Contractors already in the CRM are skipped. "Prospect all" runs every trade × area from the rules.',
    'mk.pr.trade': 'Trade',
    'mk.pr.city': 'City',
    'mk.pr.state': 'State',
    'mk.pr.search': 'Search',
    'mk.pr.searchAll': 'Prospect all (rules)',
    'mk.pr.searchDone': '{q} searches · {n} new prospects · {k} qualified',
    'mk.pr.searchOneDone': 'Found {f} · {n} new · {k} qualified · {c} already contractors',
    'mk.pr.total': 'Prospects',
    'mk.pr.repliedSub': '{n} in meeting',
    'mk.pr.rejectedSub': '{n} unsubscribed',
    'mk.pr.empty': 'No prospects here yet. Search above.',
    'mk.pr.name': 'Name',
    'mk.pr.where': 'Where',
    'mk.pr.rating': 'Rating · reviews',
    'mk.pr.score': 'Score',
    'mk.pr.contact': 'Contact',
    'mk.pr.email': 'Email',
    'mk.pr.phone': 'Phone',
    'mk.pr.notes': 'Notes',
    'mk.pr.enrich': 'Find email on website',
    'mk.pr.enrichHint': 'Visits the website (and /contact) looking for a public email.',
    'mk.pr.enrichFound': 'Found {e}',
    'mk.pr.enrichNone': 'No public email found on the website.',
    'mk.pr.actions': 'Actions',
    'mk.pr.actionsHint': 'Rejecting or unsubscribing stops every active sequence for this prospect. Converting creates the contractor in the CRM.',
    'mk.pr.markQualified': 'Mark qualified',
    'mk.pr.markRejected': 'Reject',
    'mk.pr.markMeeting': 'Meeting set',
    'mk.pr.convert': 'Convert to contractor',
    'mk.pr.convertConfirm': 'Create this prospect as a contractor in the CRM?',
    'mk.pr.converted': 'Contractor created.',
    'mk.pr.noCampaigns': 'Not in any campaign.',
    'mk.pr.lastTouch': 'Last touch',
    'mk.ch.email': 'Email',
    'mk.ch.sms': 'SMS',
    'mk.ch.call': 'Call',
    'mk.cp.draft': 'Draft',
    'mk.cp.pending_approval': 'Waiting approval',
    'mk.cp.running': 'Running',
    'mk.cp.paused': 'Paused',
    'mk.cp.done': 'Finished',
    'mk.cp.rejected': 'Rejected',
    'mk.cp.approvalNote': 'Nothing goes out without approval: a campaign is written here, submitted, and only after someone on this list approves it does the worker start sending, inside the office window and under the daily caps.',
    'mk.cp.listHint': 'Each campaign = who (filter) + what (sequence of steps) + how much (caps and window).',
    'mk.cp.new': 'New campaign',
    'mk.cp.defaultName': 'Contractor outreach',
    'mk.cp.empty': 'No campaigns yet.',
    'mk.cp.steps': 'steps',
    'mk.cp.from': 'From',
    'mk.cp.eligible': 'Eligible',
    'mk.cp.enrolled': 'Enrolled',
    'mk.cp.sent': 'Sent',
    'mk.cp.calls': 'Calls scheduled',
    'mk.cp.replies': 'Replies',
    'mk.cp.unsubscribed': 'Unsubscribed',
    'mk.cp.active': 'active',
    'mk.cp.stopped': 'stopped',
    'mk.cp.sentEmail': 'Emails sent',
    'mk.cp.sentSms': 'SMS sent',
    'mk.cp.queued': 'Queued',
    'mk.cp.submit': 'Submit for approval',
    'mk.cp.pause': 'Pause',
    'mk.cp.resume': 'Resume',
    'mk.cp.finish': 'Finish',
    'mk.cp.finishConfirm': 'Finish this campaign? Queued steps are cancelled.',
    'mk.cp.approvedBy': 'Approved by {who} · {when}',
    'mk.cp.rejectedBy': 'Rejected by {who} · {when}',
    'mk.cp.pendingTitle': 'This campaign is waiting for approval.',
    'mk.cp.pendingHint': 'Read the sequence and the filter below. Approving starts sending to {n} eligible prospects (inside the window, under the caps).',
    'mk.cp.decisionNote': 'Note (optional)',
    'mk.cp.approve': 'Approve and start',
    'mk.cp.reject': 'Reject',
    'mk.cp.sequence': 'Sequence',
    'mk.cp.sequenceHint': 'One step per touch: day (from enrollment), channel and text. Every email must include the unsubscribe link; every SMS must say "Reply STOP to opt out"; a call creates a task for a person. Placeholders:',
    'mk.cp.day': 'Day',
    'mk.cp.enabled': 'Enabled',
    'mk.cp.subject': 'Subject',
    'mk.cp.body': 'Message',
    'mk.cp.callNote': 'What the caller should say / check',
    'mk.cp.needUnsub': 'This email has no {unsubscribe_url}: it will not pass the compliance check.',
    'mk.cp.smsOff': 'SMS is off for this campaign (rule allow_sms / campaign setting).',
    'mk.cp.touches': 'Touches',
    'mk.cp.touchesEmpty': 'Nothing sent or queued yet.',
    'mk.cp.step': 'Step',
    'mk.cp.when': 'When',
    'mk.tq.queued': 'Queued',
    'mk.tq.sent': 'Sent',
    'mk.tq.failed': 'Failed',
    'mk.tq.skipped': 'Skipped',
    'mk.tq.dry_run': 'Dry run',
    'mk.cp.settings': 'Settings',
    'mk.cp.fromName': 'Sender name',
    'mk.cp.fromHint': 'the address comes from the agent rules (from_domain / from_local).',
    'mk.cp.capEmail': 'Emails / day',
    'mk.cp.windowStart': 'From (h)',
    'mk.cp.windowEnd': 'To (h)',
    'mk.cp.businessDays': 'Business days only (no weekends or federal holidays)',
    'mk.cp.allowCalls': 'Call steps create tasks',
    'mk.cp.allowSms': 'Allow SMS steps',
    'mk.cp.allowSmsHint': 'Also requires the agent rule allow_sms to be on. Cold SMS has TCPA risk: keep it off unless you have consent.',
    'mk.cp.filter': 'Who gets it (filter)',
    'mk.cp.filterHint': 'Qualified prospects matching these filters, never unsubscribed, never an existing contractor, never in two campaigns at once.',
    'mk.cp.commaList': 'comma-separated',
    'mk.cp.minScore': 'Min score',
    'mk.cp.maxProspects': 'Max prospects',
    'mk.cp.eligibleNow': '{n} eligible right now.',
    'mk.cp.dryRun': 'Dry run',
    'mk.cp.dryRunHint': 'Runs one worker tick without sending: enrolls and writes what WOULD go out (status "dry run"), so you can read the actual messages.',
    'mk.cp.dryRunBtn': 'Run a dry tick',
    'mk.cp.dryRunDone': '{n} touches prepared · {e} enrolled · {w} campaigns outside the window',
    'mk.rp.hint': 'Replies to the campaigns (email via the Reply-To token, SMS by phone). Each one stopped the sequence and opened a task; mark it handled when done.',
    'mk.rp.pending': 'Pending',
    'mk.rp.empty': 'No replies.',
    'mk.rp.handledBy': 'Handled by {who}',
    'mk.rp.meeting': 'Meeting set',
    'mk.rp.handled': 'Mark handled',
    'mk.rp.taskOpen': 'A task is open for this reply.',
    'mk.cl.interested': 'Interested',
    'mk.cl.question': 'Question',
    'mk.cl.not_interested': 'Not interested',
    'mk.cl.unsubscribe': 'Unsubscribe',
    'mk.cl.auto_reply': 'Auto-reply',
    'mk.cl.other': 'Other',
    // Marketing → Social (DMs y comentarios de Meta, mig 0564)
    'mk.tab.social': 'Social',
    'mk.so.approvalNote': 'Every direct message and post comment from the connected pages lands here with a reply draft. A person reads, edits if needed and sends. Nothing goes out alone unless the rule "Auto-send" of the Social media agent is on. Complaints, legal words and anything about a specific claim are escalated with a task.',
    'mk.so.webhookOff': 'The Meta webhook is not configured on the server (META_APP_SECRET / META_VERIFY_TOKEN). Messages will not arrive until it is.',
    'mk.so.accounts': 'Connected pages',
    'mk.so.connect': 'Connect a page',
    'mk.so.webhookUrl': 'Webhook URL for the Meta app',
    'mk.so.connectHint': 'From Meta for Developers: the Page id (or Instagram business account id), a name, and the Page access token with pages_messaging, pages_manage_engagement, pages_read_engagement (and instagram_manage_messages / instagram_manage_comments for Instagram). The token is stored encrypted and never shown again.',
    'mk.so.externalId': 'Page / account id',
    'mk.so.token': 'Page access token (optional now, required to reply)',
    'mk.so.noAccounts': 'No page connected yet.',
    'mk.so.disconnected': 'Disconnected',
    'mk.so.tokenOk': 'Can reply',
    'mk.so.noToken': 'No token: read only',
    'mk.so.pending': 'pending',
    'mk.so.disconnect': 'Disconnect',
    'mk.so.disconnectConfirm': 'Disconnect {name}? Its token is deleted; messages stop arriving until you connect it again.',
    'mk.so.inboxHint': 'Inbox: what people wrote and what the bot proposes.',
    'mk.so.f.pending': 'Pending',
    'mk.so.f.sent': 'Sent',
    'mk.so.f.ignored': 'Ignored',
    'mk.so.empty': 'Nothing here.',
    'mk.so.dm': 'Direct message',
    'mk.so.comment': 'Comment on a post',
    'mk.so.noText': '(no text, attachment only)',
    'mk.so.attachments': 'attachment(s)',
    'mk.so.why': 'Why',
    'mk.so.st.new': 'New',
    'mk.so.st.drafted': 'Draft ready',
    'mk.so.st.escalated': 'Needs a person',
    'mk.so.st.sent': 'Sent',
    'mk.so.st.ignored': 'Ignored',
    'mk.so.st.failed': 'Send failed',
    'mk.so.cl.lead': 'Lead',
    'mk.so.cl.question': 'Question',
    'mk.so.cl.complaint': 'Complaint',
    'mk.so.cl.praise': 'Praise',
    'mk.so.cl.spam': 'Spam',
    'mk.so.cl.other': 'Other',
    'mk.so.replyPlaceholder': 'Write the reply (or regenerate the draft)…',
    'mk.so.send': 'Send reply',
    'mk.so.redraft': 'Regenerate draft',
    'mk.so.ignore': 'Ignore',
    'mk.so.autoSent': 'Sent automatically by the bot',
    'mk.so.sentBy': 'Sent by {who}',
    'mk.so.openProfile': 'Open their profile',
    'mk.so.showThread': 'Show the conversation so far',
    'mk.so.hideThread': 'Hide the conversation',
    'mk.so.noThread': 'First message from this person.',
    'mk.so.us': 'Us',
    'mk.so.them': 'Them',
    'mk.alert.tag': 'Social',
    'mk.alert.needs': '{red} · {who} needs a person',
    'mk.alert.failed': '{red} · reply to {who} failed',
    'mk.alert.more': '+{n} more',
    'mk.alert.open': 'Open',
    'mk.alert.dismiss': 'Hide for 10 minutes',
    // Agents → corrida del bot de rounds: resumen en dos líneas y partida por partida (dueño 2026-11-02)
    'ag.rd.title': 'What the bot decided, line by line',
    'ag.rd.redecide': 'Re-decide with today\'s evidence',
    'ag.rd.changed': '{n} line(s) changed',
    'ag.rd.photos': 'Photos',
    'ag.rd.pickPhotos': 'Pick ClaimCam photos for this line; the bot decides again right away',
    'ag.rd.photosFor': 'Photos for {item}',
    'ag.rd.note': 'Note the bot wrote on the line',
    'ag.rd.noteHint': 'this note goes on the counter offer line',
    'ag.rd.ours': 'Ours',
    'ag.rd.theirs': 'Theirs',
    'ag.rd.gap': 'Gap',
    'ag.rd.approvedN': '{n} approved as written',
    'ag.rd.disputing': 'Fighting',
    'ag.rd.lettingGo': 'Letting go',
    'ag.rd.pending': 'A person decides',
    'ag.rd.nLines': '{n} line(s)',
    'ag.rd.openReview': 'Open Review Estimate',
    'ag.rd.openReviewHint': 'The decisions are pre-loaded there: change, add or remove what you want, then generate the counter offer.',
    'ag.rd.g.dispute': 'Fighting',
    'ag.rd.g.let_go': 'Letting go',
    'ag.rd.g.pending': 'For a person to decide',
    'ag.rd.line': 'Line',
    'ag.rd.why': 'Why',
    'ag.rd.rule': 'Rule',
    'ag.rd.noPhoto': 'No photo',
    'ag.rd.earlierRound': 'Let go by the office in an earlier round',
    'ag.rd.openLine': 'Open this line in Review Estimate',
    'ag.rd.dispute': 'Dispute',
    'ag.rd.letGo': 'Let go',
    'ag.rd.toPending': 'A person decides',
    'ag.rd.byHand': 'Set by {who}',
    'ag.rd.botHad': 'the bot had: {what}',
    'ag.rd.needs': 'What the bot needs to go further',
    // Marketing → Content (calendario, piezas, assets, blog, Meta Ads; mig 0566)
    'mk.tab.calendar': 'Calendar',
    'mk.tab.content': 'Content',
    'mk.tab.assets': 'Assets',
    'mk.tab.blog': 'Blog',
    'mk.tab.ads': 'Ads',
    'mk.ct.intro': 'The Content director writes the week (posts, reels, video scripts), picks a design or photo from Assets, turns each new blog article into a post and a video script, and publishes approved pieces to Facebook and Instagram at their time. Rules (posts per week, topics, tone, auto-publish) are in Agents → Content director.',
    'mk.ct.autoOff': 'Auto-publish is OFF: every piece waits here for your approval. Turn it on in Agents → Content director → Rules when you trust it.',
    'mk.ct.autoOn': 'Auto-publish is ON: pieces the bot writes are scheduled and published alone. You can still edit, reschedule or reject anything before its time.',
    'mk.ct.planNow': 'Plan the week now',
    'mk.ct.planQueued': 'Planning run queued: pieces appear here in a minute or two.',
    'mk.ct.new': 'New piece',
    'mk.ct.generate': 'Write with AI',
    'mk.ct.regenerate': 'Rewrite with AI',
    'mk.ct.approve': 'Approve & schedule',
    'mk.ct.publishNow': 'Publish now',
    'mk.ct.reject': 'Reject',
    'mk.ct.delete': 'Delete',
    'mk.ct.deleteConfirm': 'Delete this piece?',
    'mk.ct.publishConfirm': 'Publish now to {platforms}?',
    'mk.ct.save': 'Save',
    'mk.ct.topic': 'Topic',
    'mk.ct.title': 'Internal title',
    'mk.ct.headline': 'Headline on the image',
    'mk.ct.headlineHint': '2-6 words stamped on the generated image, in uppercase. The writer suggests one; edit it here and generate the image again.',
    'mk.ct.headlinePh': 'Did hail hit your roof?',
    'mk.ct.template': 'Design template',
    'mk.ct.templateHint': 'How the design is built in code: Photo (full-bleed photo with the navy veil), Split (photo on top, navy panel below), Solid (no photo: navy background). Auto follows the Content director rule.',
    'mk.ct.tpl.auto': 'Auto (rule)',
    'mk.ct.tpl.photo': 'Photo',
    'mk.ct.tpl.split': 'Split',
    'mk.ct.tpl.solid': 'Solid',
    'mk.ct.buildDesign': 'Build design',
    'mk.ct.buildDesignHint': 'Builds the design in code with the chosen template: the photo of this piece (or one from Assets by topic), the real logo, the headline and the footer. No AI.',
    'mk.ct.warn.no_photo': 'No photo for this piece: the solid template was used. Attach a photo from Assets or generate one with AI and build the design again.',
    'mk.ct.brief': 'Brief for the AI (optional)',
    'mk.ct.briefPh': 'What you want this piece to say, who it is for, anything to include…',
    'mk.ct.captionEn': 'Caption (English)',
    'mk.ct.captionEs': 'Caption (Spanish)',
    'mk.ct.hashtags': 'Hashtags',
    'mk.ct.hashtagsPh': '#one #two (space or comma separated)',
    'mk.ct.scheduledAt': 'Scheduled for',
    'mk.ct.noDate': 'No date yet (next free slot when approved)',
    'mk.ct.kind': 'Type',
    'mk.ct.k.post': 'Post',
    'mk.ct.k.reel': 'Reel',
    'mk.ct.k.story': 'Story',
    'mk.ct.k.video': 'Video',
    'mk.ct.k.ad': 'Ad',
    'mk.ct.platforms': 'Platforms',
    'mk.ct.st.idea': 'Idea',
    'mk.ct.st.draft': 'Draft',
    'mk.ct.st.review': 'Waiting for review',
    'mk.ct.st.approved': 'Approved',
    'mk.ct.st.scheduled': 'Scheduled',
    'mk.ct.st.publishing': 'Publishing…',
    'mk.ct.st.published': 'Published',
    'mk.ct.st.failed': 'Failed',
    'mk.ct.st.rejected': 'Rejected',
    'mk.ct.f.pending': 'To review',
    'mk.ct.f.scheduled': 'Scheduled',
    'mk.ct.f.published': 'Published',
    'mk.ct.f.all': 'All',
    'mk.ct.empty': 'No pieces here yet. Press "Plan the week now" or create one.',
    'mk.ct.media': 'Image / video',
    'mk.ct.pickMedia': 'Choose from Assets',
    'mk.ct.noMedia': 'No image or video yet. Instagram needs one.',
    'mk.ct.removeMedia': 'Remove',
    'mk.ct.script': 'Video script',
    'mk.ct.hook': 'Hook',
    'mk.ct.scene': 'Scene',
    'mk.ct.visual': 'What we see',
    'mk.ct.voiceover': 'Voice-over',
    'mk.ct.onScreen': 'On-screen text',
    'mk.ct.cta': 'Call to action',
    'mk.ct.shotList': 'Shot list',
    'mk.ct.duration': '{s}s',
    'mk.ct.copyScript': 'Copy script',
    'mk.ct.copied': 'Copied',
    'mk.ct.source.blog': 'From the blog',
    'mk.ct.source.agent': 'Planned by the bot',
    'mk.ct.source.manual': 'Written by hand',
    'mk.ct.openArticle': 'Open article',
    'mk.ct.published.on': 'Published on {platform}',
    'mk.ct.openPost': 'Open post',
    'mk.ct.warn.ai_not_configured': 'AI is not configured on the server (OPENROUTER_API_KEY / CLAUDE_API_KEY): the text was not written.',
    'mk.ct.warn.needs_image': 'No matching image in Assets: upload one and attach it.',
    'mk.ct.warn.needs_video': 'No video in Assets for this piece: upload one and attach it, or record from the script.',
    'mk.ct.warn.model_no_json': 'The model did not answer in the expected shape.',
    'mk.ct.warn.model_failed': 'The model failed. Try "Rewrite with AI".',
    'mk.ct.warn.partial_publish': 'Published on some platforms only. See the error.',
    'mk.ct.warn.other': 'Discarded wording: "{w}"',
    'mk.ct.warn.auto_publish_blocked': 'Could not auto-schedule: {why}',
    'mk.ct.errors.instagram_needs_media': 'Instagram needs an image or a video.',
    'mk.ct.errors.needs_caption': 'Write or generate the caption first.',
    'mk.ct.errors.already_published': 'This piece was already published.',
    'mk.ct.errors.not_publishable': 'This piece cannot be published in its current state.',
    'mk.ct.by': 'by {who}',
    'mk.ct.genImage': 'Generate photo with AI',
    'mk.ct.genImageHint': 'Asks Nano Banana (OpenRouter) for the PHOTO only, then builds the design in code on top of it. Costs credits: use it when no photo in Assets fits.',
    'mk.ct.genVideo': 'Generate video (Higgsfield)',
    'mk.ct.genVideoHint': 'Asks Higgsfield for a short vertical video from the piece image and the script; takes a few minutes and attaches itself.',
    'mk.ct.video.queued': 'Video requested to Higgsfield…',
    'mk.ct.video.in_progress': 'Higgsfield is rendering the video…',
    'mk.ct.video.failed': 'Video failed',
    'mk.ct.warn.image_failed': 'The image could not be generated. Try "Generate image" again or attach one from Assets.',
    'mk.ct.warn.no_logo_asset': 'No logo in Assets: upload the logo (PNG with transparent background) and tag it "logo" so it is stamped on every generated image.',
    'mk.ct.warn.logo_unreadable': 'The Asset tagged "logo" could not be read as an image: upload it again as PNG.',
    'mk.ct.warn.font_unreadable': 'A font in Assets could not be read (.ttf / .otf expected): the system font was used.',
    'mk.ct.warn.video_in_progress': 'Video in progress at Higgsfield; it attaches itself when ready.',
    'mk.ct.warn.video_failed': 'Video failed: {why}',
    'mk.ct.errors.higgsfield_not_configured': 'Higgsfield is not connected: set HIGGSFIELD_API_KEY and HIGGSFIELD_API_SECRET in Railway.',
    'mk.ct.errors.ai_not_configured': 'OPENROUTER_API_KEY is not set on the server.',
    'mk.ct.errors.video_in_progress': 'A video is already being generated for this piece.',
    'mk.ct.errors.image_generation_failed': 'Image generation failed.',
    'mk.ct.errors.video_request_failed': 'Higgsfield rejected the request.',
    'mk.pv.image': 'Images',
    'mk.pv.imageOff': 'OPENROUTER_API_KEY missing',
    'mk.pv.video': 'Video',
    'mk.pv.videoOff': 'Higgsfield keys missing',
    'mk.pv.auto': 'auto for reels',
    'mk.pv.test': 'Test Higgsfield',
    'mk.pv.hint': 'Models and endpoints: Agents → Content director → Rules. Brand references: assets tagged "brand" or "logo".',
    // Marketing → Leads (Meta Lead Ads → Intake; máquina de marketing fase 1)
    'mk.tab.leads': 'Leads',
    'mk.ld.intro': 'Every lead from a Facebook / Instagram lead form lands here and in Intake as a claim within seconds, gets the automatic SMS and opens a task. Rules (SMS texts, consent, duplicates, who gets the task) are in Agents → Lead responder. The Meta webhook needs the "leadgen" field and the leads_retrieval permission.',
    'mk.ld.today': 'Leads today',
    'mk.ld.d7': '{n} in 7 days',
    'mk.ld.d30': '{n} in 30 days',
    'mk.ld.replied': 'Auto-replied',
    'mk.ld.last7': 'last 7 days',
    'mk.ld.median': 'Time to first reply',
    'mk.ld.medianHint': 'median, last 30 days',
    'mk.ld.byCampaign': 'By campaign (30 d)',
    'mk.ld.all': 'All',
    'mk.ld.st.new': 'New',
    'mk.ld.st.claim_created': 'Claim created',
    'mk.ld.st.duplicate': 'Duplicate',
    'mk.ld.st.failed': 'Failed',
    'mk.ld.empty': 'No leads yet.',
    'mk.ld.when': 'When',
    'mk.ld.who': 'Who',
    'mk.ld.source': 'Campaign · ad · form',
    'mk.ld.status': 'Status',
    'mk.ld.reply': 'First reply',
    'mk.ld.claim': 'Claim',
    'mk.ld.noReply': 'not replied',
    'mk.ld.retry': 'Retry',
    'mk.ct.ad': 'Create ad from this piece',
    'mk.ct.adHint': 'Asks for a Meta campaign with this text, link and image (7 days at the default budget). Waits for approval in Ads.',
    'mk.ct.boost': 'Boost on Facebook',
    'mk.ct.boostHint': 'Asks to promote this published post for 5 days. Waits for approval in Ads.',
    'mk.ct.errors.ads_write_disabled': 'Ads are read-only: turn on "Allow the CRM to change ads" in Agents → Ads manager → Rules.',
    'mk.ct.errors.no_ad_account': 'No ad account: set "Meta Ads account id" in Agents → Content director → Rules.',
    'mk.ct.errors.no_token': 'No Meta token with ads permissions (META_ADS_TOKEN or the page token).',
    'mk.ct.errors.monthly_spend_cap': 'This would exceed the monthly ads cap (Agents → Ads manager → Rules).',
    'mk.ct.errors.not_published_on_facebook': 'This piece is not published on Facebook yet.',
    'mk.ct.errors.action_not_pending': 'This change was already decided.',
    'mk.ax.title': 'Changes to ads',
    'mk.ax.hint': 'Nothing changes in Meta until someone approves here (Agents → Ads manager → Rules).',
    'mk.ax.f.open': 'Waiting',
    'mk.ax.f.all': 'All',
    'mk.ax.empty': 'Nothing waiting.',
    'mk.ax.st.pending_approval': 'Waiting for approval',
    'mk.ax.st.approved': 'Applying…',
    'mk.ax.st.applied': 'Applied',
    'mk.ax.st.rejected': 'Rejected',
    'mk.ax.st.failed': 'Failed',
    'mk.ax.k.create_campaign': 'New campaign',
    'mk.ax.k.boost_post': 'Boost post',
    'mk.ax.k.pause': 'Pause',
    'mk.ax.k.resume': 'Resume',
    'mk.ax.k.budget': 'Budget',
    'mk.ax.bot': 'bot',
    'mk.ax.approve': 'Approve',
    'mk.ax.reject': 'Reject',
    'mk.ax.retry': 'Retry',
    'mk.ax.pause': 'Pause',
    'mk.ax.resume': 'Resume',
    'mk.ax.requested': 'Requested: approve it in "Changes to ads".',
    'mk.cv.title': 'Conversions API',
    'mk.cv.on': 'on',
    'mk.cv.off': 'META_PIXEL_ID / META_CAPI_TOKEN missing',
    'mk.cv.sent': 'sent',
    'mk.cv.queued': 'queued',
    'mk.cv.failed': 'failed',
    'mk.tab.storms': 'Storms',
    'mk.st.intro': 'The Storm responder reads the NOAA Storm Prediction Center hail and wind reports every few hours for your states. For each storm above the thresholds it prepares a post and a reel script for the homeowners of those counties, a local lead ad and a contractor campaign for those cities. Approve the package and everything goes to its queue; dismiss it and nothing goes out. Rules in Agents → Storm responder.',
    'mk.st.check': 'Check NOAA now',
    'mk.st.checkQueued': 'Checking… the package appears here in a couple of minutes if there was a storm.',
    'mk.st.empty': 'No storms above the thresholds in the last 30 days.',
    'mk.st.st.proposed': 'Waiting for your decision',
    'mk.st.st.approved': 'Approved',
    'mk.st.st.dismissed': 'Dismissed',
    'mk.st.reports': '{n} reports',
    'mk.st.hail': 'Hail up to',
    'mk.st.wind': 'Wind up to',
    'mk.st.approve': 'Approve package',
    'mk.st.dismiss': 'Dismiss',
    'mk.st.counties': 'Counties',
    'mk.st.cities': 'Places',
    'mk.st.ad': 'Lead ad',
    'mk.st.noAd': 'no ad (ads write-off or no account)',
    'mk.st.outreach': 'Contractor campaign',
    'mk.st.recent': 'NOAA reports, last 7 days',
    'mk.st.noReports': 'No reports in your states.',
    'mk.st.date': 'Date · time (UTC)',
    'mk.st.kind': 'Type',
    'mk.st.magnitude': 'Size / speed',
    'mk.st.place': 'Place',
    'mk.st.county': 'County',
    'mk.tab.funnel': 'Funnel',
    'mk.ct.perfHint': 'Reach · interactions · clicks (read from Meta daily)',
    'mk.fn.intro': 'By lead source: leads → inspections → signed contracts → accepted claims → RCV of the accepted claims (from the financial engine, no fee math), with ads spend and cost per lead / per accepted claim. Below, what the bot learned: topics and hours with the best interaction rate (used to plan the next week).',
    'mk.fn.sync': 'Read performance now',
    'mk.fn.synced': '{n} piece(s) updated',
    'mk.fn.report': 'Weekly report',
    'mk.fn.sendReport': 'Send report now',
    'mk.fn.reportSent': 'Report sent (notification + DM).',
    'mk.fn.leads': 'Leads',
    'mk.fn.inspections': 'Inspections',
    'mk.fn.contracts': 'Contracts',
    'mk.fn.accepted': 'Accepted claims',
    'mk.fn.ofLeads': 'of leads',
    'mk.fn.rcv': 'RCV (accepted)',
    'mk.fn.rcvHint': 'current insurance RCV',
    'mk.fn.ads': 'Ads spend',
    'mk.fn.cpl': 'per lead',
    'mk.fn.cpc': 'per claim',
    'mk.fn.source': 'Source',
    'mk.fn.src.meta_lead_ad': 'Meta lead form',
    'mk.fn.src.meta_ads': 'Meta ads (site)',
    'mk.fn.src.website': 'Website form',
    'mk.fn.src.whatsapp': 'WhatsApp',
    'mk.fn.src.storm': 'Storm campaign',
    'mk.fn.src.other': 'Other / unknown',
    'mk.fn.learned': 'What the bot learned (90 days)',
    'mk.fn.noPerf': 'No performance data yet. It needs published pieces and the permissions pages_read_engagement / instagram_manage_insights on the token; the director reads it on every run.',
    'mk.fn.topics': 'Topics by interaction rate',
    'mk.fn.hours': 'Hours by interaction rate',
    'mk.tab.reviews': 'Reviews',
    'mk.rv.intro': 'When the homeowner has received their money, the Review collector opens a request and sends it (or waits for your click) by SMS and email in their language. 4-5 stars go to your Google review page; 1-3 stay private and open a task. Rules (delay, Google link, texts, minimum rating, who gets the task) are in Agents → Review collector.',
    'mk.rv.requested': 'Requests (12 mo)',
    'mk.rv.pendingShort': 'waiting',
    'mk.rv.rated': 'Rated',
    'mk.rv.ofSent': 'of sent',
    'mk.rv.avg': 'Average',
    'mk.rv.fourPlus': '4★ or more',
    'mk.rv.toGoogle': 'Sent to Google',
    'mk.rv.low': 'Low (private)',
    'mk.rv.lowHint': 'each opened a task',
    'mk.rv.all': 'All',
    'mk.rv.s.pending': 'Waiting',
    'mk.rv.s.sent': 'Sent',
    'mk.rv.s.rated': 'Rated',
    'mk.rv.s.failed': 'Could not send',
    'mk.rv.s.skipped': 'Skipped',
    'mk.rv.scan': 'Find paid claims now',
    'mk.rv.scanned': '{n} new request(s)',
    'mk.rv.rules': 'Rules',
    'mk.rv.empty': 'No review requests yet. They appear when a payment to the homeowner is marked delivered.',
    'mk.rv.homeowner': 'Homeowner',
    'mk.rv.status': 'Status',
    'mk.rv.due': 'Due',
    'mk.rv.rating': 'Rating',
    'mk.rv.comment': 'Private comment',
    'mk.rv.manual': 'manual',
    'mk.rv.taskOpened': 'task opened',
    'mk.rv.send': 'Send',
    'mk.rv.skip': 'Skip',
    'mk.ct.k.carousel': 'Carousel',
    'mk.ct.newsletter': 'Draft newsletter',
    'mk.ct.newsletterHint': 'Collects this week\'s published pieces and blog articles into an email draft in Broadcast. You send it from there.',
    'mk.ct.newsletterDone': 'Newsletter draft created in Broadcast ({n} pieces, {a} articles).',
    'mk.ct.newsletterEmpty': 'Nothing published this week and no new articles: no draft created.',
    'mk.dr.title': 'Follow-up sequence for unsigned leads',
    'mk.dr.stats': '{a} active · {s} sent in 30 days · {d} finished · {x} stopped',
    'mk.dr.intro': 'Off by default. When enabled in Agents → Lead responder, every lead in Lead / Contract Sent gets the sequence (SMS / email in their language) until they sign, reply, opt out or the steps end. Stop one here if you are handling it personally.',
    'mk.dr.empty': 'No sequences yet.',
    'mk.dr.stage': 'Stage',
    'mk.dr.status': 'Sequence',
    'mk.dr.steps': 'Steps sent',
    'mk.dr.next': 'Next',
    'mk.dr.stop': 'Stop',
    'mk.dr.s.active': 'Active',
    'mk.dr.s.done': 'Finished',
    'mk.dr.s.stopped': 'Stopped',
    'mk.ct.compliance': 'Check compliance',
    'mk.ct.complianceHint': 'Code rules (no guarantees, no deductible talk, no legal advice, never-say list, license in ads) plus a second read by the model. Approving runs it anyway.',
    'mk.ct.compBlock': 'Compliance: this cannot go out as written.',
    'mk.ct.compWarn': 'Compliance: passed with notes.',
    'mk.ct.errors.compliance_failed': 'Blocked by compliance:',
    'aim.f.marketing_compliance': "Marketing → compliance reviewer", 'aim.f.marketing_compliance.d': "Marketing: reads each post, ad or script before approval and flags implied promises, deductible talk, legal advice, invented facts or false urgency. The code blocks the hard rules on its own; the model adds a second read and only warns if it fails.",
    'mk.rv.sentToGoogle': '→ Google',
    'mk.prev.button': 'Preview',
    'mk.prev.day': 'Preview this day as a feed',
    'mk.prev.hint': 'How it will look. A mock-up with the connected page, the image and the caption + hashtags exactly as the CRM publishes them.',
    'mk.prev.noMedia': 'No image yet',
    'mk.prev.now': 'now',
    'mk.prev.likes': 'Liked by your followers',
    'mk.prev.more': 'more',
    'mk.prev.like': 'Like',
    'mk.prev.comment': 'Comment',
    'mk.prev.share': 'Share',
    'mk.prev.count': '{n} piece(s)',
    'mk.prev.empty': 'Nothing planned for this day.',
    'mk.prev.notOn': 'not planned for {platform}',
    'mk.prev.open': 'Open piece',
    'mk.prev.prev': 'Previous photo',
    'mk.prev.next': 'Next photo',
    'mk.ct.warn.image_in_progress': 'Generating the image with Nano Banana… it appears here by itself in a minute or two.',
    'mk.ct.genImageBusy': 'Generating image…',
    'mk.ct.errors.image_in_progress': 'The image is already being generated. Wait a minute.',
    'mk.cal.today': 'Today',
    'mk.cal.more': '+{n} more',
    'mk.cal.legend': 'Click a piece to open it. Colors: gray idea/draft, amber waiting for review, blue scheduled, green published, red failed.',
    'mk.as.intro': 'Upload logos, designs, photos, videos and the brand fonts (.ttf / .otf) here. Tag them (roof, hail, team, logo…): the bot picks the file for each piece by its tags; the logo and the fonts are stamped on every generated image (tag a font "headline" or "footer" to use two). Drop files anywhere on this panel.',
    'mk.as.drop': 'Drop files here or click to upload',
    'mk.as.uploading': 'Uploading {n}…',
    'mk.as.tags': 'Tags',
    'mk.as.tagsPh': 'roof, hail, team…',
    'mk.as.notes': 'Notes',
    'mk.as.kind': 'Type',
    'mk.as.k.image': 'Image',
    'mk.as.k.video': 'Video',
    'mk.as.k.logo': 'Logo',
    'mk.as.k.design': 'Design',
    'mk.as.k.document': 'Document',
    'mk.as.k.font': 'Font',
    'mk.as.uses': 'Used in {n} piece(s)',
    'mk.as.archive': 'Remove',
    'mk.as.archiveConfirm': 'Remove "{name}" from Assets? Pieces that already use it keep it.',
    'mk.as.empty': 'Nothing uploaded yet.',
    'mk.as.search': 'Search by name or tag',
    'mk.as.pick': 'Use this one',
    'mk.as.close': 'Close',
    'mk.bl.intro': 'Every new article of the website blog becomes a post (with the link) and a video script. The blog URL is a rule of the Content director.',
    'mk.bl.noUrl': 'No blog URL yet. Set "Website blog" in Agents → Content director → Rules (the blog page or its RSS feed).',
    'mk.bl.url': 'Blog',
    'mk.bl.sync': 'Read the blog now',
    'mk.bl.synced': '{n} new article(s) found ({total} read via {via}). The bot writes their pieces on the next run — or press "Plan the week now".',
    'mk.bl.empty': 'No articles read yet.',
    'mk.bl.post': 'Post',
    'mk.bl.video': 'Video script',
    'mk.bl.pending': 'not written yet',
    'mk.ads.intro': 'Read-only view of Meta Ads: spend, reach, clicks and leads per campaign, refreshed daily by the bot. Nothing here changes an ad.',
    'mk.ads.noAccount': 'No ad account yet. Set "Meta Ads account id" (act_…) in Agents → Content director → Rules. The page token needs the ads_read permission.',
    'mk.ads.sync': 'Refresh now',
    'mk.ads.lastFetched': 'Last read {when}',
    'mk.ads.never': 'never read',
    'mk.ads.spend': 'Spend',
    'mk.ads.impressions': 'Impressions',
    'mk.ads.reach': 'Reach',
    'mk.ads.clicks': 'Clicks',
    'mk.ads.leads': 'Leads',
    'mk.ads.cpl': 'Cost per lead',
    'mk.ads.cpc': 'Cost per click',
    'mk.ads.ctr': 'CTR',
    'mk.ads.campaign': 'Campaign',
    'mk.ads.status': 'Status',
    'mk.ads.objective': 'Objective',
    'mk.ads.byDay': 'Spend per day',
    'mk.ads.days': 'Last {n} days',
    'mk.ads.empty': 'No campaign data yet.',
};
